var Ea = Object.defineProperty;
var Oa = (e, t, n) => t in e ? Ea(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var xe = (e, t, n) => (Oa(e, typeof t != "symbol" ? t + "" : t, n), n);
import { toRaw as Os, isRef as Be, isReactive as bo, toRef as vn, hasInjectionContext as xa, inject as ai, getCurrentInstance as _a, ref as Y, watch as _e, reactive as fi, markRaw as wn, effectScope as Ua, nextTick as at, computed as k, getCurrentScope as Fa, onScopeDispose as $a, toRefs as Ki, openBlock as c, createElementBlock as p, defineComponent as T, resolveComponent as R, createBlock as C, normalizeClass as D, unref as h, withCtx as _, renderSlot as Te, createTextVNode as ne, toDisplayString as N, resolveDynamicComponent as xt, useAttrs as Ra, resolveDirective as It, createCommentVNode as A, createElementVNode as m, withDirectives as Ze, mergeProps as Tt, withKeys as Co, vModelDynamic as Va, createVNode as M, Transition as Xe, Fragment as X, renderList as te, normalizeStyle as Ce, pushScopeId as Sn, popScopeId as Ln, withModifiers as be, onMounted as _t, onUnmounted as xs, vModelText as yi, vModelSelect as _s, useCssVars as Us, vShow as Ba, TransitionGroup as Fs, provide as qi } from "vue";
var Ya = !1;
function oo(e, t, n) {
  return Array.isArray(e) ? (e.length = Math.max(e.length, t), e.splice(t, 1, n), n) : (e[t] = n, n);
}
function Qo(e, t) {
  if (Array.isArray(e)) {
    e.splice(t, 1);
    return;
  }
  delete e[t];
}
/*!
 * pinia v2.1.7
 * (c) 2023 Eduardo San Martin Morote
 * @license MIT
 */
let Dn;
const ho = (e) => Dn = e, Qa = process.env.NODE_ENV !== "production" ? Symbol("pinia") : (
  /* istanbul ignore next */
  Symbol()
);
function Zt(e) {
  return e && typeof e == "object" && Object.prototype.toString.call(e) === "[object Object]" && typeof e.toJSON != "function";
}
var Tn;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(Tn || (Tn = {}));
const Ii = typeof window < "u", Po = (process.env.NODE_ENV !== "production" || !1) && process.env.NODE_ENV !== "test" && Ii;
function $s(e, t) {
  for (const n in t) {
    const o = t[n];
    if (!(n in e))
      continue;
    const i = e[n];
    Zt(i) && Zt(o) && !Be(o) && !bo(o) ? e[n] = $s(i, o) : e[n] = o;
  }
  return e;
}
const Rs = () => {
};
function Xi(e, t, n, o = Rs) {
  e.push(t);
  const i = () => {
    const r = e.indexOf(t);
    r > -1 && (e.splice(r, 1), o());
  };
  return !n && Fa() && $a(i), i;
}
function on(e, ...t) {
  e.slice().forEach((n) => {
    n(...t);
  });
}
const Pa = (e) => e();
function li(e, t) {
  e instanceof Map && t instanceof Map && t.forEach((n, o) => e.set(o, n)), e instanceof Set && t instanceof Set && t.forEach(e.add, e);
  for (const n in t) {
    if (!t.hasOwnProperty(n))
      continue;
    const o = t[n], i = e[n];
    Zt(i) && Zt(o) && e.hasOwnProperty(n) && !Be(o) && !bo(o) ? e[n] = li(i, o) : e[n] = o;
  }
  return e;
}
const Ga = process.env.NODE_ENV !== "production" ? Symbol("pinia:skipHydration") : (
  /* istanbul ignore next */
  Symbol()
);
function Za(e) {
  return !Zt(e) || !e.hasOwnProperty(Ga);
}
const { assign: st } = Object;
function es(e) {
  return !!(Be(e) && e.effect);
}
function ts(e, t, n, o) {
  const { state: i, actions: r, getters: s } = t, l = n.state.value[e];
  let a;
  function u() {
    !l && (process.env.NODE_ENV === "production" || !o) && (n.state.value[e] = i ? i() : {});
    const g = process.env.NODE_ENV !== "production" && o ? (
      // use ref() to unwrap refs inside state TODO: check if this is still necessary
      Ki(Y(i ? i() : {}).value)
    ) : Ki(n.state.value[e]);
    return st(g, r, Object.keys(s || {}).reduce((d, f) => (process.env.NODE_ENV !== "production" && f in g && console.warn(`[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${f}" in store "${e}".`), d[f] = wn(k(() => {
      ho(n);
      const I = n._s.get(e);
      return s[f].call(I, I);
    })), d), {}));
  }
  return a = ci(e, u, t, n, o, !0), a;
}
function ci(e, t, n = {}, o, i, r) {
  let s;
  const l = st({ actions: {} }, n);
  if (process.env.NODE_ENV !== "production" && !o._e.active)
    throw new Error("Pinia destroyed");
  const a = {
    deep: !0
    // flush: 'post',
  };
  process.env.NODE_ENV !== "production" && !Ya && (a.onTrigger = (F) => {
    u ? I = F : u == !1 && !U._hotUpdating && (Array.isArray(I) ? I.push(F) : console.error("🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug."));
  });
  let u, g, d = [], f = [], I;
  const z = o.state.value[e];
  !r && !z && (process.env.NODE_ENV === "production" || !i) && (o.state.value[e] = {});
  const v = Y({});
  let Q;
  function H(F) {
    let $;
    u = g = !1, process.env.NODE_ENV !== "production" && (I = []), typeof F == "function" ? (F(o.state.value[e]), $ = {
      type: Tn.patchFunction,
      storeId: e,
      events: I
    }) : (li(o.state.value[e], F), $ = {
      type: Tn.patchObject,
      payload: F,
      storeId: e,
      events: I
    });
    const oe = Q = Symbol();
    at().then(() => {
      Q === oe && (u = !0);
    }), g = !0, on(d, $, o.state.value[e]);
  }
  const ee = r ? function() {
    const { state: $ } = n, oe = $ ? $() : {};
    this.$patch((pe) => {
      st(pe, oe);
    });
  } : (
    /* istanbul ignore next */
    process.env.NODE_ENV !== "production" ? () => {
      throw new Error(`🍍: Store "${e}" is built using the setup syntax and does not implement $reset().`);
    } : Rs
  );
  function j() {
    s.stop(), d = [], f = [], o._s.delete(e);
  }
  function G(F, $) {
    return function() {
      ho(o);
      const oe = Array.from(arguments), pe = [], Qe = [];
      function ot(B) {
        pe.push(B);
      }
      function Mt(B) {
        Qe.push(B);
      }
      on(f, {
        args: oe,
        name: F,
        store: U,
        after: ot,
        onError: Mt
      });
      let q;
      try {
        q = $.apply(this && this.$id === e ? this : U, oe);
      } catch (B) {
        throw on(Qe, B), B;
      }
      return q instanceof Promise ? q.then((B) => (on(pe, B), B)).catch((B) => (on(Qe, B), Promise.reject(B))) : (on(pe, q), q);
    };
  }
  const V = /* @__PURE__ */ wn({
    actions: {},
    getters: {},
    state: [],
    hotState: v
  }), K = {
    _p: o,
    // _s: scope,
    $id: e,
    $onAction: Xi.bind(null, f),
    $patch: H,
    $reset: ee,
    $subscribe(F, $ = {}) {
      const oe = Xi(d, F, $.detached, () => pe()), pe = s.run(() => _e(() => o.state.value[e], (Qe) => {
        ($.flush === "sync" ? g : u) && F({
          storeId: e,
          type: Tn.direct,
          events: I
        }, Qe);
      }, st({}, a, $)));
      return oe;
    },
    $dispose: j
  }, U = fi(process.env.NODE_ENV !== "production" || Po ? st(
    {
      _hmrPayload: V,
      _customProperties: wn(/* @__PURE__ */ new Set())
      // devtools custom properties
    },
    K
    // must be added later
    // setupStore
  ) : K);
  o._s.set(e, U);
  const se = (o._a && o._a.runWithContext || Pa)(() => o._e.run(() => (s = Ua()).run(t)));
  for (const F in se) {
    const $ = se[F];
    if (Be($) && !es($) || bo($))
      process.env.NODE_ENV !== "production" && i ? oo(v.value, F, vn(se, F)) : r || (z && Za($) && (Be($) ? $.value = z[F] : li($, z[F])), o.state.value[e][F] = $), process.env.NODE_ENV !== "production" && V.state.push(F);
    else if (typeof $ == "function") {
      const oe = process.env.NODE_ENV !== "production" && i ? $ : G(F, $);
      se[F] = oe, process.env.NODE_ENV !== "production" && (V.actions[F] = $), l.actions[F] = $;
    } else
      process.env.NODE_ENV !== "production" && es($) && (V.getters[F] = r ? (
        // @ts-expect-error
        n.getters[F]
      ) : $, Ii && (se._getters || // @ts-expect-error: same
      (se._getters = wn([]))).push(F));
  }
  if (st(U, se), st(Os(U), se), Object.defineProperty(U, "$state", {
    get: () => process.env.NODE_ENV !== "production" && i ? v.value : o.state.value[e],
    set: (F) => {
      if (process.env.NODE_ENV !== "production" && i)
        throw new Error("cannot set hotState");
      H(($) => {
        st($, F);
      });
    }
  }), process.env.NODE_ENV !== "production" && (U._hotUpdate = wn((F) => {
    U._hotUpdating = !0, F._hmrPayload.state.forEach(($) => {
      if ($ in U.$state) {
        const oe = F.$state[$], pe = U.$state[$];
        typeof oe == "object" && Zt(oe) && Zt(pe) ? $s(oe, pe) : F.$state[$] = pe;
      }
      oo(U, $, vn(F.$state, $));
    }), Object.keys(U.$state).forEach(($) => {
      $ in F.$state || Qo(U, $);
    }), u = !1, g = !1, o.state.value[e] = vn(F._hmrPayload, "hotState"), g = !0, at().then(() => {
      u = !0;
    });
    for (const $ in F._hmrPayload.actions) {
      const oe = F[$];
      oo(U, $, G($, oe));
    }
    for (const $ in F._hmrPayload.getters) {
      const oe = F._hmrPayload.getters[$], pe = r ? (
        // special handling of options api
        k(() => (ho(o), oe.call(U, U)))
      ) : oe;
      oo(U, $, pe);
    }
    Object.keys(U._hmrPayload.getters).forEach(($) => {
      $ in F._hmrPayload.getters || Qo(U, $);
    }), Object.keys(U._hmrPayload.actions).forEach(($) => {
      $ in F._hmrPayload.actions || Qo(U, $);
    }), U._hmrPayload = F._hmrPayload, U._getters = F._getters, U._hotUpdating = !1;
  })), Po) {
    const F = {
      writable: !0,
      configurable: !0,
      // avoid warning on devtools trying to display this property
      enumerable: !1
    };
    ["_p", "_hmrPayload", "_getters", "_customProperties"].forEach(($) => {
      Object.defineProperty(U, $, st({ value: U[$] }, F));
    });
  }
  return o._p.forEach((F) => {
    if (Po) {
      const $ = s.run(() => F({
        store: U,
        app: o._a,
        pinia: o,
        options: l
      }));
      Object.keys($ || {}).forEach((oe) => U._customProperties.add(oe)), st(U, $);
    } else
      st(U, s.run(() => F({
        store: U,
        app: o._a,
        pinia: o,
        options: l
      })));
  }), process.env.NODE_ENV !== "production" && U.$state && typeof U.$state == "object" && typeof U.$state.constructor == "function" && !U.$state.constructor.toString().includes("[native code]") && console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${U.$id}".`), z && r && n.hydrate && n.hydrate(U.$state, z), u = !0, g = !0, U;
}
function Wt(e, t, n) {
  let o, i;
  const r = typeof t == "function";
  if (typeof e == "string")
    o = e, i = r ? n : t;
  else if (i = e, o = e.id, process.env.NODE_ENV !== "production" && typeof o != "string")
    throw new Error('[🍍]: "defineStore()" must be passed a store id as its first argument.');
  function s(l, a) {
    const u = xa();
    if (l = // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    (process.env.NODE_ENV === "test" && Dn && Dn._testing ? null : l) || (u ? ai(Qa, null) : null), l && ho(l), process.env.NODE_ENV !== "production" && !Dn)
      throw new Error(`[🍍]: "getActivePinia()" was called but there was no active Pinia. Are you trying to use a store before calling "app.use(pinia)"?
See https://pinia.vuejs.org/core-concepts/outside-component-usage.html for help.
This will fail in production.`);
    l = Dn, l._s.has(o) || (r ? ci(o, t, i, l) : ts(o, i, l), process.env.NODE_ENV !== "production" && (s._pinia = l));
    const g = l._s.get(o);
    if (process.env.NODE_ENV !== "production" && a) {
      const d = "__hot:" + o, f = r ? ci(d, t, i, l, !0) : ts(d, st({}, i), l, !0);
      a._hotUpdate(f), delete l.state.value[d], l._s.delete(d);
    }
    if (process.env.NODE_ENV !== "production" && Ii) {
      const d = _a();
      if (d && d.proxy && // avoid adding stores that are just built for hot module replacement
      !a) {
        const f = d.proxy, I = "_pStores" in f ? f._pStores : f._pStores = {};
        I[o] = g;
      }
    }
    return g;
  }
  return s.$id = o, s;
}
let Wa = "Store";
function wo(...e) {
  return process.env.NODE_ENV !== "production" && Array.isArray(e[0]) && (console.warn(`[🍍]: Directly pass all stores to "mapStores()" without putting them in an array:
Replace
	mapStores([useAuthStore, useCartStore])
with
	mapStores(useAuthStore, useCartStore)
This will fail in production if not fixed.`), e = e[0]), e.reduce((t, n) => (t[n.$id + Wa] = function() {
    return n(this.$pinia);
  }, t), {});
}
function ue(e, t) {
  return Array.isArray(t) ? t.reduce((n, o) => (n[o] = function() {
    return e(this.$pinia)[o];
  }, n), {}) : Object.keys(t).reduce((n, o) => (n[o] = function() {
    const i = e(this.$pinia), r = t[o];
    return typeof r == "function" ? r.call(this, i) : i[r];
  }, n), {});
}
function fe(e, t) {
  return Array.isArray(t) ? t.reduce((n, o) => (n[o] = function(...i) {
    return e(this.$pinia)[o](...i);
  }, n), {}) : Object.keys(t).reduce((n, o) => (n[o] = function(...i) {
    return e(this.$pinia)[t[o]](...i);
  }, n), {});
}
function De(e) {
  {
    e = Os(e);
    const t = {};
    for (const n in e) {
      const o = e[n];
      (Be(o) || bo(o)) && (t[n] = // ---
      vn(e, n));
    }
    return t;
  }
}
var ze = /* @__PURE__ */ ((e) => (e.ADMIN = "admin", e.KNOWLEDGE = "knowledge", e.FAVORITES = "favorites", e.NOTIFICATIONS = "notifications", e.SEARCH = "search", e.FEEDBACK = "feedback", e.TOASTS = "toasts", e))(ze || {});
const ns = 15, Ha = 350, Ja = [
  "EDIT_KNOWLEDGE_BASE",
  "READ_ANALYTICS_DASHBOARDS",
  "EDIT_COMPANY_USERS",
  "EDIT_AGENT_NOTIFICATION",
  "IS_REACHABLE",
  "IS_GLOBALLY_REACHABLE",
  "EDIT_COMPANY_SETTINGS"
], Ka = {
  authorizedSession: (e) => !!e.accessToken && Date.now() < e.accessExpirationDate,
  /**
   * IMPORTANT: version is defined as a getter and no as a state to
   * avoid conflicts at extension update. Indeed, if a version
   * already exists in the store, it won't be updated by the app.
   * @returns string
   */
  currentVersion: (e) => e.version,
  isDeprecated: (e) => {
    const { version: t, latestVersion: n } = e;
    return n ? t !== n : !1;
  },
  /**
   * COMPANY
   */
  collaborators: (e) => e.company.reachableUsers && e.company.reachableUsers.length ? e.company.reachableUsers.map((t) => ({
    value: { id: t.id, type: "collaborator" },
    username: t.username
  })) : [],
  groups: (e) => e.company.reachableRoles && e.company.reachableRoles.length ? e.company.reachableRoles.map((t) => ({
    value: { id: t.id, type: "group" },
    username: `Groupe: ${t.name}`,
    reachable: !0
  })) : [],
  reportRecipients() {
    return this.groups.concat(this.collaborators);
  },
  companyHasIntegration: (e) => (t) => !!e.company.integrations.find(
    (n) => n.integration.toLowerCase() === t.toLowerCase()
  ),
  companyHasPreference: (e) => (t) => !!e.company.preferences.find((n) => n.type === t),
  companyLogo: (e) => e.company.logo,
  /**
   * Here we use both companyDomain and companySubdomain to handle
   * chrome update transition. Indeed, at extension update companySubdomain
   * may not be initialized, hence we use companyDomain temporarily
   * @param {Store} state
   * @returns string
   */
  subdomainUrl: (e) => {
    const { companyDomain: t, company: n } = e, o = n.subdomain || t;
    return o ? `https://${o}.mayday.fr` : null;
  },
  /**
   * USER
   */
  hasEditingRights: (e) => e.userPermissions.includes("EDIT_KNOWLEDGE_BASE"),
  hasAdminAccess: (e) => e.userPermissions.some((t) => Ja.includes(t)),
  recommendationsAvailable: (e) => e.recommendations.length > 0,
  appPosition: (e) => {
    var t;
    return (t = e.preferences.find(({ preference: n }) => n === "WEB_EXT_POSITION")) == null ? void 0 : t.value;
  },
  appPositionByHostname: (e) => {
    var t;
    return (t = e.preferences.find(({ preference: n }) => n === "WEB_EXT_POSITION_BY_HOSTNAME")) == null ? void 0 : t.value;
  },
  hasModalClosureShortcut: (e) => !!e.preferences.find(({ preference: t }) => t === "MODAL_CLOSURE_SHORTCUT"),
  hasArticleCopyPasteShortcut: (e) => !!e.preferences.find(({ preference: t }) => t === "ARTICLE_COPY_PASTE_SHORTCUT"),
  hasAnswerCopyPasteShortcut: (e) => !!e.preferences.find(({ preference: t }) => t === "ANSWER_COPY_PASTE_SHORTCUT"),
  hasUnreadNotificationsOnly: (e) => !!e.preferences.find(({ preference: t }) => t === "UNREAD_NOTIFICATIONS_ONLY"),
  resetNavigationPathAtOpening: (e) => !!e.preferences.find(({ preference: t }) => t === "RESET_NAVIGATION_PATH_AT_OPENING"),
  displayFullTitle: (e) => !!e.preferences.find(({ preference: t }) => t === "DISPLAY_FULL_TITLE"),
  contentFontSize: (e) => {
    var t;
    return ((t = e.preferences.find(({ preference: n }) => n === "CONTENT_FONT_SIZE")) == null ? void 0 : t.value) || "md";
  },
  displayArticleInMainFrame: (e) => {
    var t;
    return !!((t = e.preferences.find(({ preference: n }) => n === "DISPLAY_ARTICLE_IN_MAIN_FRAME")) != null && t.value);
  },
  urlBlacklistUserPreference: (e) => {
    var t;
    return (t = e.preferences.find(({ preference: n }) => n === "WEB_EXT_URL_BLACKLIST")) == null ? void 0 : t.value;
  },
  customWidth: (e) => {
    const t = e.preferences.find(
      ({ preference: n }) => n === "SIDEBAR_CUSTOM_WIDTH"
    );
    return t ? parseInt(t.value, 10) : Ha;
  },
  hasUserBrainHighlight: (e) => !!e.preferences.find(({ preference: t }) => t === "BRAIN_ENABLE_HIGHLIGHT"),
  // COMPANY
  automationsDelay: (e) => {
    const t = e.company.preferences.find(
      ({ type: n }) => n === "WEB_EXT_AUTOMATION_DISPLAY_DELAY"
    );
    return t ? parseInt(t.value, 10) * 1e3 : ns * 1e3;
  },
  companyColor: (e) => {
    var t;
    return (t = e.company.preferences.find(({ type: n }) => n === "PRIMARY_COLOR")) == null ? void 0 : t.value;
  },
  webExtPrimaryColor: (e) => {
    var t;
    return (t = e.company.preferences.find(({ type: n }) => n === "WEB_EXT_PRIMARY_COLOR")) == null ? void 0 : t.value;
  },
  webExtSecondaryColor: (e) => {
    var t;
    return (t = e.company.preferences.find(({ type: n }) => n === "WEB_EXT_SECONDARY_COLOR")) == null ? void 0 : t.value;
  },
  maydayWebPrimaryColor: (e) => {
    var t;
    return (t = e.company.preferences.find(({ type: n }) => n === "MAYDAY_WEB_PRIMARY_COLOR")) == null ? void 0 : t.value;
  },
  maydayWebSecondaryColor: (e) => {
    var t;
    return (t = e.company.preferences.find(({ type: n }) => n === "MAYDAY_WEB_SECONDARY_COLOR")) == null ? void 0 : t.value;
  },
  idzPrimaryColor: (e) => {
    var t;
    return (t = e.company.preferences.find(({ type: n }) => n === "IDZ_PRIMARY_COLOR")) == null ? void 0 : t.value;
  },
  idzSecondaryColor: (e) => {
    var t;
    return (t = e.company.preferences.find(({ type: n }) => n === "IDZ_SECONDARY_COLOR")) == null ? void 0 : t.value;
  },
  idzAutomationDelay: (e) => {
    const t = e.company.preferences.find(
      ({ type: n }) => n === "IDZ_AUTOMATION_DISPLAY_DELAY"
    );
    return t ? parseInt(t.value, 10) * 1e3 : ns * 1e3;
  },
  salesForceFocusTab: (e) => {
    var t;
    return (t = e.company.preferences.find(({ type: n }) => n === "WEB_EXT_SALESFORCE_FOCUS_TAB")) == null ? void 0 : t.value;
  },
  manuallyTriggerActions: (e) => {
    var t;
    return !!((t = e.company.preferences.find(
      ({ type: n, value: o }) => n === "WEB_EXT_MANUALLY_TRIGGER_ACTIONS" && o === "1"
    )) != null && t.value);
  },
  isSearchNoSteps: (e) => !!e.company.preferences.find(
    (t) => ["WEB_EXT_SEARCH_NO_STEPS", "ZENDESK_SEARCH_NO_STEPS"].includes(t.type)
  ),
  hasToastSound: (e) => !!e.company.preferences.find(({ type: t }) => t === "ALLOW_TOAST_SOUND"),
  hasCompanyBrainHighlight: (e) => !!e.company.preferences.find(({ type: t }) => t === "BRAIN_ENABLE_HIGHLIGHT"),
  urlBlacklistCompanyPreference: (e) => {
    var t;
    return (t = e.company.preferences.find((n) => n.type === "WEB_EXT_URL_BLACKLIST")) == null ? void 0 : t.value;
  },
  extensionIcon: (e) => {
    var t;
    return (t = e.company.preferences.find((n) => n.type === "WEB_EXT_ICON")) == null ? void 0 : t.value;
  },
  maydayWebIcon: (e) => {
    var t;
    return (t = e.company.preferences.find((n) => n.type === "MAYDAY_WEB_ICON")) == null ? void 0 : t.value;
  },
  maydayWebMainPageCover: (e) => {
    var t;
    return (t = e.company.preferences.find((n) => n.type === "MAYDAY_WEB_MAIN_PAGE_COVER")) == null ? void 0 : t.value;
  },
  searchCategoriesAndFilter: (e) => !!e.company.preferences.find(({ type: t }) => t === "SEARCH_CATEGORIES_AND_FILTER")
};
function Mi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var fo = { exports: {} };
fo.exports;
(function(e, t) {
  var n = 200, o = "__lodash_hash_undefined__", i = 9007199254740991, r = "[object Arguments]", s = "[object Array]", l = "[object Boolean]", a = "[object Date]", u = "[object Error]", g = "[object Function]", d = "[object GeneratorFunction]", f = "[object Map]", I = "[object Number]", z = "[object Object]", v = "[object Promise]", Q = "[object RegExp]", H = "[object Set]", ee = "[object String]", j = "[object Symbol]", G = "[object WeakMap]", V = "[object ArrayBuffer]", K = "[object DataView]", U = "[object Float32Array]", he = "[object Float64Array]", se = "[object Int8Array]", F = "[object Int16Array]", $ = "[object Int32Array]", oe = "[object Uint8Array]", pe = "[object Uint8ClampedArray]", Qe = "[object Uint16Array]", ot = "[object Uint32Array]", Mt = /[\\^$.*+?()[\]{}|]/g, q = /\w*$/, B = /^\[object .+?Constructor\]$/, ae = /^(?:0|[1-9]\d*)$/, re = {};
  re[r] = re[s] = re[V] = re[K] = re[l] = re[a] = re[U] = re[he] = re[se] = re[F] = re[$] = re[f] = re[I] = re[z] = re[Q] = re[H] = re[ee] = re[j] = re[oe] = re[pe] = re[Qe] = re[ot] = !0, re[u] = re[g] = re[G] = !1;
  var de = typeof {} == "object" && {} && {}.Object === Object && {}, ke = typeof self == "object" && self && self.Object === Object && self, ce = de || ke || Function("return this")(), O = t && !t.nodeType && t, ge = O && !0 && e && !e.nodeType && e, At = ge && ge.exports === O;
  function Ut(y, w) {
    return y.set(w[0], w[1]), y;
  }
  function Ht(y, w) {
    return y.add(w), y;
  }
  function Ft(y, w) {
    for (var S = -1, J = y ? y.length : 0; ++S < J && w(y[S], S, y) !== !1; )
      ;
    return y;
  }
  function He(y, w) {
    for (var S = -1, J = w.length, Oe = y.length; ++S < J; )
      y[Oe + S] = w[S];
    return y;
  }
  function Je(y, w, S, J) {
    var Oe = -1, Ge = y ? y.length : 0;
    for (J && Ge && (S = y[++Oe]); ++Oe < Ge; )
      S = w(S, y[Oe], Oe, y);
    return S;
  }
  function Ie(y, w) {
    for (var S = -1, J = Array(y); ++S < y; )
      J[S] = w(S);
    return J;
  }
  function un(y, w) {
    return y == null ? void 0 : y[w];
  }
  function Nt(y) {
    var w = !1;
    if (y != null && typeof y.toString != "function")
      try {
        w = !!(y + "");
      } catch {
      }
    return w;
  }
  function $t(y) {
    var w = -1, S = Array(y.size);
    return y.forEach(function(J, Oe) {
      S[++w] = [Oe, J];
    }), S;
  }
  function jt(y, w) {
    return function(S) {
      return y(w(S));
    };
  }
  function dn(y) {
    var w = -1, S = Array(y.size);
    return y.forEach(function(J) {
      S[++w] = J;
    }), S;
  }
  var $n = Array.prototype, Oo = Function.prototype, St = Object.prototype, bt = ce["__core-js_shared__"], Ct = function() {
    var y = /[^.]+$/.exec(bt && bt.keys && bt.keys.IE_PROTO || "");
    return y ? "Symbol(src)_1." + y : "";
  }(), wt = Oo.toString, ut = St.hasOwnProperty, Rt = St.toString, Rn = RegExp(
    "^" + wt.call(ut).replace(Mt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Jt = At ? ce.Buffer : void 0, gn = ce.Symbol, Vt = ce.Uint8Array, Kt = jt(Object.getPrototypeOf, Object), dt = Object.create, Lt = St.propertyIsEnumerable, pn = $n.splice, qt = Object.getOwnPropertySymbols, xo = Jt ? Jt.isBuffer : void 0, Dt = jt(Object.keys, Object), mn = tn(ce, "DataView"), Bt = tn(ce, "Map"), we = tn(ce, "Promise"), pt = tn(ce, "Set"), hn = tn(ce, "WeakMap"), Et = tn(Object, "create"), fn = Pt(mn), Vn = Pt(Bt), Bn = Pt(we), _o = Pt(pt), Xt = Pt(hn), en = gn ? gn.prototype : void 0, Yn = en ? en.valueOf : void 0;
  function Pe(y) {
    var w = -1, S = y ? y.length : 0;
    for (this.clear(); ++w < S; ) {
      var J = y[w];
      this.set(J[0], J[1]);
    }
  }
  function yn() {
    this.__data__ = Et ? Et(null) : {};
  }
  function Qn(y) {
    return this.has(y) && delete this.__data__[y];
  }
  function Pn(y) {
    var w = this.__data__;
    if (Et) {
      var S = w[y];
      return S === o ? void 0 : S;
    }
    return ut.call(w, y) ? w[y] : void 0;
  }
  function Uo(y) {
    var w = this.__data__;
    return Et ? w[y] !== void 0 : ut.call(w, y);
  }
  function Gn(y, w) {
    var S = this.__data__;
    return S[y] = Et && w === void 0 ? o : w, this;
  }
  Pe.prototype.clear = yn, Pe.prototype.delete = Qn, Pe.prototype.get = Pn, Pe.prototype.has = Uo, Pe.prototype.set = Gn;
  function je(y) {
    var w = -1, S = y ? y.length : 0;
    for (this.clear(); ++w < S; ) {
      var J = y[w];
      this.set(J[0], J[1]);
    }
  }
  function Zn() {
    this.__data__ = [];
  }
  function Wn(y) {
    var w = this.__data__, S = Xn(w, y);
    if (S < 0)
      return !1;
    var J = w.length - 1;
    return S == J ? w.pop() : pn.call(w, S, 1), !0;
  }
  function Hn(y) {
    var w = this.__data__, S = Xn(w, y);
    return S < 0 ? void 0 : w[S][1];
  }
  function Jn(y) {
    return Xn(this.__data__, y) > -1;
  }
  function Fo(y, w) {
    var S = this.__data__, J = Xn(S, y);
    return J < 0 ? S.push([y, w]) : S[J][1] = w, this;
  }
  je.prototype.clear = Zn, je.prototype.delete = Wn, je.prototype.get = Hn, je.prototype.has = Jn, je.prototype.set = Fo;
  function Z(y) {
    var w = -1, S = y ? y.length : 0;
    for (this.clear(); ++w < S; ) {
      var J = y[w];
      this.set(J[0], J[1]);
    }
  }
  function b() {
    this.__data__ = {
      hash: new Pe(),
      map: new (Bt || je)(),
      string: new Pe()
    };
  }
  function E(y) {
    return eo(this, y).delete(y);
  }
  function W(y) {
    return eo(this, y).get(y);
  }
  function me(y) {
    return eo(this, y).has(y);
  }
  function Ee(y, w) {
    return eo(this, y).set(y, w), this;
  }
  Z.prototype.clear = b, Z.prototype.delete = E, Z.prototype.get = W, Z.prototype.has = me, Z.prototype.set = Ee;
  function Me(y) {
    this.__data__ = new je(y);
  }
  function Re() {
    this.__data__ = new je();
  }
  function zt(y) {
    return this.__data__.delete(y);
  }
  function Yt(y) {
    return this.__data__.get(y);
  }
  function Ve(y) {
    return this.__data__.has(y);
  }
  function Kn(y, w) {
    var S = this.__data__;
    if (S instanceof je) {
      var J = S.__data__;
      if (!Bt || J.length < n - 1)
        return J.push([y, w]), this;
      S = this.__data__ = new Z(J);
    }
    return S.set(y, w), this;
  }
  Me.prototype.clear = Re, Me.prototype.delete = zt, Me.prototype.get = Yt, Me.prototype.has = Ve, Me.prototype.set = Kn;
  function qn(y, w) {
    var S = Vo(y) || za(y) ? Ie(y.length, String) : [], J = S.length, Oe = !!J;
    for (var Ge in y)
      (w || ut.call(y, Ge)) && !(Oe && (Ge == "length" || ba(Ge, J))) && S.push(Ge);
    return S;
  }
  function Ri(y, w, S) {
    var J = y[w];
    (!(ut.call(y, w) && Qi(J, S)) || S === void 0 && !(w in y)) && (y[w] = S);
  }
  function Xn(y, w) {
    for (var S = y.length; S--; )
      if (Qi(y[S][0], w))
        return S;
    return -1;
  }
  function oa(y, w) {
    return y && Vi(w, Bo(w), y);
  }
  function $o(y, w, S, J, Oe, Ge, it) {
    var Ke;
    if (J && (Ke = Ge ? J(y, Oe, Ge, it) : J(y)), Ke !== void 0)
      return Ke;
    if (!to(y))
      return y;
    var Zi = Vo(y);
    if (Zi) {
      if (Ke = Ma(y), !w)
        return fa(y, Ke);
    } else {
      var nn = Qt(y), Wi = nn == g || nn == d;
      if (Ta(y))
        return ca(y, w);
      if (nn == z || nn == r || Wi && !Ge) {
        if (Nt(y))
          return Ge ? y : {};
        if (Ke = Aa(Wi ? {} : y), !w)
          return ya(y, oa(Ke, y));
      } else {
        if (!re[nn])
          return Ge ? y : {};
        Ke = Na(y, nn, $o, w);
      }
    }
    it || (it = new Me());
    var Hi = it.get(y);
    if (Hi)
      return Hi;
    if (it.set(y, Ke), !Zi)
      var Ji = S ? Ia(y) : Bo(y);
    return Ft(Ji || y, function(Yo, no) {
      Ji && (no = Yo, Yo = y[no]), Ri(Ke, no, $o(Yo, w, S, J, no, y, it));
    }), Ke;
  }
  function ia(y) {
    return to(y) ? dt(y) : {};
  }
  function sa(y, w, S) {
    var J = w(y);
    return Vo(y) ? J : He(J, S(y));
  }
  function ra(y) {
    return Rt.call(y);
  }
  function aa(y) {
    if (!to(y) || wa(y))
      return !1;
    var w = Gi(y) || Nt(y) ? Rn : B;
    return w.test(Pt(y));
  }
  function la(y) {
    if (!Yi(y))
      return Dt(y);
    var w = [];
    for (var S in Object(y))
      ut.call(y, S) && S != "constructor" && w.push(S);
    return w;
  }
  function ca(y, w) {
    if (w)
      return y.slice();
    var S = new y.constructor(y.length);
    return y.copy(S), S;
  }
  function Ro(y) {
    var w = new y.constructor(y.byteLength);
    return new Vt(w).set(new Vt(y)), w;
  }
  function ua(y, w) {
    var S = w ? Ro(y.buffer) : y.buffer;
    return new y.constructor(S, y.byteOffset, y.byteLength);
  }
  function da(y, w, S) {
    var J = w ? S($t(y), !0) : $t(y);
    return Je(J, Ut, new y.constructor());
  }
  function ga(y) {
    var w = new y.constructor(y.source, q.exec(y));
    return w.lastIndex = y.lastIndex, w;
  }
  function pa(y, w, S) {
    var J = w ? S(dn(y), !0) : dn(y);
    return Je(J, Ht, new y.constructor());
  }
  function ma(y) {
    return Yn ? Object(Yn.call(y)) : {};
  }
  function ha(y, w) {
    var S = w ? Ro(y.buffer) : y.buffer;
    return new y.constructor(S, y.byteOffset, y.length);
  }
  function fa(y, w) {
    var S = -1, J = y.length;
    for (w || (w = Array(J)); ++S < J; )
      w[S] = y[S];
    return w;
  }
  function Vi(y, w, S, J) {
    S || (S = {});
    for (var Oe = -1, Ge = w.length; ++Oe < Ge; ) {
      var it = w[Oe], Ke = J ? J(S[it], y[it], it, S, y) : void 0;
      Ri(S, it, Ke === void 0 ? y[it] : Ke);
    }
    return S;
  }
  function ya(y, w) {
    return Vi(y, Bi(y), w);
  }
  function Ia(y) {
    return sa(y, Bo, Bi);
  }
  function eo(y, w) {
    var S = y.__data__;
    return Ca(w) ? S[typeof w == "string" ? "string" : "hash"] : S.map;
  }
  function tn(y, w) {
    var S = un(y, w);
    return aa(S) ? S : void 0;
  }
  var Bi = qt ? jt(qt, Object) : Sa, Qt = ra;
  (mn && Qt(new mn(new ArrayBuffer(1))) != K || Bt && Qt(new Bt()) != f || we && Qt(we.resolve()) != v || pt && Qt(new pt()) != H || hn && Qt(new hn()) != G) && (Qt = function(y) {
    var w = Rt.call(y), S = w == z ? y.constructor : void 0, J = S ? Pt(S) : void 0;
    if (J)
      switch (J) {
        case fn:
          return K;
        case Vn:
          return f;
        case Bn:
          return v;
        case _o:
          return H;
        case Xt:
          return G;
      }
    return w;
  });
  function Ma(y) {
    var w = y.length, S = y.constructor(w);
    return w && typeof y[0] == "string" && ut.call(y, "index") && (S.index = y.index, S.input = y.input), S;
  }
  function Aa(y) {
    return typeof y.constructor == "function" && !Yi(y) ? ia(Kt(y)) : {};
  }
  function Na(y, w, S, J) {
    var Oe = y.constructor;
    switch (w) {
      case V:
        return Ro(y);
      case l:
      case a:
        return new Oe(+y);
      case K:
        return ua(y, J);
      case U:
      case he:
      case se:
      case F:
      case $:
      case oe:
      case pe:
      case Qe:
      case ot:
        return ha(y, J);
      case f:
        return da(y, J, S);
      case I:
      case ee:
        return new Oe(y);
      case Q:
        return ga(y);
      case H:
        return pa(y, J, S);
      case j:
        return ma(y);
    }
  }
  function ba(y, w) {
    return w = w ?? i, !!w && (typeof y == "number" || ae.test(y)) && y > -1 && y % 1 == 0 && y < w;
  }
  function Ca(y) {
    var w = typeof y;
    return w == "string" || w == "number" || w == "symbol" || w == "boolean" ? y !== "__proto__" : y === null;
  }
  function wa(y) {
    return !!Ct && Ct in y;
  }
  function Yi(y) {
    var w = y && y.constructor, S = typeof w == "function" && w.prototype || St;
    return y === S;
  }
  function Pt(y) {
    if (y != null) {
      try {
        return wt.call(y);
      } catch {
      }
      try {
        return y + "";
      } catch {
      }
    }
    return "";
  }
  function Da(y) {
    return $o(y, !0, !0);
  }
  function Qi(y, w) {
    return y === w || y !== y && w !== w;
  }
  function za(y) {
    return va(y) && ut.call(y, "callee") && (!Lt.call(y, "callee") || Rt.call(y) == r);
  }
  var Vo = Array.isArray;
  function Pi(y) {
    return y != null && ka(y.length) && !Gi(y);
  }
  function va(y) {
    return ja(y) && Pi(y);
  }
  var Ta = xo || La;
  function Gi(y) {
    var w = to(y) ? Rt.call(y) : "";
    return w == g || w == d;
  }
  function ka(y) {
    return typeof y == "number" && y > -1 && y % 1 == 0 && y <= i;
  }
  function to(y) {
    var w = typeof y;
    return !!y && (w == "object" || w == "function");
  }
  function ja(y) {
    return !!y && typeof y == "object";
  }
  function Bo(y) {
    return Pi(y) ? qn(y) : la(y);
  }
  function Sa() {
    return [];
  }
  function La() {
    return !1;
  }
  e.exports = Da;
})(fo, fo.exports);
var qa = fo.exports;
const Ai = /* @__PURE__ */ Mi(qa), Xa = {
  /**
   * APP
   */
  // TODO REMOVE FROM MODULE
  version: "2.0.0",
  latestVersion: "",
  init: !1,
  /**
   * AUTH
   */
  accessToken: null,
  refreshToken: null,
  accessExpirationDate: 0,
  authIsLoading: !1,
  ssoIsLoading: !1,
  loggedIn: !1,
  status: null,
  loginMethod: null,
  loginCount: 0,
  /**
   * WEBSOCKET
   */
  websocketUrl: null,
  websocketGroups: [],
  /**
   * USER
   */
  userId: null,
  username: "",
  preferences: [],
  userPermissions: [],
  /**
   * COMPANY
   */
  company: {
    logo: null,
    preferences: [],
    integrations: [],
    reachableUsers: [],
    reachableRoles: [],
    subdomain: null
  },
  companyDomain: null,
  /**
   * RECOMMENDATIONS
   */
  focusedTicket: null,
  recommendations: [],
  ticketContext: null,
  askIsLoading: !1
};
function os() {
  return Ai(Xa);
}
const ft = Wt(ze.ADMIN, {
  state: os,
  getters: { ...Ka },
  actions: {
    mutate(e) {
      this.$patch((t) => {
        Object.keys(e).forEach((n) => {
          t[n] = e[n];
        });
      });
    },
    // patch object will not be synced
    unsyncedMutate(e) {
      this.$patch(e);
    },
    async reset() {
      await this.logLogout();
      const { companyDomain: e, loginCount: t, ...n } = os();
      this.mutate(n);
    },
    async logs(e, t) {
      this.$logs(e, t);
    },
    logLoginSuccess() {
      this.logs({
        topic: "APP_LOGIN_SUCCESS",
        event: {
          method: this.loginMethod
        },
        url: window.location.href
      });
    },
    async logLogout() {
      this.accessToken && this.logs({
        topic: "APP_LOGOUT",
        event: {},
        url: window.location.href
      });
    },
    logMeIn() {
      this.mutate({ loggedIn: !0 });
    },
    init() {
      this.mutate({ init: !0 });
    },
    async userLogin(e) {
      this.mutate({ authIsLoading: !0 });
      try {
        const t = await this.$adminService.login(e);
        if (!t)
          return this.mutate({ status: "AUTHENTICATION_ERROR" });
        const { accessToken: n, refreshToken: o, accessExpirationDate: i } = t;
        return this.initSessionFromToken({
          accessToken: n,
          refreshToken: o,
          accessExpirationDate: i
        });
      } catch (t) {
        let n = 400;
        try {
          n = t.response.status;
        } finally {
          this.mutate({ status: n });
        }
      } finally {
        this.mutate({ authIsLoading: !1 });
      }
    },
    async initSessionFromToken({
      accessToken: e,
      refreshToken: t,
      accessExpirationDate: n,
      isRefresh: o = !1,
      logEvent: i = !0
    }) {
      try {
        const r = await this.$adminService.loginFromToken(e), { user: s } = r;
        if (!s)
          return this.mutate({ status: "AUTHENTICATION_ERROR" });
        const { isVerified: l, auth: a } = s;
        if (!l)
          return this.mutate({
            accessToken: null,
            refreshToken: null,
            accessExpirationDate: null
          });
        const { websocketData: u } = a;
        return this.mutate({
          accessToken: e,
          refreshToken: t,
          accessExpirationDate: n,
          websocketUrl: u.connectionUrl,
          websocketGroups: u.connectionGroups
        }), this.storeAccountData(s), !o && i && (this.logLoginSuccess(), this.incrementLoginCount()), {
          loginData: s,
          accessToken: e
        };
      } catch (r) {
        let s = 400;
        try {
          s = r.response.data.code;
        } finally {
          this.mutate({ status: s });
        }
      } finally {
        this.mutate({ authIsLoading: !1 });
      }
    },
    async loginFromOboToken(e) {
      this.mutate({ authIsLoading: !0, loginMethod: "OBO_TOKEN" });
      try {
        const t = await this.$adminService.loginFromOboToken(e);
        if (!t)
          return this.mutate({ status: "AUTHENTICATION_ERROR" });
        const { accessToken: n, refreshToken: o, accessExpirationDate: i } = t;
        return this.initSessionFromToken({
          accessToken: n,
          refreshToken: o,
          accessExpirationDate: i
        });
      } catch (t) {
        let n = 400;
        try {
          n = t.response.status;
        } finally {
          this.mutate({ status: n });
        }
      } finally {
        this.mutate({ authIsLoading: !1 });
      }
    },
    incrementLoginCount() {
      this.mutate({ loginCount: this.loginCount + 1 });
    },
    storeAccountData(e) {
      this.mutate(e), this.mutate({ userId: e.id });
    },
    startSsoLoading() {
      this.mutate({ ssoIsLoading: !0 }), setTimeout(() => {
        this.mutate({ ssoIsLoading: !1 });
      }, 3e4);
    },
    verifyCompanyDomain(e) {
      return this.$adminService.verifyDomain(e);
    },
    storeCompanyDomain(e) {
      this.mutate({ companyDomain: e });
    },
    async addPreference(e) {
      const t = await this.$adminService.addPreference(e);
      this.mutate({ preferences: t });
    },
    async removePreference(e) {
      const t = await this.$adminService.removePreference(e);
      this.mutate({ preferences: t });
    },
    async updatePreference(e, t) {
      if (!this.accessToken)
        return;
      const n = t === !0 ? "1" : t === !1 ? "0" : t, o = {
        preference: {
          type: e,
          value: n
        }
      };
      if (t)
        await this.addPreference({
          preferenceType: e,
          preferenceValue: n
        }), this.logs({
          topic: "SETTINGS_ADD",
          event: o,
          url: window.location.href
        });
      else {
        const i = this.preferences.find(
          ({ preference: r }) => r === e
        );
        i && (await this.removePreference(i.id), this.logs({
          topic: "SETTINGS_REMOVE",
          event: o,
          url: window.location.href
        }));
      }
    },
    async refreshRoles() {
      if (!this.accessToken)
        return;
      const t = (await this.$adminService.loginFromToken(this.accessToken)).user.company;
      this.mutate({ company: t });
    },
    // URL BLACKLIST
    async addUrlToBlacklist(e) {
      var t;
      if (this.urlBlacklistUserPreference) {
        const n = this.urlBlacklistUserPreference.split(`
`);
        if (this.urlBlacklistCompanyPreference && ((t = this.urlBlacklistCompanyPreference) == null ? void 0 : t.split(`
`)).findIndex((s) => s === e) > -1 || n.findIndex((i) => i === e) > -1)
          return;
        n.push(e), await this.updatePreference("WEB_EXT_URL_BLACKLIST", n.join(`
`));
      } else
        await this.updatePreference("WEB_EXT_URL_BLACKLIST", e);
    },
    async removeUrlFromBlacklist(e) {
      if (this.urlBlacklistUserPreference) {
        const t = this.urlBlacklistUserPreference.split(`
`), n = t.findIndex((o) => o === e);
        if (n === -1)
          return;
        t.splice(n, 1), await this.updatePreference(
          "WEB_EXT_URL_BLACKLIST",
          t.length ? t.join(`
`) : !1
        );
      }
    },
    // APP POSITION
    getAppPositionByHostname(e) {
      return JSON.parse(this.appPositionByHostname || "{}")[e];
    },
    updateAppPosition(e, t) {
      if (this.appPositionByHostname) {
        const n = Object.assign({}, JSON.parse(this.appPositionByHostname), {
          [t]: e
        });
        this.updatePreference("WEB_EXT_POSITION_BY_HOSTNAME", JSON.stringify(n));
      } else
        this.updatePreference(
          "WEB_EXT_POSITION_BY_HOSTNAME",
          JSON.stringify({ [t]: e })
        );
    },
    removeAppPositionByHostname(e) {
      if (this.appPositionByHostname) {
        const t = Object.assign({}, JSON.parse(this.appPositionByHostname));
        delete t[e], this.updatePreference("WEB_EXT_POSITION_BY_HOSTNAME", JSON.stringify(t));
      }
    },
    // RECOMMENDATIONS
    updateRecommendations(e) {
      this.unsyncedMutate({ recommendations: e });
    },
    updateTicketContext(e) {
      this.unsyncedMutate({ ticketContext: e });
    },
    async getRecommendations({
      tabSource: e,
      conversationId: t,
      context: n,
      preferredLanguage: o
    }) {
      if (!e || !t)
        return null;
      this.unsyncedMutate({ askIsLoading: !0 });
      try {
        if (!this.companyHasIntegration(e))
          return this.unsyncedMutate({ askIsLoading: !1 }), null;
        const i = this.companyHasPreference(
          "HAS_MULTI_SALESFORCE_ACCOUNT"
        );
        let { recommendations: r, queryId: s } = await this.$adminService.getRecommendations(
          t,
          e,
          i ? n : null,
          o
        );
        r.length && this.logs({
          topic: "CONTENT_RECOMMENDATION_RECEIVE",
          event: {
            recommendations: r,
            integration: e.toUpperCase()
          }
        }), this.companyHasPreference("WEB_EXT_MERGE_RECOMMENDATIONS") && (r = r.reduce(
          (a, u) => (a.find((g) => g.treeNodeId === u.treeNodeId) || a.push(u), a),
          []
        )), s ? (this.unsyncedMutate({
          recommendations: r,
          focusedTicket: t
        }), setTimeout(() => {
          this.unsyncedMutate({
            askIsLoading: !1
          });
        }, 3e4), await this.getBrainRecommendations(s, t, e)) : this.unsyncedMutate({
          recommendations: r,
          askIsLoading: !1
        });
        return;
      } catch (i) {
        console.error(i), this.unsyncedMutate({
          askIsLoading: !1
        });
      }
    },
    async getBrainRecommendations(e, t, n) {
      var o;
      if (!(!t || t !== this.focusedTicket))
        try {
          const { status: i, recommendations: r, ticketContext: s } = await this.$adminService.getBrainRecommendations(e);
          i === "DONE" ? this.unsyncedMutate({
            recommendations: [
              ...this.recommendations,
              ...r.filter(
                (l) => !this.recommendations.find((a) => a.treeNodeId === l.treeNodeId)
              ).slice(0, 3)
            ],
            ticketContext: { ...s, source: (o = this.ticketContext) == null ? void 0 : o.source },
            askIsLoading: !1
          }) : i === "PENDING" ? setTimeout(() => this.getBrainRecommendations(e, t, n), 1e3) : this.unsyncedMutate({
            askIsLoading: !1
          });
        } catch {
          this.unsyncedMutate({ askIsLoading: !1 });
        }
    },
    updateAskLoading(e) {
      this.unsyncedMutate({ askIsLoading: e });
    },
    resetStatus() {
      this.mutate({ status: null });
    },
    setStatus(e) {
      this.mutate({ status: e });
    },
    setAppVersion(e, t) {
      this.mutate({ version: e, latestVersion: t });
    },
    setLoginMethod(e) {
      this.mutate({ loginMethod: e });
    },
    async handleFetchInlineMention({
      entityId: e,
      entityType: t
    }) {
      if (t === "User") {
        const o = (await this.$adminService.getUsers([e]))[0];
        if (!o)
          return null;
        const { username: i, isDeleted: r } = o;
        return {
          entityId: e,
          entityType: t,
          label: i,
          isDeleted: r
        };
      }
      return null;
    }
  },
  blacklist: ["ticketContext", "recommendations", "askIsLoading", "focusedTicket"],
  persist: {
    key: `md-${ze.ADMIN}`
  },
  share: {
    enable: !1
  }
});
function el(e) {
  return "data" in e;
}
const Ne = (e) => el(e) ? e.data : e;
async function Vs(e, t) {
  const n = new URLSearchParams();
  return t && t.length && t.forEach((o) => n.append("userIds[]", o)), e.get(`users-or-deleted-users?${n.toString()}`).then((o) => Ne(o));
}
var ht = [], rt = [], tl = typeof Uint8Array < "u" ? Uint8Array : Array, Ni = !1;
function Bs() {
  Ni = !0;
  for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t = 0, n = e.length; t < n; ++t)
    ht[t] = e[t], rt[e.charCodeAt(t)] = t;
  rt["-".charCodeAt(0)] = 62, rt["_".charCodeAt(0)] = 63;
}
function nl(e) {
  Ni || Bs();
  var t, n, o, i, r, s, l = e.length;
  if (l % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  r = e[l - 2] === "=" ? 2 : e[l - 1] === "=" ? 1 : 0, s = new tl(l * 3 / 4 - r), o = r > 0 ? l - 4 : l;
  var a = 0;
  for (t = 0, n = 0; t < o; t += 4, n += 3)
    i = rt[e.charCodeAt(t)] << 18 | rt[e.charCodeAt(t + 1)] << 12 | rt[e.charCodeAt(t + 2)] << 6 | rt[e.charCodeAt(t + 3)], s[a++] = i >> 16 & 255, s[a++] = i >> 8 & 255, s[a++] = i & 255;
  return r === 2 ? (i = rt[e.charCodeAt(t)] << 2 | rt[e.charCodeAt(t + 1)] >> 4, s[a++] = i & 255) : r === 1 && (i = rt[e.charCodeAt(t)] << 10 | rt[e.charCodeAt(t + 1)] << 4 | rt[e.charCodeAt(t + 2)] >> 2, s[a++] = i >> 8 & 255, s[a++] = i & 255), s;
}
function ol(e) {
  return ht[e >> 18 & 63] + ht[e >> 12 & 63] + ht[e >> 6 & 63] + ht[e & 63];
}
function il(e, t, n) {
  for (var o, i = [], r = t; r < n; r += 3)
    o = (e[r] << 16) + (e[r + 1] << 8) + e[r + 2], i.push(ol(o));
  return i.join("");
}
function is(e) {
  Ni || Bs();
  for (var t, n = e.length, o = n % 3, i = "", r = [], s = 16383, l = 0, a = n - o; l < a; l += s)
    r.push(il(e, l, l + s > a ? a : l + s));
  return o === 1 ? (t = e[n - 1], i += ht[t >> 2], i += ht[t << 4 & 63], i += "==") : o === 2 && (t = (e[n - 2] << 8) + e[n - 1], i += ht[t >> 10], i += ht[t >> 4 & 63], i += ht[t << 2 & 63], i += "="), r.push(i), r.join("");
}
function Do(e, t, n, o, i) {
  var r, s, l = i * 8 - o - 1, a = (1 << l) - 1, u = a >> 1, g = -7, d = n ? i - 1 : 0, f = n ? -1 : 1, I = e[t + d];
  for (d += f, r = I & (1 << -g) - 1, I >>= -g, g += l; g > 0; r = r * 256 + e[t + d], d += f, g -= 8)
    ;
  for (s = r & (1 << -g) - 1, r >>= -g, g += o; g > 0; s = s * 256 + e[t + d], d += f, g -= 8)
    ;
  if (r === 0)
    r = 1 - u;
  else {
    if (r === a)
      return s ? NaN : (I ? -1 : 1) * (1 / 0);
    s = s + Math.pow(2, o), r = r - u;
  }
  return (I ? -1 : 1) * s * Math.pow(2, r - o);
}
function Ys(e, t, n, o, i, r) {
  var s, l, a, u = r * 8 - i - 1, g = (1 << u) - 1, d = g >> 1, f = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, I = o ? 0 : r - 1, z = o ? 1 : -1, v = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (l = isNaN(t) ? 1 : 0, s = g) : (s = Math.floor(Math.log(t) / Math.LN2), t * (a = Math.pow(2, -s)) < 1 && (s--, a *= 2), s + d >= 1 ? t += f / a : t += f * Math.pow(2, 1 - d), t * a >= 2 && (s++, a /= 2), s + d >= g ? (l = 0, s = g) : s + d >= 1 ? (l = (t * a - 1) * Math.pow(2, i), s = s + d) : (l = t * Math.pow(2, d - 1) * Math.pow(2, i), s = 0)); i >= 8; e[n + I] = l & 255, I += z, l /= 256, i -= 8)
    ;
  for (s = s << i | l, u += i; u > 0; e[n + I] = s & 255, I += z, s /= 256, u -= 8)
    ;
  e[n + I - z] |= v * 128;
}
var sl = {}.toString, Qs = Array.isArray || function(e) {
  return sl.call(e) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var rl = 50;
L.TYPED_ARRAY_SUPPORT = {}.TYPED_ARRAY_SUPPORT !== void 0 ? {}.TYPED_ARRAY_SUPPORT : !0;
yo();
function yo() {
  return L.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function vt(e, t) {
  if (yo() < t)
    throw new RangeError("Invalid typed array length");
  return L.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t), e.__proto__ = L.prototype) : (e === null && (e = new L(t)), e.length = t), e;
}
function L(e, t, n) {
  if (!L.TYPED_ARRAY_SUPPORT && !(this instanceof L))
    return new L(e, t, n);
  if (typeof e == "number") {
    if (typeof t == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return bi(this, e);
  }
  return Ps(this, e, t, n);
}
L.poolSize = 8192;
L._augment = function(e) {
  return e.__proto__ = L.prototype, e;
};
function Ps(e, t, n, o) {
  if (typeof t == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && t instanceof ArrayBuffer ? cl(e, t, n, o) : typeof t == "string" ? ll(e, t, n) : ul(e, t);
}
L.from = function(e, t, n) {
  return Ps(null, e, t, n);
};
L.TYPED_ARRAY_SUPPORT && (L.prototype.__proto__ = Uint8Array.prototype, L.__proto__ = Uint8Array);
function Gs(e) {
  if (typeof e != "number")
    throw new TypeError('"size" argument must be a number');
  if (e < 0)
    throw new RangeError('"size" argument must not be negative');
}
function al(e, t, n, o) {
  return Gs(t), t <= 0 ? vt(e, t) : n !== void 0 ? typeof o == "string" ? vt(e, t).fill(n, o) : vt(e, t).fill(n) : vt(e, t);
}
L.alloc = function(e, t, n) {
  return al(null, e, t, n);
};
function bi(e, t) {
  if (Gs(t), e = vt(e, t < 0 ? 0 : Ci(t) | 0), !L.TYPED_ARRAY_SUPPORT)
    for (var n = 0; n < t; ++n)
      e[n] = 0;
  return e;
}
L.allocUnsafe = function(e) {
  return bi(null, e);
};
L.allocUnsafeSlow = function(e) {
  return bi(null, e);
};
function ll(e, t, n) {
  if ((typeof n != "string" || n === "") && (n = "utf8"), !L.isEncoding(n))
    throw new TypeError('"encoding" must be a valid string encoding');
  var o = Zs(t, n) | 0;
  e = vt(e, o);
  var i = e.write(t, n);
  return i !== o && (e = e.slice(0, i)), e;
}
function ui(e, t) {
  var n = t.length < 0 ? 0 : Ci(t.length) | 0;
  e = vt(e, n);
  for (var o = 0; o < n; o += 1)
    e[o] = t[o] & 255;
  return e;
}
function cl(e, t, n, o) {
  if (t.byteLength, n < 0 || t.byteLength < n)
    throw new RangeError("'offset' is out of bounds");
  if (t.byteLength < n + (o || 0))
    throw new RangeError("'length' is out of bounds");
  return n === void 0 && o === void 0 ? t = new Uint8Array(t) : o === void 0 ? t = new Uint8Array(t, n) : t = new Uint8Array(t, n, o), L.TYPED_ARRAY_SUPPORT ? (e = t, e.__proto__ = L.prototype) : e = ui(e, t), e;
}
function ul(e, t) {
  if (yt(t)) {
    var n = Ci(t.length) | 0;
    return e = vt(e, n), e.length === 0 || t.copy(e, 0, 0, n), e;
  }
  if (t) {
    if (typeof ArrayBuffer < "u" && t.buffer instanceof ArrayBuffer || "length" in t)
      return typeof t.length != "number" || kl(t.length) ? vt(e, 0) : ui(e, t);
    if (t.type === "Buffer" && Qs(t.data))
      return ui(e, t.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function Ci(e) {
  if (e >= yo())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + yo().toString(16) + " bytes");
  return e | 0;
}
L.isBuffer = jl;
function yt(e) {
  return !!(e != null && e._isBuffer);
}
L.compare = function(t, n) {
  if (!yt(t) || !yt(n))
    throw new TypeError("Arguments must be Buffers");
  if (t === n)
    return 0;
  for (var o = t.length, i = n.length, r = 0, s = Math.min(o, i); r < s; ++r)
    if (t[r] !== n[r]) {
      o = t[r], i = n[r];
      break;
    }
  return o < i ? -1 : i < o ? 1 : 0;
};
L.isEncoding = function(t) {
  switch (String(t).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
L.concat = function(t, n) {
  if (!Qs(t))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (t.length === 0)
    return L.alloc(0);
  var o;
  if (n === void 0)
    for (n = 0, o = 0; o < t.length; ++o)
      n += t[o].length;
  var i = L.allocUnsafe(n), r = 0;
  for (o = 0; o < t.length; ++o) {
    var s = t[o];
    if (!yt(s))
      throw new TypeError('"list" argument must be an Array of Buffers');
    s.copy(i, r), r += s.length;
  }
  return i;
};
function Zs(e, t) {
  if (yt(e))
    return e.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer))
    return e.byteLength;
  typeof e != "string" && (e = "" + e);
  var n = e.length;
  if (n === 0)
    return 0;
  for (var o = !1; ; )
    switch (t) {
      case "ascii":
      case "latin1":
      case "binary":
        return n;
      case "utf8":
      case "utf-8":
      case void 0:
        return Io(e).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return n * 2;
      case "hex":
        return n >>> 1;
      case "base64":
        return er(e).length;
      default:
        if (o)
          return Io(e).length;
        t = ("" + t).toLowerCase(), o = !0;
    }
}
L.byteLength = Zs;
function dl(e, t, n) {
  var o = !1;
  if ((t === void 0 || t < 0) && (t = 0), t > this.length || ((n === void 0 || n > this.length) && (n = this.length), n <= 0) || (n >>>= 0, t >>>= 0, n <= t))
    return "";
  for (e || (e = "utf8"); ; )
    switch (e) {
      case "hex":
        return Nl(this, t, n);
      case "utf8":
      case "utf-8":
        return Js(this, t, n);
      case "ascii":
        return Ml(this, t, n);
      case "latin1":
      case "binary":
        return Al(this, t, n);
      case "base64":
        return yl(this, t, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return bl(this, t, n);
      default:
        if (o)
          throw new TypeError("Unknown encoding: " + e);
        e = (e + "").toLowerCase(), o = !0;
    }
}
L.prototype._isBuffer = !0;
function Gt(e, t, n) {
  var o = e[t];
  e[t] = e[n], e[n] = o;
}
L.prototype.swap16 = function() {
  var t = this.length;
  if (t % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var n = 0; n < t; n += 2)
    Gt(this, n, n + 1);
  return this;
};
L.prototype.swap32 = function() {
  var t = this.length;
  if (t % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var n = 0; n < t; n += 4)
    Gt(this, n, n + 3), Gt(this, n + 1, n + 2);
  return this;
};
L.prototype.swap64 = function() {
  var t = this.length;
  if (t % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var n = 0; n < t; n += 8)
    Gt(this, n, n + 7), Gt(this, n + 1, n + 6), Gt(this, n + 2, n + 5), Gt(this, n + 3, n + 4);
  return this;
};
L.prototype.toString = function() {
  var t = this.length | 0;
  return t === 0 ? "" : arguments.length === 0 ? Js(this, 0, t) : dl.apply(this, arguments);
};
L.prototype.equals = function(t) {
  if (!yt(t))
    throw new TypeError("Argument must be a Buffer");
  return this === t ? !0 : L.compare(this, t) === 0;
};
L.prototype.inspect = function() {
  var t = "", n = rl;
  return this.length > 0 && (t = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (t += " ... ")), "<Buffer " + t + ">";
};
L.prototype.compare = function(t, n, o, i, r) {
  if (!yt(t))
    throw new TypeError("Argument must be a Buffer");
  if (n === void 0 && (n = 0), o === void 0 && (o = t ? t.length : 0), i === void 0 && (i = 0), r === void 0 && (r = this.length), n < 0 || o > t.length || i < 0 || r > this.length)
    throw new RangeError("out of range index");
  if (i >= r && n >= o)
    return 0;
  if (i >= r)
    return -1;
  if (n >= o)
    return 1;
  if (n >>>= 0, o >>>= 0, i >>>= 0, r >>>= 0, this === t)
    return 0;
  for (var s = r - i, l = o - n, a = Math.min(s, l), u = this.slice(i, r), g = t.slice(n, o), d = 0; d < a; ++d)
    if (u[d] !== g[d]) {
      s = u[d], l = g[d];
      break;
    }
  return s < l ? -1 : l < s ? 1 : 0;
};
function Ws(e, t, n, o, i) {
  if (e.length === 0)
    return -1;
  if (typeof n == "string" ? (o = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
    if (i)
      return -1;
    n = e.length - 1;
  } else if (n < 0)
    if (i)
      n = 0;
    else
      return -1;
  if (typeof t == "string" && (t = L.from(t, o)), yt(t))
    return t.length === 0 ? -1 : ss(e, t, n, o, i);
  if (typeof t == "number")
    return t = t & 255, L.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? i ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : ss(e, [t], n, o, i);
  throw new TypeError("val must be string, number or Buffer");
}
function ss(e, t, n, o, i) {
  var r = 1, s = e.length, l = t.length;
  if (o !== void 0 && (o = String(o).toLowerCase(), o === "ucs2" || o === "ucs-2" || o === "utf16le" || o === "utf-16le")) {
    if (e.length < 2 || t.length < 2)
      return -1;
    r = 2, s /= 2, l /= 2, n /= 2;
  }
  function a(I, z) {
    return r === 1 ? I[z] : I.readUInt16BE(z * r);
  }
  var u;
  if (i) {
    var g = -1;
    for (u = n; u < s; u++)
      if (a(e, u) === a(t, g === -1 ? 0 : u - g)) {
        if (g === -1 && (g = u), u - g + 1 === l)
          return g * r;
      } else
        g !== -1 && (u -= u - g), g = -1;
  } else
    for (n + l > s && (n = s - l), u = n; u >= 0; u--) {
      for (var d = !0, f = 0; f < l; f++)
        if (a(e, u + f) !== a(t, f)) {
          d = !1;
          break;
        }
      if (d)
        return u;
    }
  return -1;
}
L.prototype.includes = function(t, n, o) {
  return this.indexOf(t, n, o) !== -1;
};
L.prototype.indexOf = function(t, n, o) {
  return Ws(this, t, n, o, !0);
};
L.prototype.lastIndexOf = function(t, n, o) {
  return Ws(this, t, n, o, !1);
};
function gl(e, t, n, o) {
  n = Number(n) || 0;
  var i = e.length - n;
  o ? (o = Number(o), o > i && (o = i)) : o = i;
  var r = t.length;
  if (r % 2 !== 0)
    throw new TypeError("Invalid hex string");
  o > r / 2 && (o = r / 2);
  for (var s = 0; s < o; ++s) {
    var l = parseInt(t.substr(s * 2, 2), 16);
    if (isNaN(l))
      return s;
    e[n + s] = l;
  }
  return s;
}
function pl(e, t, n, o) {
  return To(Io(t, e.length - n), e, n, o);
}
function Hs(e, t, n, o) {
  return To(vl(t), e, n, o);
}
function ml(e, t, n, o) {
  return Hs(e, t, n, o);
}
function hl(e, t, n, o) {
  return To(er(t), e, n, o);
}
function fl(e, t, n, o) {
  return To(Tl(t, e.length - n), e, n, o);
}
L.prototype.write = function(t, n, o, i) {
  if (n === void 0)
    i = "utf8", o = this.length, n = 0;
  else if (o === void 0 && typeof n == "string")
    i = n, o = this.length, n = 0;
  else if (isFinite(n))
    n = n | 0, isFinite(o) ? (o = o | 0, i === void 0 && (i = "utf8")) : (i = o, o = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var r = this.length - n;
  if ((o === void 0 || o > r) && (o = r), t.length > 0 && (o < 0 || n < 0) || n > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  i || (i = "utf8");
  for (var s = !1; ; )
    switch (i) {
      case "hex":
        return gl(this, t, n, o);
      case "utf8":
      case "utf-8":
        return pl(this, t, n, o);
      case "ascii":
        return Hs(this, t, n, o);
      case "latin1":
      case "binary":
        return ml(this, t, n, o);
      case "base64":
        return hl(this, t, n, o);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return fl(this, t, n, o);
      default:
        if (s)
          throw new TypeError("Unknown encoding: " + i);
        i = ("" + i).toLowerCase(), s = !0;
    }
};
L.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function yl(e, t, n) {
  return t === 0 && n === e.length ? is(e) : is(e.slice(t, n));
}
function Js(e, t, n) {
  n = Math.min(e.length, n);
  for (var o = [], i = t; i < n; ) {
    var r = e[i], s = null, l = r > 239 ? 4 : r > 223 ? 3 : r > 191 ? 2 : 1;
    if (i + l <= n) {
      var a, u, g, d;
      switch (l) {
        case 1:
          r < 128 && (s = r);
          break;
        case 2:
          a = e[i + 1], (a & 192) === 128 && (d = (r & 31) << 6 | a & 63, d > 127 && (s = d));
          break;
        case 3:
          a = e[i + 1], u = e[i + 2], (a & 192) === 128 && (u & 192) === 128 && (d = (r & 15) << 12 | (a & 63) << 6 | u & 63, d > 2047 && (d < 55296 || d > 57343) && (s = d));
          break;
        case 4:
          a = e[i + 1], u = e[i + 2], g = e[i + 3], (a & 192) === 128 && (u & 192) === 128 && (g & 192) === 128 && (d = (r & 15) << 18 | (a & 63) << 12 | (u & 63) << 6 | g & 63, d > 65535 && d < 1114112 && (s = d));
      }
    }
    s === null ? (s = 65533, l = 1) : s > 65535 && (s -= 65536, o.push(s >>> 10 & 1023 | 55296), s = 56320 | s & 1023), o.push(s), i += l;
  }
  return Il(o);
}
var rs = 4096;
function Il(e) {
  var t = e.length;
  if (t <= rs)
    return String.fromCharCode.apply(String, e);
  for (var n = "", o = 0; o < t; )
    n += String.fromCharCode.apply(
      String,
      e.slice(o, o += rs)
    );
  return n;
}
function Ml(e, t, n) {
  var o = "";
  n = Math.min(e.length, n);
  for (var i = t; i < n; ++i)
    o += String.fromCharCode(e[i] & 127);
  return o;
}
function Al(e, t, n) {
  var o = "";
  n = Math.min(e.length, n);
  for (var i = t; i < n; ++i)
    o += String.fromCharCode(e[i]);
  return o;
}
function Nl(e, t, n) {
  var o = e.length;
  (!t || t < 0) && (t = 0), (!n || n < 0 || n > o) && (n = o);
  for (var i = "", r = t; r < n; ++r)
    i += zl(e[r]);
  return i;
}
function bl(e, t, n) {
  for (var o = e.slice(t, n), i = "", r = 0; r < o.length; r += 2)
    i += String.fromCharCode(o[r] + o[r + 1] * 256);
  return i;
}
L.prototype.slice = function(t, n) {
  var o = this.length;
  t = ~~t, n = n === void 0 ? o : ~~n, t < 0 ? (t += o, t < 0 && (t = 0)) : t > o && (t = o), n < 0 ? (n += o, n < 0 && (n = 0)) : n > o && (n = o), n < t && (n = t);
  var i;
  if (L.TYPED_ARRAY_SUPPORT)
    i = this.subarray(t, n), i.__proto__ = L.prototype;
  else {
    var r = n - t;
    i = new L(r, void 0);
    for (var s = 0; s < r; ++s)
      i[s] = this[s + t];
  }
  return i;
};
function Ue(e, t, n) {
  if (e % 1 !== 0 || e < 0)
    throw new RangeError("offset is not uint");
  if (e + t > n)
    throw new RangeError("Trying to access beyond buffer length");
}
L.prototype.readUIntLE = function(t, n, o) {
  t = t | 0, n = n | 0, o || Ue(t, n, this.length);
  for (var i = this[t], r = 1, s = 0; ++s < n && (r *= 256); )
    i += this[t + s] * r;
  return i;
};
L.prototype.readUIntBE = function(t, n, o) {
  t = t | 0, n = n | 0, o || Ue(t, n, this.length);
  for (var i = this[t + --n], r = 1; n > 0 && (r *= 256); )
    i += this[t + --n] * r;
  return i;
};
L.prototype.readUInt8 = function(t, n) {
  return n || Ue(t, 1, this.length), this[t];
};
L.prototype.readUInt16LE = function(t, n) {
  return n || Ue(t, 2, this.length), this[t] | this[t + 1] << 8;
};
L.prototype.readUInt16BE = function(t, n) {
  return n || Ue(t, 2, this.length), this[t] << 8 | this[t + 1];
};
L.prototype.readUInt32LE = function(t, n) {
  return n || Ue(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + this[t + 3] * 16777216;
};
L.prototype.readUInt32BE = function(t, n) {
  return n || Ue(t, 4, this.length), this[t] * 16777216 + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
};
L.prototype.readIntLE = function(t, n, o) {
  t = t | 0, n = n | 0, o || Ue(t, n, this.length);
  for (var i = this[t], r = 1, s = 0; ++s < n && (r *= 256); )
    i += this[t + s] * r;
  return r *= 128, i >= r && (i -= Math.pow(2, 8 * n)), i;
};
L.prototype.readIntBE = function(t, n, o) {
  t = t | 0, n = n | 0, o || Ue(t, n, this.length);
  for (var i = n, r = 1, s = this[t + --i]; i > 0 && (r *= 256); )
    s += this[t + --i] * r;
  return r *= 128, s >= r && (s -= Math.pow(2, 8 * n)), s;
};
L.prototype.readInt8 = function(t, n) {
  return n || Ue(t, 1, this.length), this[t] & 128 ? (255 - this[t] + 1) * -1 : this[t];
};
L.prototype.readInt16LE = function(t, n) {
  n || Ue(t, 2, this.length);
  var o = this[t] | this[t + 1] << 8;
  return o & 32768 ? o | 4294901760 : o;
};
L.prototype.readInt16BE = function(t, n) {
  n || Ue(t, 2, this.length);
  var o = this[t + 1] | this[t] << 8;
  return o & 32768 ? o | 4294901760 : o;
};
L.prototype.readInt32LE = function(t, n) {
  return n || Ue(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
};
L.prototype.readInt32BE = function(t, n) {
  return n || Ue(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
};
L.prototype.readFloatLE = function(t, n) {
  return n || Ue(t, 4, this.length), Do(this, t, !0, 23, 4);
};
L.prototype.readFloatBE = function(t, n) {
  return n || Ue(t, 4, this.length), Do(this, t, !1, 23, 4);
};
L.prototype.readDoubleLE = function(t, n) {
  return n || Ue(t, 8, this.length), Do(this, t, !0, 52, 8);
};
L.prototype.readDoubleBE = function(t, n) {
  return n || Ue(t, 8, this.length), Do(this, t, !1, 52, 8);
};
function tt(e, t, n, o, i, r) {
  if (!yt(e))
    throw new TypeError('"buffer" argument must be a Buffer instance');
  if (t > i || t < r)
    throw new RangeError('"value" argument is out of bounds');
  if (n + o > e.length)
    throw new RangeError("Index out of range");
}
L.prototype.writeUIntLE = function(t, n, o, i) {
  if (t = +t, n = n | 0, o = o | 0, !i) {
    var r = Math.pow(2, 8 * o) - 1;
    tt(this, t, n, o, r, 0);
  }
  var s = 1, l = 0;
  for (this[n] = t & 255; ++l < o && (s *= 256); )
    this[n + l] = t / s & 255;
  return n + o;
};
L.prototype.writeUIntBE = function(t, n, o, i) {
  if (t = +t, n = n | 0, o = o | 0, !i) {
    var r = Math.pow(2, 8 * o) - 1;
    tt(this, t, n, o, r, 0);
  }
  var s = o - 1, l = 1;
  for (this[n + s] = t & 255; --s >= 0 && (l *= 256); )
    this[n + s] = t / l & 255;
  return n + o;
};
L.prototype.writeUInt8 = function(t, n, o) {
  return t = +t, n = n | 0, o || tt(this, t, n, 1, 255, 0), L.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[n] = t & 255, n + 1;
};
function zo(e, t, n, o) {
  t < 0 && (t = 65535 + t + 1);
  for (var i = 0, r = Math.min(e.length - n, 2); i < r; ++i)
    e[n + i] = (t & 255 << 8 * (o ? i : 1 - i)) >>> (o ? i : 1 - i) * 8;
}
L.prototype.writeUInt16LE = function(t, n, o) {
  return t = +t, n = n | 0, o || tt(this, t, n, 2, 65535, 0), L.TYPED_ARRAY_SUPPORT ? (this[n] = t & 255, this[n + 1] = t >>> 8) : zo(this, t, n, !0), n + 2;
};
L.prototype.writeUInt16BE = function(t, n, o) {
  return t = +t, n = n | 0, o || tt(this, t, n, 2, 65535, 0), L.TYPED_ARRAY_SUPPORT ? (this[n] = t >>> 8, this[n + 1] = t & 255) : zo(this, t, n, !1), n + 2;
};
function vo(e, t, n, o) {
  t < 0 && (t = 4294967295 + t + 1);
  for (var i = 0, r = Math.min(e.length - n, 4); i < r; ++i)
    e[n + i] = t >>> (o ? i : 3 - i) * 8 & 255;
}
L.prototype.writeUInt32LE = function(t, n, o) {
  return t = +t, n = n | 0, o || tt(this, t, n, 4, 4294967295, 0), L.TYPED_ARRAY_SUPPORT ? (this[n + 3] = t >>> 24, this[n + 2] = t >>> 16, this[n + 1] = t >>> 8, this[n] = t & 255) : vo(this, t, n, !0), n + 4;
};
L.prototype.writeUInt32BE = function(t, n, o) {
  return t = +t, n = n | 0, o || tt(this, t, n, 4, 4294967295, 0), L.TYPED_ARRAY_SUPPORT ? (this[n] = t >>> 24, this[n + 1] = t >>> 16, this[n + 2] = t >>> 8, this[n + 3] = t & 255) : vo(this, t, n, !1), n + 4;
};
L.prototype.writeIntLE = function(t, n, o, i) {
  if (t = +t, n = n | 0, !i) {
    var r = Math.pow(2, 8 * o - 1);
    tt(this, t, n, o, r - 1, -r);
  }
  var s = 0, l = 1, a = 0;
  for (this[n] = t & 255; ++s < o && (l *= 256); )
    t < 0 && a === 0 && this[n + s - 1] !== 0 && (a = 1), this[n + s] = (t / l >> 0) - a & 255;
  return n + o;
};
L.prototype.writeIntBE = function(t, n, o, i) {
  if (t = +t, n = n | 0, !i) {
    var r = Math.pow(2, 8 * o - 1);
    tt(this, t, n, o, r - 1, -r);
  }
  var s = o - 1, l = 1, a = 0;
  for (this[n + s] = t & 255; --s >= 0 && (l *= 256); )
    t < 0 && a === 0 && this[n + s + 1] !== 0 && (a = 1), this[n + s] = (t / l >> 0) - a & 255;
  return n + o;
};
L.prototype.writeInt8 = function(t, n, o) {
  return t = +t, n = n | 0, o || tt(this, t, n, 1, 127, -128), L.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[n] = t & 255, n + 1;
};
L.prototype.writeInt16LE = function(t, n, o) {
  return t = +t, n = n | 0, o || tt(this, t, n, 2, 32767, -32768), L.TYPED_ARRAY_SUPPORT ? (this[n] = t & 255, this[n + 1] = t >>> 8) : zo(this, t, n, !0), n + 2;
};
L.prototype.writeInt16BE = function(t, n, o) {
  return t = +t, n = n | 0, o || tt(this, t, n, 2, 32767, -32768), L.TYPED_ARRAY_SUPPORT ? (this[n] = t >>> 8, this[n + 1] = t & 255) : zo(this, t, n, !1), n + 2;
};
L.prototype.writeInt32LE = function(t, n, o) {
  return t = +t, n = n | 0, o || tt(this, t, n, 4, 2147483647, -2147483648), L.TYPED_ARRAY_SUPPORT ? (this[n] = t & 255, this[n + 1] = t >>> 8, this[n + 2] = t >>> 16, this[n + 3] = t >>> 24) : vo(this, t, n, !0), n + 4;
};
L.prototype.writeInt32BE = function(t, n, o) {
  return t = +t, n = n | 0, o || tt(this, t, n, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), L.TYPED_ARRAY_SUPPORT ? (this[n] = t >>> 24, this[n + 1] = t >>> 16, this[n + 2] = t >>> 8, this[n + 3] = t & 255) : vo(this, t, n, !1), n + 4;
};
function Ks(e, t, n, o, i, r) {
  if (n + o > e.length)
    throw new RangeError("Index out of range");
  if (n < 0)
    throw new RangeError("Index out of range");
}
function qs(e, t, n, o, i) {
  return i || Ks(e, t, n, 4), Ys(e, t, n, o, 23, 4), n + 4;
}
L.prototype.writeFloatLE = function(t, n, o) {
  return qs(this, t, n, !0, o);
};
L.prototype.writeFloatBE = function(t, n, o) {
  return qs(this, t, n, !1, o);
};
function Xs(e, t, n, o, i) {
  return i || Ks(e, t, n, 8), Ys(e, t, n, o, 52, 8), n + 8;
}
L.prototype.writeDoubleLE = function(t, n, o) {
  return Xs(this, t, n, !0, o);
};
L.prototype.writeDoubleBE = function(t, n, o) {
  return Xs(this, t, n, !1, o);
};
L.prototype.copy = function(t, n, o, i) {
  if (o || (o = 0), !i && i !== 0 && (i = this.length), n >= t.length && (n = t.length), n || (n = 0), i > 0 && i < o && (i = o), i === o || t.length === 0 || this.length === 0)
    return 0;
  if (n < 0)
    throw new RangeError("targetStart out of bounds");
  if (o < 0 || o >= this.length)
    throw new RangeError("sourceStart out of bounds");
  if (i < 0)
    throw new RangeError("sourceEnd out of bounds");
  i > this.length && (i = this.length), t.length - n < i - o && (i = t.length - n + o);
  var r = i - o, s;
  if (this === t && o < n && n < i)
    for (s = r - 1; s >= 0; --s)
      t[s + n] = this[s + o];
  else if (r < 1e3 || !L.TYPED_ARRAY_SUPPORT)
    for (s = 0; s < r; ++s)
      t[s + n] = this[s + o];
  else
    Uint8Array.prototype.set.call(
      t,
      this.subarray(o, o + r),
      n
    );
  return r;
};
L.prototype.fill = function(t, n, o, i) {
  if (typeof t == "string") {
    if (typeof n == "string" ? (i = n, n = 0, o = this.length) : typeof o == "string" && (i = o, o = this.length), t.length === 1) {
      var r = t.charCodeAt(0);
      r < 256 && (t = r);
    }
    if (i !== void 0 && typeof i != "string")
      throw new TypeError("encoding must be a string");
    if (typeof i == "string" && !L.isEncoding(i))
      throw new TypeError("Unknown encoding: " + i);
  } else
    typeof t == "number" && (t = t & 255);
  if (n < 0 || this.length < n || this.length < o)
    throw new RangeError("Out of range index");
  if (o <= n)
    return this;
  n = n >>> 0, o = o === void 0 ? this.length : o >>> 0, t || (t = 0);
  var s;
  if (typeof t == "number")
    for (s = n; s < o; ++s)
      this[s] = t;
  else {
    var l = yt(t) ? t : Io(new L(t, i).toString()), a = l.length;
    for (s = 0; s < o - n; ++s)
      this[s + n] = l[s % a];
  }
  return this;
};
var Cl = /[^+\/0-9A-Za-z-_]/g;
function wl(e) {
  if (e = Dl(e).replace(Cl, ""), e.length < 2)
    return "";
  for (; e.length % 4 !== 0; )
    e = e + "=";
  return e;
}
function Dl(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function zl(e) {
  return e < 16 ? "0" + e.toString(16) : e.toString(16);
}
function Io(e, t) {
  t = t || 1 / 0;
  for (var n, o = e.length, i = null, r = [], s = 0; s < o; ++s) {
    if (n = e.charCodeAt(s), n > 55295 && n < 57344) {
      if (!i) {
        if (n > 56319) {
          (t -= 3) > -1 && r.push(239, 191, 189);
          continue;
        } else if (s + 1 === o) {
          (t -= 3) > -1 && r.push(239, 191, 189);
          continue;
        }
        i = n;
        continue;
      }
      if (n < 56320) {
        (t -= 3) > -1 && r.push(239, 191, 189), i = n;
        continue;
      }
      n = (i - 55296 << 10 | n - 56320) + 65536;
    } else
      i && (t -= 3) > -1 && r.push(239, 191, 189);
    if (i = null, n < 128) {
      if ((t -= 1) < 0)
        break;
      r.push(n);
    } else if (n < 2048) {
      if ((t -= 2) < 0)
        break;
      r.push(
        n >> 6 | 192,
        n & 63 | 128
      );
    } else if (n < 65536) {
      if ((t -= 3) < 0)
        break;
      r.push(
        n >> 12 | 224,
        n >> 6 & 63 | 128,
        n & 63 | 128
      );
    } else if (n < 1114112) {
      if ((t -= 4) < 0)
        break;
      r.push(
        n >> 18 | 240,
        n >> 12 & 63 | 128,
        n >> 6 & 63 | 128,
        n & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return r;
}
function vl(e) {
  for (var t = [], n = 0; n < e.length; ++n)
    t.push(e.charCodeAt(n) & 255);
  return t;
}
function Tl(e, t) {
  for (var n, o, i, r = [], s = 0; s < e.length && !((t -= 2) < 0); ++s)
    n = e.charCodeAt(s), o = n >> 8, i = n % 256, r.push(i), r.push(o);
  return r;
}
function er(e) {
  return nl(wl(e));
}
function To(e, t, n, o) {
  for (var i = 0; i < o && !(i + n >= t.length || i >= e.length); ++i)
    t[i + n] = e[i];
  return i;
}
function kl(e) {
  return e !== e;
}
function jl(e) {
  return e != null && (!!e._isBuffer || tr(e) || Sl(e));
}
function tr(e) {
  return !!e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function Sl(e) {
  return typeof e.readFloatLE == "function" && typeof e.slice == "function" && tr(e.slice(0, 0));
}
const as = (e) => new Promise((t) => setTimeout(t, e));
class Ll {
  constructor(t, n, o, i, r, s) {
    xe(this, "authClient");
    xe(this, "adminClient");
    xe(this, "brainClient");
    xe(this, "frontUrl");
    xe(this, "ssoUrl");
    xe(this, "source");
    this.authClient = t, this.adminClient = n, this.brainClient = o, this.frontUrl = i, this.ssoUrl = r, this.source = s;
  }
  async login(t) {
    const n = await Promise.race([
      this.authClient.post("auth/login", { ...t, source: this.source }),
      as(15e3)
    ]);
    if (n)
      return n.data || n;
  }
  async loginFromToken(t) {
    const n = await this.adminClient.get("login-with-token", {
      headers: {
        Authorization: `Bearer ${t}`
      }
    });
    return n.data || n;
  }
  async loginFromOboToken(t) {
    const n = await Promise.race([
      this.authClient.post("auth/login/obo-token", {
        token: t,
        source: "chrome"
      }),
      as(15e3)
    ]);
    if (n)
      return n.data || n;
  }
  getRedirectionUrl(t, n) {
    let o = `${this.ssoUrl}/${t}`;
    const i = {
      url: this.frontUrl,
      source: this.source
    };
    L.from(this.frontUrl).toString("base64"), t === "saml" && n && (o = `${o}/${n}`, i.url = `https://${n}.mayday.fr`);
    const r = L.from(JSON.stringify(i)).toString("base64");
    return `${o}?state=${r}`;
  }
  async verifyDomain(t) {
    return this.adminClient.get(`sso/verify/${t}`);
  }
  async addPreference(t) {
    const n = await this.adminClient.post("preferences/add", { preference: t });
    return n.data || n;
  }
  async removePreference(t) {
    const n = await this.adminClient.post("preferences/remove", {
      preferenceId: t
    });
    return n.data || n;
  }
  async getRecommendations(t, n, o, i) {
    let r = `recommend/${n.toLowerCase()}/${t}`;
    o && (r += `?context=${o}`), i && (r += `${o ? "&" : "?"}preferredLanguage=${i}`);
    const s = await this.adminClient.get(r);
    return {
      recommendations: s.data.recommendations,
      queryId: s.data.queryId
    };
  }
  async getBrainRecommendations(t) {
    var o;
    const n = await this.brainClient.get(`recommend/status/${encodeURIComponent(t)}`);
    return {
      status: n.data.status,
      recommendations: n.data.recommendations,
      ticketContext: (o = n.data.enrichments) == null ? void 0 : o.enrichments
    };
  }
  async getUsers(t) {
    return Vs(this.adminClient, t);
  }
}
const nr = (e, t, n, o, i, r) => new Ll(e, t, n, o, i, r), x = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
}, El = {}, Ol = { class: "block h-px w-full my-3 bg-gray-3" };
function xl(e, t) {
  return c(), p("hr", Ol);
}
const or = /* @__PURE__ */ x(El, [["render", xl]]), _l = ["href"], Ul = ["disabled"], ye = /* @__PURE__ */ T({
  __name: "BaseButton",
  props: {
    text: {},
    type: { default: "primary" },
    size: { default: "small" },
    to: { default: void 0 },
    href: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    outline: { type: Boolean, default: !1 },
    icon: { type: Boolean, default: !1 },
    hyperlink: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = `
    font-bold ${t.rounded ? "rounded-lg" : "rounded"}
    cursor-pointer
    transition-colors
    flex items-center justify-center gap-2
    disabled:!cursor-not-allowed
  `, o = {
      primary: "text-white bg-blue hover:bg-blue-6 active:bg-blue-7 disabled:!bg-gray-2 disabled:!text-gray-5",
      secondary: "text-gray-8 bg-white hover:bg-gray-3 active:bg-gray-4 disabled:!bg-white",
      success: "text-white bg-green hover:bg-green-6 active:bg-green-7 disabled:!bg-green",
      warning: "text-black bg-yellow hover:bg-yellow-6 active:bg-yellow-7 disabled:!bg-yellow",
      danger: "text-white bg-red hover:bg-red-6 active:bg-red-7 disabled:!bg-red-2",
      custom: "text-primary-contrast bg-primary hover:bg-primary-6 active:bg-primary-7 disabled:!bg-primary",
      "custom-secondary": "text-secondary-contrast bg-secondary hover:bg-secondary-6 active:bg-secondary-7 disabled:!bg-secondary"
    }, i = {
      primary: "text-blue bg-blue/10 border border-blue hover:bg-blue hover:text-white active:text-white active:bg-blue-6 disabled:bg-blue/10 disabled:!text-blue",
      secondary: "text-gray-8 bg-gray-1 border border-gray-8 hover:bg-gray-3 hover:border-gray-3 active:bg-gray-4 active:border-gray-4 disabled:bg-gray-1",
      success: "text-green bg-green/10 border border-green hover:bg-green hover:text-white active:text-white active:bg-green-6 disabled:bg-green/10 disabled:!text-green",
      warning: "text-yellow bg-yellow/10 border border-yellow hover:bg-yellow hover:text-black active:text-black active:bg-yellow-6 disabled:bg-yellow/10 disabled:!text-yellow",
      danger: "text-red bg-red/10 border border-red hover:bg-red hover:text-white active:text-white active:bg-red-6 disabled:bg-red/10 disabled:!text-red",
      custom: "text-primary bg-primary/10 border border-primary hover:bg-primary hover:text-primary-contrast active:text-primary-contrast active:bg-primary-6 disabled:bg-primary/10 disabled:!text-primary",
      "custom-secondary": "text-secondary bg-secondary/10 border border-secondary hover:bg-secondary hover:text-secondary-contrast active:text-secondary-contrast active:bg-secondary-6 disabled:bg-secondary/10 disabled:!text-secondary"
    }, r = {
      primary: "text-blue bg-transparent hover:text-blue-6 active:text-blue-7 disabled:opacity-40",
      secondary: "text-gray-8 bg-transparent hover:text-gray-9 active:text-black disabled:opacity-40",
      success: "text-green bg-transparent hover:text-green-6 active:text-green-7 disabled:opacity-40",
      warning: "text-yellow bg-transparent hover:text-yellow-6 active:text-yellow-7 disabled:opacity-40",
      danger: "text-red bg-transparent hover:text-red-6 active:text-red-7 disabled:opacity-40",
      custom: "text-primary bg-transparent hover:opacity-80 active:opacity-80 disabled:opacity-40",
      "custom-secondary": "text-secondary bg-transparent hover:opacity-80 active:opacity-80 disabled:opacity-40"
    }, s = {
      medium: "h-11 min-w-11 px-4 text-base",
      small: "h-8.5 min-w-8.5 px-3 text-xs",
      mini: "h-5.5 min-w-5.5 px-2.5 text-xs"
    }, l = k(() => t.outline ? i[t.type] || i.primary : t.hyperlink ? r[t.type] || r.primary : o[t.type] || o.primary), a = k(() => s[t.size] || s.medium), u = k(() => t.icon ? "!px-0" : "");
    return (g, d) => {
      const f = R("router-link");
      return g.to ? (c(), C(f, {
        key: 0,
        to: g.to,
        class: D(`${n} ${h(l)} ${h(a)} ${h(u)}`)
      }, {
        default: _(() => [
          Te(g.$slots, "default", {}, () => [
            ne(N(g.text), 1)
          ])
        ]),
        _: 3
      }, 8, ["to", "class"])) : g.href ? (c(), p("a", {
        key: 1,
        class: D(`${n} ${h(l)} ${h(a)} ${h(u)}`),
        href: g.href,
        target: "_blank"
      }, [
        Te(g.$slots, "default", {}, () => [
          ne(N(g.text), 1)
        ])
      ], 10, _l)) : (c(), p("button", {
        key: 2,
        class: D(`${n} ${h(l)} ${h(a)} ${h(u)}`),
        disabled: t.disabled
      }, [
        Te(g.$slots, "default", {}, () => [
          ne(N(g.text), 1)
        ])
      ], 10, Ul));
    };
  }
}), P = /* @__PURE__ */ T({
  __name: "FontAwesomeIcon",
  props: {
    icon: {},
    spin: { type: Boolean },
    role: {}
  },
  setup(e) {
    const t = e, n = {
      fas: "fa-solid",
      far: "fa-regular",
      fal: "fa-light",
      fab: "fa-brands"
    }, o = k(() => n[t.icon[0]]), i = k(() => `fa-${t.icon[1]}`), r = k(() => t.spin ? "fa-spin" : "");
    return (s, l) => (c(), C(xt(s.role || "i"), {
      class: D(["select-none !inline-flex items-center justify-center", [h(o), h(i), h(r)]])
    }, null, 8, ["class"]));
  }
}), Fl = ["for"], En = /* @__PURE__ */ T({
  __name: "LoginInput",
  props: {
    label: {
      type: [String || Boolean],
      default: !1
    },
    isError: {
      type: Boolean,
      default: !1
    },
    value: {
      type: String,
      default: ""
    },
    validator: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["input", "submit"],
  setup(e, { emit: t }) {
    const n = e, o = Y(n.value), i = Y(!1), r = Y(!1), s = k(() => {
      const { name: d, type: f, placeholder: I } = Ra();
      return {
        name: d,
        type: f || "text",
        placeholder: I
      };
    }), l = k(() => s.value.name || "name"), a = () => {
      r.value = !1, i.value = !0;
    }, u = () => {
      r.value = n.validator && !!n.value.length, i.value = !1;
    }, g = (d) => {
      t("input", d.target.value);
    };
    return (d, f) => {
      const I = It("stop-propagation");
      return c(), p("div", null, [
        e.label ? (c(), p("label", {
          key: 0,
          for: h(l),
          class: "mb-1.5 block text-black text-base font-bold"
        }, N(e.label), 9, Fl)) : A("", !0),
        m("div", {
          class: D(["px-3.5 py-3 flex border border-gray-4 rounded-lg", { "border-red": e.isError || h(r), "border-blue": h(i) }])
        }, [
          Ze(m("input", Tt({
            class: "w-full outline-none font-bold placeholder-gray-5 !leading-[18px] bg-transparent",
            "onUpdate:modelValue": f[0] || (f[0] = (z) => Be(o) ? o.value = z : null)
          }, h(s), {
            onFocus: f[1] || (f[1] = (z) => a()),
            onBlur: f[2] || (f[2] = (z) => u()),
            onKeydown: f[3] || (f[3] = Co((z) => t("submit", e.value), ["enter"])),
            onInput: g
          }), null, 16), [
            [Va, h(o)],
            [I]
          ])
        ], 2)
      ]);
    };
  }
}), $l = T({
  name: "SsoDomainForm",
  components: {
    LoginInput: En
  },
  data() {
    return {
      domain: "",
      loading: !1,
      pendingError: "",
      errorCode: ""
    };
  },
  computed: {
    invalidDomain() {
      return !(this.domain && this.domain.length > 0);
    },
    sanitizedDomain() {
      return this.domain.split(".")[0].toLowerCase();
    },
    ...wo(ft)
  },
  methods: {
    async verifyDomain() {
      if (!this.invalidDomain) {
        if (this.domain = this.sanitizedDomain, this.loading = !0, this.domain && this.domain.length > 0)
          try {
            const e = await this.verifyCompanyDomain(this.domain);
            e.status === 200 ? e.data.domain_validity ? (this.storeCompanyDomain(this.domain), this.$nextTick(() => this.$emit("valid-domain"))) : this.setPendingError("INVALID_DOMAIN") : this.setPendingError(e.data.message);
          } catch (e) {
            this.setPendingError(e.message);
          }
        this.loading = !1;
      }
    },
    setPendingError(e) {
      switch (e) {
        case "INVALID_DOMAIN":
          this.pendingError = this.$t("login.errors.invalid-domain"), this.errorCode = "ERRSSO01";
          break;
        default:
          this.pendingError = this.$t("login.errors.default"), this.errorCode = "ERR00";
      }
    },
    ...fe(ft, ["verifyCompanyDomain", "storeCompanyDomain"])
  }
});
const Rl = { class: "" }, Vl = { class: "mb-4 md-subtitle" }, Bl = {
  key: 0,
  class: "text-red leading-none"
}, Yl = ["innerHTML"], Ql = {
  key: 0,
  class: "block text-xs"
};
function Pl(e, t, n, o, i, r) {
  const s = En, l = P, a = ye;
  return c(), p("div", Rl, [
    m("div", Vl, N(e.$t("login.sso-instructions")), 1),
    M(s, {
      type: "text",
      placeholder: e.$t("login.sso-placeholder"),
      label: e.$t("login.form.domain"),
      "is-error": e.pendingError.length > 0,
      value: e.domain,
      onSubmit: t[0] || (t[0] = (u) => e.verifyDomain()),
      onInput: t[1] || (t[1] = (u) => e.domain = u)
    }, null, 8, ["placeholder", "label", "is-error", "value"]),
    e.pendingError.length > 0 ? (c(), p("div", Bl, [
      m("span", {
        class: "md-error-message",
        innerHTML: e.pendingError
      }, null, 8, Yl),
      e.errorCode ? (c(), p("span", Ql, N(e.errorCode), 1)) : A("", !0)
    ])) : A("", !0),
    M(a, {
      class: "mt-4 w-full",
      disabled: e.invalidDomain,
      outline: "",
      rounded: "",
      type: "secondary",
      size: "medium",
      onClick: t[2] || (t[2] = (u) => e.verifyDomain())
    }, {
      default: _(() => [
        e.loading ? (c(), C(l, {
          key: 0,
          icon: ["fas", "spinner-third"],
          spin: e.loading
        }, null, 8, ["spin"])) : A("", !0),
        m("span", null, N(e.$t("login.form.sso-cta")), 1)
      ]),
      _: 1
    }, 8, ["disabled"]),
    m("div", {
      class: "mt-1 flex items-center gap-2 text-xs hover:text-blue cursor-pointer",
      onClick: t[3] || (t[3] = (u) => e.$emit("close"))
    }, [
      M(l, { icon: ["fas", "long-arrow-left"] }),
      ne(" " + N(e.$t("login.back-to-login")), 1)
    ])
  ]);
}
const Gl = /* @__PURE__ */ x($l, [["render", Pl], ["__scopeId", "data-v-20ef7cac"]]), Zl = T({
  name: "BaseSwag"
});
const Wl = { class: "h-[5px] w-full bg-center swag" };
function Hl(e, t, n, o, i, r) {
  return c(), p("div", Wl);
}
const ir = /* @__PURE__ */ x(Zl, [["render", Hl]]), Jl = T({
  name: "FooterComponent",
  components: {
    BaseSwag: ir
  },
  computed: ue(ft, ["authorizedSession", "currentVersion"])
}), Kl = { class: "px-3" }, ql = { class: "mb-2 flex justify-center gap-1 text-xs font-bold text-black" }, Xl = {
  class: "text-blue hover:text-blue-6 text-xs",
  href: "https://app.mayday.fr/register",
  target: "_blank"
}, ec = {
  key: 0,
  class: "mb-6 flex justify-center text-xs text-gray-7 font-bold"
};
function tc(e, t, n, o, i, r) {
  const s = ir;
  return c(), p("div", Kl, [
    M(s, { class: "mb-4 w-full rounded-sm" }),
    m("div", ql, [
      m("div", null, N(e.$t("login.register.question")), 1),
      m("a", Xl, N(e.$t("login.register.action")), 1)
    ]),
    e.authorizedSession ? A("", !0) : (c(), p("div", ec, N(`v${e.currentVersion}`), 1))
  ]);
}
const nc = /* @__PURE__ */ x(Jl, [["render", tc]]), oc = { class: "" }, ic = { class: "mb-4 md-subtitle" }, sc = {
  key: 0,
  class: "text-red leading-none"
}, rc = ["innerHTML"], ac = {
  key: 0,
  class: "block text-xs"
}, lc = /* @__PURE__ */ T({
  __name: "AccessTokenForm",
  emits: ["close", "login-success"],
  setup(e, { emit: t }) {
    const { loginFromOboToken: n } = ft(), o = async () => {
      if (l.value) {
        s.value = !0;
        try {
          await n(l.value) && t("login-success");
        } catch (a) {
          i.value = a.message, r.value = a.code, s.value = !1;
        }
      }
    }, i = Y(""), r = Y(""), s = Y(!1), l = Y("");
    return (a, u) => {
      var f;
      const g = P, d = ye;
      return c(), p("div", oc, [
        m("div", ic, N(a.$t("login.access-token-instructions")), 1),
        M(En, {
          type: "text",
          placeholder: a.$t("login.access-token-placeholder"),
          label: a.$t("login.form.access-token"),
          "is-error": h(i).length > 0,
          value: h(l),
          onSubmit: o,
          onInput: u[0] || (u[0] = (I) => l.value = I)
        }, null, 8, ["placeholder", "label", "is-error", "value"]),
        h(i).length > 0 ? (c(), p("div", sc, [
          m("span", {
            class: "md-error-message",
            innerHTML: h(i)
          }, null, 8, rc),
          h(r) ? (c(), p("span", ac, N(h(r)), 1)) : A("", !0)
        ])) : A("", !0),
        M(d, {
          class: "mt-4 w-full",
          disabled: h(s) || !((f = h(l)) != null && f.length),
          outline: "",
          rounded: "",
          type: "secondary",
          size: "medium",
          onClick: o
        }, {
          default: _(() => [
            h(s) ? (c(), C(g, {
              key: 0,
              icon: ["fas", "spinner-third"],
              spin: h(s)
            }, null, 8, ["spin"])) : A("", !0),
            m("span", null, N(a.$t("login.form.sso-cta")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        m("div", {
          class: "mt-1 flex items-center gap-2 text-xs hover:text-blue cursor-pointer",
          onClick: u[1] || (u[1] = (I) => a.$emit("close"))
        }, [
          M(g, { icon: ["fas", "long-arrow-left"] }),
          ne(" " + N(a.$t("login.back-to-login")), 1)
        ])
      ]);
    };
  }
}), cc = T({
  name: "LoginView",
  components: {
    AccessTokenForm: lc,
    SsoDomainForm: Gl,
    LoginFooter: nc,
    LoginInput: En
  },
  emits: ["login-success", "on-sso"],
  data() {
    return {
      model: {
        email: "",
        password: ""
      },
      showSsoForm: !1,
      showAccessTokenForm: !1,
      isError: !1,
      isLoading: !1
    };
  },
  computed: {
    loginIsActive() {
      return this.isValidEmail && this.isValidPassword && !this.isError;
    },
    isValidEmail() {
      return this.model.email !== "";
    },
    isValidPassword() {
      return this.model.password === "" ? !1 : this.model.password.length >= 6;
    },
    modelIsInvalid() {
      try {
        return !this.model.email.length || !this.model.password;
      } catch {
        return !0;
      }
    },
    loginSuccess() {
      return !!this.accessToken && !this.status;
    },
    displayAccessTokenFormButton() {
      return window.location.href.includes("https://maydayhq.retool.com");
    },
    ...ue(ft, ["accessToken", "status", "companyDomain", "isDeprecated"]),
    ...wo(ft)
  },
  mounted() {
    this.resetStatus();
  },
  methods: {
    setError() {
      this.isError = !0, setTimeout(() => {
        this.isError = !1;
      }, 2e3);
    },
    async login() {
      if (this.modelIsInvalid)
        return;
      this.setLoginMethod("CREDENTIALS"), this.isLoading = !0;
      const e = await this.userLogin(this.model);
      if (!(e && e.accessToken))
        return this.isLoading = !1, this.setError();
      this.isLoading = !1, setTimeout(() => {
        this.$emit("login-success");
      }, 750);
    },
    openSso(e) {
      if (this.showSsoForm = !1, this.setLoginMethod(e === "google" ? "GOOGLE_OIDC" : "SAML"), e !== "saml" || this.companyDomain) {
        const t = this.adminStore.$adminService.getRedirectionUrl(e, this.companyDomain);
        this.startSsoLoading(), this.$emit("on-sso"), window.open(t, "_blank");
      } else
        this.showSsoForm = !0;
    },
    ...fe(ft, [
      "userLogin",
      "startSsoLoading",
      "storeCompanyDomain",
      "resetStatus",
      "setLoginMethod"
    ])
  }
}), uc = { class: "h-full relative" }, dc = { class: "h-full overflow-y-auto" }, gc = { class: "pt-8 pb-6 px-7" }, pc = { key: 2 }, mc = {
  class: "mt-1 block text-xs text-gray-8 hover:text-blue font-bold",
  href: "https://app.mayday.fr/reset",
  target: "_blank"
}, hc = { class: "my-[18px] flex items-center" }, fc = { class: "px-6 text-gray-6" };
function yc(e, t, n, o, i, r) {
  const s = R("SsoDomainForm"), l = R("AccessTokenForm"), a = En, u = P, g = ye, d = or, f = R("LoginFooter");
  return c(), p("div", uc, [
    m("div", dc, [
      m("div", gc, [
        e.showSsoForm ? (c(), C(s, {
          key: 0,
          onValidDomain: t[0] || (t[0] = (I) => e.openSso("saml")),
          onClose: t[1] || (t[1] = (I) => e.showSsoForm = !1)
        })) : e.showAccessTokenForm ? (c(), C(l, {
          key: 1,
          onClose: t[2] || (t[2] = (I) => e.showAccessTokenForm = !1),
          onLoginSuccess: t[3] || (t[3] = (I) => e.$emit("login-success")),
          onOnSso: t[4] || (t[4] = (I) => e.$emit("on-sso"))
        })) : (c(), p("div", pc, [
          M(a, {
            label: e.$t("login.form.email"),
            type: "text",
            name: "email",
            placeholder: "john.doe@mayday.fr",
            "is-error": e.isError,
            validator: !e.isValidEmail,
            value: e.model.email,
            onInput: t[5] || (t[5] = (I) => e.model.email = I)
          }, null, 8, ["label", "is-error", "validator", "value"]),
          M(a, {
            class: "mt-4 focus:border-blue",
            label: e.$t("login.form.password"),
            type: "password",
            name: "password",
            placeholder: "••••••••",
            "is-error": e.isError,
            validator: !e.isValidPassword,
            value: e.model.password,
            onSubmit: t[6] || (t[6] = (I) => e.login()),
            onInput: t[7] || (t[7] = (I) => e.model.password = I)
          }, null, 8, ["label", "is-error", "validator", "value"]),
          m("a", mc, N(e.$t("login.forgot-password")), 1),
          M(g, {
            class: "mt-8 w-full",
            disabled: !e.loginIsActive,
            rounded: "",
            size: "medium",
            onClick: t[8] || (t[8] = (I) => e.login())
          }, {
            default: _(() => [
              e.loginSuccess ? (c(), C(u, {
                key: 0,
                icon: ["fal", "check"]
              })) : e.isLoading ? (c(), C(u, {
                key: 1,
                icon: ["fas", "spinner-third"],
                spin: ""
              })) : A("", !0),
              m("span", null, N(e.$t("login.form.login")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          m("div", hc, [
            M(d),
            m("div", fc, N(e.$t("login.form.or")), 1),
            M(d)
          ]),
          e.displayAccessTokenFormButton ? (c(), C(g, {
            key: 0,
            class: "mb-4 w-full",
            outline: "",
            rounded: "",
            type: "secondary",
            size: "medium",
            onClick: t[9] || (t[9] = (I) => e.showAccessTokenForm = !0)
          }, {
            default: _(() => [
              M(u, { icon: ["fas", "lock"] }),
              m("span", null, N(e.$t("login.form.access-token-signin")), 1)
            ]),
            _: 1
          })) : A("", !0),
          M(g, {
            class: "w-full",
            outline: "",
            rounded: "",
            type: "secondary",
            size: "medium",
            onClick: t[10] || (t[10] = (I) => e.openSso("google"))
          }, {
            default: _(() => [
              M(u, {
                class: "",
                icon: ["fab", "google"]
              }),
              m("span", null, N(e.$t("login.form.google-signin")), 1)
            ]),
            _: 1
          }),
          M(g, {
            class: "mt-4 w-full",
            outline: "",
            rounded: "",
            type: "secondary",
            size: "medium",
            onClick: t[11] || (t[11] = (I) => e.openSso("saml"))
          }, {
            default: _(() => [
              M(u, {
                class: "",
                icon: ["fas", "key"]
              }),
              m("span", null, N(e.$t("login.form.sso-signin")), 1)
            ]),
            _: 1
          }),
          e.companyDomain ? (c(), p("button", {
            key: 1,
            class: "mt-1 flex items-center text-xs text-gray-8 hover:text-blue font-bold cursor-pointer",
            onClick: t[12] || (t[12] = (I) => e.storeCompanyDomain(null))
          }, [
            M(u, {
              icon: ["fas", "undo"],
              class: "mr-2"
            }),
            ne(" " + N(e.$t("login.reset-domain")), 1)
          ])) : A("", !0)
        ]))
      ]),
      M(f, { class: "bg-white" })
    ])
  ]);
}
const Ic = /* @__PURE__ */ x(cc, [["render", yc]]), Mc = { class: "relative text-sm" }, Ac = ["disabled"], Nc = {
  key: 0,
  class: "absolute z-10 top-full mt-1 right-0 left-0 bg-white rounded border-gray-4 shadow divide-y divide-gray-2 overflow-hidden"
}, bc = ["onClick"], wi = /* @__PURE__ */ T({
  __name: "BaseSelect",
  props: {
    value: {},
    options: {},
    loading: { type: Boolean },
    removeBorder: { type: Boolean }
  },
  emits: ["update"],
  setup(e, { emit: t }) {
    const n = e, o = Y(n.value), i = k(() => n.options.find(
      (g) => o.value === g.key
    )), r = Y(!1), s = () => {
      r.value = !1;
    }, l = () => {
      r.value = !r.value;
    }, a = (g) => {
      o.value = g, r.value = !1;
    }, u = Y(!1);
    return _e(o, (g) => {
      u.value || t("update", g);
    }), _e(
      () => n.value,
      (g) => {
        o.value = g, u.value = !0, setTimeout(() => {
          u.value = !1;
        }, 100);
      }
    ), (g, d) => {
      const f = P, I = It("click-outside");
      return Ze((c(), p("div", Mc, [
        h(i) ? (c(), p("button", {
          key: 0,
          class: D(["w-full p-3 flex items-center justify-between gap-2 rounded transition-colors group", [
            h(r) ? "border-blue" : "border-gray-4",
            n.loading ? "cursor-wait hover:border-gray-7" : "cursor-pointer hover:border-blue",
            n.removeBorder ? "border-none" : "border"
          ]]),
          disabled: n.loading,
          onClick: l
        }, [
          Te(g.$slots, "trigger", { selectedOption: h(i) }, () => [
            m("span", null, N(g.$t(h(i).label)), 1)
          ]),
          M(f, {
            icon: ["fas", n.loading ? "spinner-third" : "chevron-down"],
            spin: n.loading,
            class: D(["text-xs transition-all text-gray-4 group-hover:text-gray-9", { "-rotate-180 text-gray-9": h(r) }])
          }, null, 8, ["icon", "spin", "class"])
        ], 10, Ac)) : A("", !0),
        M(Xe, { name: "fade" }, {
          default: _(() => [
            h(r) ? (c(), p("div", Nc, [
              (c(!0), p(X, null, te(g.options, (z) => (c(), p("button", {
                class: "bg-transparent text-left hover:bg-blue/10 hover:text-blue active:bg-blue active:text-white transition-colors w-full p-2 flex items-center gap-2",
                key: z.key,
                onClick: (v) => a(z.key)
              }, [
                h(o) === z.key ? (c(), C(f, {
                  key: 0,
                  class: "text-xs",
                  icon: ["fas", "check"]
                })) : A("", !0),
                m("span", null, N(g.$t(z.label)), 1)
              ], 8, bc))), 128))
            ])) : A("", !0)
          ]),
          _: 1
        })
      ])), [
        [I, s]
      ]);
    };
  }
});
function an(e) {
  const t = parseInt(e.slice(1, 3), 16), n = parseInt(e.slice(3, 5), 16), o = parseInt(e.slice(5, 7), 16);
  return [t, n, o];
}
function Cc(e, t) {
  const [n, o, i] = an(e), r = Math.round(n * (1 - t / 100)), s = Math.round(o * (1 - t / 100)), l = Math.round(i * (1 - t / 100));
  return [r, s, l];
}
function wc(e, t) {
  const [n, o, i] = an(e), r = (n * 299 + o * 587 + i * 114) / 1e3, s = (t == null ? void 0 : t.dark) || "#000000", l = (t == null ? void 0 : t.light) || "#FFFFFF";
  return an(r >= 180 ? s : l);
}
function Dc(e, t) {
  const [n, o, i] = an(e), r = (n * 299 + o * 587 + i * 114) / 1e3, s = (t == null ? void 0 : t.dark) || "#000000", l = (t == null ? void 0 : t.light) || "#FFFFFF";
  return an(r < 180 ? s : l);
}
const io = (e) => `${e.join(" ")}`, sr = ["DEFAULT", "5", "6", "7", "contrast", "complement"], zc = {
  DEFAULT: "#0081f9",
  1: "#9ED0FE",
  2: "#77BCFD",
  3: "#4FA9FB",
  4: "#2895FA",
  5: "#0081F9",
  6: "#006CD0",
  7: "#0057A7",
  8: "#00417F",
  9: "#002C56",
  contrast: "#ffffff",
  complement: "#000000"
}, zn = (e, t) => t === "DEFAULT" ? `--${e}` : `--${e}-${t}`, ls = (e) => sr.reduce((t, n) => (t[n] = `rgb(var(${zn(e, n)}, ${zc[n]}) / <alpha-value>)`, t), {}), eN = (e, t) => {
  const n = {};
  return sr.forEach((o) => {
    if (o === "DEFAULT" || o === "5")
      n[zn(e, o)] = io(an(t));
    else if (o === "contrast")
      n[zn(e, o)] = io(
        wc(t, { dark: "#222222" })
      );
    else if (o === "complement")
      n[zn(e, o)] = io(Dc(t));
    else {
      const i = parseInt(o) - 5;
      n[zn(e, o)] = io(Cc(t, i * 10));
    }
  }), n;
};
var rr = {}, ar = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "cloneDeep", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n) {
    return Array.isArray(n) ? n.map((o) => t(o)) : typeof n == "object" && n !== null ? Object.fromEntries(Object.entries(n).map(([o, i]) => [
      o,
      t(i)
    ])) : n;
  }
})(ar);
var vc = {
  content: [],
  presets: [],
  darkMode: "media",
  // or 'class'
  theme: {
    accentColor: ({ theme: e }) => ({
      ...e("colors"),
      auto: "auto"
    }),
    animation: {
      none: "none",
      spin: "spin 1s linear infinite",
      ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
      pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
      bounce: "bounce 1s infinite"
    },
    aria: {
      busy: 'busy="true"',
      checked: 'checked="true"',
      disabled: 'disabled="true"',
      expanded: 'expanded="true"',
      hidden: 'hidden="true"',
      pressed: 'pressed="true"',
      readonly: 'readonly="true"',
      required: 'required="true"',
      selected: 'selected="true"'
    },
    aspectRatio: {
      auto: "auto",
      square: "1 / 1",
      video: "16 / 9"
    },
    backdropBlur: ({ theme: e }) => e("blur"),
    backdropBrightness: ({ theme: e }) => e("brightness"),
    backdropContrast: ({ theme: e }) => e("contrast"),
    backdropGrayscale: ({ theme: e }) => e("grayscale"),
    backdropHueRotate: ({ theme: e }) => e("hueRotate"),
    backdropInvert: ({ theme: e }) => e("invert"),
    backdropOpacity: ({ theme: e }) => e("opacity"),
    backdropSaturate: ({ theme: e }) => e("saturate"),
    backdropSepia: ({ theme: e }) => e("sepia"),
    backgroundColor: ({ theme: e }) => e("colors"),
    backgroundImage: {
      none: "none",
      "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
      "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
      "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
      "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
      "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
      "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
      "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
      "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
    },
    backgroundOpacity: ({ theme: e }) => e("opacity"),
    backgroundPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    backgroundSize: {
      auto: "auto",
      cover: "cover",
      contain: "contain"
    },
    blur: {
      0: "0",
      none: "0",
      sm: "4px",
      DEFAULT: "8px",
      md: "12px",
      lg: "16px",
      xl: "24px",
      "2xl": "40px",
      "3xl": "64px"
    },
    borderColor: ({ theme: e }) => ({
      ...e("colors"),
      DEFAULT: e("colors.gray.200", "currentColor")
    }),
    borderOpacity: ({ theme: e }) => e("opacity"),
    borderRadius: {
      none: "0px",
      sm: "0.125rem",
      DEFAULT: "0.25rem",
      md: "0.375rem",
      lg: "0.5rem",
      xl: "0.75rem",
      "2xl": "1rem",
      "3xl": "1.5rem",
      full: "9999px"
    },
    borderSpacing: ({ theme: e }) => ({
      ...e("spacing")
    }),
    borderWidth: {
      DEFAULT: "1px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    boxShadow: {
      sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
      "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
      inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
      none: "none"
    },
    boxShadowColor: ({ theme: e }) => e("colors"),
    brightness: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    caretColor: ({ theme: e }) => e("colors"),
    colors: ({ colors: e }) => ({
      inherit: e.inherit,
      current: e.current,
      transparent: e.transparent,
      black: e.black,
      white: e.white,
      slate: e.slate,
      gray: e.gray,
      zinc: e.zinc,
      neutral: e.neutral,
      stone: e.stone,
      red: e.red,
      orange: e.orange,
      amber: e.amber,
      yellow: e.yellow,
      lime: e.lime,
      green: e.green,
      emerald: e.emerald,
      teal: e.teal,
      cyan: e.cyan,
      sky: e.sky,
      blue: e.blue,
      indigo: e.indigo,
      violet: e.violet,
      purple: e.purple,
      fuchsia: e.fuchsia,
      pink: e.pink,
      rose: e.rose
    }),
    columns: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      "3xs": "16rem",
      "2xs": "18rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    },
    container: {},
    content: {
      none: "none"
    },
    contrast: {
      0: "0",
      50: ".5",
      75: ".75",
      100: "1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    cursor: {
      auto: "auto",
      default: "default",
      pointer: "pointer",
      wait: "wait",
      text: "text",
      move: "move",
      help: "help",
      "not-allowed": "not-allowed",
      none: "none",
      "context-menu": "context-menu",
      progress: "progress",
      cell: "cell",
      crosshair: "crosshair",
      "vertical-text": "vertical-text",
      alias: "alias",
      copy: "copy",
      "no-drop": "no-drop",
      grab: "grab",
      grabbing: "grabbing",
      "all-scroll": "all-scroll",
      "col-resize": "col-resize",
      "row-resize": "row-resize",
      "n-resize": "n-resize",
      "e-resize": "e-resize",
      "s-resize": "s-resize",
      "w-resize": "w-resize",
      "ne-resize": "ne-resize",
      "nw-resize": "nw-resize",
      "se-resize": "se-resize",
      "sw-resize": "sw-resize",
      "ew-resize": "ew-resize",
      "ns-resize": "ns-resize",
      "nesw-resize": "nesw-resize",
      "nwse-resize": "nwse-resize",
      "zoom-in": "zoom-in",
      "zoom-out": "zoom-out"
    },
    divideColor: ({ theme: e }) => e("borderColor"),
    divideOpacity: ({ theme: e }) => e("borderOpacity"),
    divideWidth: ({ theme: e }) => e("borderWidth"),
    dropShadow: {
      sm: "0 1px 1px rgb(0 0 0 / 0.05)",
      DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
      md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
      lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
      xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
      "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
      none: "0 0 #0000"
    },
    fill: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    flex: {
      1: "1 1 0%",
      auto: "1 1 auto",
      initial: "0 1 auto",
      none: "none"
    },
    flexBasis: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%"
    }),
    flexGrow: {
      0: "0",
      DEFAULT: "1"
    },
    flexShrink: {
      0: "0",
      DEFAULT: "1"
    },
    fontFamily: {
      sans: [
        "ui-sans-serif",
        "system-ui",
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        '"Noto Sans"',
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"'
      ],
      serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
      mono: [
        "ui-monospace",
        "SFMono-Regular",
        "Menlo",
        "Monaco",
        "Consolas",
        '"Liberation Mono"',
        '"Courier New"',
        "monospace"
      ]
    },
    fontSize: {
      xs: ["0.75rem", { lineHeight: "1rem" }],
      sm: ["0.875rem", { lineHeight: "1.25rem" }],
      base: ["1rem", { lineHeight: "1.5rem" }],
      lg: ["1.125rem", { lineHeight: "1.75rem" }],
      xl: ["1.25rem", { lineHeight: "1.75rem" }],
      "2xl": ["1.5rem", { lineHeight: "2rem" }],
      "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
      "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
      "5xl": ["3rem", { lineHeight: "1" }],
      "6xl": ["3.75rem", { lineHeight: "1" }],
      "7xl": ["4.5rem", { lineHeight: "1" }],
      "8xl": ["6rem", { lineHeight: "1" }],
      "9xl": ["8rem", { lineHeight: "1" }]
    },
    fontWeight: {
      thin: "100",
      extralight: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    },
    gap: ({ theme: e }) => e("spacing"),
    gradientColorStops: ({ theme: e }) => e("colors"),
    gradientColorStopPositions: {
      "0%": "0%",
      "5%": "5%",
      "10%": "10%",
      "15%": "15%",
      "20%": "20%",
      "25%": "25%",
      "30%": "30%",
      "35%": "35%",
      "40%": "40%",
      "45%": "45%",
      "50%": "50%",
      "55%": "55%",
      "60%": "60%",
      "65%": "65%",
      "70%": "70%",
      "75%": "75%",
      "80%": "80%",
      "85%": "85%",
      "90%": "90%",
      "95%": "95%",
      "100%": "100%"
    },
    grayscale: {
      0: "0",
      DEFAULT: "100%"
    },
    gridAutoColumns: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridAutoRows: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridColumn: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridColumnEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridColumnStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRow: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-full": "1 / -1"
    },
    gridRowEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7"
    },
    gridRowStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7"
    },
    gridTemplateColumns: {
      none: "none",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    gridTemplateRows: {
      none: "none",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))"
    },
    height: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      full: "100%",
      screen: "100vh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    hueRotate: {
      0: "0deg",
      15: "15deg",
      30: "30deg",
      60: "60deg",
      90: "90deg",
      180: "180deg"
    },
    inset: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    invert: {
      0: "0",
      DEFAULT: "100%"
    },
    keyframes: {
      spin: {
        to: {
          transform: "rotate(360deg)"
        }
      },
      ping: {
        "75%, 100%": {
          transform: "scale(2)",
          opacity: "0"
        }
      },
      pulse: {
        "50%": {
          opacity: ".5"
        }
      },
      bounce: {
        "0%, 100%": {
          transform: "translateY(-25%)",
          animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
          transform: "none",
          animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
      }
    },
    letterSpacing: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0em",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeight: {
      none: "1",
      tight: "1.25",
      snug: "1.375",
      normal: "1.5",
      relaxed: "1.625",
      loose: "2",
      3: ".75rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem"
    },
    listStyleType: {
      none: "none",
      disc: "disc",
      decimal: "decimal"
    },
    listStyleImage: {
      none: "none"
    },
    margin: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing")
    }),
    lineClamp: {
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6"
    },
    maxHeight: ({ theme: e }) => ({
      ...e("spacing"),
      none: "none",
      full: "100%",
      screen: "100vh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    maxWidth: ({ theme: e, breakpoints: t }) => ({
      none: "none",
      0: "0rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content",
      prose: "65ch",
      ...t(e("screens"))
    }),
    minHeight: {
      0: "0px",
      full: "100%",
      screen: "100vh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    },
    minWidth: {
      0: "0px",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    },
    objectPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    opacity: {
      0: "0",
      5: "0.05",
      10: "0.1",
      20: "0.2",
      25: "0.25",
      30: "0.3",
      40: "0.4",
      50: "0.5",
      60: "0.6",
      70: "0.7",
      75: "0.75",
      80: "0.8",
      90: "0.9",
      95: "0.95",
      100: "1"
    },
    order: {
      first: "-9999",
      last: "9999",
      none: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12"
    },
    outlineColor: ({ theme: e }) => e("colors"),
    outlineOffset: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    outlineWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    padding: ({ theme: e }) => e("spacing"),
    placeholderColor: ({ theme: e }) => e("colors"),
    placeholderOpacity: ({ theme: e }) => e("opacity"),
    ringColor: ({ theme: e }) => ({
      DEFAULT: e("colors.blue.500", "#3b82f6"),
      ...e("colors")
    }),
    ringOffsetColor: ({ theme: e }) => e("colors"),
    ringOffsetWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    ringOpacity: ({ theme: e }) => ({
      DEFAULT: "0.5",
      ...e("opacity")
    }),
    ringWidth: {
      DEFAULT: "3px",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    rotate: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg",
      45: "45deg",
      90: "90deg",
      180: "180deg"
    },
    saturate: {
      0: "0",
      50: ".5",
      100: "1",
      150: "1.5",
      200: "2"
    },
    scale: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5"
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px"
    },
    scrollMargin: ({ theme: e }) => ({
      ...e("spacing")
    }),
    scrollPadding: ({ theme: e }) => e("spacing"),
    sepia: {
      0: "0",
      DEFAULT: "100%"
    },
    skew: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg"
    },
    space: ({ theme: e }) => ({
      ...e("spacing")
    }),
    spacing: {
      px: "1px",
      0: "0px",
      0.5: "0.125rem",
      1: "0.25rem",
      1.5: "0.375rem",
      2: "0.5rem",
      2.5: "0.625rem",
      3: "0.75rem",
      3.5: "0.875rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      14: "3.5rem",
      16: "4rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem"
    },
    stroke: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    strokeWidth: {
      0: "0",
      1: "1",
      2: "2"
    },
    supports: {},
    data: {},
    textColor: ({ theme: e }) => e("colors"),
    textDecorationColor: ({ theme: e }) => e("colors"),
    textDecorationThickness: {
      auto: "auto",
      "from-font": "from-font",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    textIndent: ({ theme: e }) => ({
      ...e("spacing")
    }),
    textOpacity: ({ theme: e }) => e("opacity"),
    textUnderlineOffset: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    transformOrigin: {
      center: "center",
      top: "top",
      "top-right": "top right",
      right: "right",
      "bottom-right": "bottom right",
      bottom: "bottom",
      "bottom-left": "bottom left",
      left: "left",
      "top-left": "top left"
    },
    transitionDelay: {
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionDuration: {
      DEFAULT: "150ms",
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionProperty: {
      none: "none",
      all: "all",
      DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
      colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
      opacity: "opacity",
      shadow: "box-shadow",
      transform: "transform"
    },
    transitionTimingFunction: {
      DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
      linear: "linear",
      in: "cubic-bezier(0.4, 0, 1, 1)",
      out: "cubic-bezier(0, 0, 0.2, 1)",
      "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
    },
    translate: ({ theme: e }) => ({
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    width: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      screen: "100vw",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    willChange: {
      auto: "auto",
      scroll: "scroll-position",
      contents: "contents",
      transform: "transform"
    },
    zIndex: {
      auto: "auto",
      0: "0",
      10: "10",
      20: "20",
      30: "30",
      40: "40",
      50: "50"
    }
  },
  plugins: []
};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const t = ar, n = /* @__PURE__ */ o(vc);
  function o(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  const i = (0, t.cloneDeep)(n.default.theme);
})(rr);
let Go = rr;
var Tc = (Go.__esModule ? Go : { default: Go }).default;
const kc = /* @__PURE__ */ Mi(Tc), $e = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#ffffff",
  primary: ls("primary"),
  secondary: ls("secondary"),
  blue: {
    DEFAULT: "#0081f9",
    light: "#a5d1ff",
    1: "#9ED0FE",
    2: "#77BCFD",
    3: "#4FA9FB",
    4: "#2895FA",
    5: "#0081F9",
    6: "#006CD0",
    7: "#0057A7",
    8: "#00417F",
    9: "#002C56"
  },
  gray: {
    1: "#f6f9fc",
    2: "#e9ecef",
    3: "#dee2e6",
    4: "#ced4da",
    5: "#adb5bd",
    6: "#8898aa",
    7: "#828282",
    8: "#4f4f4f",
    9: "#333333",
    "9.5": "#111111"
  },
  red: {
    DEFAULT: "#FD0044",
    1: "#FFA2BA",
    2: "#FE799D",
    3: "#FE517F",
    4: "#FD2862",
    5: "#FD0044",
    6: "#D40039",
    7: "#AB002E",
    8: "#830023",
    9: "#5A0018"
  },
  yellow: {
    DEFAULT: "#FCBF49",
    1: "#FEF2DB",
    2: "#FEE5B6",
    3: "#FDD992",
    4: "#FDCC6D",
    5: "#FCBF49",
    6: "#E1A93B",
    7: "#C7922D",
    8: "#AC7C1E",
    9: "#926510"
  },
  green: {
    DEFAULT: "#8CB369",
    1: "#DFEAD5",
    2: "#CADCBA",
    3: "#B6CF9F",
    4: "#A1C184",
    5: "#8CB369",
    6: "#789A59",
    7: "#64814A",
    8: "#4F673A",
    9: "#3B4E2B"
  },
  purple: {
    DEFAULT: "#733df9",
    1: "#E3D8FE",
    2: "#C7B1FD",
    3: "#AB8AFB",
    4: "#8F63FA",
    5: "#733DF9",
    6: "#6131D7",
    7: "#4F25B5",
    8: "#3C1A92",
    9: "#2A0E70"
  },
  orange: {
    DEFAULT: "#F97316",
    1: "#FFEDD5",
    2: "#FED7AA",
    3: "#FDBA74",
    4: "#FB923C",
    5: "#F97316",
    6: "#EA580C",
    7: "#C2410C",
    8: "#9A3412",
    9: "#7C2D12"
  },
  body: "#f8f9fe"
}, jc = (e) => {
  const t = (n) => {
    if (Array.isArray(n))
      return n.map(t);
    if (typeof n == "object") {
      const o = {};
      for (const i of Object.keys(n))
        o[i] = t(n[i]);
      return o;
    }
    return Sc(n);
  };
  return t(e);
}, Sc = (e) => (typeof e == "string" && (e = e.replace(/((\d*\.)?\d+)rem\b/g, (t, n) => `${16 * +n}px`)), e);
jc(kc.spacing);
const Lc = (e) => (Sn("data-v-db432714"), e = e(), Ln(), e), Ec = ["checked"], Oc = /* @__PURE__ */ Lc(() => /* @__PURE__ */ m("span", { class: "switch alt:!ring-1 alt:!ring-gray-4" }, null, -1)), xc = /* @__PURE__ */ T({
  __name: "BaseSwitch",
  props: {
    label: { type: [String, Boolean] },
    checked: { type: Boolean },
    size: { default: "medium" }
  },
  emits: ["update:checked"],
  setup(e, { emit: t }) {
    const n = e, o = k(() => n.size === "small"), i = k(() => n.size === "mini"), r = i.value ? 26 : 34, s = k(() => ({
      "--switch-container-width": `${r}px`,
      "--switch-size": `${r / 2 - 1}px`,
      //f00c is check, f00d is x
      "--content": `"\\f00${n.checked ? "c" : "d"}"`,
      "--bg-off": $e.gray[5],
      "--gray": $e.gray[5],
      "--dark-gray": $e.gray[5],
      "--bg-on": $e.gray[9],
      "--b-round-on": $e.gray[9]
    }));
    return (l, a) => (c(), p("label", {
      class: "base-switch-container",
      style: Ce(h(s))
    }, [
      Te(l.$slots, "default", {}, () => [
        l.label ? (c(), p("span", {
          key: 0,
          class: D(["label text-blue-9 font-bold", { "text-xs": h(i), "text-sm": h(o) }])
        }, N(l.label), 3)) : A("", !0)
      ], !0),
      m("input", Tt(l.$attrs, {
        class: "input",
        type: "checkbox",
        checked: l.checked,
        onChange: a[0] || (a[0] = (u) => t("update:checked", u.target.checked))
      }), null, 16, Ec),
      Oc
    ], 4));
  }
});
const kn = /* @__PURE__ */ x(xc, [["__scopeId", "data-v-db432714"]]);
let so;
const _c = new Uint8Array(16);
function Uc() {
  if (!so && (so = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !so))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return so(_c);
}
const Fe = [];
for (let e = 0; e < 256; ++e)
  Fe.push((e + 256).toString(16).slice(1));
function Fc(e, t = 0) {
  return Fe[e[t + 0]] + Fe[e[t + 1]] + Fe[e[t + 2]] + Fe[e[t + 3]] + "-" + Fe[e[t + 4]] + Fe[e[t + 5]] + "-" + Fe[e[t + 6]] + Fe[e[t + 7]] + "-" + Fe[e[t + 8]] + Fe[e[t + 9]] + "-" + Fe[e[t + 10]] + Fe[e[t + 11]] + Fe[e[t + 12]] + Fe[e[t + 13]] + Fe[e[t + 14]] + Fe[e[t + 15]];
}
const $c = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), cs = {
  randomUUID: $c
};
function rn(e, t, n) {
  if (cs.randomUUID && !t && !e)
    return cs.randomUUID();
  e = e || {};
  const o = e.random || (e.rng || Uc)();
  if (o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, t) {
    n = n || 0;
    for (let i = 0; i < 16; ++i)
      t[n + i] = o[i];
    return t;
  }
  return Fc(o);
}
const Rc = T({
  name: "TextEllipsis",
  props: {
    text: {
      type: String,
      required: !1
    },
    stop: {
      type: Boolean,
      default: !1
    },
    width: {
      type: String,
      default: null
    },
    customClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      textId: rn(),
      previewWidth: 0,
      loading: !0,
      distance: 0,
      scroll: !1
    };
  },
  computed: {
    textPreviewRef() {
      return this.textId + "-preview";
    },
    scrollStyle() {
      return this.stop ? "" : `transition: transform ${Math.floor(this.distance / 60 * 1e3)}ms linear ${this.scroll ? "500ms" : "0ms"}; transform: translateX(-${this.distance}px)`;
    },
    dynamicWidth() {
      return this.width ? `max-width: ${this.width}` : "max-width: 100%";
    }
  },
  methods: {
    startScroll() {
      this.calcPreviewWidth();
      const e = this.$refs[this.textId], t = e == null ? void 0 : e.getBoundingClientRect().width;
      t && (this.distance = this.previewWidth - t, this.scroll = !0);
    },
    stopScroll() {
      this.distance = 0, this.scroll = !1;
    },
    calcPreviewWidth() {
      const e = this.$refs[this.textPreviewRef];
      this.previewWidth = (e == null ? void 0 : e.getBoundingClientRect().width) || 0, this.loading = !1;
    }
  }
});
function Vc(e, t, n, o, i, r) {
  return c(), p("div", {
    onMouseenter: t[0] || (t[0] = (...s) => e.startScroll && e.startScroll(...s)),
    onMouseleave: t[1] || (t[1] = (...s) => e.stopScroll && e.stopScroll(...s)),
    class: D(["relative min-w-0 max-w-full inline-block whitespace-nowrap overflow-hidden", [e.customClass]]),
    style: Ce(e.dynamicWidth),
    ref: e.textId
  }, [
    m("div", {
      ref: e.textPreviewRef,
      class: D(["absolute overflow-x-hidden opacity-0 z-[-1]", { truncate: !e.scroll }])
    }, N(e.text), 3),
    m("div", {
      style: Ce(e.scrollStyle),
      class: D({ truncate: !e.scroll })
    }, N(e.text), 7)
  ], 38);
}
const Le = /* @__PURE__ */ x(Rc, [["render", Vc]]), lr = /* @__PURE__ */ T({
  __name: "BaseDropdown",
  props: {
    direction: {
      type: String,
      default: "down"
    },
    title: {
      type: String,
      description: "Dropdown title"
    },
    icon: {
      type: String,
      description: "Icon for dropdown title"
    },
    position: {
      type: String,
      description: "Position of dropdown menu (e.g right|left)"
    },
    menuClasses: {
      type: [String, Object],
      description: "Dropdown menu classes"
    },
    hideArrow: {
      type: Boolean,
      description: "Whether dropdown arrow should be hidden"
    },
    appendToBody: {
      type: Boolean,
      default: !0,
      description: "Whether dropdown should be appended to document body"
    },
    tag: {
      type: String,
      default: "div",
      description: "Dropdown html tag (e.g div, li etc)"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = e;
    let o = Y(!1);
    const i = () => {
      n.disabled || (o.value = !o.value, t("change", o.value));
    }, r = () => {
      o.value = !1, t("change", o.value);
    };
    return (s, l) => {
      const a = It("click-outside");
      return Ze((c(), C(xt(e.tag), {
        class: D(["dropdown", [
          { show: h(o) },
          { "right-direction": e.position === "right" },
          { dropdown: e.direction === "down" },
          { dropup: e.direction === "up" }
        ]]),
        "aria-haspopup": "true",
        "aria-expanded": h(o),
        onClick: be(i, ["stop"])
      }, {
        default: _(() => [
          Te(s.$slots, "title"),
          M(Xe, { name: "fade" }, {
            default: _(() => [
              h(o) ? (c(), p("div", {
                key: 0,
                class: D(["dropdown-menu shadow", [{ show: h(o) }, e.menuClasses]])
              }, [
                Te(s.$slots, "default")
              ], 2)) : A("", !0)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["class", "aria-expanded", "onClick"])), [
        [a, r]
      ]);
    };
  }
});
const Bc = ["fr", "en", "en-us", "es-es", "it-it", "pt-pt", "de-de", "pl-pl", "nl-nl"], Yc = {
  fr: "🇫🇷",
  "en-gb": "🇬🇧",
  en: "🇺🇸",
  "es-es": "🇪🇸",
  "it-it": "🇮🇹",
  "pt-pt": "🇵🇹",
  "de-de": "🇩🇪",
  "pl-pl": "🇵🇱",
  "nl-nl": "🇳🇱"
}, Qc = T({
  name: "language-flag",
  data() {
    return {
      emojies: Yc
    };
  },
  props: {
    language: {
      type: String,
      default: "fr",
      validator: (e) => Bc.includes(e)
    },
    emoji: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    flagPath() {
      return require(`../assets/flags/${this.language}.png`);
    },
    flagEmoji() {
      return this.emojies[this.language];
    }
  }
});
const Pc = { key: 0 }, Gc = ["src"];
function Zc(e, t, n, o, i, r) {
  return c(), p("div", null, [
    e.emoji ? (c(), p("div", Pc, N(e.emojies[e.language]), 1)) : (c(), p("img", {
      key: 1,
      src: e.flagPath
    }, null, 8, Gc))
  ]);
}
const Wc = /* @__PURE__ */ x(Qc, [["render", Zc], ["__scopeId", "data-v-5288e947"]]), cr = () => navigator.userAgent.search("Windows") !== -1, Hc = { class: "language-item" }, Jc = { class: "text-sm" }, us = /* @__PURE__ */ T({
  __name: "LanguageItem",
  props: {
    language: {
      type: String,
      default: "fr"
    }
  },
  setup(e) {
    return (t, n) => (c(), p("div", Hc, [
      h(cr)() ? A("", !0) : (c(), C(Wc, {
        key: 0,
        class: "flag-emoji",
        language: e.language,
        emoji: ""
      }, null, 8, ["language"])),
      m("span", Jc, N(t.$t(`settings.languages.${e.language}`)), 1)
    ]));
  }
});
const Kc = { class: "w-full bg-white" }, qc = /* @__PURE__ */ T({
  __name: "TranslationDropdown",
  props: {
    locale: {
      type: String,
      default: "fr"
    }
  },
  emits: ["update:locale"],
  setup(e, { emit: t }) {
    const n = e, o = ["fr", "en"], i = k(() => o.filter((s) => s !== n.locale)), r = Y(!1);
    return (s, l) => {
      const a = P, u = lr;
      return c(), C(u, {
        onChange: l[0] || (l[0] = (g) => r.value = g),
        menuClasses: "right-0"
      }, {
        title: _(() => [
          m("div", {
            class: D(["w-full px-3 py-3 flex items-center justify-between gap-2 border rounded transition-colors group", h(r) ? "border-blue" : "border-gray-4 hover:border-blue"])
          }, [
            M(us, { language: e.locale }, null, 8, ["language"]),
            M(a, {
              icon: ["fas", "chevron-down"],
              class: D(["text-xs transition-all", {
                "text-gray-5 group-hover:text-gray-9": !h(r),
                "-rotate-180 text-gray-9": h(r)
              }])
            }, null, 8, ["class"])
          ], 2)
        ]),
        default: _(() => [
          m("div", Kc, [
            (c(!0), p(X, null, te(h(i), (g) => (c(), p("div", {
              class: "px-[18px] py-2 hover:bg-blue hover:text-white border-b border-gray-4 last:border-b-0",
              key: g
            }, [
              M(us, {
                class: "slide font-bold",
                language: g,
                onClick: be((d) => t("update:locale", g), ["prevent"])
              }, null, 8, ["language", "onClick"])
            ]))), 128))
          ])
        ]),
        _: 1
      });
    };
  }
}), Xc = { class: "p-3 flex items-center gap-3 bg-gray-1 rounded" }, eu = {
  key: 0,
  class: "text-[18px]"
}, tu = { class: "flex-1" }, nu = { class: "mt-[2px] flex-1 text-xs text-blue-9" }, ou = { class: "mt-[2px] flex-1 flex justify-between text-xs text-blue-9" }, iu = { class: "ml-1" }, su = { class: "ml-1" }, Zo = /* @__PURE__ */ T({
  __name: "ShortcutCard",
  props: {
    checked: { type: Boolean },
    icon: {},
    label: {},
    subject: {},
    command: {},
    isSmall: { type: Boolean }
  },
  emits: ["update:checked"],
  setup(e, { emit: t }) {
    const n = e;
    return (o, i) => {
      const r = P, s = kn;
      return c(), p("div", null, [
        m("div", Xc, [
          o.icon ? (c(), p("div", eu, [
            M(r, { icon: o.icon }, null, 8, ["icon"])
          ])) : A("", !0),
          m("div", tu, [
            M(s, {
              class: "w-full",
              label: n.label,
              size: "mini",
              checked: o.checked,
              "onUpdate:checked": i[0] || (i[0] = (l) => t("update:checked", l))
            }, null, 8, ["label", "checked"]),
            m("div", {
              class: D(["mt-[2px] w-full flex", o.isSmall ? "flex-col" : "items-center justify-between"])
            }, [
              m("div", nu, N(n.subject), 1),
              m("div", ou, [
                m("div", null, [
                  M(r, { icon: ["fab", "apple"] }),
                  m("span", iu, N(n.command.mac), 1)
                ]),
                m("div", null, [
                  M(r, { icon: ["fab", "windows"] }),
                  m("span", su, N(n.command.win), 1)
                ])
              ])
            ], 2)
          ])
        ])
      ]);
    };
  }
}), ru = {
  key: 0,
  class: "pb-6 border-b border-gray-2"
}, au = { class: "mb-5.5 text-2xs text-blue-7 font-bold tracking-wide uppercase" }, lu = { class: "mb-2 text-sm text-blue-9 font-bold !leading-[19px]" }, cu = { class: "py-6 border-b border-gray-2" }, uu = { class: "mb-5.5 text-2xs text-blue-7 font-bold tracking-wide uppercase" }, du = { class: "space-y-4" }, gu = { key: 0 }, pu = { class: "mt-1 text-xs text-gray-6" }, mu = { key: 1 }, hu = { class: "mt-1 text-xs text-gray-6" }, fu = {
  key: 2,
  class: "space-y-1"
}, yu = { class: "text-blue-9 font-bold text-sm" }, Iu = {
  key: 3,
  class: "space-y-1"
}, Mu = { class: "text-blue-9 font-bold text-sm" }, Au = {
  key: 0,
  class: "bg-gray-1 border-gray-2 border p-2 rounded-lg flex items-center gap-2 !mt-2"
}, Nu = { class: "space-y-2" }, bu = { class: "text-blue-9 text-xs" }, Cu = { class: "py-6 border-b border-gray-2" }, wu = { class: "mb-5.5 text-2xs text-blue-7 font-bold tracking-wide uppercase" }, Du = { class: "space-y-4" }, zu = { key: 0 }, vu = { class: "mt-1 text-xs text-gray-6" }, Tu = { key: 1 }, ku = { class: "mt-1 text-xs text-gray-6" }, ju = { key: 2 }, Su = { class: "mt-1 text-xs text-gray-6 overflow-y-hidden" }, Lu = { class: "block" }, Eu = {
  key: 0,
  class: "mt-1 flex gap-3"
}, Ou = { class: "ml-1" }, xu = { class: "ml-1" }, _u = {
  key: 0,
  class: "overflow-y-hidden z-0"
}, Uu = {
  key: 1,
  class: "pt-6 pb-[19px]"
}, Fu = /* @__PURE__ */ T({
  __name: "Settings",
  props: {
    width: {},
    locale: {},
    options: { default: () => ({
      language: !0,
      displayFullTitle: !0,
      displayArticleInMainFrame: !0,
      resetNavigationPathAtOpening: !0,
      appShortcuts: !0,
      contentFontSize: !0,
      appPosition: !0,
      copyArticleShortcut: !0,
      copyGuideShortcut: !0,
      closeModalShortcut: !0,
      brainHighlight: !0,
      appActions: !0
    }) },
    hostApp: { default: "chrome-extension" }
  },
  emits: ["update:locale", "update:position", "refresh", "logout"],
  setup(e, { emit: t }) {
    const n = e, o = Y(null), i = k(() => n.width < 400), r = { mac: "cmd + maj + k", win: "ctrl + shift + k" }, s = { mac: "cmd + c", win: "ctrl + c" }, l = { mac: "cmd + esc", win: "ctrl + esc" }, a = ft(), {
      displayFullTitle: u,
      displayArticleInMainFrame: g,
      resetNavigationPathAtOpening: d,
      hasArticleCopyPasteShortcut: f,
      hasAnswerCopyPasteShortcut: I,
      hasModalClosureShortcut: z,
      appPosition: v,
      hasCompanyBrainHighlight: Q,
      hasUserBrainHighlight: H,
      contentFontSize: ee
    } = De(a), j = k(() => n.hostApp === "chrome-ext"), G = (O) => {
      t("update:locale", O);
      const ge = {
        oldLanguage: n.locale,
        newLanguage: O
      };
      a.logs({
        topic: "SETTINGS_LANGUAGE",
        url: window.location.href,
        event: ge
      });
    }, V = k({
      get() {
        return u.value;
      },
      set(O) {
        a.updatePreference("DISPLAY_FULL_TITLE", O);
      }
    }), K = k({
      get() {
        return g.value;
      },
      set(O) {
        a.updatePreference("DISPLAY_ARTICLE_IN_MAIN_FRAME", O);
      }
    }), U = k({
      get() {
        return d.value;
      },
      set(O) {
        a.updatePreference("RESET_NAVIGATION_PATH_AT_OPENING", O);
      }
    }), he = k({
      get() {
        return f.value;
      },
      set(O) {
        a.updatePreference("ARTICLE_COPY_PASTE_SHORTCUT", O);
      }
    }), se = k({
      get() {
        return I.value;
      },
      set(O) {
        a.updatePreference("ANSWER_COPY_PASTE_SHORTCUT", O);
      }
    }), F = k({
      get() {
        return z.value;
      },
      set(O) {
        a.updatePreference("MODAL_CLOSURE_SHORTCUT", O);
      }
    });
    let $ = Y(he.value || se.value || F.value);
    const oe = k({
      get() {
        return he.value || se.value || F.value || $.value;
      },
      set(O) {
        $.value = O, a.updatePreference("ARTICLE_COPY_PASTE_SHORTCUT", O), a.updatePreference("ANSWER_COPY_PASTE_SHORTCUT", O), a.updatePreference("MODAL_CLOSURE_SHORTCUT", O), O && pe();
      }
    }), pe = async () => {
      await at();
      const O = o.value;
      O == null || O.scrollIntoView({ behavior: "smooth", block: "start" });
    }, Qe = [
      { key: "top-left", label: "settings.display.position.options.top-left" },
      { key: "top-right", label: "settings.display.position.options.top-right" },
      { key: "bottom-right", label: "settings.display.position.options.bottom-right" },
      { key: "bottom-left", label: "settings.display.position.options.bottom-left" }
    ], ot = Y(!1), Mt = (O) => {
      ot.value = !0, q.value = O, ae.value || t("update:position", O), setTimeout(() => {
        ot.value = !1;
      }, 1e3);
    }, q = k({
      get() {
        return v.value || "bottom-right";
      },
      set(O) {
        a.updatePreference("WEB_EXT_POSITION", O);
      }
    }), B = Y(window.location.hostname), ae = Y(a.getAppPositionByHostname(B.value)), re = () => {
      a.removeAppPositionByHostname(B.value), ae.value = void 0, t("update:position", q.value);
    }, de = k({
      get() {
        return H.value;
      },
      set(O) {
        a.updatePreference("BRAIN_ENABLE_HIGHLIGHT", O);
      }
    }), ke = [
      { key: "sm", label: "settings.display.content-size.options.sm" },
      { key: "md", label: "settings.display.content-size.options.md" },
      { key: "lg", label: "settings.display.content-size.options.lg" },
      { key: "xl", label: "settings.display.content-size.options.xl" }
    ], ce = (O) => {
      a.updatePreference("CONTENT_FONT_SIZE", O);
    };
    return (O, ge) => {
      const At = kn, Ut = Le, Ht = kn, Ft = wi, He = P, Je = ye;
      return c(), p("div", null, [
        O.options.language ? (c(), p("div", ru, [
          m("h2", au, N(O.$t(h(j) ? "settings.language.title" : "settings.language.app-title")), 1),
          m("div", lu, N(O.$t("settings.language.select-language")), 1),
          M(qc, {
            locale: O.locale,
            "onUpdate:locale": G
          }, null, 8, ["locale"])
        ])) : A("", !0),
        m("div", cu, [
          m("h2", uu, N(O.$t("settings.display.title")), 1),
          m("div", du, [
            O.options.displayFullTitle ? (c(), p("div", gu, [
              M(At, {
                size: "small",
                label: O.$t("settings.display.full-title.title"),
                checked: h(V),
                "onUpdate:checked": ge[0] || (ge[0] = (Ie) => Be(V) ? V.value = Ie : null)
              }, null, 8, ["label", "checked"]),
              m("div", pu, N(O.$t("settings.display.full-title.description")), 1)
            ])) : A("", !0),
            O.options.displayArticleInMainFrame ? (c(), p("div", mu, [
              M(Ht, {
                class: "gap-2",
                size: "small",
                checked: h(K),
                "onUpdate:checked": ge[1] || (ge[1] = (Ie) => Be(K) ? K.value = Ie : null)
              }, {
                default: _(() => [
                  M(Ut, {
                    customClass: "text-sm text-blue-9 font-bold",
                    text: O.$t("settings.display.open-article.title")
                  }, null, 8, ["text"])
                ]),
                _: 1
              }, 8, ["checked"]),
              m("div", hu, N(O.$t("settings.display.open-article.description")), 1)
            ])) : A("", !0),
            O.options.contentFontSize ? (c(), p("div", fu, [
              m("div", yu, N(O.$t("settings.display.content-size.title")), 1),
              M(Ft, {
                options: ke,
                value: h(ee),
                onUpdate: ce
              }, null, 8, ["value"])
            ])) : A("", !0),
            O.options.appPosition ? (c(), p("div", Iu, [
              m("div", Mu, N(O.$t("settings.display.position.title")), 1),
              M(Ft, {
                options: Qe,
                value: h(q),
                onUpdate: Mt,
                loading: h(ot)
              }, null, 8, ["value", "loading"]),
              h(ae) ? (c(), p("div", Au, [
                M(He, {
                  class: "text-blue-9 h-[19px]",
                  icon: ["fas", "info-circle"]
                }),
                m("div", Nu, [
                  m("div", bu, [
                    m("span", null, N(O.$t("settings.display.position.by-hostname.set")), 1),
                    m("strong", null, ' "' + N(O.$t("settings.display.position.options." + h(ae))) + '" ', 1),
                    m("span", null, N(O.$t("settings.display.position.by-hostname.for")), 1),
                    m("em", null, N(h(B)), 1)
                  ]),
                  M(Je, {
                    size: "mini",
                    outline: "",
                    type: "secondary",
                    onClick: re
                  }, {
                    default: _(() => [
                      ne(N(O.$t("settings.display.position.reset")), 1)
                    ]),
                    _: 1
                  })
                ])
              ])) : A("", !0)
            ])) : A("", !0)
          ])
        ]),
        m("div", Cu, [
          m("h2", wu, N(O.$t("settings.productivity.title")), 1),
          m("div", Du, [
            O.options.resetNavigationPathAtOpening ? (c(), p("div", zu, [
              M(At, {
                size: "small",
                label: O.$t("settings.productivity.reset-label"),
                checked: h(U),
                "onUpdate:checked": ge[2] || (ge[2] = (Ie) => Be(U) ? U.value = Ie : null)
              }, null, 8, ["label", "checked"]),
              m("div", vu, N(O.$t("settings.productivity.reset-desc")), 1)
            ])) : A("", !0),
            h(Q) && O.options.brainHighlight ? (c(), p("div", Tu, [
              M(At, {
                size: "small",
                label: O.$t("settings.productivity.brain-highlight-label"),
                checked: h(de),
                "onUpdate:checked": ge[3] || (ge[3] = (Ie) => Be(de) ? de.value = Ie : null)
              }, null, 8, ["label", "checked"]),
              m("div", ku, N(O.$t("settings.productivity.brain-highlight-desc")), 1)
            ])) : A("", !0),
            O.options.appShortcuts ? (c(), p("div", ju, [
              M(At, {
                size: "small",
                label: O.$t("settings.productivity.shortcut-label"),
                checked: h(oe),
                "onUpdate:checked": ge[4] || (ge[4] = (Ie) => Be(oe) ? oe.value = Ie : null)
              }, null, 8, ["label", "checked"]),
              m("div", Su, [
                m("span", Lu, N(O.$t(
                  h(j) ? "settings.productivity.shortcut-desc" : "settings.productivity.app-shortcut-desc"
                )), 1),
                h(j) ? (c(), p("div", Eu, [
                  m("div", null, [
                    M(He, { icon: ["fab", "apple"] }),
                    m("span", Ou, N(r.mac), 1)
                  ]),
                  m("div", null, [
                    M(He, { icon: ["fab", "windows"] }),
                    m("span", xu, N(r.win), 1)
                  ])
                ])) : A("", !0)
              ]),
              M(Xe, { name: "fade" }, {
                default: _(() => [
                  h($) ? (c(), p("div", _u, [
                    O.options.copyArticleShortcut ? (c(), C(Zo, {
                      key: 0,
                      class: "mt-3",
                      checked: h(he),
                      "onUpdate:checked": ge[5] || (ge[5] = (Ie) => Be(he) ? he.value = Ie : null),
                      icon: ["fal", "copy"],
                      label: O.$t("settings.productivity.copy-paste"),
                      subject: O.$t("settings.productivity.article"),
                      command: s,
                      "is-small": h(i)
                    }, null, 8, ["checked", "label", "subject", "is-small"])) : A("", !0),
                    O.options.copyGuideShortcut ? (c(), C(Zo, {
                      key: 1,
                      class: "mt-1",
                      checked: h(se),
                      "onUpdate:checked": ge[6] || (ge[6] = (Ie) => Be(se) ? se.value = Ie : null),
                      icon: ["fal", "copy"],
                      label: O.$t("settings.productivity.copy-paste"),
                      subject: O.$t("settings.productivity.guide"),
                      command: s,
                      "is-small": h(i)
                    }, null, 8, ["checked", "label", "subject", "is-small"])) : A("", !0),
                    O.options.closeModalShortcut ? (c(), C(Zo, {
                      key: 2,
                      class: "mt-1",
                      checked: h(F),
                      "onUpdate:checked": ge[7] || (ge[7] = (Ie) => Be(F) ? F.value = Ie : null),
                      icon: ["fal", "close"],
                      label: O.$t("settings.productivity.modal-closing"),
                      subject: O.$t("settings.productivity.article-diagnosis"),
                      command: l,
                      "is-small": h(i)
                    }, null, 8, ["checked", "label", "subject", "is-small"])) : A("", !0),
                    m("div", {
                      ref_key: "bottomRef",
                      ref: o
                    }, null, 512)
                  ])) : A("", !0)
                ]),
                _: 1
              })
            ])) : A("", !0)
          ])
        ]),
        O.options.appActions ? (c(), p("div", Uu, [
          M(Je, {
            class: "w-full",
            outline: "",
            rounded: "",
            type: "secondary",
            size: "medium",
            onClick: ge[8] || (ge[8] = (Ie) => t("refresh"))
          }, {
            default: _(() => [
              M(He, { icon: ["fas", "rotate"] }),
              m("span", null, N(O.$t("settings.actions.refresh")), 1)
            ]),
            _: 1
          }),
          M(Je, {
            class: "mt-4 w-full",
            outline: "",
            rounded: "",
            type: "secondary",
            size: "medium",
            onClick: ge[9] || (ge[9] = (Ie) => t("logout"))
          }, {
            default: _(() => [
              M(He, { icon: ["fas", "power-off"] }),
              m("span", null, N(O.$t("settings.actions.logout")), 1)
            ]),
            _: 1
          })
        ])) : A("", !0)
      ]);
    };
  }
}), et = {
  en: {
    login: {
      baseline: {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Welcome 👋"]);
        },
        subtitle: (e) => {
          const { normalize: t } = e;
          return t(["Log in to unlock the potential of knowledge!"]);
        }
      },
      instructions: (e) => {
        const { normalize: t } = e;
        return t(["Enter your login information"]);
      },
      "sso-instructions": (e) => {
        const { normalize: t } = e;
        return t(["Enter your company's Mayday domain name"]);
      },
      "sso-placeholder": (e) => {
        const { normalize: t } = e;
        return t(["Company's subdomain"]);
      },
      "access-token-instructions": (e) => {
        const { normalize: t } = e;
        return t(["Enter your access token"]);
      },
      "access-token-placeholder": (e) => {
        const { normalize: t } = e;
        return t(["Access token"]);
      },
      "weak-connection": (e) => {
        const { normalize: t } = e;
        return t(["Slow internet connection, loading may take some time."]);
      },
      "please-wait": (e) => {
        const { normalize: t } = e;
        return t(["Please wait"]);
      },
      "back-to-login": (e) => {
        const { normalize: t } = e;
        return t(["Log in differently"]);
      },
      "reset-domain": (e) => {
        const { normalize: t } = e;
        return t(["Reset domain"]);
      },
      form: {
        email: (e) => {
          const { normalize: t } = e;
          return t(["Email address"]);
        },
        password: (e) => {
          const { normalize: t } = e;
          return t(["Password"]);
        },
        domain: (e) => {
          const { normalize: t } = e;
          return t(["Domain name"]);
        },
        "access-token": (e) => {
          const { normalize: t } = e;
          return t(["Access token"]);
        },
        login: (e) => {
          const { normalize: t } = e;
          return t(["Log in"]);
        },
        "sso-cta": (e) => {
          const { normalize: t } = e;
          return t(["Continue"]);
        },
        or: (e) => {
          const { normalize: t } = e;
          return t(["or"]);
        },
        "google-signin": (e) => {
          const { normalize: t } = e;
          return t(["Log in with Google"]);
        },
        "sso-signin": (e) => {
          const { normalize: t } = e;
          return t(["Single Sign-On (SSO)"]);
        },
        "access-token-signin": (e) => {
          const { normalize: t } = e;
          return t(["Access token"]);
        }
      },
      errors: {
        authentication: (e) => {
          const { normalize: t } = e;
          return t(["The combination of email and password is incorrect"]);
        },
        "invalid-domain": (e) => {
          const { normalize: t } = e;
          return t(["The entered domain name is invalid"]);
        },
        permissions: (e) => {
          const { normalize: t } = e;
          return t(["You do not have sufficient access rights, please ask an administrator to assign you to a group"]);
        },
        unverified: (e) => {
          const { normalize: t } = e;
          return t(["Your account is still being validated, please contact an administrator"]);
        },
        default: (e) => {
          const { normalize: t } = e;
          return t(["An error has occurred, please try again"]);
        },
        "tab-1": (e) => {
          const { normalize: t } = e;
          return t(["A problem related to the current tab has occurred. Please"]);
        },
        "tab-2": (e) => {
          const { normalize: t } = e;
          return t(["clear your cache"]);
        },
        "tab-3": (e) => {
          const { normalize: t } = e;
          return t(["and try again."]);
        }
      },
      "forgot-password": (e) => {
        const { normalize: t } = e;
        return t(["Forgot password?"]);
      },
      register: {
        question: (e) => {
          const { normalize: t } = e;
          return t(["Not registered?"]);
        },
        action: (e) => {
          const { normalize: t } = e;
          return t(["Create account"]);
        }
      }
    },
    dropdown: {
      preferences: (e) => {
        const { normalize: t } = e;
        return t(["Preferences"]);
      },
      refresh: (e) => {
        const { normalize: t } = e;
        return t(["Refresh"]);
      },
      "knowledge-base": (e) => {
        const { normalize: t } = e;
        return t(["Knowledge Base"]);
      },
      "knowledge-language": (e) => {
        const { normalize: t } = e;
        return t(["Languages"]);
      },
      "change-knowledge-base": (e) => {
        const { normalize: t } = e;
        return t(["Switch Knowledge"]);
      },
      "bug-report": (e) => {
        const { normalize: t } = e;
        return t(["Report a bug"]);
      },
      "reset-domain": (e) => {
        const { normalize: t } = e;
        return t(["Reset domain"]);
      },
      logout: (e) => {
        const { normalize: t } = e;
        return t(["Log out"]);
      },
      collection: (e) => {
        const { normalize: t, interpolate: n, named: o, plural: i } = e;
        return i([t([n(o("count")), " content sorted by:"]), t([n(o("count")), " contents sorted by :  "])]);
      },
      options: {
        recommended: (e) => {
          const { normalize: t } = e;
          return t(["Recommended"]);
        },
        "alpha-asc": (e) => {
          const { normalize: t } = e;
          return t(["Alphabetical (A-Z)"]);
        },
        "alpha-desc": (e) => {
          const { normalize: t } = e;
          return t(["Anti-Alphabetical (Z-A)"]);
        }
      }
    },
    search: {
      cta: (e) => {
        const { normalize: t } = e;
        return t(["Quick search"]);
      },
      breadcrumb: (e) => {
        const { normalize: t } = e;
        return t(["Filter"]);
      },
      "no-results": (e) => {
        const { normalize: t } = e;
        return t(["No results found 🧐"]);
      },
      filters: {
        types: (e) => {
          const { normalize: t } = e;
          return t(["Types"]);
        },
        reset: (e) => {
          const { normalize: t } = e;
          return t(["Reset"]);
        },
        "see-more": (e) => {
          const { normalize: t } = e;
          return t(["See more"]);
        },
        "see-less": (e) => {
          const { normalize: t } = e;
          return t(["See less"]);
        },
        "filters-count": (e) => {
          const { normalize: t, interpolate: n, named: o, plural: i } = e;
          return i([t([n(o("count")), " filter"]), t([n(o("count")), " filters"])]);
        },
        advanced: (e) => {
          const { normalize: t, plural: n } = e;
          return n([t(["Advanced search filter"]), t(["Advanced search filters"])]);
        },
        "focus-case": (e) => {
          const { normalize: t, interpolate: n, named: o } = e;
          return t(["Current collection only : ", n(o("label"))]);
        }
      },
      "user-boost": {
        high: (e) => {
          const { normalize: t } = e;
          return t(["In the top 10% of your consultations"]);
        },
        medium: (e) => {
          const { normalize: t } = e;
          return t(["In the top 20% of your consultations"]);
        },
        low: (e) => {
          const { normalize: t } = e;
          return t(["In the top 30% of your consultations"]);
        }
      }
    },
    knowledge: {
      explore: (e) => {
        const { normalize: t } = e;
        return t(["Explore"]);
      },
      "show-more": (e) => {
        const { normalize: t } = e;
        return t(["Show more"]);
      },
      "show-less": (e) => {
        const { normalize: t } = e;
        return t(["Show less"]);
      },
      automation: (e) => {
        const { normalize: t } = e;
        return t(["Automation detected"]);
      },
      "diag-viewer": {
        description: (e) => {
          const { normalize: t } = e;
          return t(["The problem concerns"]);
        },
        "linked-articles": (e) => {
          const { normalize: t } = e;
          return t(["Related Articles"]);
        },
        "linked-files": (e) => {
          const { normalize: t } = e;
          return t(["Related Files"]);
        }
      },
      "zoom-element": (e) => {
        const { normalize: t } = e;
        return t(["Zoom on the element"]);
      },
      "zoom-open-tab": (e) => {
        const { normalize: t } = e;
        return t(["Click to enlarge"]);
      },
      "empty-collection": {
        title: (e) => {
          const { normalize: t } = e;
          return t(["This folder is empty"]);
        },
        description: (e) => {
          const { normalize: t } = e;
          return t(["This may be due to your access rights"]);
        },
        cta: (e) => {
          const { normalize: t } = e;
          return t(["Go back"]);
        }
      },
      "collection-description": (e) => {
        const { normalize: t } = e;
        return t(["Description"]);
      },
      "empty-step": {
        title: (e) => {
          const { normalize: t } = e;
          return t(["This step is empty"]);
        },
        description: (e) => {
          const { normalize: t } = e;
          return t(["This may be due to your access rights"]);
        },
        cta: (e) => {
          const { normalize: t } = e;
          return t(["Go back"]);
        }
      },
      answer: (e) => {
        const { normalize: t } = e;
        return t(["Suggested answer:"]);
      },
      actions: {
        "favorite-add": (e) => {
          const { normalize: t } = e;
          return t(["Add to favorites"]);
        },
        "favorite-remove": (e) => {
          const { normalize: t } = e;
          return t(["Remove from favorites"]);
        },
        "copy-body": (e) => {
          const { normalize: t } = e;
          return t(["Copy content"]);
        },
        "copy-link": (e) => {
          const { normalize: t } = e;
          return t(["Copy URL"]);
        },
        answer: (e) => {
          const { normalize: t } = e;
          return t(["Open suggested answer"]);
        },
        "go-to-feedback": (e) => {
          const { normalize: t } = e;
          return t(["Give feedback"]);
        },
        "open-in-web": (e) => {
          const { normalize: t } = e;
          return t(["Open in full page"]);
        },
        "salesforce-case": (e) => {
          const { normalize: t } = e;
          return t(["Update Salesforce case"]);
        }
      },
      notification: {
        "add-favorite": (e) => {
          const { normalize: t } = e;
          return t(["The content has been successfully added to favorites!"]);
        },
        "remove-favorite": (e) => {
          const { normalize: t } = e;
          return t(["The content has been successfully removed from favorites!"]);
        },
        "copy-body": (e) => {
          const { normalize: t } = e;
          return t(["The content has been successfully copied!"]);
        },
        "copy-link": (e) => {
          const { normalize: t } = e;
          return t(["The URL has been successfully copied!"]);
        },
        feedback: (e) => {
          const { normalize: t } = e;
          return t(["Thank you for your feedback!"]);
        },
        satisfaction: (e) => {
          const { normalize: t } = e;
          return t(["Thank you for your feedback!"]);
        },
        "access-rights": (e) => {
          const { normalize: t } = e;
          return t(["You do not have the rights to access this content"]);
        }
      },
      satisfaction: {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Was this content helpful?"]);
        },
        cta: (e) => {
          const { normalize: t } = e;
          return t(["Send feedback to improve it"]);
        }
      },
      "ai-collapse": {
        summary: (e) => {
          const { normalize: t } = e;
          return t(["Summary"]);
        },
        "action-items": (e) => {
          const { normalize: t } = e;
          return t(["Action items"]);
        },
        "edited-at": (e) => {
          const { normalize: t } = e;
          return t(["Manually edited on"]);
        },
        "generated-at": (e) => {
          const { normalize: t } = e;
          return t(["Generated on"]);
        }
      },
      "empty-state": {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Sorry, we can not display this page"]);
        },
        cta: (e) => {
          const { normalize: t } = e;
          return t(["Please refresh"]);
        },
        "cta-close": (e) => {
          const { normalize: t } = e;
          return t(["Close"]);
        },
        "no-content": (e) => {
          const { normalize: t } = e;
          return t(["You do not have access to this content, please contact an administrator"]);
        }
      },
      "empty-filter": {
        title: (e) => {
          const { normalize: t } = e;
          return t(["No result"]);
        },
        description: (e) => {
          const { normalize: t } = e;
          return t(["No content matches your research."]);
        },
        cta: (e) => {
          const { normalize: t } = e;
          return t(["Reset filters"]);
        }
      }
    },
    feedback: {
      "label-text": (e) => {
        const { normalize: t } = e;
        return t(["Feedback"]);
      },
      attachments: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["Attachment"]), t(["Attachment"]), t(["Attachments"])]);
      },
      link: (e) => {
        const { normalize: t } = e;
        return t(["Link the current content being read"]);
      },
      "label-target": (e) => {
        const { normalize: t } = e;
        return t(["Recipient"]);
      },
      "target-placeholder": (e) => {
        const { normalize: t } = e;
        return t(["Select a recipient"]);
      },
      placeholder: (e) => {
        const { normalize: t } = e;
        return t(["What do you want to share?"]);
      },
      "success-message": (e) => {
        const { normalize: t } = e;
        return t(["Your message has been successfully sent ✉️"]);
      },
      cta: (e) => {
        const { normalize: t } = e;
        return t(["Send"]);
      },
      cancel: (e) => {
        const { normalize: t } = e;
        return t(["Cancel"]);
      },
      "tab-new": (e) => {
        const { normalize: t } = e;
        return t(["New"]);
      },
      "tab-history": (e) => {
        const { normalize: t } = e;
        return t(["Sent"]);
      },
      "sent-at": (e) => {
        const { normalize: t } = e;
        return t(["Sent on"]);
      },
      "sent-to": (e) => {
        const { normalize: t } = e;
        return t(["To"]);
      },
      "deleted-user": (e) => {
        const { normalize: t } = e;
        return t(["Deleted user"]);
      },
      groups: (e) => {
        const { normalize: t } = e;
        return t(["Groups"]);
      },
      collaborators: (e) => {
        const { normalize: t } = e;
        return t(["Collaborators"]);
      },
      "add-attachment": (e) => {
        const { normalize: t } = e;
        return t(["Add"]);
      },
      status: {
        doing: (e) => {
          const { normalize: t } = e;
          return t(["In progress"]);
        },
        sent: (e) => {
          const { normalize: t } = e;
          return t(["Sent"]);
        },
        "to-do": (e) => {
          const { normalize: t } = e;
          return t(["To do"]);
        },
        archived: (e) => {
          const { normalize: t } = e;
          return t(["Archived"]);
        },
        over: (e) => {
          const { normalize: t } = e;
          return t(["Done"]);
        }
      },
      content: (e) => {
        const { normalize: t } = e;
        return t(["Related content:"]);
      },
      rating: (e) => {
        const { normalize: t } = e;
        return t(["Note:"]);
      },
      comments: (e) => {
        const { normalize: t } = e;
        return t(["Messages"]);
      },
      answer: (e) => {
        const { normalize: t } = e;
        return t(["Reply"]);
      },
      "show-more": (e) => {
        const { normalize: t } = e;
        return t(["See more"]);
      },
      "new-feedback": (e) => {
        const { normalize: t } = e;
        return t(["Write feedback"]);
      },
      empty: (e) => {
        const { normalize: t } = e;
        return t(["You have not yet sent any feedback!"]);
      }
    },
    modals: {
      "copy-article": (e) => {
        const { normalize: t } = e;
        return t(["The article has been successfully copied 🖇️"]);
      },
      "copy-answer": (e) => {
        const { normalize: t } = e;
        return t(["The answer has been successfully copied 🖇️"]);
      }
    },
    attachments: {
      title: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["Attachment:"]), t(["Attachment:"]), t(["Attachments:"])]);
      },
      "disable-file-upload": (e) => {
        const { normalize: t } = e;
        return t(["The maximum number of attachments has been reached."]);
      },
      "too-many-files": (e) => {
        const { normalize: t } = e;
        return t(["You cannot attach more than 3 files"]);
      },
      "file-too-big": (e) => {
        const { normalize: t } = e;
        return t(["The file size exceeds the allowed limit."]);
      },
      "upload-problem": (e) => {
        const { normalize: t } = e;
        return t(["The file could not be downloaded, please try again."]);
      },
      "existing-file": (e) => {
        const { normalize: t } = e;
        return t(["A file you want to attach is already in your attachments."]);
      }
    },
    notifications: {
      title: (e) => {
        const { normalize: t } = e;
        return t(["Notifications"]);
      },
      tabs: {
        all: (e) => {
          const { normalize: t } = e;
          return t(["All"]);
        },
        info: (e) => {
          const { normalize: t } = e;
          return t(["Info"]);
        },
        feedback: (e) => {
          const { normalize: t } = e;
          return t(["Feedback"]);
        }
      },
      you: (e) => {
        const { normalize: t } = e;
        return t(["You"]);
      },
      "read-all": (e) => {
        const { normalize: t } = e;
        return t(["Read all"]);
      },
      "get-more": (e) => {
        const { normalize: t } = e;
        return t(["Show more"]);
      },
      "time-ago": (e) => {
        const { normalize: t, interpolate: n, named: o } = e;
        return t([n(o("time")), " ago"]);
      },
      yesterday: (e) => {
        const { normalize: t } = e;
        return t(["Yesterday"]);
      },
      now: (e) => {
        const { normalize: t } = e;
        return t(["Now"]);
      },
      urgent: (e) => {
        const { normalize: t } = e;
        return t(["Urgent notification"]);
      },
      filters: {
        button: (e) => {
          const { normalize: t } = e;
          return t(["Filter"]);
        },
        unread: (e) => {
          const { normalize: t } = e;
          return t(["Unread"]);
        },
        feedback: (e) => {
          const { normalize: t } = e;
          return t(["Feedback"]);
        },
        infos: (e) => {
          const { normalize: t } = e;
          return t(["Information"]);
        },
        date: (e) => {
          const { normalize: t } = e;
          return t(["Date"]);
        },
        reset: (e) => {
          const { normalize: t } = e;
          return t(["Reset"]);
        },
        timeframes: {
          "3-last-days": (e) => {
            const { normalize: t } = e;
            return t(["Last 3 days"]);
          },
          "last-week": (e) => {
            const { normalize: t } = e;
            return t(["Last week"]);
          },
          "2-last-weeks": (e) => {
            const { normalize: t } = e;
            return t(["Last 2 weeks"]);
          },
          "last-month": (e) => {
            const { normalize: t } = e;
            return t(["Last month"]);
          },
          "3-last-months": (e) => {
            const { normalize: t } = e;
            return t(["Last 3 months"]);
          }
        }
      },
      empty: {
        title: (e) => {
          const { normalize: t } = e;
          return t(["No notifications"]);
        },
        description: (e) => {
          const { normalize: t } = e;
          return t(["You currently have no notifications to display"]);
        },
        "filtered-title": (e) => {
          const { normalize: t } = e;
          return t(["No results!"]);
        },
        "filtered-description": (e) => {
          const { normalize: t } = e;
          return t(["Clear or modify your filters to display better results"]);
        },
        cta: (e) => {
          const { normalize: t } = e;
          return t(["Clear filters"]);
        },
        close: (e) => {
          const { normalize: t } = e;
          return t(["Close"]);
        }
      },
      footer: (e) => {
        const { normalize: t } = e;
        return t(["Click on notifications to send a read confirmation"]);
      },
      feedback: {
        title: {
          TaskMineComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["replied to the feedback related to content:"]), t(["replied to this global feedback:"])]);
          },
          TaskComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["commented on the feedback related to content:"]), t(["commented on this global feedback:"])]);
          },
          MentionTaskComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["mentioned you in a comment on the feedback related to content:"]), t(["mentioned you in a comment on this global feedback:"])]);
          },
          UsedToBeMentionTaskComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["commented on the feedback where you were mentioned related to the content:"]), t(["commented on this feedback global where you were mentioned"])]);
          },
          InternalTaskMineComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["created an internal note on the feedback related to content:"]), t(["created an internal note on this global feedback:"])]);
          },
          InternalTaskComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["created an internal note on the feedback related to content:"]), t(["created an internal note on this global feedback:"])]);
          },
          MentionInternalTaskComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["mentioned you in an internal note on the feedback related to content:"]), t(["mentioned you in an internal note on this global feedback:"])]);
          },
          TaskMoved: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["is processing your feedback on content:"]), t(["is processing your global feedback:"])]);
          },
          TaskUpvoted: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["liked your feedback on the content:"]), t(["liked your global feedback"])]);
          },
          TaskAssigned: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["assigned you a task on the content:"]), t(["assigned you a task on a global feedback"])]);
          },
          Feedback: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["gave you feedback on the content:"]), t(["gave you global feedback"])]);
          },
          ContentToVerify: (e) => {
            const { normalize: t } = e;
            return t(["have a verification to do on a content:"]);
          },
          ContentMention: (e) => {
            const { normalize: t } = e;
            return t(["mentioned you on the content:"]);
          },
          ContentThreadMessage: (e) => {
            const { normalize: t } = e;
            return t(["added a comment on the content:"]);
          },
          ContentThreadMention: (e) => {
            const { normalize: t } = e;
            return t(["mentioned you in a comment on the content:"]);
          },
          ContentThreadVote: (e) => {
            const { normalize: t } = e;
            return t(["liked your comment on the content:"]);
          },
          ContentThreadStatus: {
            SOLVED: (e) => {
              const { normalize: t } = e;
              return t(["resolved a thread on the content:"]);
            },
            ARCHIVED: (e) => {
              const { normalize: t } = e;
              return t(["archived a thread on the content:"]);
            }
          }
        },
        response: {
          button: (e) => {
            const { normalize: t } = e;
            return t(["Reply"]);
          },
          placeholder: (e) => {
            const { normalize: t } = e;
            return t(["Type your answer"]);
          }
        }
      },
      info: {
        "attached-content": (e) => {
          const { normalize: t } = e;
          return t(["View content"]);
        },
        task: (e) => {
          const { normalize: t } = e;
          return t(["View task"]);
        },
        "content-error": (e) => {
          const { normalize: t } = e;
          return t(["Missing content"]);
        },
        "author-error": (e) => {
          const { normalize: t } = e;
          return t(["User not found"]);
        },
        "deleted-user": (e) => {
          const { normalize: t } = e;
          return t(["(Deleted user)"]);
        },
        edited: (e) => {
          const { normalize: t } = e;
          return t(["(modified)"]);
        }
      },
      "show-more": (e) => {
        const { normalize: t, interpolate: n, named: o, plural: i } = e;
        return i([t(["Show one comment"]), t(["Show ", n(o("count")), " comments"])]);
      },
      "show-less": (e) => {
        const { normalize: t } = e;
        return t(["Show less"]);
      },
      urgents: {
        label: (e) => {
          const { normalize: t } = e;
          return t(["Urgent Notification"]);
        },
        display: (e) => {
          const { normalize: t } = e;
          return t(["Show"]);
        },
        hide: (e) => {
          const { normalize: t } = e;
          return t(["Hide"]);
        },
        "linked-content": (e) => {
          const { normalize: t } = e;
          return t(["View content"]);
        },
        count: (e) => {
          const { normalize: t } = e;
          return t(["Notification"]);
        },
        link: (e) => {
          const { normalize: t } = e;
          return t(["Link"]);
        },
        slide: {
          "all-read": (e) => {
            const { normalize: t } = e;
            return t(["You have read all urgent notifications."]);
          },
          reread: (e) => {
            const { normalize: t } = e;
            return t(["Read again"]);
          },
          hide: (e) => {
            const { normalize: t } = e;
            return t(["Hide"]);
          }
        }
      }
    },
    settings: {
      language: {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Extension language"]);
        },
        "app-title": (e) => {
          const { normalize: t } = e;
          return t(["Application language"]);
        },
        "select-language": (e) => {
          const { normalize: t } = e;
          return t(["Select a language"]);
        }
      },
      display: {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Display"]);
        },
        "full-title": {
          title: (e) => {
            const { normalize: t } = e;
            return t(["Full title"]);
          },
          description: (e) => {
            const { normalize: t } = e;
            return t(["If this option is not activated, long titles will be truncated by an ellipsis (...). The full title will be displayed on mouse hover."]);
          }
        },
        "open-article": {
          title: (e) => {
            const { normalize: t } = e;
            return t(["Open articles in main view"]);
          },
          description: (e) => {
            const { normalize: t } = e;
            return t(["If this option is not activated, articles will be opened in a modal by default"]);
          }
        },
        position: {
          title: (e) => {
            const { normalize: t } = e;
            return t(["Select default position"]);
          },
          options: {
            "top-left": (e) => {
              const { normalize: t } = e;
              return t(["Top left"]);
            },
            "top-right": (e) => {
              const { normalize: t } = e;
              return t(["Top right"]);
            },
            "bottom-right": (e) => {
              const { normalize: t } = e;
              return t(["Bottom right"]);
            },
            "bottom-left": (e) => {
              const { normalize: t } = e;
              return t(["Bottom left"]);
            }
          },
          "by-hostname": {
            set: (e) => {
              const { normalize: t } = e;
              return t(["The position is set to "]);
            },
            for: (e) => {
              const { normalize: t } = e;
              return t([" for the following site: "]);
            }
          },
          reset: (e) => {
            const { normalize: t } = e;
            return t(["Reset"]);
          }
        },
        "content-size": {
          title: (e) => {
            const { normalize: t } = e;
            return t(["Select content font size"]);
          },
          options: {
            sm: (e) => {
              const { normalize: t } = e;
              return t(["Small"]);
            },
            md: (e) => {
              const { normalize: t } = e;
              return t(["Normal"]);
            },
            lg: (e) => {
              const { normalize: t } = e;
              return t(["Large"]);
            },
            xl: (e) => {
              const { normalize: t } = e;
              return t(["Very large"]);
            }
          }
        }
      },
      productivity: {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Productivity"]);
        },
        "reset-label": (e) => {
          const { normalize: t } = e;
          return t(["Reset"]);
        },
        "reset-desc": (e) => {
          const { normalize: t } = e;
          return t(["Reset navigation path on each extension opening"]);
        },
        "brain-highlight-label": (e) => {
          const { normalize: t } = e;
          return t(["AI Highlight"]);
        },
        "brain-highlight-desc": (e) => {
          const { normalize: t } = e;
          return t(["Highlight a question/request and allow Mayday AI to recommend relevant content"]);
        },
        "automations-label": (e) => {
          const { normalize: t } = e;
          return t(["Automations"]);
        },
        "automations-desc": (e) => {
          const { normalize: t } = e;
          return t(["Automatically apply smart automations"]);
        },
        "shortcut-label": (e) => {
          const { normalize: t } = e;
          return t(["Keyboard shortcuts"]);
        },
        "shortcut-desc": (e) => {
          const { normalize: t } = e;
          return t(["Enable keyboard shortcuts in addition to the default one to open the extension"]);
        },
        "app-shortcut-desc": (e) => {
          const { normalize: t } = e;
          return t(["Enable keyboard shortcuts"]);
        },
        "copy-paste": (e) => {
          const { normalize: t } = e;
          return t(["Copy-paste"]);
        },
        article: (e) => {
          const { normalize: t } = e;
          return t(["Article"]);
        },
        guide: (e) => {
          const { normalize: t } = e;
          return t(["Guide"]);
        },
        "article-diagnosis": (e) => {
          const { normalize: t } = e;
          return t(["Article & Guide"]);
        },
        "modal-closing": (e) => {
          const { normalize: t } = e;
          return t(["Modal close"]);
        }
      },
      languages: {
        fr: (e) => {
          const { normalize: t } = e;
          return t(["Français (FR)"]);
        },
        en: (e) => {
          const { normalize: t } = e;
          return t(["English (US)"]);
        }
      },
      actions: {
        refresh: (e) => {
          const { normalize: t } = e;
          return t(["Refresh"]);
        },
        logout: (e) => {
          const { normalize: t } = e;
          return t(["Log out"]);
        }
      }
    },
    starred: {
      favorites: (e) => {
        const { normalize: t } = e;
        return t(["Favorites"]);
      },
      "no-favorites": (e) => {
        const { normalize: t } = e;
        return t(["There are no favorite articles yet 🕵! Add some!"]);
      },
      "magic-answers": (e) => {
        const { normalize: t } = e;
        return t(["Magic"]);
      },
      "no-magic-answers": (e) => {
        const { normalize: t } = e;
        return t(["There are no magic answers yet 🕵"]);
      }
    },
    "super-search": {
      placeholder: (e) => {
        const { normalize: t } = e;
        return t(["How can I help you?"]);
      },
      "more-filters": (e) => {
        const { normalize: t } = e;
        return t(["Show more filters"]);
      },
      "less-filters": (e) => {
        const { normalize: t } = e;
        return t(["Show less filters"]);
      },
      type: (e) => {
        const { normalize: t } = e;
        return t(["Type"]);
      },
      labels: (e) => {
        const { normalize: t } = e;
        return t(["Labels"]);
      },
      "content-status": (e) => {
        const { normalize: t } = e;
        return t(["Content status"]);
      },
      "product-univers": (e) => {
        const { normalize: t } = e;
        return t(["Product universe"]);
      },
      family: (e) => {
        const { normalize: t } = e;
        return t(["Family"]);
      },
      brands: (e) => {
        const { normalize: t } = e;
        return t(["Brands"]);
      },
      content: (e) => {
        const { normalize: t } = e;
        return t(["Content"]);
      },
      product: (e) => {
        const { normalize: t } = e;
        return t(["Product"]);
      },
      products: (e) => {
        const { normalize: t } = e;
        return t(["Products"]);
      },
      article: (e) => {
        const { normalize: t } = e;
        return t(["Article"]);
      },
      articles: (e) => {
        const { normalize: t } = e;
        return t(["Articles"]);
      },
      diagnostic: (e) => {
        const { normalize: t } = e;
        return t(["Guide"]);
      },
      diagnostics: (e) => {
        const { normalize: t } = e;
        return t(["Guides"]);
      },
      case: (e) => {
        const { normalize: t } = e;
        return t(["Case"]);
      },
      draft: (e) => {
        const { normalize: t } = e;
        return t(["Draft"]);
      },
      published: (e) => {
        const { normalize: t } = e;
        return t(["Published"]);
      },
      verified: (e) => {
        const { normalize: t } = e;
        return t(["Verified"]);
      },
      "to-be-verified": (e) => {
        const { normalize: t } = e;
        return t(["To be verified"]);
      },
      "should-filter": (e) => {
        const { normalize: t } = e;
        return t(["You should filter your search"]);
      },
      "click-on-product": (e) => {
        const { normalize: t } = e;
        return t(["Click on the corresponding item"]);
      },
      "select-univers": (e) => {
        const { normalize: t } = e;
        return t(["Select a product universe"]);
      },
      "select-families": (e) => {
        const { normalize: t } = e;
        return t(["Select one or more families"]);
      },
      show: (e) => {
        const { normalize: t } = e;
        return t(["Show"]);
      },
      result: (e) => {
        const { normalize: t } = e;
        return t(["result"]);
      },
      results: (e) => {
        const { normalize: t } = e;
        return t(["results"]);
      },
      "results-count-exceeds": (e) => {
        const { normalize: t } = e;
        return t(["Show more than 10,000 results"]);
      },
      delete: (e) => {
        const { normalize: t } = e;
        return t(["Clear"]);
      },
      clear: (e) => {
        const { normalize: t } = e;
        return t(["Erase"]);
      },
      enter: (e) => {
        const { normalize: t } = e;
        return t(["enter"]);
      },
      "show-less": (e) => {
        const { normalize: t } = e;
        return t(["Show less"]);
      },
      "show-more": (e) => {
        const { normalize: t } = e;
        return t(["Show more"]);
      },
      "show-all": (e) => {
        const { normalize: t, interpolate: n, named: o } = e;
        return t(["Show all results (", n(o("total")), ")"]);
      },
      restore: (e) => {
        const { normalize: t } = e;
        return t(["Restore"]);
      },
      "delete-definitively": (e) => {
        const { normalize: t } = e;
        return t(["⚠️ Permanently delete"]);
      },
      terms: (e) => {
        const { normalize: t } = e;
        return t(["Search terms"]);
      },
      collections: (e) => {
        const { normalize: t } = e;
        return t(["collections"]);
      },
      select: (e) => {
        const { normalize: t } = e;
        return t(["Select"]);
      },
      archive: (e) => {
        const { normalize: t } = e;
        return t(["Archive"]);
      },
      edit: (e) => {
        const { normalize: t } = e;
        return t(["Edit product settings"]);
      },
      "search-results": (e) => {
        const { normalize: t } = e;
        return t(["Search results"]);
      },
      "empty-state": (e) => {
        const { normalize: t } = e;
        return t(["No results"]);
      },
      reset: (e) => {
        const { normalize: t } = e;
        return t(["Reset search"]);
      },
      "suggestion-filter": (e) => {
        const { normalize: t } = e;
        return t(["Use this filter :"]);
      },
      correction: (e) => {
        const { normalize: t } = e;
        return t(["Did you mean"]);
      }
    },
    favorites: {
      edit: (e) => {
        const { normalize: t } = e;
        return t(["Edit"]);
      },
      done: (e) => {
        const { normalize: t } = e;
        return t(["Finish"]);
      },
      "empty-state": {
        "user-favorites": {
          title: (e) => {
            const { normalize: t } = e;
            return t(["You don't have any favorites!"]);
          },
          subtitle: (e) => {
            const { normalize: t } = e;
            return t(['Click on the "star" icon to add an article or guide to your favorites.']);
          }
        },
        "company-favorites": {
          title: (e) => {
            const { normalize: t } = e;
            return t(["You have no company favorites!"]);
          },
          subtitle: (e) => {
            const { normalize: t } = e;
            return t(["Your company has not yet set up favorites. Give them a feedback to let them know!"]);
          }
        }
      },
      "search-empty-state": {
        title: (e) => {
          const { normalize: t } = e;
          return t(["No favorite found!"]);
        },
        subtitle: (e) => {
          const { normalize: t } = e;
          return t(["Please modify your search terms"]);
        }
      }
    },
    "list-item": {
      "show-more": (e) => {
        const { normalize: t } = e;
        return t(["Show more"]);
      },
      "show-less": (e) => {
        const { normalize: t } = e;
        return t(["Show less"]);
      },
      actions: {
        "favorite-add": (e) => {
          const { normalize: t } = e;
          return t(["Add to favorites"]);
        },
        "favorite-remove": (e) => {
          const { normalize: t } = e;
          return t(["Remove from favorites"]);
        },
        "copy-url": (e) => {
          const { normalize: t } = e;
          return t(["Copy URL"]);
        },
        "open-page": (e) => {
          const { normalize: t } = e;
          return t(["Open in full page"]);
        },
        "open-summary": (e) => {
          const { normalize: t } = e;
          return t(["Open summary"]);
        },
        "close-summary": (e) => {
          const { normalize: t } = e;
          return t(["Close summary"]);
        },
        overview: (e) => {
          const { normalize: t } = e;
          return t(["Open in the side panel"]);
        },
        filter: (e) => {
          const { normalize: t } = e;
          return t(["Filters"]);
        },
        reset: (e) => {
          const { normalize: t } = e;
          return t(["Reset"]);
        }
      }
    },
    toasts: {
      "group-titles": {
        automation: (e) => {
          const { normalize: t, plural: n } = e;
          return n([t(["Automation detected"]), t(["Automations detected"])]);
        },
        notification: (e) => {
          const { normalize: t, plural: n } = e;
          return n([t(["New notification"]), t(["New notifications"])]);
        },
        "urgent-notification": (e) => {
          const { normalize: t, plural: n } = e;
          return n([t(["Urgent notification"]), t(["Urgent notifications"])]);
        },
        context: (e) => {
          const { normalize: t } = e;
          return t(["Ticket context"]);
        }
      },
      cta: {
        show: (e) => {
          const { normalize: t } = e;
          return t(["Show"]);
        },
        "show-more": (e) => {
          const { normalize: t } = e;
          return t(["Show more"]);
        },
        "show-less": (e) => {
          const { normalize: t } = e;
          return t(["Show less"]);
        },
        "open-content": (e) => {
          const { normalize: t } = e;
          return t(["Open content"]);
        },
        close: (e) => {
          const { normalize: t } = e;
          return t(["Close"]);
        }
      },
      footer: {
        "other-contents": (e) => {
          const { normalize: t, interpolate: n, named: o, plural: i } = e;
          return i([t(["1 other content"]), t([n(o("count")), " other contents"])]);
        },
        "other-notifications": (e) => {
          const { normalize: t, interpolate: n, named: o, plural: i } = e;
          return i([t(["1 other notification"]), t([n(o("count")), " other notifications"])]);
        }
      },
      context: {
        1: (e) => {
          const { normalize: t } = e;
          return t(["The user is very dissatisfied"]);
        },
        2: (e) => {
          const { normalize: t } = e;
          return t(["The user is dissatisfied"]);
        },
        3: (e) => {
          const { normalize: t } = e;
          return t(["The user is neutral"]);
        },
        4: (e) => {
          const { normalize: t } = e;
          return t(["The user is satisfied"]);
        },
        5: (e) => {
          const { normalize: t } = e;
          return t(["The user is very satisfied"]);
        }
      }
    },
    lightbox: {
      open: (e) => {
        const { normalize: t } = e;
        return t(["Open in a new tab"]);
      },
      close: (e) => {
        const { normalize: t } = e;
        return t(["Close"]);
      }
    },
    toc: {
      title: (e) => {
        const { normalize: t } = e;
        return t(["Summary"]);
      }
    }
  },
  fr: {
    login: {
      baseline: {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Bienvenue 👋"]);
        },
        subtitle: (e) => {
          const { normalize: t } = e;
          return t(["Connectez-vous pour libérer le potentiel de la connaissance !"]);
        }
      },
      instructions: (e) => {
        const { normalize: t } = e;
        return t(["Renseignez vos informations de connexion"]);
      },
      "sso-instructions": (e) => {
        const { normalize: t } = e;
        return t(["Renseignez le nom de domaine Mayday de votre entreprise"]);
      },
      "sso-placeholder": (e) => {
        const { normalize: t } = e;
        return t(["Sous-domaine d'entreprise"]);
      },
      "access-token-instructions": (e) => {
        const { normalize: t } = e;
        return t(["Renseignez votre token d'accès"]);
      },
      "access-token-placeholder": (e) => {
        const { normalize: t } = e;
        return t(["Token d'accès"]);
      },
      "weak-connection": (e) => {
        const { normalize: t } = e;
        return t(["Connexion internet faible, le chargement peut prendre du temps."]);
      },
      "please-wait": (e) => {
        const { normalize: t } = e;
        return t(["Merci de patienter"]);
      },
      "back-to-login": (e) => {
        const { normalize: t } = e;
        return t(["Se connecter autrement"]);
      },
      "reset-domain": (e) => {
        const { normalize: t } = e;
        return t(["Réinitialiser le domaine"]);
      },
      form: {
        email: (e) => {
          const { normalize: t } = e;
          return t(["Adresse email"]);
        },
        password: (e) => {
          const { normalize: t } = e;
          return t(["Mot de passe"]);
        },
        domain: (e) => {
          const { normalize: t } = e;
          return t(["Nom de domaine"]);
        },
        "access-token": (e) => {
          const { normalize: t } = e;
          return t(["Token d'accès"]);
        },
        login: (e) => {
          const { normalize: t } = e;
          return t(["Se connecter"]);
        },
        "sso-cta": (e) => {
          const { normalize: t } = e;
          return t(["Continuer"]);
        },
        or: (e) => {
          const { normalize: t } = e;
          return t(["ou"]);
        },
        "google-signin": (e) => {
          const { normalize: t } = e;
          return t(["Se connecter avec Google"]);
        },
        "sso-signin": (e) => {
          const { normalize: t } = e;
          return t(["Authentification Unique (SSO)"]);
        },
        "access-token-signin": (e) => {
          const { normalize: t } = e;
          return t(["Se connecter avec un token d'accès"]);
        }
      },
      errors: {
        authentication: (e) => {
          const { normalize: t } = e;
          return t(["La combinaison email, mot de passe est incorrecte"]);
        },
        "invalid-domain": (e) => {
          const { normalize: t } = e;
          return t(["Le nom de domaine renseigné est invalide"]);
        },
        permissions: (e) => {
          const { normalize: t } = e;
          return t(["Vous n'avez pas les droits d'accès suffisants, veuillez demander à un administrateur de vous assigner un groupe"]);
        },
        unverified: (e) => {
          const { normalize: t } = e;
          return t(["Votre compte est encore en cours de validation, veuillez contacter un administrateur"]);
        },
        default: (e) => {
          const { normalize: t } = e;
          return t(["Une erreur est survenue, veuillez réessayer"]);
        },
        "tab-1": (e) => {
          const { normalize: t } = e;
          return t(["Un problème lié à l'onglet actuel est survenu. Veuillez"]);
        },
        "tab-2": (e) => {
          const { normalize: t } = e;
          return t(["vider votre cache"]);
        },
        "tab-3": (e) => {
          const { normalize: t } = e;
          return t(["et réessayer."]);
        }
      },
      "forgot-password": (e) => {
        const { normalize: t } = e;
        return t(["Mot de passe oublié ?"]);
      },
      register: {
        question: (e) => {
          const { normalize: t } = e;
          return t(["Pas inscrit ?"]);
        },
        action: (e) => {
          const { normalize: t } = e;
          return t(["Créer un compte"]);
        }
      }
    },
    dropdown: {
      preferences: (e) => {
        const { normalize: t } = e;
        return t(["Preferences"]);
      },
      refresh: (e) => {
        const { normalize: t } = e;
        return t(["Rafraîchir"]);
      },
      "knowledge-base": (e) => {
        const { normalize: t } = e;
        return t(["Base de connaissance"]);
      },
      "knowledge-language": (e) => {
        const { normalize: t } = e;
        return t(["Langues"]);
      },
      "change-knowledge-base": (e) => {
        const { normalize: t } = e;
        return t(["Changer de base"]);
      },
      "bug-report": (e) => {
        const { normalize: t } = e;
        return t(["Remonter un bug"]);
      },
      "reset-domain": (e) => {
        const { normalize: t } = e;
        return t(["Réinitialiser le domaine"]);
      },
      logout: (e) => {
        const { normalize: t } = e;
        return t(["Se déconnecter"]);
      },
      collection: (e) => {
        const { normalize: t, interpolate: n, named: o, plural: i } = e;
        return i([t([n(o("count")), " contenu trié par :"]), t([n(o("count")), " contenus triés par : "])]);
      },
      options: {
        recommended: (e) => {
          const { normalize: t } = e;
          return t(["Recommandé"]);
        },
        "alpha-asc": (e) => {
          const { normalize: t } = e;
          return t(["Alphabétique (A-Z)"]);
        },
        "alpha-desc": (e) => {
          const { normalize: t } = e;
          return t(["Anti-Alphabétique (Z-A)"]);
        }
      }
    },
    search: {
      cta: (e) => {
        const { normalize: t } = e;
        return t(["Recherche express"]);
      },
      breadcrumb: (e) => {
        const { normalize: t } = e;
        return t(["Filtrer"]);
      },
      "no-results": (e) => {
        const { normalize: t } = e;
        return t(["Aucun résultat 🧐"]);
      },
      filters: {
        types: (e) => {
          const { normalize: t } = e;
          return t(["Types"]);
        },
        reset: (e) => {
          const { normalize: t } = e;
          return t(["Réinitialiser"]);
        },
        "see-more": (e) => {
          const { normalize: t } = e;
          return t(["Voir plus"]);
        },
        "see-less": (e) => {
          const { normalize: t } = e;
          return t(["Voir moins"]);
        },
        "filters-count": (e) => {
          const { normalize: t, interpolate: n, named: o, plural: i } = e;
          return i([t([n(o("count")), " filtre"]), t([n(o("count")), " filtres"])]);
        },
        advanced: (e) => {
          const { normalize: t, plural: n } = e;
          return n([t(["Filtre de recherche avancé"]), t(["Filtres de recherche avancés"])]);
        },
        "focus-case": (e) => {
          const { normalize: t, interpolate: n, named: o } = e;
          return t(["Collection actuelle seulement : ", n(o("label"))]);
        }
      },
      "user-boost": {
        high: (e) => {
          const { normalize: t } = e;
          return t(["Ce contenu fait partie des 10% que vous avez le plus consultés"]);
        },
        medium: (e) => {
          const { normalize: t } = e;
          return t(["Ce contenu fait partie des 20% que vous avez le plus consultés"]);
        },
        low: (e) => {
          const { normalize: t } = e;
          return t(["Ce contenu fait partie des 30% que vous avez le plus consultés"]);
        }
      }
    },
    knowledge: {
      explore: (e) => {
        const { normalize: t } = e;
        return t(["Parcourir"]);
      },
      "show-more": (e) => {
        const { normalize: t } = e;
        return t(["Afficher plus"]);
      },
      "show-less": (e) => {
        const { normalize: t } = e;
        return t(["Afficher moins"]);
      },
      automation: (e) => {
        const { normalize: t } = e;
        return t(["Raccourci détecté"]);
      },
      "diag-viewer": {
        description: (e) => {
          const { normalize: t } = e;
          return t(["Le problème concerne"]);
        },
        "linked-articles": (e) => {
          const { normalize: t } = e;
          return t(["Articles Liés"]);
        },
        "linked-files": (e) => {
          const { normalize: t } = e;
          return t(["Fichiers Liés"]);
        }
      },
      "zoom-element": (e) => {
        const { normalize: t } = e;
        return t(["Zoom sur l'élément"]);
      },
      "zoom-open-tab": (e) => {
        const { normalize: t } = e;
        return t(["Cliquer pour agrandir"]);
      },
      "empty-collection": {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Ce dossier est vide"]);
        },
        description: (e) => {
          const { normalize: t } = e;
          return t(["Cela peut être dû à vos droits d'accès"]);
        },
        cta: (e) => {
          const { normalize: t } = e;
          return t(["Revenir en arrière"]);
        }
      },
      "collection-description": (e) => {
        const { normalize: t } = e;
        return t(["Description"]);
      },
      "empty-step": {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Cette étape est vide"]);
        },
        description: (e) => {
          const { normalize: t } = e;
          return t(["Cela peut être dû à vos droits d'accès"]);
        },
        cta: (e) => {
          const { normalize: t } = e;
          return t(["Revenir en arrière"]);
        }
      },
      answer: (e) => {
        const { normalize: t } = e;
        return t(["Réponse suggérée :"]);
      },
      actions: {
        "favorite-add": (e) => {
          const { normalize: t } = e;
          return t(["Mettre en favori"]);
        },
        "favorite-remove": (e) => {
          const { normalize: t } = e;
          return t(["Retirer des favoris"]);
        },
        "copy-body": (e) => {
          const { normalize: t } = e;
          return t(["Copier le contenu"]);
        },
        "copy-link": (e) => {
          const { normalize: t } = e;
          return t(["Copier l'URL"]);
        },
        answer: (e) => {
          const { normalize: t } = e;
          return t(["Ouvrir la réponse suggérée"]);
        },
        "go-to-feedback": (e) => {
          const { normalize: t } = e;
          return t(["Faire un feedback"]);
        },
        "open-in-web": (e) => {
          const { normalize: t } = e;
          return t(["Ouvrir en pleine page"]);
        },
        "salesforce-case": (e) => {
          const { normalize: t } = e;
          return t(["Mettre à jour le case Salesforce"]);
        }
      },
      notification: {
        "add-favorite": (e) => {
          const { normalize: t } = e;
          return t(["Le contenu a bien été ajouté aux favoris !"]);
        },
        "remove-favorite": (e) => {
          const { normalize: t } = e;
          return t(["Le contenu a bien été retiré des favoris !"]);
        },
        "copy-body": (e) => {
          const { normalize: t } = e;
          return t(["Le contenu a bien été copié !"]);
        },
        "copy-link": (e) => {
          const { normalize: t } = e;
          return t(["L'URL a bien été copiée !"]);
        },
        feedback: (e) => {
          const { normalize: t } = e;
          return t(["Merci pour votre feedback !"]);
        },
        satisfaction: (e) => {
          const { normalize: t } = e;
          return t(["Merci pour votre retour de satisfaction !"]);
        },
        "access-rights": (e) => {
          const { normalize: t } = e;
          return t(["Vous n'avez pas les droits pour accéder à ce contenu"]);
        }
      },
      satisfaction: {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Ce contenu vous a été utile ?"]);
        },
        cta: (e) => {
          const { normalize: t } = e;
          return t(["Envoyer un feedback pour l'améliorer"]);
        }
      },
      "ai-collapse": {
        summary: (e) => {
          const { normalize: t } = e;
          return t(["Résumé"]);
        },
        "action-items": (e) => {
          const { normalize: t } = e;
          return t(["Action items"]);
        },
        "edited-at": (e) => {
          const { normalize: t } = e;
          return t(["Édité manuellement le"]);
        },
        "generated-at": (e) => {
          const { normalize: t } = e;
          return t(["Généré le"]);
        }
      },
      "empty-state": {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Désolé, nous ne pouvons pas afficher cette page"]);
        },
        cta: (e) => {
          const { normalize: t } = e;
          return t(["Rafraîchir"]);
        },
        "cta-close": (e) => {
          const { normalize: t } = e;
          return t(["Fermer"]);
        },
        "no-content": (e) => {
          const { normalize: t } = e;
          return t(["Vous n'avez pas accès à ce contenu, veuillez contacter un administrateur"]);
        }
      },
      "empty-filter": {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Pas de résultat"]);
        },
        description: (e) => {
          const { normalize: t } = e;
          return t(["Aucun contenu ne correspond à votre recherche"]);
        },
        cta: (e) => {
          const { normalize: t } = e;
          return t(["Réinitialiser les filtres"]);
        }
      }
    },
    feedback: {
      "label-text": (e) => {
        const { normalize: t } = e;
        return t(["Feedback"]);
      },
      attachments: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["Pièce jointe"]), t(["Pièce jointe"]), t(["Pièces jointes"])]);
      },
      link: (e) => {
        const { normalize: t } = e;
        return t(["Lier le contenu en cours de lecture"]);
      },
      "label-target": (e) => {
        const { normalize: t } = e;
        return t(["Destinataire"]);
      },
      "target-placeholder": (e) => {
        const { normalize: t } = e;
        return t(["Sélectionnez un destinataire"]);
      },
      placeholder: (e) => {
        const { normalize: t } = e;
        return t(["Que souhaitez vous partager ?"]);
      },
      "success-message": (e) => {
        const { normalize: t } = e;
        return t(["Votre message a bien été envoyé ✉️"]);
      },
      cta: (e) => {
        const { normalize: t } = e;
        return t(["Envoyer"]);
      },
      cancel: (e) => {
        const { normalize: t } = e;
        return t(["Annuler"]);
      },
      "tab-new": (e) => {
        const { normalize: t } = e;
        return t(["Nouveau"]);
      },
      "tab-history": (e) => {
        const { normalize: t } = e;
        return t(["Envoyés"]);
      },
      "sent-at": (e) => {
        const { normalize: t } = e;
        return t(["Envoyé le"]);
      },
      "sent-to": (e) => {
        const { normalize: t } = e;
        return t(["À"]);
      },
      "deleted-user": (e) => {
        const { normalize: t } = e;
        return t(["Utilisateur supprimé"]);
      },
      groups: (e) => {
        const { normalize: t } = e;
        return t(["Groupes"]);
      },
      collaborators: (e) => {
        const { normalize: t } = e;
        return t(["Collaborateurs"]);
      },
      "add-attachment": (e) => {
        const { normalize: t } = e;
        return t(["Ajouter"]);
      },
      status: {
        doing: (e) => {
          const { normalize: t } = e;
          return t(["En cours"]);
        },
        sent: (e) => {
          const { normalize: t } = e;
          return t(["Envoyé"]);
        },
        "to-do": (e) => {
          const { normalize: t } = e;
          return t(["À faire"]);
        },
        archived: (e) => {
          const { normalize: t } = e;
          return t(["Archivé"]);
        },
        over: (e) => {
          const { normalize: t } = e;
          return t(["Traité"]);
        }
      },
      content: (e) => {
        const { normalize: t } = e;
        return t(["Contenu lié :"]);
      },
      rating: (e) => {
        const { normalize: t } = e;
        return t(["Note :"]);
      },
      comments: (e) => {
        const { normalize: t } = e;
        return t(["Messages"]);
      },
      answer: (e) => {
        const { normalize: t } = e;
        return t(["Répondre"]);
      },
      "show-more": (e) => {
        const { normalize: t } = e;
        return t(["Voir plus"]);
      },
      "new-feedback": (e) => {
        const { normalize: t } = e;
        return t(["Rédiger un feedback"]);
      },
      empty: (e) => {
        const { normalize: t } = e;
        return t(["Vous n’avez pas encore envoyé de feedback !"]);
      }
    },
    modals: {
      "copy-article": (e) => {
        const { normalize: t } = e;
        return t(["L'article a bien été copié 🖇️"]);
      },
      "copy-answer": (e) => {
        const { normalize: t } = e;
        return t(["La réponse a bien été copiée 🖇️"]);
      }
    },
    attachments: {
      title: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["Pièce jointe :"]), t(["Pièce jointe :"]), t(["Pièces jointes :"])]);
      },
      "disable-file-upload": (e) => {
        const { normalize: t } = e;
        return t(["Le nombre de pièces jointes maximum est atteint."]);
      },
      "too-many-files": (e) => {
        const { normalize: t } = e;
        return t(["Vous ne pouvez pas joindre plus de 3 fichiers"]);
      },
      "file-too-big": (e) => {
        const { normalize: t } = e;
        return t(["La taille du fichier dépasse la limite autorisée."]);
      },
      "upload-problem": (e) => {
        const { normalize: t } = e;
        return t(["Le fichier n'a pas pu être téléchargé, veuillez réessayer."]);
      },
      "existing-file": (e) => {
        const { normalize: t } = e;
        return t(["Un fichier que vous voulez joindre se trouve déjà dans vos pièces jointes."]);
      }
    },
    notifications: {
      title: (e) => {
        const { normalize: t } = e;
        return t(["Notifications"]);
      },
      tabs: {
        all: (e) => {
          const { normalize: t } = e;
          return t(["Tout"]);
        },
        info: (e) => {
          const { normalize: t } = e;
          return t(["Info"]);
        },
        feedback: (e) => {
          const { normalize: t } = e;
          return t(["Feedback"]);
        }
      },
      you: (e) => {
        const { normalize: t } = e;
        return t(["Vous"]);
      },
      "read-all": (e) => {
        const { normalize: t } = e;
        return t(["Lire tout"]);
      },
      "get-more": (e) => {
        const { normalize: t } = e;
        return t(["Afficher Plus"]);
      },
      "time-ago": (e) => {
        const { normalize: t, interpolate: n, named: o } = e;
        return t(["il y a ", n(o("time"))]);
      },
      yesterday: (e) => {
        const { normalize: t } = e;
        return t(["Hier"]);
      },
      now: (e) => {
        const { normalize: t } = e;
        return t(["Maintenant"]);
      },
      urgent: (e) => {
        const { normalize: t } = e;
        return t(["Notification urgente"]);
      },
      filters: {
        button: (e) => {
          const { normalize: t } = e;
          return t(["Filtrer"]);
        },
        unread: (e) => {
          const { normalize: t } = e;
          return t(["Non lue"]);
        },
        feedback: (e) => {
          const { normalize: t } = e;
          return t(["Feedback"]);
        },
        infos: (e) => {
          const { normalize: t } = e;
          return t(["Information"]);
        },
        date: (e) => {
          const { normalize: t } = e;
          return t(["Date"]);
        },
        reset: (e) => {
          const { normalize: t } = e;
          return t(["Réinitialiser"]);
        },
        timeframes: {
          "3-last-days": (e) => {
            const { normalize: t } = e;
            return t(["3 derniers jours"]);
          },
          "last-week": (e) => {
            const { normalize: t } = e;
            return t(["La semaine dernière"]);
          },
          "2-last-weeks": (e) => {
            const { normalize: t } = e;
            return t(["Les 2 dernières semaines"]);
          },
          "last-month": (e) => {
            const { normalize: t } = e;
            return t(["Le mois dernier"]);
          },
          "3-last-months": (e) => {
            const { normalize: t } = e;
            return t(["Les 3 derniers mois"]);
          }
        }
      },
      empty: {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Aucune notification"]);
        },
        description: (e) => {
          const { normalize: t } = e;
          return t(["Vous n’avez pour le moment aucune notification à afficher"]);
        },
        "filtered-title": (e) => {
          const { normalize: t } = e;
          return t(["Aucun résultat !"]);
        },
        "filtered-description": (e) => {
          const { normalize: t } = e;
          return t(["Effacez ou modifiez vos filtres pour afficher de meilleurs résultats"]);
        },
        cta: (e) => {
          const { normalize: t } = e;
          return t(["Effacer les filtres"]);
        },
        close: (e) => {
          const { normalize: t } = e;
          return t(["Fermer"]);
        }
      },
      footer: (e) => {
        const { normalize: t } = e;
        return t(["Cliquez sur les notifications pour envoyer une confirmation de lecture"]);
      },
      feedback: {
        title: {
          TaskMineComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["avez répondu au feedback lié au contenu :"]), t(["avez répondu au feedback global"])]);
          },
          TaskComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t([" a commenté le feedback lié au contenu :"]), t(["a commenté ce feedback global"])]);
          },
          MentionTaskComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["vous a mentionné dans un commentaire sur le feedback lié au contenu :"]), t(["vous a mentionné dans un commentaire sur ce feedback global"])]);
          },
          UsedToBeMentionTaskComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["a commenté le feedback où vous avez été mentionné lié au contenu :"]), t(["a commenté ce feedback global où vous avez été mentionné"])]);
          },
          InternalTaskMineComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["avez créé une note interne sur le feedback lié au contenu :"]), t(["avez créé une note interne sur ce feedback global"])]);
          },
          InternalTaskComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["a créé une note en interne sur le feedback lié au contenu :"]), t(["a créé une note en interne sur ce feedback global"])]);
          },
          MentionInternalTaskComment: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["vous a mentionné dans une note interne sur le feedback lié au contenu :"]), t(["vous a mentionné dans une note interne sur ce feedback global"])]);
          },
          TaskMoved: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["est en train de traiter votre feedback sur le contenu :"]), t(["est en train de traiter votre feedback global"])]);
          },
          TaskUpvoted: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["a aimé votre feedback sur le contenu :"]), t(["a aimé votre feedback global"])]);
          },
          TaskAssigned: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["vous a assigné à une tâche sur le contenu :"]), t(["vous a assigné à une tâche sur un feedback global"])]);
          },
          Feedback: (e) => {
            const { normalize: t, plural: n } = e;
            return n([t(["vous a fait un feedback sur le contenu :"]), t(["vous a fait un feedback global"])]);
          },
          ContentToVerify: (e) => {
            const { normalize: t } = e;
            return t(["avez une vérification à faire sur un contenu : "]);
          },
          ContentMention: (e) => {
            const { normalize: t } = e;
            return t(["vous a mentionné sur le contenu : "]);
          },
          ContentThreadMessage: (e) => {
            const { normalize: t } = e;
            return t(["a ajouté un commentaire sur le contenu : "]);
          },
          ContentThreadMention: (e) => {
            const { normalize: t } = e;
            return t(["vous a mentionné dans un commentaire sur le contenu : "]);
          },
          ContentThreadVote: (e) => {
            const { normalize: t } = e;
            return t(["a aimé votre commentaire sur le contenu : "]);
          },
          ContentThreadStatus: {
            SOLVED: (e) => {
              const { normalize: t } = e;
              return t(["a résolu un fil de discussion sur le contenu : "]);
            },
            ARCHIVED: (e) => {
              const { normalize: t } = e;
              return t(["a archivé un fil de discussion sur le contenu : "]);
            }
          }
        },
        response: {
          button: (e) => {
            const { normalize: t } = e;
            return t(["Répondre"]);
          },
          placeholder: (e) => {
            const { normalize: t } = e;
            return t(["Taper votre réponse"]);
          }
        }
      },
      info: {
        "attached-content": (e) => {
          const { normalize: t } = e;
          return t(["Consulter le contenu"]);
        },
        task: (e) => {
          const { normalize: t } = e;
          return t(["Consulter la tâche"]);
        },
        "content-error": (e) => {
          const { normalize: t } = e;
          return t(["Contenu introuvable"]);
        },
        "author-error": (e) => {
          const { normalize: t } = e;
          return t(["Un utilisateur introuvable"]);
        },
        "deleted-user": (e) => {
          const { normalize: t } = e;
          return t(["(Utilisateur supprimé)"]);
        },
        edited: (e) => {
          const { normalize: t } = e;
          return t(["(modifié)"]);
        }
      },
      "show-more": (e) => {
        const { normalize: t, interpolate: n, named: o, plural: i } = e;
        return i([t(["Afficher un commentaire"]), t(["Afficher ", n(o("count")), " commentaires"])]);
      },
      "show-less": (e) => {
        const { normalize: t } = e;
        return t(["Afficher moins"]);
      },
      urgents: {
        label: (e) => {
          const { normalize: t } = e;
          return t(["Notification urgente"]);
        },
        display: (e) => {
          const { normalize: t } = e;
          return t(["Afficher"]);
        },
        hide: (e) => {
          const { normalize: t } = e;
          return t(["Masquer"]);
        },
        "linked-content": (e) => {
          const { normalize: t } = e;
          return t(["Consulter le contenu"]);
        },
        count: (e) => {
          const { normalize: t } = e;
          return t(["Notification"]);
        },
        link: (e) => {
          const { normalize: t } = e;
          return t(["Lien"]);
        },
        slide: {
          "all-read": (e) => {
            const { normalize: t } = e;
            return t(["Vous avez lu toutes les notifications urgentes."]);
          },
          reread: (e) => {
            const { normalize: t } = e;
            return t(["Relire"]);
          },
          hide: (e) => {
            const { normalize: t } = e;
            return t(["Masquer"]);
          }
        }
      }
    },
    settings: {
      language: {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Language de l'extension"]);
        },
        "app-title": (e) => {
          const { normalize: t } = e;
          return t(["Language de l'application"]);
        },
        "select-language": (e) => {
          const { normalize: t } = e;
          return t(["Sélectionner une langue"]);
        }
      },
      display: {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Affichage"]);
        },
        "full-title": {
          title: (e) => {
            const { normalize: t } = e;
            return t(["Titre complet"]);
          },
          description: (e) => {
            const { normalize: t } = e;
            return t(["Si cette option n'est pas activée, les titres longs seront tronqués par une ellipse (...). Le titre complet sera affiché au survol de la souris."]);
          }
        },
        "open-article": {
          title: (e) => {
            const { normalize: t } = e;
            return t(["Ouvrir les articles dans l'affichage principal"]);
          },
          description: (e) => {
            const { normalize: t } = e;
            return t(["Si cette option n'est pas activée, les articles s'ouvrent par défaut dans la modale"]);
          }
        },
        position: {
          title: (e) => {
            const { normalize: t } = e;
            return t(["Sélectionnez la position par défaut"]);
          },
          options: {
            "top-left": (e) => {
              const { normalize: t } = e;
              return t(["En haut à gauche"]);
            },
            "top-right": (e) => {
              const { normalize: t } = e;
              return t(["En haut à droite"]);
            },
            "bottom-right": (e) => {
              const { normalize: t } = e;
              return t(["En bas à droite"]);
            },
            "bottom-left": (e) => {
              const { normalize: t } = e;
              return t(["En bas à gauche"]);
            }
          },
          "by-hostname": {
            set: (e) => {
              const { normalize: t } = e;
              return t(["La position est définie sur "]);
            },
            for: (e) => {
              const { normalize: t } = e;
              return t([" pour le site suivant : "]);
            }
          },
          reset: (e) => {
            const { normalize: t } = e;
            return t(["Réinitialiser"]);
          }
        },
        "content-size": {
          title: (e) => {
            const { normalize: t } = e;
            return t(["Sélectionnez la taille de police des contenus"]);
          },
          options: {
            sm: (e) => {
              const { normalize: t } = e;
              return t(["Petit"]);
            },
            md: (e) => {
              const { normalize: t } = e;
              return t(["Normal"]);
            },
            lg: (e) => {
              const { normalize: t } = e;
              return t(["Grand"]);
            },
            xl: (e) => {
              const { normalize: t } = e;
              return t(["Très grand"]);
            }
          }
        }
      },
      productivity: {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Productivité"]);
        },
        "reset-label": (e) => {
          const { normalize: t } = e;
          return t(["Réinitialisation"]);
        },
        "reset-desc": (e) => {
          const { normalize: t } = e;
          return t(["Réinitialiser le chemin de navigation à chaque ouverture de l'extension"]);
        },
        "brain-highlight-label": (e) => {
          const { normalize: t } = e;
          return t(["Highlight IA"]);
        },
        "brain-highlight-desc": (e) => {
          const { normalize: t } = e;
          return t(["Sélectionner une question ou une requête et Mayday IA vous recommandera des contenus pertinents"]);
        },
        "automations-label": (e) => {
          const { normalize: t } = e;
          return t(["Automatisations"]);
        },
        "automations-desc": (e) => {
          const { normalize: t } = e;
          return t(["Appliquer automatiquement des automatisations intelligentes"]);
        },
        "shortcut-label": (e) => {
          const { normalize: t } = e;
          return t(["Raccourcis clavier"]);
        },
        "shortcut-desc": (e) => {
          const { normalize: t } = e;
          return t(["Activer les raccourcis clavier en plus de celui par défaut pour ouvrir l'extension"]);
        },
        "app-shortcut-desc": (e) => {
          const { normalize: t } = e;
          return t(["Activer les raccourcis clavier"]);
        },
        "copy-paste": (e) => {
          const { normalize: t } = e;
          return t(["Copier-coller"]);
        },
        article: (e) => {
          const { normalize: t } = e;
          return t(["Article"]);
        },
        guide: (e) => {
          const { normalize: t } = e;
          return t(["Diagnostic"]);
        },
        "article-diagnosis": (e) => {
          const { normalize: t } = e;
          return t(["Article & Diagnostic"]);
        },
        "modal-closing": (e) => {
          const { normalize: t } = e;
          return t(["Fermeture modale"]);
        }
      },
      languages: {
        fr: (e) => {
          const { normalize: t } = e;
          return t(["Français (FR)"]);
        },
        en: (e) => {
          const { normalize: t } = e;
          return t(["English (US)"]);
        }
      },
      actions: {
        refresh: (e) => {
          const { normalize: t } = e;
          return t(["Rafraîchir"]);
        },
        logout: (e) => {
          const { normalize: t } = e;
          return t(["Se déconnecter"]);
        }
      }
    },
    starred: {
      favorites: (e) => {
        const { normalize: t } = e;
        return t(["Favoris"]);
      },
      "no-favorites": (e) => {
        const { normalize: t } = e;
        return t(["Il n'y a pas encore d'articles favoris 🕵 ! Ajoutez-en !"]);
      },
      "magic-answers": (e) => {
        const { normalize: t } = e;
        return t(["Magique"]);
      },
      "no-magic-answers": (e) => {
        const { normalize: t } = e;
        return t(["Il n'y a pas encore de réponses magiques 🕵"]);
      }
    },
    "super-search": {
      placeholder: (e) => {
        const { normalize: t } = e;
        return t(["Comment puis-je vous aider ?"]);
      },
      "more-filters": (e) => {
        const { normalize: t } = e;
        return t(["Afficher plus de filtres"]);
      },
      "less-filters": (e) => {
        const { normalize: t } = e;
        return t(["Afficher moins de filtres"]);
      },
      type: (e) => {
        const { normalize: t } = e;
        return t(["Type"]);
      },
      labels: (e) => {
        const { normalize: t } = e;
        return t(["Labels"]);
      },
      "content-status": (e) => {
        const { normalize: t } = e;
        return t(["État du contenu"]);
      },
      "product-univers": (e) => {
        const { normalize: t } = e;
        return t(["Univers produit"]);
      },
      family: (e) => {
        const { normalize: t } = e;
        return t(["Famille"]);
      },
      brands: (e) => {
        const { normalize: t } = e;
        return t(["Marques"]);
      },
      content: (e) => {
        const { normalize: t } = e;
        return t(["Contenu"]);
      },
      product: (e) => {
        const { normalize: t } = e;
        return t(["Produit"]);
      },
      products: (e) => {
        const { normalize: t } = e;
        return t(["Produits"]);
      },
      article: (e) => {
        const { normalize: t } = e;
        return t(["Article"]);
      },
      articles: (e) => {
        const { normalize: t } = e;
        return t(["Articles"]);
      },
      diagnostic: (e) => {
        const { normalize: t } = e;
        return t(["Diagnostic"]);
      },
      diagnostics: (e) => {
        const { normalize: t } = e;
        return t(["Diagnostics"]);
      },
      case: (e) => {
        const { normalize: t } = e;
        return t(["Case"]);
      },
      draft: (e) => {
        const { normalize: t } = e;
        return t(["Brouillon"]);
      },
      published: (e) => {
        const { normalize: t } = e;
        return t(["Publié"]);
      },
      verified: (e) => {
        const { normalize: t } = e;
        return t(["Vérifié"]);
      },
      "to-be-verified": (e) => {
        const { normalize: t } = e;
        return t(["À vérifier"]);
      },
      "should-filter": (e) => {
        const { normalize: t } = e;
        return t(["Vous devriez filtrer votre recherche"]);
      },
      "click-on-product": (e) => {
        const { normalize: t } = e;
        return t(["Cliquez sur l'élément correspondant"]);
      },
      "select-univers": (e) => {
        const { normalize: t } = e;
        return t(["Sélectionner un univers produit"]);
      },
      "select-families": (e) => {
        const { normalize: t } = e;
        return t(["Sélectionner une ou plusieurs familles"]);
      },
      show: (e) => {
        const { normalize: t } = e;
        return t(["Afficher"]);
      },
      result: (e) => {
        const { normalize: t } = e;
        return t(["résultat"]);
      },
      results: (e) => {
        const { normalize: t } = e;
        return t(["résultats"]);
      },
      "results-count-exceeds": (e) => {
        const { normalize: t } = e;
        return t(["Afficher plus de 10 000 résultats"]);
      },
      delete: (e) => {
        const { normalize: t } = e;
        return t(["Effacer"]);
      },
      clear: (e) => {
        const { normalize: t } = e;
        return t(["Effacer"]);
      },
      enter: (e) => {
        const { normalize: t } = e;
        return t(["enter"]);
      },
      "show-less": (e) => {
        const { normalize: t } = e;
        return t(["Afficher moins"]);
      },
      "show-more": (e) => {
        const { normalize: t } = e;
        return t(["Afficher plus"]);
      },
      "show-all": (e) => {
        const { normalize: t, interpolate: n, named: o } = e;
        return t(["Afficher tous les résultats (", n(o("total")), ")"]);
      },
      restore: (e) => {
        const { normalize: t } = e;
        return t(["Restaurer"]);
      },
      "delete-definitively": (e) => {
        const { normalize: t } = e;
        return t(["⚠️ Supprimer définitivement"]);
      },
      terms: (e) => {
        const { normalize: t } = e;
        return t(["Termes de recherche"]);
      },
      collections: (e) => {
        const { normalize: t } = e;
        return t(["collections"]);
      },
      select: (e) => {
        const { normalize: t } = e;
        return t(["Sélectionner"]);
      },
      archive: (e) => {
        const { normalize: t } = e;
        return t(["Archiver"]);
      },
      edit: (e) => {
        const { normalize: t } = e;
        return t(["Modifier les paramètres produit"]);
      },
      "search-results": (e) => {
        const { normalize: t } = e;
        return t(["Résultats de recherche"]);
      },
      "empty-state": (e) => {
        const { normalize: t } = e;
        return t(["Aucun résultat"]);
      },
      reset: (e) => {
        const { normalize: t } = e;
        return t(["Réinitialiser la recherche"]);
      },
      "suggestion-filter": (e) => {
        const { normalize: t } = e;
        return t(["Utilisez ce filtre :"]);
      },
      correction: (e) => {
        const { normalize: t } = e;
        return t(["Essayez avec cette orthographe :"]);
      }
    },
    favorites: {
      edit: (e) => {
        const { normalize: t } = e;
        return t(["Modifier"]);
      },
      done: (e) => {
        const { normalize: t } = e;
        return t(["Terminer"]);
      },
      "empty-state": {
        "user-favorites": {
          title: (e) => {
            const { normalize: t } = e;
            return t(["Vous n’avez pas de favori !"]);
          },
          subtitle: (e) => {
            const { normalize: t } = e;
            return t(["Cliquez sur l’icône “étoile” pour ajouter un article ou un diagnostic à vos favoris."]);
          }
        },
        "company-favorites": {
          title: (e) => {
            const { normalize: t } = e;
            return t(["Vous n’avez pas de favoris d'entreprise !"]);
          },
          subtitle: (e) => {
            const { normalize: t } = e;
            return t(["Votre entreprise n'a pas encore mis en place de favoris. Faites leur un feedback pour leur en faire part !"]);
          }
        }
      },
      "search-empty-state": {
        title: (e) => {
          const { normalize: t } = e;
          return t(["Aucun favori trouvé !"]);
        },
        subtitle: (e) => {
          const { normalize: t } = e;
          return t(["Veuillez modifier vos termes de recherche"]);
        }
      }
    },
    "list-item": {
      "show-more": (e) => {
        const { normalize: t } = e;
        return t(["Afficher plus"]);
      },
      "show-less": (e) => {
        const { normalize: t } = e;
        return t(["Afficher moins"]);
      },
      actions: {
        "favorite-add": (e) => {
          const { normalize: t } = e;
          return t(["Mettre en favori"]);
        },
        "favorite-remove": (e) => {
          const { normalize: t } = e;
          return t(["Retirer des favoris"]);
        },
        "copy-url": (e) => {
          const { normalize: t } = e;
          return t(["Copier l'URL"]);
        },
        "open-page": (e) => {
          const { normalize: t } = e;
          return t(["Ouvrir en pleine page"]);
        },
        "open-summary": (e) => {
          const { normalize: t } = e;
          return t(["Ouvrir le résumé"]);
        },
        "close-summary": (e) => {
          const { normalize: t } = e;
          return t(["Fermer le résumé"]);
        },
        overview: (e) => {
          const { normalize: t } = e;
          return t(["Ouvrir dans le panneau latéral"]);
        },
        filter: (e) => {
          const { normalize: t } = e;
          return t(["Filtres"]);
        },
        reset: (e) => {
          const { normalize: t } = e;
          return t(["Réinitialiser"]);
        }
      }
    },
    toasts: {
      "group-titles": {
        automation: (e) => {
          const { normalize: t, plural: n } = e;
          return n([t(["Raccourci détecté"]), t(["Raccourcis détectés"])]);
        },
        notification: (e) => {
          const { normalize: t, plural: n } = e;
          return n([t(["Nouvelle notification"]), t(["Nouvelles notifications"])]);
        },
        "urgent-notification": (e) => {
          const { normalize: t, plural: n } = e;
          return n([t(["Notification urgente"]), t(["Notifications urgentes"])]);
        },
        context: (e) => {
          const { normalize: t } = e;
          return t(["Contexte du ticket"]);
        }
      },
      cta: {
        show: (e) => {
          const { normalize: t } = e;
          return t(["Afficher"]);
        },
        "show-more": (e) => {
          const { normalize: t } = e;
          return t(["Afficher plus"]);
        },
        "show-less": (e) => {
          const { normalize: t } = e;
          return t(["Afficher moins"]);
        },
        "open-content": (e) => {
          const { normalize: t } = e;
          return t(["Ouvrir le contenu"]);
        },
        close: (e) => {
          const { normalize: t } = e;
          return t(["Fermer"]);
        }
      },
      footer: {
        "other-contents": (e) => {
          const { normalize: t, interpolate: n, named: o, plural: i } = e;
          return i([t(["1 autre contenu"]), t([n(o("count")), " autres contenus"])]);
        },
        "other-notifications": (e) => {
          const { normalize: t, interpolate: n, named: o, plural: i } = e;
          return i([t(["1 autre notification"]), t([n(o("count")), " autres notifications"])]);
        }
      },
      context: {
        1: (e) => {
          const { normalize: t } = e;
          return t(["L'utilisateur est très insatisfait"]);
        },
        2: (e) => {
          const { normalize: t } = e;
          return t(["L'utilisateur est insatisfait"]);
        },
        3: (e) => {
          const { normalize: t } = e;
          return t(["L'utilisateur est neutre"]);
        },
        4: (e) => {
          const { normalize: t } = e;
          return t(["L'utilisateur est satisfait"]);
        },
        5: (e) => {
          const { normalize: t } = e;
          return t(["L'utilisateur est très satisfait"]);
        }
      }
    },
    lightbox: {
      open: (e) => {
        const { normalize: t } = e;
        return t(["Ouvrir dans un nouvel onglet"]);
      },
      close: (e) => {
        const { normalize: t } = e;
        return t(["Fermer"]);
      }
    },
    toc: {
      title: (e) => {
        const { normalize: t } = e;
        return t(["Sommaire"]);
      }
    }
  }
}, $u = {
  async install(e, t = {}) {
    const n = ze.ADMIN;
    if (t.pinia === void 0) {
      console.error(`[${n}] 🍍 pinia store instance not provided`);
      return;
    }
    if (t.adminClient === void 0) {
      console.error(`[${n}] 🛰 axios instance not provided`);
      return;
    }
    if (t.brainClient === void 0) {
      console.error(`[${n}] 🧠 axios instance not provided`);
      return;
    }
    t.i18n === void 0 && console.error(`[${n}] 🇫🇷 i18n instance not provided`);
    const { pinia: o, authClient: i, adminClient: r, brainClient: s, frontUrl: l, ssoUrl: a, source: u } = t;
    o.use(({ store: g }) => {
      if (g.$id === n)
        if (g.$adminService = nr(
          i,
          r,
          s,
          l,
          a,
          u
        ), t.appFunctions !== void 0) {
          const { logs: d } = t.appFunctions;
          g.$logs = d || (() => {
            console.error(`[${n}] 🛠 log function not provided`);
          });
        } else
          console.error(`[${n}] 🛠 app functions not provided`);
    }), Object.keys(et).forEach((g) => {
      var d;
      (d = t.i18n) == null || d.global.mergeLocaleMessage(g, et[g]);
    }), e.component("login-view", Ic), e.component("settings-view", Fu);
  }
}, tN = {
  plugin: $u,
  useStore: ft,
  attachService: nr
}, On = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='21'%20height='26'%20fill='none'%3e%3cmask%20id='a'%20fill='white'%3e%3crect%20width='20.73'%20height='26'%20rx='.5'/%3e%3c/mask%3e%3crect%20width='20.73'%20height='26'%20stroke='%23FCBF49'%20stroke-width='2'%20mask='url(%23a)'%20rx='.5'/%3e%3crect%20width='10'%20height='7'%20x='2'%20y='3'%20fill='%23FCBF49'%20fill-opacity='.4'%20rx='.5'/%3e%3cpath%20stroke='%23FCBF49'%20stroke-linecap='round'%20d='M2.5%2012.5h16.398M2.5%2015.5h16.398M14.5%203.5h4m-4%203h4m-4%203h4m-16%209h16.398M2.5%2021.5h10'/%3e%3c/svg%3e", xn = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='23'%20height='26'%20fill='none'%3e%3crect%20width='17.53'%20height='6.5'%20x='4.521'%20y='2.167'%20fill='%230081F9'%20rx='.5'/%3e%3crect%20width='17.53'%20height='6.5'%20x='4.521'%20y='10.833'%20fill='%230081F9'%20rx='.5'/%3e%3crect%20width='17.53'%20height='6.5'%20x='4.521'%20y='19.5'%20fill='%230081F9'%20fill-opacity='.3'%20rx='.5'/%3e%3cpath%20stroke='%230081F9'%20stroke-linecap='round'%20stroke-width='.5'%20d='M.875.25V22.5'/%3e%3c/svg%3e", ur = [
  {
    id: "article",
    key: "type",
    value: "Article",
    label: "super-search.article",
    groupLabel: "search.filters.types",
    iconUrl: On,
    color: $e.yellow.DEFAULT,
    trad: !0
  },
  {
    id: "diagnostic",
    key: "type",
    value: "Diagnostic",
    label: "super-search.diagnostic",
    groupLabel: "search.filters.types",
    iconUrl: xn,
    color: $e.blue.DEFAULT,
    trad: !0
  }
];
function Ru({
  type: e,
  value: t
}) {
  if (!["entity", "status"].includes(e))
    switch (e) {
      case "type":
        return ur.find((n) => n.value === t.id);
      case "category":
        return {
          key: "categories",
          label: t.labelName || "",
          value: t.documentId,
          id: t.documentId,
          color: t.color,
          icon: t.icon,
          groupLabel: t.categoryName
        };
    }
}
function dr(e, t) {
  if (!e.length)
    return [];
  const n = /[^A-Za-z0-9]+/g, o = (s) => s.replace(n, "").trim();
  let i = [...e];
  if (t === "recommended")
    return i;
  function r(s, l) {
    const a = o(t === "alpha-asc" ? s.label : l.label), u = o(t === "alpha-asc" ? l.label : s.label), g = a.split(/(\d+)/), d = u.split(/(\d+)/);
    for (let f = 0; f < Math.min(g.length, d.length); f++) {
      const I = f % 2 === 1, z = f % 2 === 1;
      if (I && z) {
        const v = parseInt(g[f], 10), Q = parseInt(d[f], 10);
        if (v !== Q)
          return v - Q;
      } else {
        const v = g[f].localeCompare(d[f]);
        if (v !== 0)
          return v;
      }
    }
    return g.length - d.length;
  }
  return i.sort(r);
}
const Vu = {
  hasMore(e) {
    return e.results.length < e.total;
  },
  hasSearchFilters(e) {
    var t, n;
    return ((t = e.resultsFilters.labels) == null ? void 0 : t.length) || 0 + ((n = e.resultsFilters.types) == null ? void 0 : n.length) || 0;
  },
  sortedResults(e) {
    return dr(e.results, e.sortOptionId);
  }
}, Bu = {
  correlationId: null,
  filters: { query: null, types: [], labels: [], size: 0 },
  results: [],
  total: 0,
  loading: !1,
  sortOptionId: "recommended",
  resultsFilters: { query: null, types: [], labels: [], size: 0 },
  allFilters: [],
  isGridSearch: !1
};
function ds() {
  return Object.assign({}, {}, Bu);
}
const kt = Wt(ze.SEARCH, {
  state: ds,
  getters: { ...Vu },
  actions: {
    mutate(e) {
      this.$patch((t) => {
        Object.keys(e).forEach((n) => {
          t[n] = e[n];
        });
      });
    },
    // patch object will not be synced
    unsyncedMutate(e) {
      this.$patch(e);
    },
    reset() {
      this.mutate(ds());
    },
    logs(e) {
      this.$logs(e);
    },
    async knowledgeSearchAction({
      queryText: e,
      correlationId: t,
      searchFilters: n,
      categories: o,
      size: i,
      lang: r,
      caseId: s
    }) {
      try {
        const { search: l } = await this.$searchService.search({
          ...n,
          categories: o,
          queryText: e,
          correlationId: t,
          size: i,
          lang: r,
          caseId: s
        });
        return l.documents.forEach((a) => {
          a.__typename === "Case" && (a.type = "Case");
        }), l;
      } catch {
        return null;
      }
    },
    async searchSuggestions({
      queryText: e,
      pre: t,
      lang: n
    }) {
      try {
        t && t.type && t.type.length && (t.type = t.type.map((i) => i === "Case" ? null : i)), t.published = ["true"];
        const o = await this.$searchService.suggestions({
          queryText: e,
          pre: t,
          lang: n
        });
        return o || null;
      } catch {
        return null;
      }
    },
    async getContentParameterLabels() {
      const e = await this.$searchService.getContentParameterLabels();
      return this.mutate({ allFilters: e }), e;
    },
    async searchFromHighlight({
      queryText: e,
      correlationId: t,
      preferredLanguage: n
    }) {
      try {
        return await this.$searchService.searchFromHighlight(
          e,
          t,
          n
        );
      } catch {
        return null;
      }
    },
    mutateSearchResults({
      results: e,
      total: t,
      correlationId: n
    }) {
      this.correlationId = n, this.results = e, this.total = t;
    },
    mutateSearchFilters(e) {
      this.mutate({ filters: { ...this.filters, ...e } });
    },
    updateSortOption(e) {
      this.mutate({ sortOptionId: e });
    },
    updateFilters(e) {
      this.mutate({ resultsFilters: { ...this.resultsFilters, ...e } });
    },
    updateLayout(e) {
      this.mutate({ isGridSearch: e });
    }
  },
  persist: {
    key: `md-${ze.SEARCH}`
  },
  share: {
    enable: !1
  }
});
function Di(e) {
  const t = e.labels.map(
    (o) => {
      const i = kt().allFilters.find((r) => r.id === o);
      return i ? {
        key: "categories",
        value: i.id,
        label: i.labelName,
        groupLabel: i.categoryName,
        id: i.id,
        icon: i.icon,
        color: i.color
      } : null;
    }
  ).filter(Boolean), n = e.types.map((o) => {
    const i = ur.find((r) => r.value === o);
    return i || null;
  }).filter(Boolean);
  return [...t, ...n];
}
function Yu(e, t, n) {
  const o = [...e], i = Di(t);
  let r = o;
  const s = [], l = [];
  return i.forEach((a) => {
    a.key === "type" ? s.push(a.id) : l.push(a.label);
  }), i.length && (s.length && (r = o.filter((a) => s.includes(a.type.toLowerCase()))), l.length && (r = r.filter((a) => {
    if (a.type === "Case")
      return !1;
    const u = a.labels.map((g) => g.labelName);
    return n ? l.every((g) => u.includes(g)) : u.some((g) => l.includes(g));
  }))), r;
}
const Ae = {
  isError: (e) => !!e.errorId,
  modalIsError: (e) => !!e.modalErrorId,
  appIsLoading: (e) => e.knowledgeIsLoading || e.mainIsLoading,
  // KNOWLEDGE
  knowledgeValue: (e) => (t) => e.knowledges.find((o) => o.id === t).value,
  focusKnowledge: (e) => e.knowledges.find((t) => t.value === e.knowledgeId),
  knowledgeRoot: (e) => {
    var o, i;
    const t = Ae.focusKnowledge(e);
    if (!t)
      return {
        id: "0",
        label: "Home",
        type: "Knowledge"
      };
    const n = Ae.focusDefaultLanguage(e);
    return {
      id: t.value,
      label: ((i = (o = t.translations) == null ? void 0 : o[n]) == null ? void 0 : i.label) || t.label || "Home",
      type: "Knowledge"
    };
  },
  focusKnowledgeLabel: (e) => {
    var t;
    return (t = Ae.focusKnowledge(e)) == null ? void 0 : t.label;
  },
  focusDefaultLanguage: (e) => {
    var t;
    return ((t = Ae.focusKnowledge(e)) == null ? void 0 : t.defaultLanguage) || "fr-fr";
  },
  selectedLanguage: (e) => {
    var t;
    return e.focusLanguage || ((t = Ae.focusKnowledge(e)) == null ? void 0 : t.defaultLanguage) || "fr-fr";
  },
  isMultiLanguage: (e) => {
    const t = Ae.focusKnowledge(e);
    return t ? t.supportedLanguages.length > 1 : !1;
  },
  remainingKnowledges: (e) => e.knowledges.filter((t) => t.value !== e.knowledgeId),
  rootIsFocused: (e) => {
    var t;
    return ((t = e.path) == null ? void 0 : t.length) === 1;
  },
  rootPanelIsFocused: (e) => {
    var t;
    return ((t = e.modalPath) == null ? void 0 : t.length) === 1;
  },
  mainContent: (e) => {
    const { content: t, knowledgeContent: n } = e;
    return Ae.rootIsFocused(e) ? n : t;
  },
  panelContent: (e) => {
    const { modalContent: t, knowledgeContent: n } = e;
    return Ae.rootPanelIsFocused(e) ? n : t;
  },
  mainContentChildren: (e) => e.contentChildren,
  panelContentChildren: (e) => {
    const { modalContentChildren: t, knowledgeRoots: n } = e;
    return Ae.rootPanelIsFocused(e) ? n : t;
  },
  collectionIsEmpty: (e) => {
    const t = Ae.mainContent(e);
    return (t == null ? void 0 : t.type) === "Case" && Ae.mainContentChildren(e) ? Ae.mainContentChildren(e).length === 0 : !1;
  },
  panelCollectionIsEmpty: (e) => {
    const t = Ae.panelContent(e);
    return (t == null ? void 0 : t.type) === "Case" && Ae.panelContentChildren(e) ? Ae.panelContentChildren(e).length === 0 : !1;
  },
  diagnosticIsFocused: (e) => {
    const t = Ae.mainContent(e);
    return t ? ["Diagnostic", "Step", "keyStep"].includes(t.type) : !1;
  },
  articleIsFocused: (e) => {
    const t = Ae.mainContent(e);
    return t ? ["Article"].includes(t.type) : !1;
  },
  contentIsFocused: (e) => Ae.diagnosticIsFocused(e) || Ae.articleIsFocused(e),
  contentLanguages: (e) => {
    const t = Ae.mainContent(e);
    return t == null ? void 0 : t.setLanguages;
  },
  diagnosticTitle: (e) => e.contentParents.length ? e.contentParents[0].label : "",
  contentSiblings: (e) => {
    var t;
    return e.contentParents.length ? (t = e.contentParents.at(-1)) == null ? void 0 : t.children : [];
  },
  modalContentSiblings: (e) => {
    var t;
    return e.modalContentParents.length ? (t = e.modalContentParents.at(-1)) == null ? void 0 : t.children : [];
  },
  answerModaleIsActive: (e) => ["CUSTOM_MESSAGE", "ZENDESK_MESSAGE"].includes(e.modalContent.id),
  mainContentIsAnswer: (e) => e.content.type === "Answer",
  modalContentIsAnswer: (e) => e.modalContent.type === "Answer",
  hasKnowledgeFilters(e) {
    return e.filters.labels.length + e.filters.types.length;
  },
  filteredCollection: (e) => (t) => Yu([...Ae.mainContentChildren(e)], e.filters, t),
  filteredLength: (e) => (t) => Ae.filteredCollection(e)(t).length
}, Qu = {
  /**
   * ERROR
   */
  errorCode: "",
  errorId: "",
  modalErrorCode: "",
  modalErrorId: "",
  /**
  /**
   * KNOWLEDGE
   */
  knowledges: [],
  knowledgeId: null,
  knowledgeContent: {},
  knowledgeRoots: [],
  knowledgeIsLoading: !1,
  parents: [],
  focusLanguage: void 0,
  sortOptionId: "recommended",
  filters: { query: null, types: [], labels: [], size: 0 },
  isGrid: !1,
  /**
   * CONTENTS
   */
  path: [],
  content: {},
  contentChildren: [],
  contentParents: [],
  tableOfContents: [],
  mainIsLoading: !1,
  /**
   * MODAL CONTENT
   */
  modalPath: [],
  modalContent: {},
  modalContentChildren: [],
  modalContentParents: [],
  modalIsLoading: !1,
  /**
   * CACHE
   */
  users: {}
};
function gs() {
  return Ai(Qu);
}
function Pu(e) {
  return e ? e.find((n) => n.isDefault) || e[0] : null;
}
const Gu = {
  Knowledge: "knowledges",
  Case: "cases",
  Diagnostic: "contents",
  Step: "contents",
  keyStep: "contents"
}, gr = ["agent-client", "chrome-extension"], le = Wt(ze.KNOWLEDGE, {
  state: gs,
  getters: { ...Ae },
  actions: {
    mutate(e) {
      this.$patch((t) => {
        Object.keys(e).forEach((n) => {
          t[n] = e[n];
        });
      });
    },
    // patch object will not be synced
    unsyncedMutate(e) {
      this.$patch(e);
    },
    reset() {
      this.mutate(gs());
    },
    logs(e, t = !1) {
      this.$logs(e, t);
    },
    logContentRead(e, t, n, o) {
      const i = {
        content: {
          ...e
        },
        lang: t,
        deepLoading: n,
        source: o
      };
      this.$logs(
        {
          topic: "CONTENT_READ",
          event: i
        },
        !0
      );
    },
    logKnowledgeView(e, t = !1) {
      if (this.knowledgeId === e && !t)
        return;
      const n = this.knowledges.find((i) => i.value === e);
      if (!n)
        return;
      const o = {
        knowledge: {
          id: n.id,
          value: n.value,
          type: n.type || "private",
          language: n.defaultLanguage
        }
      };
      this.$logs({
        topic: "APP_KNOWLEDGE_VIEW",
        event: o
      });
    },
    notify(e) {
      this.$notify(e);
    },
    resetContentMutation() {
      this.mutate({
        content: {},
        contentId: null,
        contentChildren: [],
        contentParents: []
      });
    },
    /**
     * GENERAL
     */
    resetPath() {
      this.updatePath([this.knowledgeRoot]);
    },
    unsetError({ isModal: e = !1 } = {}) {
      e ? this.mutate({
        modalErrorCode: "",
        modalErrorId: ""
      }) : this.mutate({
        errorCode: "",
        errorId: ""
      });
    },
    /**
     * KNOWLEDGE
     */
    setLanguage(e) {
      this.mutate({ focusLanguage: e });
    },
    async getKnowledges() {
      const { knowledges: e } = await this.$knowledgeService.getKnowledges(), t = Pu(e);
      if (t) {
        const n = t.value;
        this.mutate({ knowledges: e, knowledgeId: n }), this.logKnowledgeView(n, !0);
      }
      return t;
    },
    async getKnowledgeRootContent({
      knowledgeValue: e,
      skipOrdered: t,
      skipPath: n = !1
    }) {
      try {
        if (this.mutate({ knowledgeIsLoading: !0 }), !this.knowledges.find((r) => r.value === e) || !this.selectedLanguage)
          return [];
        const { roots: i } = await this.$knowledgeService.getKnowledgeRootContent(
          e,
          this.selectedLanguage,
          t
        );
        return this.logKnowledgeView(e), this.mutate({ knowledgeId: e }), this.mutate({ knowledgeContent: this.knowledgeRoot }), this.mutate({ knowledgeRoots: i }), n || (this.mutate({ path: [this.knowledgeRoot] }), this.resetContentMutation()), i;
      } finally {
        this.mutate({ knowledgeIsLoading: !1 });
      }
    },
    updatePath(e) {
      e && e.length === 1 && this.mutate({ content: {} }), this.mutate({ contentParents: [], path: e });
    },
    updateModalPath(e) {
      e && e.length === 1 && this.mutate({ modalContent: {} }), this.mutate({ modalContentParents: [], modalPath: e });
    },
    /**
     * CASES AND CONTENTS
     */
    async getEntity({
      id: e,
      entityType: t,
      hash: n = "",
      source: o = "",
      shouldLog: i = !1
    }) {
      try {
        this.unsetError(), this.mutate({ mainIsLoading: !0 });
        const r = `get${t}`;
        if (!this.selectedLanguage)
          return;
        const { entity: s } = await this.$knowledgeService[r](
          e,
          this.selectedLanguage
        );
        if (!s) {
          this.mutate({
            errorCode: "NO_ACCESS_RIGHTS",
            errorId: rn()
          }), this.mutate({ content: {} }), this.mutate({ contentChildren: [] }), this.mutate({ path: [] }), this.mutate({ contentParents: [] });
          return;
        }
        const { children: l, orderedChildrenAndContents: a, ...u } = s, g = l || a;
        if (this.mutate({ content: { ...u, hash: n } }), this.mutate({ contentChildren: g }), i) {
          const { type: d, knowledgeId: f } = u, I = ["Step", "keyStep"].includes(d) && !(g != null && g.length), z = !0;
          this.logContentRead(
            { id: e, type: d, knowledgeId: f, isLastStep: I, published: z },
            this.selectedLanguage,
            !1,
            o
          );
        }
      } catch (r) {
        console.error(r);
      } finally {
        this.mutate({ mainIsLoading: !1 });
      }
    },
    async getCaseChildren(e) {
      if (!(!this.selectedLanguage || !this.knowledgeId))
        if (!e)
          this.mutate({ parents: this.knowledgeRoots });
        else {
          const { entity: t } = await this.$knowledgeService.getCase(e, this.selectedLanguage);
          this.mutate({ parents: t == null ? void 0 : t.orderedChildrenAndContents });
        }
    },
    async getEntityAncestors({
      id: e,
      entityType: t,
      hash: n = "",
      isModal: o = !1,
      source: i,
      shouldLog: r = !1,
      lang: s = ""
    }) {
      var a, u, g;
      const l = o ? "modalIsLoading" : "mainIsLoading";
      try {
        if (this.unsetError({ isModal: o }), this.mutate({ [l]: !0 }), o || this.mutate({ contentChildren: [] }), !this.selectedLanguage && !s)
          return;
        const d = s || this.selectedLanguage, f = `get${t}Ancestors`, { entity: I } = await this.$knowledgeService[f](e, d);
        if (!I) {
          o ? (this.mutate({
            modalErrorCode: "NO_ACCESS_RIGHTS",
            modalErrorId: rn()
          }), this.mutate({ modalContent: {} }), this.mutate({ modalContentChildren: [] }), this.mutate({ modalPath: [] }), this.mutate({ modalContentParents: [] })) : (this.mutate({
            errorCode: "NO_ACCESS_RIGHTS",
            errorId: rn()
          }), this.mutate({ content: {} }), this.mutate({ contentChildren: [] }), this.mutate({ path: [] }), this.mutate({ contentParents: [] }));
          return;
        }
        const {
          contentAncestors: z,
          caseAncestors: v,
          children: Q,
          orderedChildrenAndContents: H,
          ...ee
        } = I, j = v && ((a = v.at(-1)) == null ? void 0 : a.id);
        if (o || await this.getCaseChildren(j), r) {
          const { type: U, knowledgeId: he } = I, se = ["Step", "keyStep"].includes(U) && !(Q != null && Q.length), F = !0;
          this.logContentRead(
            { id: e, type: U, knowledgeId: he, isLastStep: se, published: F },
            d,
            !1,
            i
          );
        }
        if (ee.knowledgeId !== ((u = this.focusKnowledge) == null ? void 0 : u.id)) {
          const U = this.knowledgeValue(ee.knowledgeId);
          await this.getKnowledgeRootContent({
            knowledgeValue: U
          });
        }
        const G = Q || H;
        o ? (this.mutate({ modalContent: { ...ee, hash: n } }), this.mutate({ modalContentChildren: G })) : (this.mutate({ content: { ...ee, hash: n } }), this.mutate({ contentChildren: G }));
        let V = [this.knowledgeRoot];
        v && (V = [...V, ...v]), ["Case", "Diagnostic", "Article"].includes(ee.type) && (V = [...V, ee]);
        let K = [{ ...ee, children: Q }];
        if (z) {
          const U = (g = z.at(-1)) == null ? void 0 : g.children;
          K = [...z.map(
            (se, F) => F === 0 ? {
              ...se,
              children: []
            } : {
              ...se,
              children: z[F - 1].children
            }
          ), { ...ee, children: U }];
        }
        ["Step", "keyStep"].includes(ee.type) && (V = [...V, K[0]]), o ? (this.mutate({ modalPath: V }), this.mutate({ modalContentParents: K })) : (this.mutate({ path: V }), this.mutate({ contentParents: K }));
      } catch (d) {
        console.error(d);
      } finally {
        this.mutate({ [l]: !1 });
      }
    },
    setContentHash({ hash: e, isModal: t = !1 }) {
      t ? this.mutate({ modalContent: { ...this.modalContent, hash: e } }) : this.mutate({ content: { ...this.content, hash: e } });
    },
    // This action is used in `ContentViewer` and knowledgeModule/openInlineLink action.
    // Lang argument will be added once we have the lang in mayday-editor
    async getContent(e) {
      if (!this.selectedLanguage)
        return null;
      const { entity: t } = await this.$knowledgeService.getContent(e, this.selectedLanguage);
      return t;
    },
    async getContentAncestors(e) {
      if (!this.selectedLanguage)
        return null;
      const { entity: t } = await this.$knowledgeService.getContentAncestors(
        e,
        this.selectedLanguage
      );
      return t;
    },
    updateContentParents(e) {
      this.mutate({ contentParents: e });
    },
    updateModalContentParents(e) {
      this.mutate({ modalContentParents: e });
    },
    // MAYDAY EDITOR
    async openInlineLink(e) {
      try {
        const { pathname: t, hash: n } = new URL(e), o = t.split("/").pop();
        if (o && o.length === 24) {
          const i = await this.getContent(o);
          return i ? { content: i, hash: n } : null;
        }
        return null;
      } catch {
        return null;
      }
    },
    // NAVIGATION
    updatePathWithChildEntity(e) {
      this.updatePath(this.path.concat([e]));
    },
    updateModalPathWithChildEntity(e) {
      this.updateModalPath(this.modalPath.concat([e]));
    },
    getParentEntity(e, t, n) {
      const o = n[e];
      if (!o || !o.type || !Gu[o.type])
        return;
      const i = o.id == "0" ? this.knowledgeValue(t || "") : o.id, r = o.type === "Knowledge";
      return {
        id: i,
        type: o.type,
        force: r,
        skipOrdered: r
      };
    },
    addContentSatisfactionMark({
      contentId: e,
      thumbType: t,
      lang: n
    }) {
      return t ? this.$knowledgeService.addContentSatisfactionMark(e, t, n) : null;
    },
    /**
     * CASES AND CONTENTS
     */
    clearModal() {
      this.mutate({
        modalPath: [],
        modalContent: {},
        modalContentChildren: [],
        modalContentParents: [],
        modalErrorCode: "",
        modalErrorId: ""
      });
    },
    setAnswerModal(e) {
      this.modalContent.id === e.id && this.modalContent.body === e.body || (this.clearModal(), this.mutate({
        modalContent: e
      }));
    },
    dispatchKnowledgeAction({
      actionId: e,
      context: t,
      contentId: n
    }) {
      return this.$knowledgeService.dispatchAction(e, n, {
        integration: t.tabSource,
        objectId: t.conversationId
      });
    },
    setTableOfContents(e) {
      this.mutate({ tableOfContents: e });
    },
    updateSortOption(e) {
      this.mutate({ sortOptionId: e });
    },
    updateFilters(e) {
      this.mutate({ filters: { ...this.filters, ...e } });
    },
    updateLayout(e) {
      this.mutate({ isGrid: e });
    },
    async fetchUser(e) {
      const t = this.users[e];
      if (t)
        return t;
      const n = (await this.$knowledgeService.getUsers([e]))[0];
      return n ? (this.mutate({ users: Object.assign({}, this.users, { [n.id]: n }) }), n) : null;
    }
  },
  persist: {
    key: `md-${ze.KNOWLEDGE}`
  },
  share: {
    enable: !1
  }
});
class Zu {
  constructor(t, n) {
    xe(this, "knowledgeClient");
    xe(this, "adminClient");
    this.knowledgeClient = t, this.adminClient = n;
  }
  /**
   * KNOWLEDGE
   */
  async getKnowledges() {
    const t = await this.knowledgeClient.get("knowledges");
    return t.data || t;
  }
  async getKnowledgeRootContent(t, n, o = !1) {
    const i = await this.knowledgeClient.get(
      `knowledge/${n}/${t}/roots?skipOrdered=${o}`
    );
    return i.data || i;
  }
  /**
   * CASE
   */
  async getCase(t, n) {
    const o = await this.knowledgeClient.get(`case/${n}/${t}`);
    return o.data || o;
  }
  async getCaseAncestors(t, n) {
    const o = await this.knowledgeClient.get(
      `case/${n}/${t}/ancestors`
    );
    return o.data || o;
  }
  /**
   * CONTENT
   */
  async getContent(t, n) {
    const o = await this.knowledgeClient.get(`content/${n}/${t}`);
    return o.data || o;
  }
  async getContentAncestors(t, n) {
    const o = await this.knowledgeClient.get(
      `content/${n}/${t}/ancestors`
    );
    return o.data || o;
  }
  async getContentDescendents(t, n) {
    const o = await this.knowledgeClient.get(`content/${n}/${t}/descendents`);
    return o.data || o;
  }
  addContentSatisfactionMark(t, n, o) {
    return this.knowledgeClient.post(`content/${o}/${t}/satisfaction`, {
      thumbType: n
    });
  }
  async dispatchAction(t, n, o) {
    const i = await this.knowledgeClient.post("action", {
      actionId: t,
      contentId: n,
      context: o
    });
    return i.data || i;
  }
  /**
   * CACHE METHODS
   */
  async getUsers(t) {
    const n = new URLSearchParams();
    t && t.length && t.forEach((i) => n.append("userIds[]", i));
    const o = await this.adminClient.get(
      `users-or-deleted-users?${n.toString()}`
    );
    return o.data || o;
  }
}
const pr = (e, t) => new Zu(e, t), Wu = "data:image/svg+xml;base64,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", Hu = "data:image/svg+xml;base64,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", Ju = "data:image/svg+xml;base64,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", Ku = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTY4IiBoZWlnaHQ9IjE2OCIgdmlld0JveD0iMCAwIDE2OCAxNjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8zNDBfMTQ4KSI+CjxwYXRoIGQ9Ik04NC45MjY0IDE1Mi4zNzhDMTE0LjYyNiAxNTIuMzc4IDEzOC44MjYgMTI4LjI3OCAxMzguODI2IDk4LjY3ODVDMTM4LjgyNiA2OC45Nzg1IDExNC43MjYgNDQuOTc4NSA4NC45MjY0IDQ0Ljk3ODVDNTUuMTI2NCA0NC44Nzg1IDMxLjAyNjQgNjguODc4NSAzMS4wMjY0IDk4LjU3ODVDMzEuMDI2NCAxMjguMjc4IDU1LjEyNjQgMTUyLjM3OCA4NC45MjY0IDE1Mi4zNzhaIiBmaWxsPSIjRUFFRUY5Ii8+CjxwYXRoIGQ9Ik03NS40MjYzIDc5Ljg3ODVMNzQuMDI2MyA3NS45Nzg1QzczLjcyNjMgNzQuOTc4NSA3Mi43MjYzIDc0LjM3ODUgNzEuNzI2MyA3NC4zNzg1SDQ3LjEyNjNDNDUuMDI2MyA3NC4zNzg1IDQzLjQyNjMgNzUuOTc4NSA0My40MjYzIDc4LjA3ODVWMTMzLjE3OVYxMjQuMDc5SDEyNy40MjZWODUuMTc4NUMxMjcuNDI2IDgzLjA3ODUgMTI1LjgyNiA4MS40Nzg1IDEyMy43MjYgODEuNDc4NUg3Ny43MjYzQzc2LjcyNjMgODEuNDc4NSA3NS44MjYzIDgwLjg3ODUgNzUuNDI2MyA3OS44Nzg1WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzM0MF8xNDgpIi8+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXIwX2RfMzQwXzE0OCkiPgo8cGF0aCBkPSJNNDUuODI2MyA0OC4wNzg1TDYyLjYyNjMgNzcuMjc4NUM2My4xMjYzIDc4LjI3ODUgNjIuODI2MyA3OS41Nzg1IDYxLjgyNjMgODAuMDc4NUwzMy4yMjYzIDk2LjA3ODVDMzIuMjI2MyA5Ni41Nzg1IDMwLjkyNjMgOTYuMjc4NSAzMC40MjYzIDk1LjI3ODVMOS4zMjYzMSA1Ny40Nzg1QzguNjI2MzEgNTYuNDc4NSA5LjEyNjMxIDU1LjE3ODUgMTAuMTI2MyA1NC42Nzg1TDMwLjkyNjMgNDMuMDc4NUw0NS44MjYzIDQ4LjA3ODVaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxwYXRoIGQ9Ik0zMC43MjYzIDUxLjE3ODVMMTYuOTI2MyA1OC44Nzg1QzE2LjYyNjMgNTkuMDc4NSAxNi4xMjYzIDU4Ljk3ODUgMTYuMDI2MyA1OC41Nzg1QzE1LjgyNjMgNTguMjc4NSAxNS45MjYzIDU3Ljc3ODUgMTYuMjI2MyA1Ny42Nzg1TDMwLjAyNjMgNTAuMDc4NUMzMC4zMjYzIDQ5Ljg3ODUgMzAuODI2MyA0OS45Nzg1IDMwLjkyNjMgNTAuMjc4NUMzMS4xMjYzIDUwLjU3ODUgMzEuMDI2MyA1MS4wNzg1IDMwLjcyNjMgNTEuMTc4NVoiIGZpbGw9IiNENURERUEiLz4KPHBhdGggZD0iTTI0LjAyNjMgNTkuMjc4NUwxOC43MjYzIDYyLjE3ODVDMTguNDI2MyA2Mi4zNzg1IDE4LjAyNjMgNjIuMjc4NSAxNy45MjYzIDYxLjk3ODVDMTcuNzI2MyA2MS42Nzg1IDE3LjgyNjMgNjEuMTc4NSAxOC4xMjYzIDYxLjA3ODVMMjMuMzI2MyA1OC4xNzg1QzIzLjYyNjMgNTcuOTc4NSAyNC4xMjYzIDU4LjA3ODUgMjQuMjI2MyA1OC4zNzg1QzI0LjUyNjMgNTguNTc4NSAyNC40MjYzIDU5LjA3ODUgMjQuMDI2MyA1OS4yNzg1WiIgZmlsbD0iI0Q1RERFQSIvPgo8cGF0aCBkPSJNMzAuOTI2MyA0My4wNzg1TDM1LjUyNjMgNTEuMTc4NUMzNi4yMjYzIDUyLjI3ODUgMzcuNzI2MyA1Mi42Nzg1IDM4LjgyNjMgNTIuMDc4NUw0Ni4xMjYzIDQ4LjA3ODUiIGZpbGw9IiNENURERUEiLz4KPHBhdGggZD0iTTQ3LjUyNjMgNjUuODc4NUM0Ni42MjYzIDY0LjA3ODUgNDUuNDI2MyA2MS45Nzg1IDQzLjkyNjMgNjAuNDc4NUM0My4xMjYzIDU5LjY3ODUgNDIuMTI2MyA1OS4xNzg1IDQwLjkyNjMgNTkuMTc4NUMzOS43MjYzIDU5LjE3ODUgMzguNjI2MyA1OS41Nzg1IDM3LjQyNjMgNjAuMTc4NUMzNS4zMjYzIDYxLjA3ODUgMzMuNDI2MyA2MS45Nzg1IDMxLjUyNjMgNjMuMTc4NUMyOS44MjYzIDY0LjE3ODUgMjcuODI2MyA2NS4yNzg1IDI2LjUyNjMgNjYuODc4NUMyNC44MjYzIDY5LjE3ODUgMjUuNzI2MyA3MS40Nzg1IDI2LjkyNjMgNzMuODc4NUMyNy44MjYzIDc1LjY3ODUgMjkuMDI2MyA3Ny43Nzg1IDMwLjUyNjMgNzkuMjc4NUMzMS43MjYzIDgwLjQ3ODUgMzMuMzI2MyA4MC44Nzg1IDM0LjkyNjMgODAuMzc4NUMzNy4wMjYzIDc5Ljg3ODUgNDAuOTI2MyA3Ny42Nzg1IDQyLjcyNjMgNzYuNTc4NUM0NC4zMjYzIDc1LjU3ODUgNDYuMjI2MyA3NC42Nzg1IDQ3LjQyNjMgNzMuMTc4NUM0OS43MjYzIDcwLjg3ODUgNDguOTI2MyA2OC40Nzg1IDQ3LjUyNjMgNjUuODc4NVpNMzMuNTI2MyA2OC4zNzg1QzMzLjIyNjMgNjcuNzc4NSAzMy40MjYzIDY3LjI3ODUgMzQuMjI2MyA2Ny4zNzg1QzM2LjMyNjMgNjcuNDc4NSAzOC4zMjYzIDY3LjQ3ODUgNDAuMzI2MyA2Ny41Nzg1QzQxLjEyNjMgNjcuNTc4NSA0MS4zMjYzIDY3Ljk3ODUgNDEuMDI2MyA2OC42Nzg1QzQwLjAyNjMgNzAuMzc4NSAzOS4wMjYzIDcyLjE3ODUgMzguMDI2MyA3My45Nzg1QzM3LjYyNjMgNzQuNTc4NSAzNy4xMjYzIDc0LjU3ODUgMzYuODI2MyA3NC4wNzg1QzM2LjUyNjMgNzMuNzc4NSAzMy44MjYzIDY4Ljg3ODUgMzMuNTI2MyA2OC4zNzg1WiIgZmlsbD0iI0Q1RERFQSIvPgo8cGF0aCBkPSJNMTA5LjQyNiA5OS4wNzg0TDEwOC41MjYgOTguNDc4NUMxMDguMzI2IDk4LjI3ODUgMTA4LjMyNiA5OC4wNzg1IDEwOC41MjYgOTcuODc4NUMxMDguNzI2IDk3LjY3ODUgMTA4LjkyNiA5Ny42Nzg1IDEwOS4yMjYgOTcuNzc4NUwxMTAuMTI2IDk4LjM3ODVDMTEwLjMyNiA5OC40Nzg1IDExMC4zMjYgOTguNzc4NSAxMTAuMjI2IDk4Ljk3ODVDMTA5LjkyNiA5OS4xNzg1IDEwOS42MjYgOTkuMTc4NCAxMDkuNDI2IDk5LjA3ODRaIiBmaWxsPSIjRTNFQUYyIi8+CjxwYXRoIGQ9Ik0xMDcuMDI2IDk3LjE3ODVMMTAxLjkyNiA5My4xNzg1QzEwMS43MjYgOTMuMDc4NSAxMDEuNzI2IDkyLjc3ODUgMTAxLjgyNiA5Mi41Nzg1QzEwMS45MjYgOTIuMzc4NSAxMDIuMjI2IDkyLjM3ODUgMTAyLjUyNiA5Mi40Nzg1TDEwNy42MjYgOTYuNDc4NUMxMDcuODI2IDk2LjU3ODUgMTA3LjgyNiA5Ni44Nzg1IDEwNy43MjYgOTcuMDc4NUMxMDcuNTI2IDk3LjI3ODUgMTA3LjIyNiA5Ny4zNzg1IDEwNy4wMjYgOTcuMTc4NVoiIGZpbGw9IiNFM0VBRjIiLz4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjFfZF8zNDBfMTQ4KSI+CjxwYXRoIGQ9Ik0xNTguOTI2IDcxLjQ3ODVMMTM5LjgyNiA5Ni4xNzg1QzEzOS4yMjYgOTcuMDc4NSAxMzguMDI2IDk3LjE3ODUgMTM3LjEyNiA5Ni40Nzg1TDExMy4zMjYgNzcuNzc4NUMxMTIuNDI2IDc3LjE3ODUgMTEyLjMyNiA3NS45Nzg1IDExMy4wMjYgNzUuMDc4NUwxMzcuODI2IDQzLjU3ODVDMTM4LjQyNiA0Mi42Nzg1IDEzOS42MjYgNDIuNTc4NSAxNDAuNTI2IDQzLjI3ODVMMTU3LjgyNiA1Ni44Nzg1TDE1OC45MjYgNzEuNDc4NVoiIGZpbGw9IndoaXRlIi8+CjwvZz4KPHBhdGggZD0iTTE1MC44MjYgNTkuNTc4NUwxMzkuMzI2IDUwLjU3ODVDMTM5LjEyNiA1MC4zNzg1IDEzOS4wMjYgNTAuMDc4NSAxMzkuMjI2IDQ5LjY3ODVDMTM5LjQyNiA0OS40Nzg1IDEzOS43MjYgNDkuMzc4NSAxNDAuMTI2IDQ5LjU3ODVMMTUxLjYyNiA1OC41Nzg1QzE1MS44MjYgNTguNzc4NSAxNTEuOTI2IDU5LjA3ODUgMTUxLjcyNiA1OS40Nzg1QzE1MS40MjYgNTkuNzc4NSAxNTEuMTI2IDU5Ljc3ODUgMTUwLjgyNiA1OS41Nzg1WiIgZmlsbD0iI0Q1RERFQSIvPgo8cGF0aCBkPSJNMTQxLjYyNiA1Ni43Nzg1TDEzNy4zMjYgNTMuMjc4NUMxMzcuMTI2IDUzLjA3ODUgMTM3LjAyNiA1Mi43Nzg1IDEzNy4yMjYgNTIuMzc4NUMxMzcuNDI2IDUyLjA3ODUgMTM3LjcyNiA1Mi4wNzg1IDEzOC4xMjYgNTIuMjc4NUwxNDIuNDI2IDU1Ljc3ODVDMTQyLjYyNiA1NS45Nzg1IDE0Mi43MjYgNTYuMjc4NSAxNDIuNTI2IDU2LjY3ODVDMTQyLjIyNiA1Ni45Nzg1IDE0MS44MjYgNTYuOTc4NSAxNDEuNjI2IDU2Ljc3ODVaIiBmaWxsPSIjRDVEREVBIi8+CjxwYXRoIGQ9Ik0xNTcuODI2IDU2Ljg3ODVMMTUyLjUyNiA2My41Nzg1QzE1MS43MjYgNjQuNTc4NSAxNTIuMDI2IDY1Ljk3ODUgMTUyLjkyNiA2Ni42Nzg1TDE1OS4wMjYgNzEuNDc4NSIgZmlsbD0iI0Q1RERFQSIvPgo8cGF0aCBkPSJNMTUxLjUyNiA3Mi45Nzg1TDE0NS41MjYgNjguMzc4NUwxMzkuMzI2IDYzLjQ3ODVMMTMzLjYyNiA1OC45Nzg1QzEzMy4wMjYgNTguNDc4NSAxMzIuMDI2IDU4LjU3ODUgMTMxLjUyNiA1OS4yNzg1TDEyMy4zMjYgNjkuNjc4NUMxMjIuODI2IDcwLjI3ODUgMTIyLjkyNiA3MS4yNzg1IDEyMy41MjYgNzEuNzc4NUwxNDEuNTI2IDg1Ljk3ODVDMTQyLjEyNiA4Ni40Nzg1IDE0My4xMjYgODYuMzc4NSAxNDMuNjI2IDg1LjY3ODVMMTUxLjgyNiA3NS4yNzg1QzE1Mi4zMjYgNzQuMzc4NSAxNTIuMjI2IDczLjU3ODUgMTUxLjUyNiA3Mi45Nzg1Wk0xMzIuNTI2IDcyLjg3ODVMMTM0LjMyNiA3MC40Nzg1TDEzOS44MjYgNzQuNzc4NUwxMzguMDI2IDc3LjE3ODVMMTMyLjUyNiA3Mi44Nzg1Wk0xMzcuNTI2IDc3Ljg3ODVMMTM1LjgyNiA4MC4wNzg1TDEzMC4zMjYgNzUuNzc4NUwxMzIuMDI2IDczLjU3ODVMMTM3LjUyNiA3Ny44Nzg1Wk0xNDIuMjI2IDcxLjc3ODVMMTQwLjQyNiA3NC4xNzg1TDEzNC45MjYgNjkuODc4NUwxMzYuNzI2IDY3LjQ3ODVMMTQyLjIyNiA3MS43Nzg1Wk0xMzcuMjI2IDY2Ljc3ODVMMTM5LjIyNiA2NC4zNzg1TDE0NC43MjYgNjguNjc4NUwxNDIuOTI2IDcxLjA3ODVMMTM3LjIyNiA2Ni43Nzg1Wk0xNDcuMjI2IDc5LjQ3ODVMMTQxLjEyNiA3NC42Nzg1TDE0Mi45MjYgNzIuMjc4NUwxNDkuMDI2IDc3LjA3ODVMMTQ3LjIyNiA3OS40Nzg1Wk0xMzQuMjI2IDY5LjI3ODVMMTI4LjMyNiA2NC42Nzg1TDEzMC4xMjYgNjIuMjc4NUwxMzYuMDI2IDY2Ljg3ODVMMTM0LjIyNiA2OS4yNzg1Wk0xMjcuNzI2IDY1LjM3ODVMMTMzLjYyNiA2OS45Nzg1TDEzMS44MjYgNzIuMzc4NUwxMjUuOTI2IDY3Ljc3ODVMMTI3LjcyNiA2NS4zNzg1Wk0xNDAuNjI2IDc1LjM3ODVMMTQ2LjcyNiA4MC4xNzg1TDE0NC45MjYgODIuNTc4NUwxMzguODI2IDc3Ljc3ODVMMTQwLjYyNiA3NS4zNzg1Wk0xNTEuMTI2IDc0LjU3ODVMMTQ5LjYyNiA3Ni40Nzg1TDE0My41MjYgNzEuNjc4NUwxNDUuMzI2IDY5LjI3ODVMMTUwLjkyNiA3My42Nzg1QzE1MS4zMjYgNzMuODc4NSAxNTEuMzI2IDc0LjI3ODUgMTUxLjEyNiA3NC41Nzg1Wk0xMzMuMDI2IDU5LjQ3ODVMMTM4LjQyNiA2My43Nzg1TDEzNi42MjYgNjYuMTc4NUwxMzAuNzI2IDYxLjU3ODVMMTMyLjIyNiA1OS42Nzg1QzEzMi40MjYgNTkuMzc4NSAxMzIuODI2IDU5LjM3ODUgMTMzLjAyNiA1OS40Nzg1Wk0xMjQuMDI2IDcwLjA3ODVMMTI1LjMyNiA2OC40Nzg1TDEzMS4yMjYgNzMuMDc4NUwxMjkuNTI2IDc1LjI3ODVMMTI0LjAyNiA3MC45Nzg1QzEyMy44MjYgNzAuNzc4NSAxMjMuODI2IDcwLjI3ODUgMTI0LjAyNiA3MC4wNzg1Wk0xNDIuMTI2IDg0Ljk3ODVMMTM2LjUyNiA4MC41Nzg1TDEzOC4yMjYgNzguMzc4NUwxNDQuMzI2IDgzLjE3ODVMMTQyLjkyNiA4NC44Nzg1QzE0Mi43MjYgODUuMjc4NSAxNDIuMzI2IDg1LjI3ODUgMTQyLjEyNiA4NC45Nzg1WiIgZmlsbD0iI0Q1RERFQSIvPgo8cGF0aCBkPSJNMTAyLjMyNiA5NS4yNzg1TDk2LjYyNjMgOTQuNjc4NUM5Ni4zMjYzIDk0LjY3ODUgOTYuMTI2MyA5NC4zNzg1IDk2LjIyNjMgOTQuMDc4NUM5Ni4yMjYzIDkzLjc3ODUgOTYuNTI2MyA5My41Nzg1IDk2LjkyNjMgOTMuNjc4NUwxMDIuNjI2IDk0LjI3ODVDMTAyLjkyNiA5NC4yNzg1IDEwMy4xMjYgOTQuNTc4NSAxMDMuMDI2IDk0Ljg3ODVDMTAyLjkyNiA5NS4xNzg1IDEwMi42MjYgOTUuNDc4NSAxMDIuMzI2IDk1LjI3ODVaIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXJfMzQwXzE0OCkiLz4KPHBhdGggZD0iTTEyOS4xMjYgMTAwLjY3OUwxMjIuOTI2IDEyOC4zNzlDMTIyLjUyNiAxMjkuOTc5IDEyMC42MjYgMTMxLjI3OSAxMTguMjI2IDEzMS4yNzlINTAuOTI2M0M0OC42MjYzIDEzMS4yNzkgNDYuNjI2MyAxMzAuMDc5IDQ2LjIyNjMgMTI4LjM3OUw0MS4xMjYzIDEwNS42NzlDNDAuNzI2MyAxMDMuOTc5IDQyLjYyNjMgMTAyLjM3OSA0NS4wMjYzIDEwMi4zNzlIODMuMDI2M0M4NC4yMjYzIDEwMi4zNzkgODUuMTI2MyAxMDEuNzc5IDg1LjUyNjMgMTAxLjA3OUw4Ni42MjYzIDk4LjY3ODVDODcuMDI2MyA5Ny44Nzg1IDg4LjAyNjMgOTcuMzc4NSA4OS4xMjYzIDk3LjM3ODVIMTI1LjMyNkMxMjcuNjI2IDk3LjM3ODUgMTI5LjQyNiA5OC45Nzg1IDEyOS4xMjYgMTAwLjY3OVoiIGZpbGw9IndoaXRlIi8+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXIyX2RfMzQwXzE0OCkiPgo8cGF0aCBkPSJNMTM0LjAyNiA5Ni45Nzg1TDEyNy4xMjYgMTM5LjQ3OEMxMjYuNzI2IDE0MS45NzggMTI0LjUyNiAxNDMuODc4IDEyMS45MjYgMTQzLjg3OEg0Ni45MjY0QzQ0LjMyNjQgMTQzLjg3OCA0Mi4xMjY0IDE0Mi4wNzggNDEuNzI2NCAxMzkuNDc4TDM2LjAyNjQgMTA0LjU3OEMzNS42MjY0IDEwMS45NzggMzcuNjI2NCA5OS40Nzg1IDQwLjMyNjQgOTkuNDc4NUg4Mi42MjY0QzgzLjkyNjQgOTkuNDc4NSA4NS4wMjY0IDk4LjU3ODUgODUuNDI2NCA5Ny4zNzg1TDg2LjYyNjQgOTMuNjc4NUM4Ny4wMjY0IDkyLjQ3ODUgODguMTI2NCA5MS41Nzg1IDg5LjQyNjQgOTEuNTc4NUgxMjkuNzI2QzEzMi4zMjYgOTEuODc4NSAxMzQuNDI2IDk0LjI3ODUgMTM0LjAyNiA5Ni45Nzg1WiIgZmlsbD0idXJsKCNwYWludDJfbGluZWFyXzM0MF8xNDgpIi8+CjwvZz4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjNfZF8zNDBfMTQ4KSI+CjxwYXRoIGQ9Ik0xMTEuMjI2IDQxLjM3ODVMMTA4LjAyNiA3Ni4wNzg1QzEwNy45MjYgNzcuMjc4NSAxMDYuODI2IDc4LjE3ODUgMTA1LjYyNiA3Ny45Nzg1TDcxLjgyNjMgNzQuNDc4NUM3MC42MjYzIDc0LjM3ODUgNjkuNzI2MyA3My4yNzg1IDY5LjgyNjMgNzIuMDc4NUw3NC40MjYzIDI3LjU3ODVDNzQuNTI2MyAyNi4zNzg1IDc1LjYyNjMgMjUuNDc4NSA3Ni44MjYzIDI1LjY3ODVMMTAxLjMyNiAyOC4xNzg1TDExMS4yMjYgNDEuMzc4NVoiIGZpbGw9IndoaXRlIi8+CjwvZz4KPHBhdGggZD0iTTEwMS40MjYgMjguMjc4NUwxMDAuNDI2IDM3Ljc3ODVDMTAwLjMyNiAzOS4wNzg1IDEwMS4zMjYgNDAuMzc4NSAxMDIuNzI2IDQwLjQ3ODVMMTExLjMyNiA0MS4zNzg1IiBmaWxsPSIjRDVEREVBIi8+CjxwYXRoIGQ9Ik0xMDQuNjI2IDY2LjY3ODVMNzYuOTI2MyA2My41Nzg1Qzc2LjIyNjMgNjMuNDc4NSA3NS43MjYzIDYyLjk3ODUgNzUuODI2MyA2Mi4yNzg1TDc3LjkyNjMgNDQuNTc4NUM3OC4wMjYzIDQzLjk3ODUgNzguNjI2MyA0My4zNzg1IDc5LjIyNjMgNDMuNDc4NUwxMDYuOTI2IDQ2LjQ3ODVDMTA3LjYyNiA0Ni41Nzg1IDEwOC4xMjYgNDcuMDc4NSAxMDguMDI2IDQ3Ljc3ODVMMTA1LjkyNiA2NS40Nzg1QzEwNS44MjYgNjYuMTc4NSAxMDUuMjI2IDY2LjY3ODUgMTA0LjYyNiA2Ni42Nzg1WiIgZmlsbD0iI0VDRjBGOCIvPgo8cGF0aCBkPSJNOTIuMTI2MyA2Mi4zNzg1TDc5LjMyNjMgNjAuODc4NUw4Ni41MjYzIDU0LjM3ODVMOTIuMTI2MyA2Mi4zNzg1WiIgZmlsbD0iI0Q1RERFQSIvPgo8cGF0aCBkPSJNMTAyLjcyNiA2My41Nzg1TDg0LjIyNjMgNjEuMzc4NUw5NC43MjYzIDUyLjA3ODVMMTAyLjcyNiA2My41Nzg1WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTg1LjUyNjIgNTEuNTc4NUM4Ni45MjYyIDUxLjU3ODUgODguMDI2MiA1MC40Nzg1IDg4LjAyNjIgNDkuMDc4NUM4OC4wMjYyIDQ3LjY3ODUgODYuOTI2MiA0Ni41Nzg1IDg1LjUyNjIgNDYuNTc4NUM4NC4xMjYyIDQ2LjU3ODUgODMuMDI2MiA0Ny42Nzg1IDgzLjAyNjIgNDkuMDc4NUM4My4wMjYyIDUwLjQ3ODUgODQuMTI2MiA1MS41Nzg1IDg1LjUyNjIgNTEuNTc4NVoiIGZpbGw9IiNENURERUEiLz4KPHBhdGggZD0iTTk2LjIyNjMgMzQuMDc4NUw3OS40MjYzIDMyLjE3ODVDNzkuMjI2MyAzMi4xNzg1IDc5LjAyNjMgMzEuOTc4NSA3OS4xMjYzIDMxLjc3ODVWMzEuNTc4NUM3OS4xMjYzIDMxLjM3ODUgNzkuMzI2MyAzMS4xNzg1IDc5LjUyNjMgMzEuMjc4NUw5Ni4zMjYzIDMzLjE3ODVDOTYuNTI2MyAzMy4xNzg1IDk2LjcyNjMgMzMuMzc4NSA5Ni42MjYzIDMzLjU3ODVWMzMuNzc4NUM5Ni43MjYzIDMzLjk3ODUgOTYuNTI2MyAzNC4xNzg1IDk2LjIyNjMgMzQuMDc4NVoiIGZpbGw9IiNENURERUEiLz4KPHBhdGggZD0iTTk2LjEyNjMgMzcuMjc4NUw3OS4xMjYzIDM1LjM3ODVDNzguOTI2MyAzNS4zNzg1IDc4LjcyNjMgMzUuMTc4NSA3OC44MjYzIDM0Ljk3ODVWMzQuNzc4NUM3OC44MjYzIDM0LjU3ODUgNzkuMDI2MyAzNC4zNzg1IDc5LjIyNjMgMzQuNDc4NUw5Ni4yMjYzIDM2LjM3ODVDOTYuNDI2MyAzNi4zNzg1IDk2LjYyNjMgMzYuNTc4NSA5Ni41MjYzIDM2Ljc3ODVWMzYuOTc4NUM5Ni42MjYzIDM3LjA3ODUgOTYuMzI2MyAzNy4yNzg1IDk2LjEyNjMgMzcuMjc4NVoiIGZpbGw9IiNENURERUEiLz4KPHBhdGggZD0iTTk2LjcyNjMgNjkuOTc4NUw3NS42MjYzIDY3LjU3ODVDNzUuMzI2MyA2Ny41Nzg1IDc1LjEyNjMgNjcuMjc4NSA3NS4yMjYzIDY2Ljk3ODVDNzUuMjI2MyA2Ni42Nzg1IDc1LjUyNjMgNjYuNDc4NSA3NS45MjYzIDY2LjU3ODVMOTYuOTI2MyA2OC45Nzg1Qzk3LjIyNjMgNjguOTc4NSA5Ny40MjYzIDY5LjI3ODUgOTcuMzI2MyA2OS41Nzg1Qzk3LjIyNjMgNjkuODc4NSA5Ny4wMjYzIDcwLjA3ODUgOTYuNzI2MyA2OS45Nzg1WiIgZmlsbD0iI0Q1RERFQSIvPgo8cGF0aCBkPSJNOTMuNjI2MyA0MC4yNzg1TDc4LjgyNjMgMzguNTc4NUM3OC41MjYzIDM4LjU3ODUgNzguMzI2MyAzOC4yNzg1IDc4LjQyNjMgMzcuOTc4NUM3OC40MjYzIDM3LjY3ODUgNzguNzI2MyAzNy40Nzg1IDc5LjEyNjMgMzcuNTc4NUw5My45MjYzIDM5LjI3ODVDOTQuMjI2MyAzOS4yNzg1IDk0LjQyNjMgMzkuNTc4NSA5NC4zMjYzIDM5Ljg3ODVDOTQuMjI2MyA0MC4wNzg1IDk0LjAyNjMgNDAuMjc4NSA5My42MjYzIDQwLjI3ODVaIiBmaWxsPSIjRDVEREVBIi8+CjxwYXRoIGQ9Ik0xMDQuNTI2IDc0LjA3ODVMNzUuMTI2MyA3MC41Nzg1Qzc0LjgyNjMgNzAuNTc4NSA3NC42MjYzIDcwLjI3ODUgNzQuNzI2MyA2OS45Nzg1Qzc0LjcyNjMgNjkuNjc4NSA3NS4wMjYzIDY5LjQ3ODUgNzUuNDI2MyA2OS41Nzg1TDEwNC44MjYgNzIuOTc4NUMxMDUuMTI2IDcyLjk3ODUgMTA1LjMyNiA3My4yNzg1IDEwNS4yMjYgNzMuNTc4NUMxMDUuMTI2IDczLjg3ODUgMTA0LjgyNiA3NC4wNzg1IDEwNC41MjYgNzQuMDc4NVoiIGZpbGw9IiNENURERUEiLz4KPHBhdGggZD0iTTc0LjAyNjMgMjEuMDc4NUM3My42MjYzIDIxLjI3ODUgNzMuMTI2MyAyMS4wNzg1IDcyLjkyNjMgMjAuNjc4NUw3MS4xMjYzIDE2LjE3ODVDNzAuOTI2MyAxNS43Nzg1IDcxLjEyNjMgMTUuMjc4NSA3MS41MjYzIDE1LjA3ODVDNzEuOTI2MyAxNC44Nzg1IDcyLjQyNjMgMTUuMDc4NSA3Mi42MjYzIDE1LjQ3ODVMNzQuNDI2MyAxOS45Nzg1Qzc0LjcyNjMgMjAuNTc4NSA3NC41MjYzIDIwLjk3ODUgNzQuMDI2MyAyMS4wNzg1WiIgZmlsbD0iI0Q1RERFQSIvPgo8cGF0aCBkPSJNNzAuNzI2MyAyNS40Nzg1QzcwLjUyNjMgMjUuNjc4NSA3MC4zMjYzIDI1Ljc3ODUgNjkuOTI2MyAyNS42Nzg1TDY1LjIyNjMgMjQuNzc4NUM2NC44MjYzIDI0LjY3ODUgNjQuNDI2MyAyNC4yNzg1IDY0LjUyNjMgMjMuNzc4NUM2NC42MjYzIDIzLjM3ODUgNjUuMDI2MyAyMi45Nzg1IDY1LjUyNjMgMjMuMTc4NUw3MC4yMjYzIDI0LjA3ODVDNzAuNjI2MyAyNC4xNzg1IDcxLjAyNjMgMjQuNTc4NSA3MC45MjYzIDI1LjA3ODVDNzAuODI2MyAyNS4xNzg1IDcwLjgyNjMgMjUuMzc4NSA3MC43MjYzIDI1LjQ3ODVaIiBmaWxsPSIjRDVEREVBIi8+CjxwYXRoIGQ9Ik04MC4yMjYzIDIwLjU3ODVDODAuMTI2MyAyMC41Nzg1IDgwLjAyNjMgMjAuNDc4NSA3OS44MjYzIDIwLjQ3ODVDNzkuNTI2MyAyMC4xNzg1IDc5LjQyNjMgMTkuNjc4NSA3OS43MjYzIDE5LjI3ODVMODIuNjI2MyAxNS40Nzg1QzgyLjkyNjMgMTUuMTc4NSA4My40MjYzIDE1LjA3ODUgODMuODI2MyAxNS4zNzg1Qzg0LjEyNjMgMTUuNjc4NSA4NC4yMjYzIDE2LjE3ODUgODMuOTI2MyAxNi41Nzg1TDgxLjAyNjMgMjAuMzc4NUM4MC43MjYzIDIwLjQ3ODUgODAuNDI2MyAyMC41Nzg1IDgwLjIyNjMgMjAuNTc4NVoiIGZpbGw9IiNENURERUEiLz4KPHBhdGggZD0iTTEwNS4xMjYgMTM3LjE3OUMxMDQuNzI2IDEzOC44NzkgMTA0LjEyNiAxNDAuNjc5IDEwMy40MjYgMTQyLjE3OUMxMDEuNTI2IDE0NS44NzkgOTguNTI2MyAxNDguNzc5IDk0LjgyNjMgMTUwLjY3OUM5MS4wMjYzIDE1Mi41NzkgODYuNTI2MyAxNTMuMzc5IDgyLjAyNjMgMTUyLjM3OUM3MS40MjYzIDE1MC4xNzkgNjQuNjI2MyAxMzkuNzc5IDY2LjgyNjMgMTI5LjE3OUM2OS4wMjYzIDExOC41NzkgNzkuMzI2MyAxMTEuNjc5IDg5LjkyNjMgMTEzLjk3OUM5My43MjYzIDExNC43NzkgOTcuMDI2MyAxMTYuNjc5IDk5LjgyNjMgMTE5LjI3OUMxMDQuNTI2IDEyMy45NzkgMTA2LjUyNiAxMzAuNzc5IDEwNS4xMjYgMTM3LjE3OVoiIGZpbGw9InVybCgjcGFpbnQzX2xpbmVhcl8zNDBfMTQ4KSIvPgo8cGF0aCBkPSJNOTIuNjEyMyAxNDFDOTIuMDM5OCAxNDEgOTIuMjQ4IDE0MS4wNTMgODcuODIzOSAxMzYuNTc5QzgzLjU1NiAxMzkuNzg5IDc3LjYyMjYgMTM2LjY4NCA3Ny42MjI2IDEzMS40MjFDNzcuNjIyNiAxMjcuODk1IDgwLjQ4NTIgMTI1IDgzLjk3MjQgMTI1Qzg5LjAyMSAxMjUgOTIuMTQzOSAxMzAuNzM3IDg5LjE3NzIgMTM1LjEwNUw5My4yODkgMTM5LjI2M0M5My45NjU2IDEzOS44OTUgOTMuNTQ5MiAxNDEgOTIuNjEyMyAxNDFaTTg0LjAyNDQgMTI3LjA1M0M4MS42MzAyIDEyNy4wNTMgNzkuNjUyNCAxMjkgNzkuNjUyNCAxMzEuNDc0Qzc5LjY1MjQgMTMzLjk0NyA4MS41NzgyIDEzNS44OTUgODQuMDI0NCAxMzUuODk1Qzg0LjI4NDcgMTM1Ljg5NSA4NC41NDQ5IDEzNS44OTUgODQuODA1MiAxMzUuODQyQzg1LjA2NTQgMTM1Ljc4OSA4NS4zMjU2IDEzNS43MzcgODUuNTMzOCAxMzUuNjMyQzg1Ljc5NDEgMTM1LjUyNiA4Ni4wMDIzIDEzNS40MjEgODYuMjEwNSAxMzUuMzE2Qzg2LjQ3MDcgMTM1LjE1OCA4Ni42Nzg5IDEzNSA4Ni44ODcxIDEzNC43ODlDODcuMDQzMiAxMzQuNjMyIDg3LjI1MTQgMTM0LjQyMSA4Ny40MDc2IDEzNC4yNjNDODcuNTYzNyAxMzQuMDUzIDg3LjcxOTggMTMzLjg0MiA4Ny44MjM5IDEzMy42MzJDODcuOTI4IDEzMy40MjEgODguMDMyMSAxMzMuMTU4IDg4LjEzNjIgMTMyLjg5NUM4OC4yNDAzIDEzMi42MzIgODguMjkyNCAxMzIuMzY4IDg4LjI5MjQgMTMyLjEwNUM4OC4yOTI0IDEzMS44OTUgODguMzQ0NCAxMzEuNzM3IDg4LjM0NDQgMTMxLjUyNkM4OC4zOTY1IDEyOSA4Ni40MTg2IDEyNy4wNTMgODQuMDI0NCAxMjcuMDUzWiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9kXzM0MF8xNDgiIHg9Ii0xMyIgeT0iMzIuMDc4NSIgd2lkdGg9Ijk3Ljg2MzgiIGhlaWdodD0iOTcuMjM3NSIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIgcmVzdWx0PSJoYXJkQWxwaGEiLz4KPGZlT2Zmc2V0IGR5PSIxMSIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxMSIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwLjM5NzcwOCAwIDAgMCAwIDAuNDc3NDkgMCAwIDAgMCAwLjU3NSAwIDAgMCAwLjI3IDAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3dfMzQwXzE0OCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvd18zNDBfMTQ4IiByZXN1bHQ9InNoYXBlIi8+CjwvZmlsdGVyPgo8ZmlsdGVyIGlkPSJmaWx0ZXIxX2RfMzQwXzE0OCIgeD0iOTAuNTY2OSIgeT0iMzEuODE5MSIgd2lkdGg9IjkwLjM1OTQiIGhlaWdodD0iOTguMTE4OCIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIgcmVzdWx0PSJoYXJkQWxwaGEiLz4KPGZlT2Zmc2V0IGR5PSIxMSIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxMSIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwLjM5NzcwOCAwIDAgMCAwIDAuNDc3NDkgMCAwIDAgMCAwLjU3NSAwIDAgMCAwLjI3IDAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3dfMzQwXzE0OCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvd18zNDBfMTQ4IiByZXN1bHQ9InNoYXBlIi8+CjwvZmlsdGVyPgo8ZmlsdGVyIGlkPSJmaWx0ZXIyX2RfMzQwXzE0OCIgeD0iMTMuOTc1MyIgeT0iODAuNTc4NSIgd2lkdGg9IjE0Mi4xIiBoZWlnaHQ9Ijk2LjMiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+CjxmZU9mZnNldCBkeT0iMTEiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMTEiLz4KPGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMC4zOTc3MDggMCAwIDAgMCAwLjQ3NzQ5IDAgMCAwIDAgMC41NzUgMCAwIDAgMC4yNyAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93XzM0MF8xNDgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3dfMzQwXzE0OCIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPGZpbHRlciBpZD0iZmlsdGVyM19kXzM0MF8xNDgiIHg9IjQ3LjgxODciIHk9IjE0LjY1MDYiIHdpZHRoPSI4NS40MDc2IiBoZWlnaHQ9Ijk2LjM1NTgiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+CjxmZU9mZnNldCBkeT0iMTEiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMTEiLz4KPGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMC4zOTc3MDggMCAwIDAgMCAwLjQ3NzQ5IDAgMCAwIDAgMC41NzUgMCAwIDAgMC4yNyAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93XzM0MF8xNDgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3dfMzQwXzE0OCIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzM0MF8xNDgiIHgxPSI4NS40MzI5IiB5MT0iNzYuNDIxMiIgeDI9Ijg1LjQzMjkiIHkyPSIxMDkuNDI1IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNCMEJBQ0MiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjOTY5RUFFIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhcl8zNDBfMTQ4IiB4MT0iOTYuMDk1MyIgeTE9Ijk0LjA2MDUiIHgyPSIxMDIuOTIiIHkyPSI5NC44NDc2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM4M0E2RkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNUE3OEZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQyX2xpbmVhcl8zNDBfMTQ4IiB4MT0iODQuOTkzNCIgeTE9IjkwLjM2ODciIHgyPSI4NC45OTM0IiB5Mj0iMTQ0LjQ0MiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjRkRGRUZGIi8+CjxzdG9wIG9mZnNldD0iMC45OTY0IiBzdG9wLWNvbG9yPSIjRUNGMEY1Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQzX2xpbmVhcl8zNDBfMTQ4IiB4MT0iODUuOTkyMSIgeTE9IjExNC45IiB4Mj0iODUuOTkyMSIgeTI9IjEzNi45NDUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0IwQkFDQyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM5NjlFQUUiLz4KPC9saW5lYXJHcmFkaWVudD4KPGNsaXBQYXRoIGlkPSJjbGlwMF8zNDBfMTQ4Ij4KPHJlY3Qgd2lkdGg9IjE2OCIgaGVpZ2h0PSIxNjgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==", qu = "data:image/svg+xml;base64,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", Xu = { class: "flex flex-col items-center gap-2" }, ed = ["src"], td = {
  key: 0,
  class: "text-gray-9"
}, nd = { key: 1 }, od = {
  key: 0,
  class: "inline-flex"
}, id = /* @__PURE__ */ m("span", null, /* @__PURE__ */ N(" "), -1), sd = /* @__PURE__ */ m("div", null, null, -1), _n = /* @__PURE__ */ T({
  __name: "EmptyState",
  props: {
    illustrationType: { default: "folder" },
    title: { type: [String, Boolean], default: !1 },
    description: { type: [Array, Boolean], default: !1 },
    actionCtaLabel: { type: [String, Boolean], default: !1 }
  },
  emits: ["action"],
  setup(e, { emit: t }) {
    const n = e, o = new URL((/* @__PURE__ */ Object.assign({ "/src/assets/illustrations/empty-favorites.svg": Wu, "/src/assets/illustrations/empty-feedback-history.svg": Hu, "/src/assets/illustrations/empty-filtered-notifications.svg": Ju, "/src/assets/illustrations/empty-folder.svg": Ku, "/src/assets/illustrations/empty-notification.svg": qu }))[`/src/assets/illustrations/empty-${n.illustrationType}.svg`], self.location).href;
    return (i, r) => {
      const s = P, l = ye;
      return c(), p("div", Xu, [
        m("img", {
          src: h(o),
          class: "max-w-[144px] h-auto"
        }, null, 8, ed),
        i.title ? (c(), p("h3", td, N(i.title), 1)) : A("", !0),
        i.description ? (c(), p("div", nd, [
          (c(!0), p(X, null, te(i.description, (a) => (c(), p("span", {
            class: "text-gray-7 text-sm",
            key: a.type
          }, [
            a.type === "p" ? (c(), p("p", od, N(a.value), 1)) : a.type === "fa" ? (c(), C(s, {
              key: 1,
              icon: a.value
            }, null, 8, ["icon"])) : A("", !0),
            id
          ]))), 128))
        ])) : A("", !0),
        sd,
        i.actionCtaLabel ? (c(), C(l, {
          key: 2,
          type: "custom-secondary",
          onClick: r[0] || (r[0] = (a) => t("action"))
        }, {
          default: _(() => [
            ne(N(i.actionCtaLabel), 1)
          ]),
          _: 1
        })) : A("", !0)
      ]);
    };
  }
}), rd = { class: "text-sm relative" }, ad = { class: "flex items-center gap-2" }, ld = ["src"], cd = ["onClick", "disabled"], ud = ["src"], zi = /* @__PURE__ */ T({
  __name: "BaseSwitcher",
  props: {
    icon: {},
    options: {},
    value: {},
    altStyle: { type: Boolean },
    centerOptions: { type: Boolean }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = e, o = Y(!1), i = () => {
      u.value && (o.value = !o.value);
    }, r = (g) => {
      t("change", g), s();
    }, s = () => {
      o.value = !1;
    }, l = k(() => n.options.find((g) => g.value === n.value)), a = k(() => n.options.filter((g) => g.value !== n.value)), u = k(() => a.value.length > 0);
    return (g, d) => {
      const f = P, I = It("click-outside");
      return Ze((c(), p("div", rd, [
        Te(g.$slots, "default", {}, () => [
          h(l) ? (c(), p("button", {
            key: 0,
            onClick: i,
            class: D(["px-2 h-8 rounded w-full flex items-center justify-between gap-2 transition-colors whitespace-nowrap truncate", [
              g.altStyle ? "bg-gray-2 text-gray-9" : "bg-primary-contrast/10 text-primary-contrast",
              h(u) ? "cursor-pointer" : "cursor-default",
              {
                "hover:bg-gray-3": h(u) && g.altStyle,
                "hover:bg-primary-contrast/20 ": h(u) && !g.altStyle
              }
            ]])
          }, [
            m("div", ad, [
              M(f, {
                icon: ["fas", n.icon]
              }, null, 8, ["icon"]),
              h(l).img ? (c(), p("img", {
                key: 0,
                src: h(l).img,
                class: "h-3"
              }, null, 8, ld)) : A("", !0),
              m("span", null, N(h(l).trad ? g.$t(h(l).label) : h(l).label), 1)
            ]),
            h(u) ? (c(), C(f, {
              key: 0,
              icon: ["fal", "chevron-down"],
              class: D(["transition-transform", { "-rotate-180": h(o) }])
            }, null, 8, ["class"])) : A("", !0)
          ], 2)) : A("", !0)
        ]),
        M(Xe, { name: "fade" }, {
          default: _(() => [
            h(o) && h(u) ? (c(), p("div", {
              key: 0,
              class: D(["absolute top-[calc(100%+4px)] rounded flex flex-col w-full shadow overflow-hidden z-30", [g.altStyle ? "bg-white" : "bg-primary-contrast"]])
            }, [
              (c(!0), p(X, null, te(h(a), (z) => (c(), p("button", {
                class: D(["w-full transition-colors p-2 flex gap-1 items-center", [
                  g.altStyle ? " hover:bg-gray-1 text-black active:!text-white" : " hover:bg-primary/10 text-primary active:text-primary-contrast",
                  g.centerOptions ? "justify-center" : "justify-start",
                  { "active:!bg-blue": g.altStyle && !z.disabled },
                  { "active:!bg-primary": !g.altStyle && !z.disabled },
                  {
                    "opacity-60 !cursor-not-allowed active:!bg-gray-1 !text-black alt:!text-white": z.disabled
                  }
                ]]),
                key: z.value,
                onClick: (v) => r(z.value),
                disabled: z.disabled
              }, [
                z.img ? (c(), p("img", {
                  key: 0,
                  src: z.img,
                  class: "h-3"
                }, null, 8, ud)) : A("", !0),
                m("span", null, N(z.trad ? g.$t(z.label) : z.label), 1)
              ], 10, cd))), 128))
            ], 2)) : A("", !0)
          ]),
          _: 1
        })
      ])), [
        [I, s]
      ]);
    };
  }
}), ko = /* @__PURE__ */ T({
  __name: "KnowledgeDropdown",
  props: {
    altStyle: { type: Boolean }
  },
  emits: ["go-to-entity"],
  setup(e, { emit: t }) {
    const n = e, o = le(), { knowledges: i, knowledgeId: r } = De(o), s = k(() => r.value || ""), l = k(() => i.value.map((u) => ({
      value: u.value,
      label: u.label
    }))), a = (u) => {
      const g = i.value.find((d) => d.value === u);
      return t("go-to-entity", {
        type: "Knowledge",
        id: u,
        lang: (g == null ? void 0 : g.defaultLanguage) || "fr-fr"
      });
    };
    return (u, g) => {
      const d = zi;
      return c(), C(d, {
        value: h(s),
        options: h(l),
        icon: "books",
        altStyle: n.altStyle,
        onChange: a
      }, null, 8, ["value", "options", "altStyle"]);
    };
  }
}), jo = /* @__PURE__ */ T({
  __name: "LanguageSwitcher",
  props: {
    mobile: { type: Boolean }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = e, o = le(), { selectedLanguage: i, focusKnowledge: r, isMultiLanguage: s, contentLanguages: l } = De(o), a = k(() => i.value), u = {
      "fr-fr": "🇫🇷",
      "en-gb": "🇬🇧",
      "en-us": "🇺🇸",
      "de-de": "🇩🇪",
      "es-es": "🇪🇸",
      "it-it": "🇮🇹",
      "pt-pt": "🇵🇹",
      "nl-nl": "🇳🇱",
      "pl-pl": "🇵🇱"
    }, g = {
      "fr-fr": "Français",
      "en-gb": "English",
      "en-us": "English",
      "de-de": "Deutsch",
      "es-es": "Español",
      "it-it": "Italiano",
      "pt-pt": "Português",
      "nl-nl": "Niederländisch",
      "pl-pl": "Polski"
    }, d = k(() => {
      if (!r.value)
        return [];
      const f = cr();
      return r.value.supportedLanguages.map((I) => {
        const z = f ? g[I] : `${u[I]} ${g[I]}`, v = f ? " " : u[I];
        return {
          value: I,
          label: n.mobile ? v : z,
          // Segoe UI on Windows does not support any flags, replace it with images
          img: f ? `https://flagcdn.com/24x18/${I.split("-")[1]}.png` : void 0,
          disabled: l.value === void 0 ? !1 : !l.value.includes(I)
        };
      });
    });
    return (f, I) => {
      const z = zi;
      return h(s) ? (c(), C(z, {
        key: 0,
        icon: "globe-stand",
        value: h(a),
        options: h(d),
        initials: n.mobile,
        onChange: I[0] || (I[0] = (v) => t("change", v))
      }, null, 8, ["value", "options", "initials"])) : A("", !0);
    };
  }
}), dd = {}, gd = /* @__PURE__ */ m("svg", {
  class: "absolute bottom-0 left-0 right-0 z-[1] md:hidden",
  width: "40",
  height: "28",
  viewBox: "0 0 40 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ m("path", {
    d: "M9.53845 7.65626C5.20474 8.33156 0 7.22433 0 4.48879L3.1884e-05 27.9999H40V12.0443C40 1.37768 32.9846 0.26662 29.6 0.266602C20.0639 0.266602 15.5224 6.26656 9.53845 7.65626Z",
    fill: "white",
    opacity: "0.2"
  })
], -1), pd = /* @__PURE__ */ m("svg", {
  class: "absolute bottom-0 left-0 right-0 z-[2] md:hidden",
  width: "40",
  height: "23",
  viewBox: "0 0 40 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ m("path", {
    d: "M9.53846 10.0801C5.20474 11.1723 0 9.38146 0 4.95701V23.0002H40V6.58707C40 1.69686 33.8486 0.0669246 30.4639 0.0668945C20.9279 0.0668945 13.8486 8.91567 9.53846 10.0801Z",
    fill: "white",
    opacity: "0.2"
  })
], -1);
function md(e, t) {
  return c(), p(X, null, [
    gd,
    pd
  ], 64);
}
const hd = /* @__PURE__ */ x(dd, [["render", md]]), So = (e, t, n) => {
  const o = n ? {
    query: {
      source: n
    }
  } : {};
  if (e.type === "Knowledge")
    return {
      name: "knowledges",
      params: {
        knowledgeId: e.id,
        lang: t
      },
      ...o
    };
  const i = !e.type || e.type === "Case" ? "cases" : "contents", r = e.type === "Case" ? "caseId" : "contentId";
  return {
    name: i,
    params: {
      [r]: e.id,
      lang: t,
      knowledgeId: e.knowledgeId
    },
    ...o
  };
}, fd = /* @__PURE__ */ T({
  __name: "RootCardLink",
  props: {
    link: { type: Boolean },
    item: {},
    source: {}
  },
  emits: ["go-to-document"],
  setup(e, { emit: t }) {
    const n = e, o = le(), { selectedLanguage: i } = De(o), r = k(() => So(n.item, i.value, n.source));
    return (s, l) => {
      const a = R("RouterLink");
      return s.link ? (c(), C(a, {
        key: 0,
        to: h(r)
      }, {
        default: _(() => [
          Te(s.$slots, "default")
        ]),
        _: 3
      }, 8, ["to"])) : (c(), p("button", {
        key: 1,
        onClick: l[0] || (l[0] = (u) => t("go-to-document"))
      }, [
        Te(s.$slots, "default")
      ]));
    };
  }
}), yd = { class: "flex items-center md:items-start md:flex-col gap-2 md:gap-3" }, Id = { class: "h-10 w-10 relative flex-none" }, Md = ["src"], Ad = { class: "font-bold tracking-wide md:text-lg line-clamp-2 text-start" }, Nd = {
  key: 0,
  class: "hidden md:line-clamp-5 text-start text-sm"
}, bd = { class: "hidden md:flex gap-3" }, Cd = { class: "font-bold" }, wd = /* @__PURE__ */ T({
  __name: "RootCard",
  props: {
    item: {},
    isOverview: { type: Boolean },
    config: {}
  },
  emits: ["overview", "go-to-document"],
  setup(e, { emit: t }) {
    const n = e, o = k(() => n.item.icon && n.item.icon.iconType === "url"), i = k(
      () => n.item.icon && n.item.icon.value ? n.item.icon.value : "folder"
    ), r = k(() => `background-color: ${n.item.icon && n.item.icon.color ? n.item.icon.color : $e.blue.DEFAULT}`), s = k(() => n.config.hostApp === "agent-client" && !n.config.isMobile && n.item.icon && n.item.icon.color ? { color: n.item.icon.color } : {}), l = k(() => n.item);
    return (a, u) => {
      const g = P;
      return c(), C(fd, {
        class: D(["py-3 px-2 md:p-4.5 w-full rounded border-black/10 dark:border-gray-9 border cursor-pointer group hover:shadow dark:hover:shadow-white/20 transition-shadow md:w-[300px] md:h-[280px] flex-none flex flex-col md:items-start justify-between relative overflow-hidden", [
          a.isOverview ? "bg-primary text-primary-contrast" : "bg-white dark:bg-black text-black dark:text-white"
        ]]),
        item: h(l),
        link: a.config.hostApp === "agent-client",
        onGoToDocument: u[1] || (u[1] = (d) => t("go-to-document", d))
      }, {
        default: _(() => [
          m("div", yd, [
            m("div", Id, [
              a.item.icon && h(o) ? (c(), p("img", {
                key: 0,
                src: a.item.icon.value,
                class: "h-full w-full rounded object-cover brightness-100 group-hover:brightness-75 md:group-hover:brightness-100 transition-all duration-500"
              }, null, 8, Md)) : (c(), p("div", {
                key: 1,
                class: "h-full w-full md:!bg-transparent rounded",
                style: Ce(h(r))
              }, [
                M(hd)
              ], 4)),
              m("div", null, [
                M(g, {
                  icon: ["fal", h(i)],
                  class: D(["h-10 w-10 text-[24px] md:text-[40px] absolute inset-0 opacity-100 group-hover:opacity-0 transition-opacity duration-500 md:!opacity-100", [
                    a.isOverview ? "text-primary-contrast" : "text-white md:text-black dark:md:text-white"
                  ]]),
                  style: Ce(h(s))
                }, null, 8, ["icon", "class", "style"]),
                M(g, {
                  icon: ["fal", "eye"],
                  class: D(["h-10 w-10 text-white text-[24px] absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 md:!opacity-0", [a.isOverview ? "text-primary-contrast" : "text-white"]])
                }, null, 8, ["class"])
              ])
            ]),
            m("div", Ad, N(a.item.label), 1),
            a.item.body ? (c(), p("div", Nd, N(a.item.body), 1)) : A("", !0)
          ]),
          m("div", bd, [
            m("span", Cd, N(a.$t("knowledge.explore")), 1),
            M(g, {
              class: "text-sm",
              icon: ["fal", "chevron-right"]
            })
          ]),
          m("button", {
            onClick: u[0] || (u[0] = be((d) => t("overview"), ["stop", "prevent"])),
            class: D(["hidden md:flex absolute top-0 right-0 h-16 w-16 bg-gray-2 dark:bg-gray-8 rounded-full items-end cursor-pointer z-10 p-3 transition-transform translate-x-[64px] translate-y-[-64px] group-hover:translate-x-[32px] group-hover:translate-y-[-32px]", [a.isOverview ? "bg-primary-contrast/10" : "bg-gray-2 dark:bg-gray-8"]])
          }, [
            M(g, {
              class: D(["text-[14px]", [a.isOverview ? "text-primary-contrast" : "text-gray-8 dark:text-gray-2"]]),
              icon: ["fal", "eye"]
            }, null, 8, ["class"])
          ], 2)
        ]),
        _: 1
      }, 8, ["class", "item", "link"]);
    };
  }
});
const Dd = {}, zd = { class: "skeleton rounded-sm" };
function vd(e, t) {
  return c(), p("div", zd);
}
const Se = /* @__PURE__ */ x(Dd, [["render", vd], ["__scopeId", "data-v-ef54f47b"]]), Td = {
  class: "py-3 px-2 md:p-4.5 w-full bg-white rounded border-black/10 border cursor-wait md:w-[300px] md:h-[280px]",
  style: { "--custom-width": "500px" }
}, kd = { class: "flex items-center md:items-start md:flex-col gap-2 md:gap-5" }, jd = { class: "hidden md:block space-y-1 w-full" }, Sd = /* @__PURE__ */ T({
  __name: "RootCardSkeleton",
  props: {
    index: {}
  },
  setup(e) {
    const t = e, n = ["w-2/3 h-3", "w-1/3 h-3", "w-1/2 h-3"], o = k(() => n[t.index % n.length]);
    return (i, r) => (c(), p("div", Td, [
      m("div", kd, [
        M(Se, { class: "h-10 w-10 flex-none rounded" }),
        M(Se, {
          class: D(h(o))
        }, null, 8, ["class"]),
        m("div", jd, [
          (c(), p(X, null, te(n, (s) => M(Se, {
            key: s,
            class: D(s)
          }, null, 8, ["class"])), 64))
        ])
      ])
    ]));
  }
}), Ld = T({
  name: "KnowledgeView",
  props: {
    overviewId: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    KnowledgeDropdown: ko,
    LanguageSwitcher: jo,
    RootCard: wd,
    RootCardSkeleton: Sd
  },
  emits: ["go-to-entity", "change-language", "overview", "empty-view"],
  setup() {
    return {
      multilingualHosts: gr
    };
  },
  computed: {
    rootFolders() {
      return this.knowledgeRoots;
    },
    ...ue(le, [
      "knowledgeRoots",
      "mainContent",
      "appIsLoading",
      "knowledgeIsLoading"
    ])
  },
  methods: {
    handleClickOnRoot(e) {
      const { id: t, type: n, label: o } = e, i = {
        id: t,
        type: n,
        label: o
      };
      this.updatePathWithChildEntity(i), this.$emit("go-to-entity", i);
    },
    ...fe(le, ["updatePathWithChildEntity"])
  }
}), Ed = {
  key: 1,
  class: "md:flex md:justify-center"
}, Od = { class: "relative md:hidden mb-4 flex items-center gap-2" }, xd = {
  key: 0,
  class: "flex justify-center flex-col md:flex-row md:flex-wrap gap-2 md:gap-5.5 md:max-w-[944px]"
}, _d = {
  key: 1,
  class: "flex justify-center flex-col md:flex-row md:flex-wrap gap-2 md:gap-5.5 md:max-w-[944px]"
};
function Ud(e, t, n, o, i, r) {
  const s = _n, l = R("KnowledgeDropdown"), a = R("LanguageSwitcher"), u = R("RootCardSkeleton"), g = R("RootCard");
  return e.mainContent.type !== "Knowledge" && !e.appIsLoading ? (c(), C(s, {
    key: 0,
    class: "h-full justify-center text-center",
    illustrationType: "filtered-notifications",
    title: e.$t("knowledge.empty-state.title"),
    "action-cta-label": e.$t("knowledge.empty-state.cta"),
    onAction: t[0] || (t[0] = (d) => e.$emit("empty-view"))
  }, null, 8, ["title", "action-cta-label"])) : (c(), p("div", Ed, [
    m("div", Od, [
      M(l, {
        class: "w-full",
        onGoToEntity: t[1] || (t[1] = (d) => e.$emit("go-to-entity", d)),
        altStyle: ""
      }),
      e.multilingualHosts.includes(e.config.hostApp) ? (c(), C(a, {
        key: 0,
        class: "w-[88px]",
        centerOptions: "",
        altStyle: "",
        mobile: "",
        onChange: t[2] || (t[2] = (d) => e.$emit("change-language", d))
      })) : A("", !0)
    ]),
    e.knowledgeIsLoading ? (c(), p("div", xd, [
      (c(), p(X, null, te(7, (d) => M(u, {
        key: d,
        index: d
      }, null, 8, ["index"])), 64))
    ])) : (c(), p("div", _d, [
      (c(!0), p(X, null, te(e.rootFolders, (d) => (c(), C(g, {
        key: d.id,
        item: d,
        isOverview: d.id === e.overviewId,
        config: e.config,
        onGoToDocument: (f) => e.handleClickOnRoot(d),
        onOverview: (f) => e.$emit("overview", d.id)
      }, null, 8, ["item", "isOverview", "config", "onGoToDocument", "onOverview"]))), 128))
    ]))
  ]));
}
const Fd = /* @__PURE__ */ x(Ld, [["render", Ud]]), $d = /* @__PURE__ */ T({
  __name: "EntityLink",
  props: {
    link: { type: Boolean },
    item: {},
    source: {}
  },
  setup(e) {
    const t = e, n = le(), { selectedLanguage: o } = De(n), i = k(() => So(t.item, o.value, t.source));
    return (r, s) => {
      const l = R("RouterLink");
      return r.link ? (c(), C(l, {
        key: 0,
        to: h(i)
      }, {
        default: _(() => [
          Te(r.$slots, "default")
        ]),
        _: 3
      }, 8, ["to"])) : (c(), p("button", {
        key: 1,
        onClick: s[0] || (s[0] = (a) => r.$emit("go-to-document", r.item))
      }, [
        Te(r.$slots, "default")
      ]));
    };
  }
}), Rd = T({
  name: "ContentLabel",
  props: {
    label: {
      type: Object,
      default: () => ({ labelName: "", icon: "", color: "" })
    }
  },
  computed: {
    computedStyle() {
      if (this.label)
        return {
          "--label-color": this.label.color,
          "--label-background-color": `${this.label.color}1a`
        };
    }
  }
}), Vd = { class: "truncate" };
function Bd(e, t, n, o, i, r) {
  var l;
  const s = P;
  return (l = e.label) != null && l.labelName ? (c(), p("div", {
    key: 0,
    class: "flex items-center h-4.5 px-2 gap-1 rounded-sm text-2xs text-[var(--label-color)] bg-[var(--label-background-color)]",
    style: Ce(e.computedStyle)
  }, [
    M(s, {
      icon: ["fas", e.label.icon]
    }, null, 8, ["icon"]),
    m("div", Vd, N(e.label.labelName), 1)
  ], 4)) : A("", !0);
}
const mr = /* @__PURE__ */ x(Rd, [["render", Bd]]), Yd = T({
  name: "ContentLabelWrapper",
  components: {
    ContentLabel: mr
  },
  props: {
    labels: { type: Array, default: () => [] },
    labelSearchedIds: { type: Array, default: () => [] }
  },
  data() {
    return {
      displayAll: !1
    };
  },
  computed: {
    orderedLabels() {
      return this.labels ? this.labelSearchedIds.reduce((e, t) => {
        const n = e.findIndex((i) => i.id === t);
        if (n === -1)
          return e;
        const o = e[n];
        return e.splice(n, 1), e.unshift(o), e;
      }, this.labels) : [];
    },
    labelsToDisplay() {
      return this.labels.length > 3 ? this.labels.slice(0, 3) : this.labels;
    }
  }
}), Qd = { class: "flex items-center" }, Pd = {
  key: 0,
  class: "flex flex-wrap items-center gap-1 w-full"
}, Gd = {
  key: 0,
  class: "flex items-center justify-center px-1 bg-blue/10 text-blue h-4.5 rounded text-2xs"
}, Zd = {
  key: 1,
  class: "flex flex-wrap items-center gap-1 w-full"
};
function Wd(e, t, n, o, i, r) {
  const s = mr, l = ye;
  return c(), p("div", Qd, [
    !e.displayAll && e.labelsToDisplay.length ? (c(), p("div", Pd, [
      (c(!0), p(X, null, te(e.labelsToDisplay, (a) => (c(), C(s, {
        key: a ? a.id : "",
        label: a
      }, null, 8, ["label"]))), 128)),
      e.orderedLabels.length > 3 ? (c(), p("div", Gd, " +" + N(e.orderedLabels.length - 3), 1)) : A("", !0),
      e.orderedLabels.length > 3 ? (c(), C(l, {
        key: 1,
        class: "!text-2xs",
        size: "mini",
        hyperlink: "",
        type: "custom-secondary",
        onClick: t[0] || (t[0] = be((a) => e.displayAll = !0, ["stop", "prevent"]))
      }, {
        default: _(() => [
          ne(N(e.$t("list-item.show-more")), 1)
        ]),
        _: 1
      })) : A("", !0)
    ])) : (c(), p("div", Zd, [
      (c(!0), p(X, null, te(e.orderedLabels, (a) => (c(), C(s, {
        key: a.id,
        label: a,
        class: "label-item"
      }, null, 8, ["label"]))), 128)),
      e.orderedLabels.length > 3 ? (c(), C(l, {
        key: 0,
        class: "!text-2xs",
        size: "mini",
        hyperlink: "",
        type: "custom-secondary",
        onClick: t[1] || (t[1] = be((a) => e.displayAll = !1, ["stop", "prevent"]))
      }, {
        default: _(() => [
          ne(N(e.$t("list-item.show-less")), 1)
        ]),
        _: 1
      })) : A("", !0)
    ]))
  ]);
}
const vi = /* @__PURE__ */ x(Yd, [["render", Wd]]), Hd = {
  key: 0,
  class: "mx-0.5"
}, Jd = /* @__PURE__ */ T({
  __name: "BaseBreadcrumb",
  props: {
    breadcrumb: {}
  },
  setup(e) {
    const t = e, n = Y([]), o = Y(null), i = Y(null);
    _t(() => {
      n.value = [...t.breadcrumb], r();
    });
    const r = () => {
      at(() => {
        var a, u;
        const s = (a = i.value) == null ? void 0 : a.clientWidth, l = (u = o.value) == null ? void 0 : u.scrollWidth;
        if (!(!s || !l) && s < l && n.value.length > 2) {
          const g = n.value[1] === "..." ? 2 : 1;
          n.value.splice(1, g, "...");
        }
      });
    };
    return _e(t.breadcrumb, () => {
      r();
    }), (s, l) => (c(), p("div", {
      ref_key: "wrapper",
      ref: i,
      class: "flex min-w-0 w-full"
    }, [
      m("div", {
        ref_key: "breadcrumb",
        ref: o,
        class: "truncate text-gray-6 text-xs"
      }, [
        (c(!0), p(X, null, te(h(n), (a, u) => (c(), p("span", { key: u }, [
          ne(N(a) + " ", 1),
          u !== h(n).length - 1 ? (c(), p("span", Hd, ">")) : A("", !0)
        ]))), 128))
      ], 512)
    ], 512));
  }
}), Kd = { class: "flex-none flex items-start gap-1 z-10 text-gray-8 h-full relative" }, qd = {
  key: 0,
  class: "absolute z-20 shadow px-2 py-1 text-2xs bg-gray-9 text-white top-0 right-[calc(100%+4px)] rounded whitespace-nowrap"
}, In = "w-5.5 h-5.5 flex items-center justify-center text-xs leading-none  rounded transition-all border", Mn = "bg-white text-gray-9 border-gray-2 hover:bg-gray-1 dark:bg-black dark:border-gray-8 dark:text-white dark:hover:bg-gray-9", An = "bg-primary-contrast/10 text-primary-contrast hover:bg-primary-contrast/20 border-transparent", Xd = /* @__PURE__ */ T({
  __name: "EntityActions",
  props: {
    isFavorite: { type: Boolean, default: !1 },
    isOverview: { type: Boolean, default: !1 },
    isSummaryExpanded: { type: Boolean, default: !1 },
    options: { default: () => ({
      favorite: !0,
      copy: !0,
      open: !0,
      summary: !0,
      overview: !0
    }) }
  },
  emits: [
    "open-in-web",
    "copy-link",
    "toggle-summary",
    "toggle-favorite",
    "overview"
  ],
  setup(e, { emit: t }) {
    const n = e, o = Y(void 0), i = (a) => {
      o.value = a;
    }, r = (a, u) => {
      a.preventDefault(), u === "copy" ? s() : t(u);
    }, s = () => {
      l.value = !0, t("copy-link"), setTimeout(() => {
        l.value = !1;
      }, 1e3);
    }, l = Y(!1);
    return (a, u) => {
      const g = P;
      return c(), p("div", Kd, [
        M(Xe, { name: "fade" }, {
          default: _(() => [
            h(o) ? (c(), p("div", qd, N(a.$t(h(o))), 1)) : A("", !0)
          ]),
          _: 1
        }),
        a.options.favorite ? (c(), C(g, {
          key: 0,
          role: "button",
          class: D([In, a.isOverview ? An : Mn]),
          icon: [a.isFavorite ? "fas" : "fal", "star"],
          onMouseenter: u[0] || (u[0] = (d) => i(`list-item.actions.favorite-${n.isFavorite ? "remove" : "add"}`)),
          onMouseleave: u[1] || (u[1] = (d) => i()),
          onClick: u[2] || (u[2] = be((d) => r(d, "toggle-favorite"), ["stop"]))
        }, null, 8, ["class", "icon"])) : A("", !0),
        a.options.overview ? (c(), C(g, {
          key: 1,
          role: "button",
          class: D([In, a.isOverview ? An : Mn]),
          icon: ["fal", "eye"],
          onMouseenter: u[3] || (u[3] = (d) => i("list-item.actions.overview")),
          onMouseleave: u[4] || (u[4] = (d) => i()),
          onClick: u[5] || (u[5] = be((d) => r(d, "overview"), ["stop"]))
        }, null, 8, ["class"])) : A("", !0),
        a.options.summary ? (c(), C(g, {
          key: 2,
          role: "button",
          class: D([In, a.isOverview ? An : Mn]),
          icon: ["fal", "clipboard-list-check"],
          onMouseenter: u[6] || (u[6] = (d) => i(`list-item.actions.${n.isSummaryExpanded ? "close" : "open"}-summary`)),
          onMouseleave: u[7] || (u[7] = (d) => i()),
          onClick: u[8] || (u[8] = be((d) => r(d, "toggle-summary"), ["stop"]))
        }, null, 8, ["class"])) : A("", !0),
        a.options.copy ? (c(), C(g, {
          key: 3,
          role: "button",
          class: D([In, a.isOverview ? An : Mn]),
          icon: ["fal", h(l) ? "check" : "link"],
          onMouseenter: u[9] || (u[9] = (d) => i("list-item.actions.copy-url")),
          onMouseleave: u[10] || (u[10] = (d) => i()),
          onClick: u[11] || (u[11] = be((d) => r(d, "copy"), ["stop"]))
        }, null, 8, ["class", "icon"])) : A("", !0),
        a.options.open ? (c(), C(g, {
          key: 4,
          role: "button",
          class: D([In, a.isOverview ? An : Mn]),
          icon: ["fal", "arrow-up-right-from-square"],
          onMouseenter: u[12] || (u[12] = (d) => i("list-item.actions.open-page")),
          onMouseleave: u[13] || (u[13] = (d) => i()),
          onClick: u[14] || (u[14] = be((d) => r(d, "open-in-web"), ["stop"]))
        }, null, 8, ["class"])) : A("", !0)
      ]);
    };
  }
}), eg = {
  key: 0,
  class: "absolute z-20 shadow px-2 py-1 text-2xs bg-gray-9 text-white top-0 right-[calc(100%+4px)] rounded w-48"
}, tg = /* @__PURE__ */ T({
  __name: "EntityUserBoost",
  props: {
    userBoost: {}
  },
  setup(e) {
    const t = e, n = Y(!1), o = k(() => {
      switch (t.userBoost) {
        case "90":
          return {
            customStyle: { "background-color": "#8CB369" },
            tooltip: "search.user-boost.high"
          };
        case "80":
          return {
            customStyle: { "background-color": "#fb7901" },
            tooltip: "search.user-boost.medium"
          };
        case "70":
          return {
            customStyle: { "background-color": "grey" },
            tooltip: "search.user-boost.low"
          };
        default:
          return {};
      }
    });
    return (i, r) => {
      const s = P;
      return c(), p(X, null, [
        M(Xe, { name: "fade" }, {
          default: _(() => [
            h(n) ? (c(), p("div", eg, N(i.$t(`${h(o).tooltip}`)), 1)) : A("", !0)
          ]),
          _: 1
        }),
        m("div", {
          class: "text-white rounded-full flex items-center justify-center w-5 h-5 mr-1",
          style: Ce(h(o).customStyle),
          onMouseenter: r[0] || (r[0] = (l) => n.value = !0),
          onMouseleave: r[1] || (r[1] = (l) => n.value = !1)
        }, [
          M(s, {
            class: "text-2xs",
            icon: ["fas", "rocket"]
          })
        ], 36)
      ], 64);
    };
  }
}), Ti = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='12'%20height='13'%20fill='none'%3e%3crect%20width='9.439'%20height='3.5'%20x='2'%20y='5'%20fill='%230081F9'%20rx='.5'/%3e%3cpath%20stroke='%230081F9'%20stroke-linecap='round'%20stroke-width='.5'%20d='M.25.25V12'/%3e%3c/svg%3e", ng = {
  key: 0,
  class: "h-4 w-4 rounded-full border border-gray-2 dark:border-gray-8 absolute -top-2 -right-2 bg-white dark:bg-black flex items-center justify-center"
}, og = ["src"], ln = /* @__PURE__ */ T({
  __name: "EntityIcon",
  props: {
    type: {},
    typename: {},
    isFavorite: { type: Boolean },
    isHovered: { type: Boolean },
    isOverview: { type: Boolean }
  },
  setup(e) {
    const t = e, n = {
      Article: {
        type: "url",
        value: On,
        border: "ring-yellow"
      },
      Diagnostic: {
        type: "url",
        value: xn,
        border: "ring-blue"
      },
      Step: {
        type: "url",
        value: Ti,
        border: "ring-blue"
      },
      keyStep: {
        type: "icon",
        value: ["fas", "key"],
        class: "text-blue fa-rotate-90",
        border: "ring-blue"
      },
      Product: {
        type: "icon",
        value: ["fas", "barcode-scan"],
        class: "text-gray-7",
        border: "ring-gray-7"
      },
      Case: {
        type: "icon",
        value: ["fas", "folder"],
        class: "text-gray-5",
        border: "ring-gray-5"
      },
      Knowledge: {
        type: "icon",
        value: ["fal", "home"],
        class: "text-gray-9",
        border: "ring-gray-9"
      }
    }, o = k(() => t.type && (t == null ? void 0 : t.typename) === "Content" ? n[t.type] : n[t.typename || t.type || "Case"]), i = k(() => o.value.value), r = k(() => o.value.value);
    return (s, l) => {
      const a = P;
      return c(), p("div", {
        class: D(["flex-none flex items-center justify-center w-7 h-7 rounded-sm relative bg-white dark:bg-black transition-all", [
          s.isHovered || s.isOverview ? `${h(o).border} ring-2` : "ring-1 ring-gray-2 dark:ring-gray-8"
        ]])
      }, [
        s.isFavorite ? (c(), p("div", ng, [
          M(a, {
            icon: ["fas", "star"],
            class: "text-yellow text-3xs"
          })
        ])) : A("", !0),
        h(o).type === "url" ? (c(), p("img", {
          key: 1,
          src: h(i),
          class: "w-auto h-4 select-none"
        }, null, 8, og)) : h(o).type === "icon" ? (c(), C(a, {
          key: 2,
          icon: h(r),
          class: D(["text-base", h(o).class])
        }, null, 8, ["icon", "class"])) : A("", !0)
      ], 2);
    };
  }
}), ig = { class: "absolute top-[11px] left-3" }, sg = { class: "whitespace-normal h-full" }, rg = {
  key: 1,
  class: "flex items-center"
}, ag = /* @__PURE__ */ T({
  __name: "EntityItem",
  props: {
    item: {},
    hovered: { type: Boolean, default: !1 },
    link: { type: Boolean, default: !1 },
    source: {},
    labelSearchedIds: { default: () => [] },
    isFavorite: { type: Boolean, default: !1 },
    fullTitlePreference: { type: Boolean, default: !1 },
    options: { default: () => ({
      copy: !0,
      open: !0,
      overview: !0
    }) },
    isOverview: { type: Boolean, default: !1 }
  },
  emits: [
    "go-to-document",
    "copy-link",
    "open-in-web",
    "toggle-favorite",
    "overview",
    "handle-click"
  ],
  setup(e, { emit: t }) {
    const n = e, o = Y(!1), i = k(() => ({
      favorite: s.value || l.value,
      copy: n.options.copy,
      open: n.options.open,
      summary: !!u.value,
      overview: n.options.overview
    })), r = k(() => n.item.__typename === "Product"), s = k(() => n.item.__typename === "Content" && n.item.type === "Article"), l = k(() => n.item.__typename === "Content" && n.item.type === "Diagnostic"), a = k(() => r.value ? n.item.reference : n.item.label), u = k(() => n.item.summary && n.item.summary.isVisible && !!n.item.summary.body && !!n.item.summary.body.length || n.item.shortSummary && n.item.shortSummary.isVisible && !!n.item.shortSummary.body && !!n.item.shortSummary.body.length), g = k(() => n.item.summary && n.item.summary.isVisible && n.item.summary.body.length ? n.item.summary.body : n.item.shortSummary && n.item.shortSummary.isVisible && n.item.shortSummary.body.length ? n.item.shortSummary.body : null), d = k(() => n.item.breadcrumb && n.item.breadcrumb.length || u.value && o.value || n.item.labels && n.item.labels.length);
    return (f, I) => {
      const z = ln, v = Le, Q = tg, H = Xd, ee = Jd, j = vi, G = $d;
      return c(), C(G, {
        class: D(["relative rounded-md overflow-hidden w-full transition-all border-gray-2 dark:border-gray-8 border bg-white dark:bg-black text-gray-8 dark:text-gray-1", [{ "shadow-sm": f.hovered }]]),
        link: f.link,
        item: f.item,
        source: f.source,
        onGoToDocument: I[5] || (I[5] = (V) => t("go-to-document", f.item)),
        onClick: I[6] || (I[6] = (V) => t("handle-click"))
      }, {
        default: _(() => [
          m("div", ig, [
            M(z, {
              type: f.item.type,
              typename: f.item.__typename,
              isFavorite: n.isFavorite,
              isHovered: f.hovered,
              isOverview: n.isOverview
            }, null, 8, ["type", "typename", "isFavorite", "isHovered", "isOverview"])
          ]),
          m("div", {
            class: D(["w-full pl-[50px] pr-1.5 py-1.5 flex justify-between gap-2 min-w-0 transition-all border-gray-2 dark:border-gray-8 text-sm", [
              h(d) ? "border-b  bg-gray-1 dark:bg-gray-9 min-h-[35px]" : "min-h-[49px] items-center",
              n.isOverview ? "bg-primary text-primary-contrast" : "",
              h(d) && n.isOverview ? "!bg-primary" : ""
            ]])
          }, [
            f.fullTitlePreference ? (c(), p("div", {
              key: 0,
              class: D(["text-left whitespace-pre-wrap [word-break:break-word]", { "pt-[3px]": h(d) }])
            }, N(h(a)), 3)) : (c(), C(v, {
              key: 1,
              text: h(a),
              class: D({ "pt-[3px]": h(d) })
            }, null, 8, ["text", "class"])),
            m("div", {
              class: D(["flex items-center justify-center flex-row relative", [
                {
                  "!absolute top-1.5 right-1.5 bg-gray-1 dark:bg-gray-9": f.fullTitlePreference && h(d)
                },
                {
                  "!absolute top-3 right-1.5 bg-white dark:bg-black": f.fullTitlePreference && !h(d)
                },
                { "!bg-primary": f.fullTitlePreference && f.isOverview }
              ]])
            }, [
              f.item.userBoost ? (c(), C(Q, {
                key: 0,
                "user-boost": f.item.userBoost
              }, null, 8, ["user-boost"])) : A("", !0),
              M(Xe, { name: "expand-width" }, {
                default: _(() => [
                  f.hovered ? (c(), C(H, {
                    key: 0,
                    options: h(i),
                    "is-favorite": n.isFavorite,
                    "is-overview": n.isOverview,
                    onCopyLink: I[0] || (I[0] = (V) => {
                      var K;
                      return t("copy-link", {
                        entityId: f.item.id,
                        entityType: f.item.type,
                        entityAncestors: (K = f.item.ancestors) == null ? void 0 : K[0]
                      });
                    }),
                    onOpenInWeb: I[1] || (I[1] = (V) => {
                      var K;
                      return t("open-in-web", {
                        entityId: f.item.id,
                        entityType: f.item.type,
                        entityAncestors: (K = f.item.ancestors) == null ? void 0 : K[0]
                      });
                    }),
                    onToggleFavorite: I[2] || (I[2] = (V) => t("toggle-favorite", f.item.id)),
                    onToggleSummary: I[3] || (I[3] = (V) => o.value = !h(o)),
                    onOverview: I[4] || (I[4] = (V) => t("overview", { id: f.item.id, type: f.item.type }))
                  }, null, 8, ["options", "is-favorite", "is-overview"])) : A("", !0)
                ]),
                _: 1
              })
            ], 2)
          ], 2),
          m("div", {
            class: D(["pl-[50px] pr-1.5 space-y-1.5", { "py-1.5": h(d) }])
          }, [
            M(Xe, { name: "expand-height" }, {
              default: _(() => [
                h(u) && h(o) ? (c(), p("div", {
                  key: 0,
                  class: D(["bg-gray-1 text-gray-8 dark:bg-gray-9 dark:text-gray-1 rounded text-xs flex-none h-fit max-h-[100px] overflow-auto p-1.5 text-left", ["summary-container", { expanded: h(o) }]])
                }, [
                  m("span", sg, N(h(g)), 1)
                ], 2)) : A("", !0)
              ]),
              _: 1
            }),
            f.item.breadcrumb ? (c(), C(ee, {
              key: 0,
              breadcrumb: f.item.breadcrumb
            }, null, 8, ["breadcrumb"])) : A("", !0),
            f.item.labels && f.item.labels.length ? (c(), p("div", rg, [
              M(j, {
                labelSearchedIds: f.labelSearchedIds,
                labels: f.item.labels
              }, null, 8, ["labelSearchedIds", "labels"])
            ])) : A("", !0)
          ], 2)
        ]),
        _: 1
      }, 8, ["class", "link", "item", "source"]);
    };
  }
});
const Un = /* @__PURE__ */ x(ag, [["__scopeId", "data-v-4f45488c"]]), lg = { class: "flex items-start py-[11px] px-3 rounded w-full border-gray-2 dark:border-gray-8 border bg-white dark:bg-black cursor-wait" }, cg = { class: "flex items-center gap-2 w-full pr-5" }, ug = { class: "flex-none w-7 h-7 flex justify-center items-center border-gray-2 dark:border-gray-8 border rounded-sm" }, cn = /* @__PURE__ */ T({
  __name: "EntityItemSkeleton",
  props: {
    index: {}
  },
  setup(e) {
    const t = e, n = ["w-1/3 h-3", "w-1/2 h-3", "w-2/3 h-3"], o = k(() => n[t.index % n.length]);
    return (i, r) => (c(), p("div", lg, [
      m("div", cg, [
        m("div", ug, [
          M(Se, { class: "flex-none w-4.5 h-4.5" })
        ]),
        M(Se, {
          class: D(h(o))
        }, null, 8, ["class"])
      ])
    ]));
  }
}), dg = T({
  name: "EmptyEntity",
  data() {
    return {
      i18nPrefix: `knowledge.empty-${this.type}`
    };
  },
  props: {
    type: {
      type: String,
      default: "collection"
    }
  }
}), gg = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='168'%20height='168'%20fill='none'%3e%3cg%20clip-path='url(%23a)'%3e%3cpath%20fill='%23EAEEF9'%20d='M84.926%20152.378c29.7%200%2053.9-24.1%2053.9-53.7%200-29.7-24.1-53.7-53.9-53.7-29.8-.1-53.9%2023.9-53.9%2053.6%200%2029.7%2024.1%2053.8%2053.9%2053.8Z'/%3e%3cpath%20fill='url(%23b)'%20d='m75.426%2079.879-1.4-3.9c-.3-1-1.3-1.6-2.3-1.6h-24.6c-2.1%200-3.7%201.6-3.7%203.7v55.1-9.1h84v-38.9c0-2.1-1.6-3.7-3.7-3.7h-46c-1%200-1.9-.6-2.3-1.6Z'/%3e%3cg%20filter='url(%23c)'%3e%3cpath%20fill='white'%20d='m45.826%2048.078%2016.8%2029.2c.5%201%20.2%202.3-.8%202.8l-28.6%2016c-1%20.5-2.3.2-2.8-.8l-21.1-37.8c-.7-1-.2-2.3.8-2.8l20.8-11.6%2014.9%205Z'/%3e%3c/g%3e%3cpath%20fill='%23D5DDEA'%20d='m30.726%2051.178-13.8%207.7c-.3.2-.8.1-.9-.3-.2-.3-.1-.8.2-.9l13.8-7.6c.3-.2.8-.1.9.2.2.3.1.8-.2.9Zm-6.7%208.101-5.3%202.9c-.3.2-.7.1-.8-.2-.2-.3-.1-.8.2-.9l5.2-2.9c.3-.2.8-.1.9.2.3.2.2.7-.2.9Zm6.9-16.201%204.6%208.1c.7%201.1%202.2%201.5%203.3.9l7.3-4m1.4%2017.801c-.9-1.8-2.1-3.9-3.6-5.4-.8-.8-1.8-1.3-3-1.3s-2.3.4-3.5%201c-2.1.9-4%201.8-5.9%203-1.7%201-3.7%202.1-5%203.7-1.7%202.3-.8%204.6.4%207%20.9%201.8%202.1%203.9%203.6%205.4%201.2%201.2%202.8%201.6%204.4%201.1%202.1-.5%206-2.7%207.8-3.8%201.6-1%203.5-1.9%204.7-3.4%202.3-2.3%201.5-4.7.1-7.3Zm-14%202.5c-.3-.6-.1-1.1.7-1%202.1.1%204.1.1%206.1.2.8%200%201%20.4.7%201.1-1%201.7-2%203.5-3%205.3-.4.6-.9.6-1.2.1-.3-.3-3-5.2-3.3-5.7Z'/%3e%3cpath%20fill='%23E3EAF2'%20d='m109.426%2099.078-.9-.6c-.2-.2-.2-.4%200-.6.2-.2.4-.2.7-.1l.9.6c.2.1.2.4.1.6-.3.2-.6.2-.8.1Zm-2.4-1.9-5.1-4c-.2-.1-.2-.4-.1-.6.1-.2.4-.2.7-.1l5.1%204c.2.1.2.4.1.6-.2.2-.5.3-.7.1Z'/%3e%3cg%20filter='url(%23d)'%3e%3cpath%20fill='white'%20d='m158.926%2071.478-19.1%2024.7c-.6.9-1.8%201-2.7.3l-23.8-18.7c-.9-.6-1-1.8-.3-2.7l24.8-31.5c.6-.9%201.8-1%202.7-.3l17.3%2013.6%201.1%2014.6Z'/%3e%3c/g%3e%3cpath%20fill='%23D5DDEA'%20d='m150.826%2059.578-11.5-9c-.2-.2-.3-.5-.1-.9.2-.2.5-.3.9-.1l11.5%209c.2.2.3.5.1.9-.3.3-.6.3-.9.1Zm-9.2-2.799-4.3-3.5c-.2-.2-.3-.5-.1-.9.2-.3.5-.3.9-.1l4.3%203.5c.2.2.3.5.1.9-.3.3-.7.3-.9.1Zm16.2.1-5.3%206.7c-.8%201-.5%202.4.4%203.1l6.1%204.8m-7.5%201.499-6-4.6-6.2-4.9-5.7-4.5c-.6-.5-1.6-.4-2.1.3l-8.2%2010.4c-.5.6-.4%201.6.2%202.1l18%2014.2c.6.5%201.6.4%202.1-.3l8.2-10.4c.5-.9.4-1.7-.3-2.3Zm-19-.1%201.8-2.4%205.5%204.3-1.8%202.4-5.5-4.3Zm5%205-1.7%202.2-5.5-4.3%201.7-2.2%205.5%204.3Zm4.7-6.1-1.8%202.4-5.5-4.3%201.8-2.4%205.5%204.3Zm-5-5%202-2.4%205.5%204.3-1.8%202.4-5.7-4.3Zm10%2012.7-6.1-4.8%201.8-2.4%206.1%204.8-1.8%202.4Zm-13-10.2-5.9-4.6%201.8-2.4%205.9%204.6-1.8%202.4Zm-6.5-3.9%205.9%204.6-1.8%202.4-5.9-4.6%201.8-2.4Zm12.9%2010%206.1%204.8-1.8%202.4-6.1-4.8%201.8-2.4Zm10.5-.8-1.5%201.9-6.1-4.8%201.8-2.4%205.6%204.4c.4.2.4.6.2.9Zm-18.1-15.1%205.4%204.3-1.8%202.4-5.9-4.6%201.5-1.9c.2-.3.6-.3.8-.2Zm-9%2010.6%201.3-1.6%205.9%204.6-1.7%202.2-5.5-4.3c-.2-.2-.2-.7%200-.9Zm18.1%2014.9-5.6-4.4%201.7-2.2%206.1%204.8-1.4%201.7c-.2.4-.6.4-.8.1Z'/%3e%3cpath%20fill='url(%23e)'%20d='m102.326%2095.278-5.7-.6c-.3%200-.5-.3-.4-.6%200-.3.3-.5.7-.4l5.7.6c.3%200%20.5.3.4.6-.1.3-.4.6-.7.4Z'/%3e%3cpath%20fill='white'%20d='m129.126%20100.679-6.2%2027.7c-.4%201.6-2.3%202.9-4.7%202.9h-67.3c-2.3%200-4.3-1.2-4.7-2.9l-5.1-22.7c-.4-1.7%201.5-3.3%203.9-3.3h38c1.2%200%202.1-.6%202.5-1.3l1.1-2.4c.4-.8%201.4-1.3%202.5-1.3h36.2c2.3%200%204.1%201.6%203.8%203.3Z'/%3e%3cg%20filter='url(%23f)'%3e%3cpath%20fill='url(%23g)'%20d='m134.026%2096.978-6.9%2042.5c-.4%202.5-2.6%204.4-5.2%204.4h-75c-2.6%200-4.8-1.8-5.2-4.4l-5.7-34.9c-.4-2.6%201.6-5.1%204.3-5.1h42.3c1.3%200%202.4-.9%202.8-2.1l1.2-3.7c.4-1.2%201.5-2.1%202.8-2.1h40.3c2.6.3%204.7%202.7%204.3%205.4Z'/%3e%3c/g%3e%3cg%20filter='url(%23h)'%3e%3cpath%20fill='white'%20d='m111.226%2041.379-3.2%2034.7c-.1%201.2-1.2%202.1-2.4%201.9l-33.8-3.5c-1.2-.1-2.1-1.2-2-2.4l4.6-44.5c.1-1.2%201.2-2.1%202.4-1.9l24.5%202.5%209.9%2013.2Z'/%3e%3c/g%3e%3cpath%20fill='%23D5DDEA'%20d='m101.426%2028.279-1%209.5c-.1%201.3.9%202.6%202.3%202.7l8.6.9'/%3e%3cpath%20fill='%23ECF0F8'%20d='m104.626%2066.678-27.7-3.1c-.7-.1-1.2-.6-1.1-1.3l2.1-17.7c.1-.6.7-1.2%201.3-1.1l27.7%203c.7.1%201.2.6%201.1%201.3l-2.1%2017.7c-.1.7-.7%201.2-1.3%201.2Z'/%3e%3cpath%20fill='%23D5DDEA'%20d='m92.126%2062.379-12.8-1.5%207.2-6.5%205.6%208Z'/%3e%3cpath%20fill='white'%20d='m102.726%2063.578-18.5-2.2%2010.5-9.3%208%2011.5Z'/%3e%3cpath%20fill='%23D5DDEA'%20d='M85.526%2051.578c1.4%200%202.5-1.1%202.5-2.5s-1.1-2.5-2.5-2.5-2.5%201.1-2.5%202.5%201.1%202.5%202.5%202.5Zm10.7-17.5-16.8-1.9c-.2%200-.4-.2-.3-.4v-.2c0-.2.2-.4.4-.3l16.8%201.9c.2%200%20.4.2.3.4v.2c.1.2-.1.4-.4.3Zm-.1%203.201-17-1.9c-.2%200-.4-.2-.3-.4v-.2c0-.2.2-.4.4-.3l17%201.9c.2%200%20.4.2.3.4v.2c.1.1-.2.3-.4.3Zm.6%2032.699-21.1-2.4c-.3%200-.5-.3-.4-.6%200-.3.3-.5.7-.4l21%202.4c.3%200%20.5.3.4.6-.1.3-.3.5-.6.4Zm-3.1-29.699-14.8-1.7c-.3%200-.5-.3-.4-.6%200-.3.3-.5.7-.4l14.8%201.7c.3%200%20.5.3.4.6-.1.2-.3.4-.7.4Zm10.9%2033.8-29.4-3.5c-.3%200-.5-.3-.4-.6%200-.3.3-.5.7-.4l29.4%203.4c.3%200%20.5.3.4.6-.1.3-.4.5-.7.5Zm-30.5-53.001c-.4.2-.9%200-1.1-.4l-1.8-4.5c-.2-.4%200-.9.4-1.1.4-.2.9%200%201.1.4l1.8%204.5c.3.6.1%201-.4%201.1Zm-3.3%204.401c-.2.2-.4.3-.8.2l-4.7-.9c-.4-.1-.8-.5-.7-1%20.1-.4.5-.8%201-.6l4.7.9c.4.1.8.5.7%201-.1.1-.1.3-.2.4Zm9.5-4.901c-.1%200-.2-.1-.4-.1-.3-.3-.4-.8-.1-1.2l2.9-3.8c.3-.3.8-.4%201.2-.1.3.3.4.8.1%201.2l-2.9%203.8c-.3.1-.6.2-.8.2Z'/%3e%3cpath%20fill='url(%23i)'%20d='M105.126%20137.179c-.4%201.7-1%203.5-1.7%205-1.9%203.7-4.9%206.6-8.6%208.5-3.8%201.9-8.3%202.7-12.8%201.7-10.6-2.2-17.4-12.6-15.2-23.2%202.2-10.6%2012.5-17.5%2023.1-15.2%203.8.8%207.1%202.7%209.9%205.3%204.7%204.7%206.7%2011.5%205.3%2017.9Z'/%3e%3cpath%20fill='white'%20d='M92.612%20141c-.572%200-.364.053-4.788-4.421-4.268%203.21-10.201.105-10.201-5.158%200-3.526%202.862-6.421%206.35-6.421%205.048%200%208.17%205.737%205.204%2010.105l4.112%204.158a.993.993%200%200%201-.677%201.737Zm-8.588-13.947c-2.394%200-4.372%201.947-4.372%204.421%200%202.473%201.926%204.421%204.372%204.421.26%200%20.52%200%20.781-.053.26-.053.52-.105.729-.21.26-.106.468-.211.676-.316a3.34%203.34%200%200%200%20.677-.527l.52-.526c.157-.21.313-.421.417-.631.104-.211.208-.474.312-.737.104-.263.156-.527.156-.79%200-.21.052-.368.052-.579.053-2.526-1.925-4.473-4.32-4.473Z'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='b'%20x1='85.433'%20x2='85.433'%20y1='76.421'%20y2='109.425'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23B0BACC'/%3e%3cstop%20offset='1'%20stop-color='%23969EAE'/%3e%3c/linearGradient%3e%3clinearGradient%20id='e'%20x1='96.095'%20x2='102.92'%20y1='94.061'%20y2='94.848'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%2383A6FF'/%3e%3cstop%20offset='1'%20stop-color='%235A78FF'/%3e%3c/linearGradient%3e%3clinearGradient%20id='g'%20x1='84.993'%20x2='84.993'%20y1='90.369'%20y2='144.442'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FDFEFF'/%3e%3cstop%20offset='.996'%20stop-color='%23ECF0F5'/%3e%3c/linearGradient%3e%3clinearGradient%20id='i'%20x1='85.992'%20x2='85.992'%20y1='114.9'%20y2='136.945'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23B0BACC'/%3e%3cstop%20offset='1'%20stop-color='%23969EAE'/%3e%3c/linearGradient%3e%3cfilter%20id='c'%20width='97.864'%20height='97.237'%20x='-13'%20y='32.078'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='11'/%3e%3cfeGaussianBlur%20stdDeviation='11'/%3e%3cfeColorMatrix%20values='0%200%200%200%200.397708%200%200%200%200%200.47749%200%200%200%200%200.575%200%200%200%200.27%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_340_148'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_340_148'%20result='shape'/%3e%3c/filter%3e%3cfilter%20id='d'%20width='90.359'%20height='98.119'%20x='90.567'%20y='31.819'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='11'/%3e%3cfeGaussianBlur%20stdDeviation='11'/%3e%3cfeColorMatrix%20values='0%200%200%200%200.397708%200%200%200%200%200.47749%200%200%200%200%200.575%200%200%200%200.27%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_340_148'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_340_148'%20result='shape'/%3e%3c/filter%3e%3cfilter%20id='f'%20width='142.1'%20height='96.3'%20x='13.975'%20y='80.579'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='11'/%3e%3cfeGaussianBlur%20stdDeviation='11'/%3e%3cfeColorMatrix%20values='0%200%200%200%200.397708%200%200%200%200%200.47749%200%200%200%200%200.575%200%200%200%200.27%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_340_148'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_340_148'%20result='shape'/%3e%3c/filter%3e%3cfilter%20id='h'%20width='85.408'%20height='96.356'%20x='47.819'%20y='14.651'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='11'/%3e%3cfeGaussianBlur%20stdDeviation='11'/%3e%3cfeColorMatrix%20values='0%200%200%200%200.397708%200%200%200%200%200.47749%200%200%200%200%200.575%200%200%200%200.27%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_340_148'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_340_148'%20result='shape'/%3e%3c/filter%3e%3cclipPath%20id='a'%3e%3cpath%20fill='white'%20d='M0%200h168v168H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", pg = { class: "flex flex-col items-center pb-10 gap-2" }, mg = /* @__PURE__ */ m("img", {
  src: gg,
  class: "max-w-[144px] h-auto"
}, null, -1), hg = { class: "text-gray-9" }, fg = { class: "text-gray-7" };
function yg(e, t, n, o, i, r) {
  const s = ye;
  return c(), p("div", pg, [
    mg,
    m("h3", hg, N(e.$t(`${e.i18nPrefix}.title`)), 1),
    m("p", fg, N(e.$t(`${e.i18nPrefix}.description`)), 1),
    M(s, {
      class: "mt-2",
      type: "custom-secondary",
      onClick: t[0] || (t[0] = (l) => e.$emit("back"))
    }, {
      default: _(() => [
        ne(N(e.$t(`${e.i18nPrefix}.cta`)), 1)
      ]),
      _: 1
    })
  ]);
}
const ki = /* @__PURE__ */ x(dg, [["render", yg]]), Ig = {
  key: 0,
  class: "py-4 w-full bg-white rounded"
}, Mg = { class: "flex items-center gap-2" }, Ag = {
  key: 0,
  class: "text-sm leading-[16px] max-h-[80px] px-3.5 mt-4 overflow-auto"
}, Ng = /* @__PURE__ */ T({
  __name: "CaseDescriptionRowMobile",
  setup(e) {
    const t = le(), { mainContent: n } = De(t), o = k(() => n.value.body), i = Y(!1), r = () => {
      i.value = !i.value;
    };
    return (s, l) => {
      const a = P;
      return h(o) ? (c(), p("div", Ig, [
        m("button", {
          class: "pl-3.5 pr-2 flex items-center justify-between gap-2 w-full",
          onClick: r
        }, [
          m("div", Mg, [
            M(a, {
              class: "w-6 h-6 flex-none bg-gray-3 rounded-lg text-sm",
              icon: ["fas", "info"]
            }),
            m("span", null, N(s.$t("knowledge.collection-description")), 1)
          ]),
          M(a, {
            class: D(["w-6 h-6 flex-none rounded-lg text-sm transition-transform", {
              "-rotate-180": h(i)
            }]),
            icon: ["fal", "chevron-down"]
          }, null, 8, ["class"])
        ]),
        M(Xe, { name: "expand-height" }, {
          default: _(() => [
            h(i) ? (c(), p("div", Ag, N(h(o)), 1)) : A("", !0)
          ]),
          _: 1
        })
      ])) : A("", !0);
    };
  }
});
const bg = /* @__PURE__ */ x(Ng, [["__scopeId", "data-v-a80f8971"]]), Cg = T({
  name: "CollectionView",
  components: {
    KnowledgeDropdown: ko,
    LanguageSwitcher: jo,
    EntityItem: Un,
    EmptyEntity: ki,
    EntityItemSkeleton: cn,
    CaseDescriptionRowMobile: bg
  },
  emits: [
    "go-to-entity",
    "toggle-favorite",
    "copy-link",
    "open-in-web",
    "show-zoom",
    "open-lightbox",
    "show-answer",
    "close-modal",
    "route-to-feedback",
    "notify-app",
    "change-language",
    "empty-view",
    "overview"
  ],
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    itemIsFavorite: {
      type: Function,
      default: () => !1
    },
    overviewId: {
      type: String,
      default: ""
    }
  },
  setup() {
    return {
      multilingualHosts: gr
    };
  },
  data() {
    return {
      hovered: -1
    };
  },
  computed: {
    entityOptions() {
      return {
        copy: !0,
        open: this.config.hostApp === "chrome-extension",
        overview: this.config.hostApp === "agent-client"
      };
    },
    collectionToDisplay() {
      return dr(
        this.filteredCollection(this.config.searchCategoriesAndFilter),
        this.sortOptionId
      );
    },
    ...ue(le, [
      "path",
      "mainContent",
      "appIsLoading",
      "mainIsLoading",
      "mainContentChildren",
      "contentParents",
      "collectionIsEmpty",
      "contentIsFocused",
      "selectedLanguage",
      "sortOptionId",
      "filters",
      "isGrid",
      "hasKnowledgeFilters",
      "filteredCollection"
    ])
  },
  methods: {
    onHover(e) {
      this.hovered = e;
    },
    handleClickOnEntity(e) {
      const { type: t, label: n } = e;
      if (t === "Case" || t === "Article") {
        const o = {
          id: e.id,
          type: t,
          label: n
        };
        return (t === "Case" || t === "Article" && this.config.displayArticleInMainFrame) && this.updatePathWithChildEntity(o), this.$emit("go-to-entity", e);
      }
      this.appearDiagnosticStep(e, !0);
    },
    appearDiagnosticStep(e, t = !1) {
      if (e.redirection) {
        const { entityId: o, entityType: i } = e.redirection;
        return this.$emit("go-to-entity", { id: o, type: i, deepLoading: !0, showBack: !0 });
      }
      t && this.updatePathWithChildEntity(e), this.updateContentParents(
        this.contentParents.concat([{ ...e, children: this.mainContentChildren }])
      );
      const n = {
        id: e.id,
        type: "Step"
      };
      this.$emit("go-to-entity", n);
    },
    async reachParentEntity(e) {
      const t = await this.getParentEntity(e, this.mainContent.knowledgeId, this.path);
      this.updatePath(this.path.slice(0, e + 1)), this.$emit("go-to-entity", t);
    },
    ...fe(le, [
      "updateContentParents",
      "updatePath",
      "updatePathWithChildEntity",
      "getParentEntity",
      "updateFilters",
      "updateLayout"
    ])
  },
  mounted() {
    this.config.hostApp === "agent-client" && this.updateLayout(!1);
  }
});
const wg = {
  key: 1,
  class: "w-full"
}, Dg = {
  key: 0,
  class: "space-y-2"
}, zg = { key: 1 }, vg = { class: "relative md:hidden mb-4 flex items-center gap-2" };
function Tg(e, t, n, o, i, r) {
  const s = _n, l = cn, a = R("KnowledgeDropdown"), u = R("LanguageSwitcher"), g = R("CaseDescriptionRowMobile"), d = R("EmptyEntity"), f = Un;
  return e.mainContent.type !== "Case" && !e.appIsLoading ? (c(), C(s, {
    key: 0,
    class: "h-full justify-center text-center",
    illustrationType: "filtered-notifications",
    title: e.$t("knowledge.empty-state.title"),
    "action-cta-label": e.$t("knowledge.empty-state.cta"),
    onAction: t[0] || (t[0] = (I) => e.$emit("empty-view"))
  }, null, 8, ["title", "action-cta-label"])) : (c(), p("div", wg, [
    e.mainIsLoading ? (c(), p("div", Dg, [
      (c(), p(X, null, te(7, (I) => M(l, {
        key: I,
        index: I
      }, null, 8, ["index"])), 64))
    ])) : (c(), p("div", zg, [
      m("div", vg, [
        M(a, {
          class: "w-full",
          onGoToEntity: t[1] || (t[1] = (I) => e.$emit("go-to-entity", I)),
          altStyle: ""
        }),
        e.multilingualHosts.includes(e.config.hostApp) ? (c(), C(u, {
          key: 0,
          class: "w-[88px]",
          centerOptions: "",
          altStyle: "",
          mobile: "",
          onChange: t[2] || (t[2] = (I) => e.$emit("change-language", I))
        })) : A("", !0)
      ]),
      e.config.hostApp === "agent-client" && e.config.isMobile ? (c(), C(g, {
        key: 0,
        class: "mb-4"
      })) : A("", !0),
      e.collectionIsEmpty ? (c(), C(d, {
        key: 1,
        onBack: t[3] || (t[3] = (I) => e.reachParentEntity(e.path.length - 2)),
        class: "mt-4"
      })) : !e.collectionToDisplay.length && e.hasKnowledgeFilters ? (c(), C(d, {
        key: 2,
        onBack: t[4] || (t[4] = (I) => e.updateFilters({ query: null, types: [], labels: [], size: 0 })),
        type: "filter",
        class: "mt-4"
      })) : (c(), p("div", {
        key: 3,
        class: D(e.isGrid ? "grid gap-4 lg:grid-cols-2" : "space-y-2")
      }, [
        (c(!0), p(X, null, te(e.collectionToDisplay, (I, z) => (c(), C(f, {
          key: I.id,
          item: I,
          hovered: z === e.hovered,
          "is-favorite": e.itemIsFavorite(I.id, e.selectedLanguage),
          "full-title-preference": e.config.displayFullTitle,
          options: e.entityOptions,
          "is-overview": I.id === e.overviewId,
          link: e.config.hostApp === "agent-client",
          onMouseenter: (v) => e.onHover(z),
          onMouseleave: t[5] || (t[5] = (v) => e.onHover(-1)),
          onGoToDocument: (v) => e.handleClickOnEntity(I),
          onToggleFavorite: t[6] || (t[6] = (v) => e.$emit("toggle-favorite", v)),
          onCopyLink: t[7] || (t[7] = (v) => e.$emit("copy-link", v)),
          onOpenInWeb: t[8] || (t[8] = (v) => e.$emit("open-in-web", v)),
          onOverview: t[9] || (t[9] = (v) => e.$emit("overview", v))
        }, null, 8, ["item", "hovered", "is-favorite", "full-title-preference", "options", "is-overview", "link", "onMouseenter", "onGoToDocument"]))), 128))
      ], 2))
    ]))
  ]));
}
const kg = /* @__PURE__ */ x(Cg, [["render", Tg], ["__scopeId", "data-v-fd36639c"]]);
function ji(e) {
  if (e === "chrome-extension") {
    const t = window.document.querySelector("#mayday-wrapper");
    if (!t)
      return window.document;
    const { shadowRoot: n } = t;
    return n;
  } else
    return window.document;
}
const jg = T({
  name: "ContentViewer",
  props: {
    contentId: {
      type: String,
      required: !0
    },
    body: {
      type: String,
      default: ""
    },
    mentions: {
      type: Array,
      default: () => []
    },
    hash: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default: () => ({})
    },
    lang: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      linkModal: {
        display: !1,
        src: ""
      },
      options: {
        fontOptions: !0,
        extraFontOptions: !0,
        colorOptions: !0,
        structurationOptions: !0,
        extraStructurationOptions: !0,
        tableOptions: !0,
        richOptions: !0,
        tocClickOptions: !0,
        allowToc: !0
      }
    };
  },
  setup(e) {
    return {
      domRoot: ji(e.config.hostApp)
    };
  },
  watch: {
    hash() {
      setTimeout(() => {
        this.handleFocusHash(this.hash);
      }, 1e3);
    }
  },
  mounted() {
    this.setTableHeadings(), setTimeout(() => {
      this.handleFocusHash(this.hash);
    }, 1e3);
  },
  methods: {
    async handleOpenLink({ href: e }) {
      if (e.includes("mayday.fr")) {
        const t = await this.openInlineLink(e);
        if (t) {
          const { content: n, hash: o } = t, { id: i, type: r } = n, s = {
            id: i,
            type: r,
            showBack: !0,
            deepLoading: !0,
            hash: o,
            source: "inline"
          };
          return this.$emit("go-to-entity", s);
        }
      }
      return window.open(e, "_blank");
    },
    handleClickAttachedFile(e) {
      e && e.href && window.open(e.href, "_blank");
    },
    openInLightbox(e, t = "img") {
      e && this.$emit("open-lightbox", { src: e, type: t });
    },
    handleOnTocClick({ id: e }) {
      this.handleFocusHash(`#${e}`);
    },
    handleFocusHash(e) {
      var o;
      if (!e)
        return;
      const t = decodeURI(e.slice(1)), n = (o = this.domRoot) == null ? void 0 : o.querySelector(`[data-uid="${t}"], [id="${t}"]`);
      n && n.scrollIntoView({ behavior: "smooth" });
    },
    async handleFetchInlineMention({
      entityId: e,
      entityType: t
    }) {
      const n = await this.resolveUser(e);
      if (!n)
        return null;
      const { username: o, isDeleted: i } = n;
      return {
        entityId: e,
        entityType: t,
        label: o,
        isDeleted: i
      };
    },
    async resolveUser(e) {
      const t = this.mentions.find((n) => n.id === e);
      return t || this.fetchUser(e);
    },
    setTableHeadings() {
      if (this.config.hostApp !== "agent-client")
        return;
      const e = this.$refs.maydayEditorRef.setHeadingIds();
      this.setTableOfContents(e);
    },
    ...fe(le, [
      "openInlineLink",
      "getContent",
      "setTableOfContents",
      "fetchUser"
    ])
  }
});
function Sg(e, t, n, o, i, r) {
  const s = R("mayday-editor");
  return c(), C(s, {
    class: "me-content-viewer break-words !p-0 w-full h-auto",
    ref: "maydayEditorRef",
    key: `${e.contentId}-${e.lang}`,
    content: e.body,
    editable: !1,
    options: e.options,
    "fetch-inline-content": e.getContent,
    "fetch-inline-mention": e.handleFetchInlineMention,
    size: e.config.contentFontSize,
    "onClick:inlineContent": t[0] || (t[0] = (l) => e.$emit("click:inline-content", l)),
    "onClick:inlineContentModal": t[1] || (t[1] = (l) => e.$emit("click:inline-content-modal", l)),
    "onClick:inlineContentTab": t[2] || (t[2] = (l) => e.$emit("click:inline-content-tab", l)),
    "onClick:attachedFile": e.handleClickAttachedFile,
    "onClick:image": t[3] || (t[3] = (l) => e.openInLightbox(l.src)),
    "onClick:toc": t[4] || (t[4] = (l) => e.handleOnTocClick(l)),
    "onClick:focusHash": e.handleFocusHash,
    "onClick:openLink": e.handleOpenLink,
    "onClick:openLinkModal": t[5] || (t[5] = (l) => e.openInLightbox(l, "embed"))
  }, null, 8, ["content", "options", "fetch-inline-content", "fetch-inline-mention", "size", "onClick:attachedFile", "onClick:focusHash", "onClick:openLink"]);
}
const Si = /* @__PURE__ */ x(jg, [["render", Sg], ["__scopeId", "data-v-12e63ac0"]]);
var Lg = "Expected a function", ps = 0 / 0, Eg = "[object Symbol]", Og = /^\s+|\s+$/g, xg = /^[-+]0x[0-9a-f]+$/i, _g = /^0b[01]+$/i, Ug = /^0o[0-7]+$/i, Fg = parseInt, $g = typeof {} == "object" && {} && {}.Object === Object && {}, Rg = typeof self == "object" && self && self.Object === Object && self, Vg = $g || Rg || Function("return this")(), Bg = Object.prototype, Yg = Bg.toString, Qg = Math.max, Pg = Math.min, Wo = function() {
  return Vg.Date.now();
};
function Gg(e, t, n) {
  var o, i, r, s, l, a, u = 0, g = !1, d = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(Lg);
  t = ms(t) || 0, di(n) && (g = !!n.leading, d = "maxWait" in n, r = d ? Qg(ms(n.maxWait) || 0, t) : r, f = "trailing" in n ? !!n.trailing : f);
  function I(K) {
    var U = o, he = i;
    return o = i = void 0, u = K, s = e.apply(he, U), s;
  }
  function z(K) {
    return u = K, l = setTimeout(H, t), g ? I(K) : s;
  }
  function v(K) {
    var U = K - a, he = K - u, se = t - U;
    return d ? Pg(se, r - he) : se;
  }
  function Q(K) {
    var U = K - a, he = K - u;
    return a === void 0 || U >= t || U < 0 || d && he >= r;
  }
  function H() {
    var K = Wo();
    if (Q(K))
      return ee(K);
    l = setTimeout(H, v(K));
  }
  function ee(K) {
    return l = void 0, f && o ? I(K) : (o = i = void 0, s);
  }
  function j() {
    l !== void 0 && clearTimeout(l), u = 0, o = a = i = l = void 0;
  }
  function G() {
    return l === void 0 ? s : ee(Wo());
  }
  function V() {
    var K = Wo(), U = Q(K);
    if (o = arguments, i = this, a = K, U) {
      if (l === void 0)
        return z(a);
      if (d)
        return l = setTimeout(H, t), I(a);
    }
    return l === void 0 && (l = setTimeout(H, t)), s;
  }
  return V.cancel = j, V.flush = G, V;
}
function di(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function Zg(e) {
  return !!e && typeof e == "object";
}
function Wg(e) {
  return typeof e == "symbol" || Zg(e) && Yg.call(e) == Eg;
}
function ms(e) {
  if (typeof e == "number")
    return e;
  if (Wg(e))
    return ps;
  if (di(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = di(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(Og, "");
  var n = _g.test(e);
  return n || Ug.test(e) ? Fg(e.slice(2), n ? 2 : 8) : xg.test(e) ? ps : +e;
}
var Hg = Gg;
const Li = /* @__PURE__ */ Mi(Hg), Jg = T({
  name: "DiagnosticNavigatorTitle",
  props: {
    content: {
      type: Object,
      required: !0
    },
    fullTitlePreference: {
      type: Boolean,
      default: !1
    },
    isFavorite: {
      type: Boolean,
      default: !1
    }
  },
  components: {
    ContentLabelWrapper: vi
    // BaseTooltip
  },
  computed: {
    isRoot() {
      return this.content.type === "Diagnostic";
    }
  }
}), Kg = { class: "flex items-center gap-2 relative" }, qg = {
  key: 2,
  class: "text-lg font-bold whitespace-pre-wrap [word-break:break-word]"
}, Xg = {
  key: 0,
  class: "flex items-center mt-1"
};
function ep(e, t, n, o, i, r) {
  const s = ln, l = P, a = ye, u = Le, g = vi;
  return c(), p("div", null, [
    m("div", Kg, [
      e.isRoot ? (c(), C(s, {
        key: 0,
        type: "Diagnostic",
        isFavorite: e.isFavorite
      }, null, 8, ["isFavorite"])) : (c(), C(a, {
        key: 1,
        type: "secondary",
        outline: "",
        size: "mini",
        class: "flex-none",
        icon: "",
        onClick: t[0] || (t[0] = (d) => e.$emit("click:back"))
      }, {
        default: _(() => [
          M(l, { icon: ["fas", "chevron-left"] })
        ]),
        _: 1
      })),
      e.fullTitlePreference ? (c(), p("span", qg, N(e.content.label), 1)) : (c(), C(u, {
        key: 3,
        class: "text-lg font-bold",
        text: e.content.label
      }, null, 8, ["text"]))
    ]),
    e.content.labels && e.content.labels.length ? (c(), p("div", Xg, [
      M(g, {
        labels: e.content.labels
      }, null, 8, ["labels"])
    ])) : A("", !0)
  ]);
}
const tp = /* @__PURE__ */ x(Jg, [["render", ep]]), np = { class: "space-y-1.5" }, op = ["onClick"], ip = /* @__PURE__ */ T({
  __name: "DiagnosticNavigatorChildren",
  props: {
    children: {}
  },
  setup(e) {
    const t = e, n = k(() => t.children.filter((o) => !o.redirection || !o.redirection.isDeleted));
    return (o, i) => {
      const r = P;
      return c(), p("div", np, [
        (c(!0), p(X, null, te(h(n), (s) => (c(), p("button", {
          key: s.id,
          class: "transition-colors rounded-[3px] w-full border border-blue text-sm flex items-center justify-center gap-2 !leading-[42px] px-2 bg-transparent text-blue hover:bg-blue hover:text-white",
          onClick: (l) => o.$emit("click:child", s)
        }, [
          s.redirection ? (c(), C(r, {
            key: 0,
            icon: ["fas", "external-link-square"]
          })) : A("", !0),
          m("span", null, N(s.label), 1)
        ], 8, op))), 128))
      ]);
    };
  }
}), sp = "satisfaction-module", rp = T({
  name: "SatisfactionModule",
  props: {
    contentId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      base: sp,
      choice: ""
    };
  },
  computed: {
    showFeedback() {
      return this.choice === "down";
    }
  },
  methods: {
    handleClick(e) {
      this.choice = e, this.$emit("choice", e), e === "down" && this.$nextTick(() => {
        this.$refs["satisfaction-module"].scrollIntoView({
          block: "end",
          inline: "nearest",
          behavior: "smooth"
        });
      });
    }
  },
  watch: {
    contentId() {
      this.choice = "";
    }
  }
});
function ap(e, t, n, o, i, r) {
  const s = P;
  return c(), p("div", {
    class: D(`${e.base}`),
    ref: "satisfaction-module"
  }, [
    m("div", {
      class: D(`${e.base}__title`)
    }, N(e.$t("knowledge.satisfaction.title")), 3),
    m("div", {
      class: D([`${e.base}__cta`, "mt-4"])
    }, [
      m("button", {
        class: D(`${e.base}__cta__icon-wrapper`),
        onClick: t[0] || (t[0] = (l) => e.handleClick("up"))
      }, [
        M(s, {
          class: D([
            `${e.base}__cta__icon transition-all rounded`,
            `${e.base}__cta__icon--up`,
            { [`${e.base}__cta__icon--up--selected`]: e.choice === "up" }
          ]),
          icon: ["fal", "thumbs-up"]
        }, null, 8, ["class"])
      ], 2),
      m("button", {
        class: D(`${e.base}__cta__icon-wrapper`),
        onClick: t[1] || (t[1] = (l) => e.handleClick("down"))
      }, [
        M(s, {
          class: D([
            `${e.base}__cta__icon transition-all rounded`,
            `${e.base}__cta__icon--down`,
            { [`${e.base}__cta__icon--down--selected`]: e.choice === "down" }
          ]),
          icon: ["fal", "thumbs-down"]
        }, null, 8, ["class"])
      ], 2)
    ], 2),
    e.showFeedback ? (c(), p("div", {
      key: 0,
      class: D(`${e.base}__feedback`)
    }, [
      m("small", {
        onClick: t[2] || (t[2] = (l) => e.$emit("click:feedback")),
        class: D(`${e.base}__feedback__cta`)
      }, N(e.$t("knowledge.satisfaction.cta")), 3)
    ], 2)) : A("", !0)
  ], 2);
}
const hr = /* @__PURE__ */ x(rp, [["render", ap], ["__scopeId", "data-v-345f58d8"]]), fr = (e) => {
  if (!e)
    return null;
  const { content: t } = e;
  if (!t)
    return null;
  let n = [];
  t.attachedTreeNodes && (n = t.attachedTreeNodes.map(
    (i) => (
      // eslint-disable-next-line implicit-arrow-linebreak
      fr(i)
    )
  ));
  let o;
  return e.type === "Folder" && (o = e.children), {
    id: e.id,
    label: t.label,
    body: t.body,
    type: e.type,
    attachedObjects: n,
    attachments: t.attachments,
    published: t.published,
    actions: e.actions,
    path: e.path,
    children: o
  };
}, lp = {
  processing: {
    MagicAnswers(e, t = []) {
      return e.map((n) => {
        let o = this.Ancestors(n.node.ancestors, n.treeNodeId);
        return t.length > 0 && (o = this.restrictedAncestorsId(t, o)), {
          alias: n.node.content.label,
          path: o,
          treeNodeId: n.treeNodeId
        };
      }).filter((n) => n.path.length > 1);
    },
    restrictedGroups(e, t) {
      const n = t.map(({ id: o }) => o);
      return e.filter((o) => !!o.ancestors.map(({ id: s }) => s).find((s) => n.includes(s)));
    },
    languages(e) {
      return e.map((t) => {
        const { rootDescendents: n, isRestricted: o, restrictedNodes: i, knowledge: r } = t, { magicAnswers: s, ...l } = r;
        return {
          tree: n,
          magicAnswers: this.MagicAnswers(
            s,
            i
            // rootDescendents
          ),
          isRestricted: o,
          restrictedNodes: i,
          ...l
        };
      });
    },
    Favorites(e) {
      return e.map((t) => ({
        id: t.id,
        content: t.content,
        path: this.Ancestors(t.ancestors, t.id),
        knowledgeId: t.knowledgeId
      }));
    },
    Ancestors(e, t) {
      return e.sort((n, o) => n.hierarchyLevel - o.hierarchyLevel).map((n) => n.id).concat([t]);
    },
    restrictedAncestorsId(e, t) {
      const n = e.find(({ id: o }) => t.includes(o));
      if (n) {
        const o = t.indexOf(n.id);
        return [0].concat(t.slice(o));
      }
      return [0];
    },
    fullAncestorIds(e, t) {
      const n = e.find(
        ({ id: o }) => t.includes(o)
      );
      return n ? n.ancestors.sort((i, r) => i.hierarchyLevel - r.hierarchyLevel).map((i) => i.id).concat(t.slice(1)).map(String) : [];
    },
    countryFlags(e) {
      const t = {
        fr: "🇫🇷",
        en: "🇬🇧",
        es: "🇪🇸",
        de: "🇩🇪",
        it: "🇮🇹",
        pt: "🇵🇹",
        ru: "🇷🇺",
        pl: "🇵🇱",
        tmp_dgpst: "",
        tmp_id_num: "",
        tmp_lp_net: "",
        tmp_lp_fr: ""
      };
      return Object.keys(t).includes(e) ? t[e] : "🏳️";
    },
    olParsing(e) {
      const [t, ...n] = e.split("<ol>");
      return n.reduce((o, i) => {
        const [r, s] = i.split("</ol>"), l = r.split("<li><p>").slice(1).map((a) => a.replace("</p></li>", "")).map((a, u) => ` ${u + 1}. ${a}`).join("<br>");
        return `${o.length > 0 ? `${o}<br>` : ""}${l}${s.length > 0 ? `${s}` : ""}`;
      }, t);
    },
    IntercomAnswer(e) {
      let t = e.split("&lt;").join("<").split("&gt;").join(">");
      return t = t.split("</p><br>").join("</p><br><br>").split("</ol><br>").join("</ol><br><br>").split("</ul><br>").join("</ul><br><br>"), t.includes("<ol>") && (t = this.olParsing(t)), t = t.split("</p><ul><li><p>").join("<br> - "), t = t.split("</p></li><li><p>").join("<br> - "), t = t.split("</p></li></ul>").join("<br>"), t = t.split("<ul><li>").join(" - "), t = t.split("</p><p>").join("<br>").split("<p>").join("").split("</p>").join(""), t = t.split("<strong>").join("<b>"), t = t.split("</strong>").join("</b>"), t = t.split("<em>").join("<i>"), t = t.split("</em>").join("</i>"), t;
    },
    getNode(e, t) {
      let n = { ...e };
      return t.slice(1).forEach((o) => {
        n = n.children.find((i) => String(i.id) === String(o));
      }), n;
    },
    tmpNodeToContent: fr
  }
}, cp = (e) => {
  let t, n;
  const o = e.querySelectorAll(".embercom-composer-editor");
  if (o.length === 0) {
    n = "ROOT";
    let i = e.querySelectorAll('div[role="textbox"]');
    i.length === 0 ? (i = e.querySelectorAll(".embercom-prosemirror-composer-editor"), i.length === 0 ? t = null : t = i) : t = i;
  } else
    t = o, n = "NESTED";
  return { inputWindow: t, inputType: n };
}, up = (e, t) => {
  const n = t.split("<br>").join("<p></p>"), o = e[0].innerHTML, i = e[0].childNodes[0].innerHTML;
  e[0].focus(), e[0].innerHTML = i.length > 1 && i !== "<br>" ? `${o}${n}` : n;
}, dp = (e, t) => {
  const n = lp.processing.IntercomAnswer(t), o = e[0].childNodes[0].innerHTML;
  e[0].focus(), e[0].childNodes[0].innerHTML = o.length > 1 ? `${o}</br>${n}` : n;
};
function gp(e, t) {
  const { inputWindow: n, inputType: o } = cp(e);
  if (n)
    switch (o) {
      case "ROOT":
        up(n, t);
        break;
      case "NESTED":
        dp(n, t);
        break;
    }
}
const pp = (e, t) => {
  if (!t)
    return !1;
  try {
    const n = e.querySelectorAll("div.oneActionsComposer.forceActionsContainer");
    if (n && n.length) {
      const o = n[0].querySelectorAll("li.tabs__item.uiTabItem"), i = [...o].findIndex(
        (s) => s.innerText.toUpperCase().split(" ").join("_") === t
      );
      if (i < 0 || o[i].classList.contains("active"))
        return !1;
      o[i].querySelectorAll("a")[0].click();
    }
  } catch (n) {
    console.error(n);
  }
  return !0;
}, mp = (e) => {
  let t = null;
  try {
    const n = e.querySelectorAll("div.oneActionsComposer.forceActionsContainer");
    n && n.length && (t = n[0].querySelectorAll("li.tabs__item.active.uiTabItem")[0].innerText);
  } catch (n) {
    console.error(n);
  }
  return t ? t.toUpperCase().split(" ").join("_") : null;
}, co = {
  EMAIL: (e) => e.querySelectorAll("div.lafPageHost.active")[0].getElementsByTagName("force-aloha-page")[0].getElementsByTagName("iframe")[0].contentDocument.getElementsByTagName("iframe")[0].contentDocument.getElementsByTagName("body"),
  POST_COMMENT: (e) => e.querySelectorAll("div.ql-editor.ql-blank.slds-rich-text-area__content"),
  EXTERNAL_MESSAGE: (e) => e.querySelectorAll("div.slds-rich-text-area__content"),
  REFRESH_TAB: (e) => {
    const t = e.getElementsByClassName(
      "oneConsoleTabItem tabItem slds-context-bar__item slds-context-bar__item_tab slds-is-active active hasActions hideAnimation  navexConsoleTabItem"
    )[0].getElementsByClassName("slds-dropdown-trigger slds-dropdown-trigger_click tabActionsList")[0], n = t.getElementsByClassName(
      "slds-button slds-button_icon-container slds-button_icon-x-small"
    )[0];
    return n.click(), n.click(), t.getElementsByClassName("slds-dropdown slds-dropdown_right")[0].getElementsByClassName("slds-dropdown__item refreshTab")[0].children[0];
  }
}, uo = async (e, t, n) => {
  let i = 0, r = co[n](e);
  for (; !r.length && i < 10; )
    await new Promise((s) => setTimeout(s, 500)), r = co[n](e), i += 1;
  i !== 10 && (r[0].click(), await new Promise((s) => setTimeout(s, 500)), r = co[n](e), r[0].innerHTML = `${t}${r[0].innerHTML}`);
}, hp = async (e, t) => {
  const n = e.querySelectorAll("div.lafPageHost.active")[0], o = n.querySelectorAll(
    "button.slds-button.slds-button--neutral.slds-col.slds-no-space.dummyButtonCallToAction.uiButton"
  )[0];
  o && o.click(), await uo(n, t, "EXTERNAL_MESSAGE");
}, hs = {
  async insertAnswer(e, t, n) {
    if (!n)
      return;
    const { tab: o } = n;
    pp(e, o);
    const i = mp(e);
    if (i)
      switch (i) {
        case "EMAIL":
          await uo(e, t, i);
          break;
        case "POST_COMMENT":
          await uo(e, t, i);
          break;
        case "EXTERNAL_MESSAGE":
          await hp(e, t);
          break;
        default:
          await uo(e, t, "EMAIL");
          break;
      }
  },
  refreshCaseTab(e) {
    try {
      co.REFRESH_TAB(e).click();
    } catch (t) {
      console.log(t);
    }
  }
};
function fp(e, t) {
  try {
    const n = e.querySelectorAll("div[contenteditable=true]")[0];
    if (!n)
      return;
    n.innerHTML = `${t}${n.innerHTML}`;
    return;
  } catch {
    return;
  }
}
function yp(e, t) {
  try {
    const n = e.querySelectorAll("div[class*=EmailComposerEditorBase]")[0];
    if (!n)
      return;
    n.innerHTML = `${t}${n.innerHTML}`;
    return;
  } catch {
    return;
  }
}
function Ip(e, t) {
  try {
    const n = e.getElementsByClassName("threadContainer");
    let o = null;
    for (let l = 0; l < n.length; l++) {
      const a = n[l].nextElementSibling;
      if (a && a.tagName === "SPAN" && !a.classList.length) {
        o = a;
        break;
      }
    }
    if (!o)
      return;
    const i = o.getElementsByClassName(
      "public-DraftStyleDefault-block"
    )[0];
    if (!i)
      return;
    const r = new DataTransfer();
    r.setData("text/plain", Mp(t)), i.click(), i.focus();
    const s = new ClipboardEvent("paste", {
      clipboardData: r,
      bubbles: !0
    });
    i.dispatchEvent(s);
  } catch (n) {
    console.log(n);
    return;
  }
}
const Mp = (e) => {
  const t = document.createElement("div");
  return t.innerHTML = e, t.textContent || t.innerText || "";
};
function Ap(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      n.hasOwnProperty(o) && (e[o] = n[o]);
  }
  return e;
}
function gi(e, t) {
  return Array(t + 1).join(e);
}
function Np(e) {
  return e.replace(/^\n*/, "");
}
function bp(e) {
  for (var t = e.length; t > 0 && e[t - 1] === `
`; )
    t--;
  return e.substring(0, t);
}
var Cp = [
  "ADDRESS",
  "ARTICLE",
  "ASIDE",
  "AUDIO",
  "BLOCKQUOTE",
  "BODY",
  "CANVAS",
  "CENTER",
  "DD",
  "DIR",
  "DIV",
  "DL",
  "DT",
  "FIELDSET",
  "FIGCAPTION",
  "FIGURE",
  "FOOTER",
  "FORM",
  "FRAMESET",
  "H1",
  "H2",
  "H3",
  "H4",
  "H5",
  "H6",
  "HEADER",
  "HGROUP",
  "HR",
  "HTML",
  "ISINDEX",
  "LI",
  "MAIN",
  "MENU",
  "NAV",
  "NOFRAMES",
  "NOSCRIPT",
  "OL",
  "OUTPUT",
  "P",
  "PRE",
  "SECTION",
  "TABLE",
  "TBODY",
  "TD",
  "TFOOT",
  "TH",
  "THEAD",
  "TR",
  "UL"
];
function Ei(e) {
  return Oi(e, Cp);
}
var yr = [
  "AREA",
  "BASE",
  "BR",
  "COL",
  "COMMAND",
  "EMBED",
  "HR",
  "IMG",
  "INPUT",
  "KEYGEN",
  "LINK",
  "META",
  "PARAM",
  "SOURCE",
  "TRACK",
  "WBR"
];
function Ir(e) {
  return Oi(e, yr);
}
function wp(e) {
  return Ar(e, yr);
}
var Mr = [
  "A",
  "TABLE",
  "THEAD",
  "TBODY",
  "TFOOT",
  "TH",
  "TD",
  "IFRAME",
  "SCRIPT",
  "AUDIO",
  "VIDEO"
];
function Dp(e) {
  return Oi(e, Mr);
}
function zp(e) {
  return Ar(e, Mr);
}
function Oi(e, t) {
  return t.indexOf(e.nodeName) >= 0;
}
function Ar(e, t) {
  return e.getElementsByTagName && t.some(function(n) {
    return e.getElementsByTagName(n).length;
  });
}
var Ye = {};
Ye.paragraph = {
  filter: "p",
  replacement: function(e) {
    return `

` + e + `

`;
  }
};
Ye.lineBreak = {
  filter: "br",
  replacement: function(e, t, n) {
    return n.br + `
`;
  }
};
Ye.heading = {
  filter: ["h1", "h2", "h3", "h4", "h5", "h6"],
  replacement: function(e, t, n) {
    var o = Number(t.nodeName.charAt(1));
    if (n.headingStyle === "setext" && o < 3) {
      var i = gi(o === 1 ? "=" : "-", e.length);
      return `

` + e + `
` + i + `

`;
    } else
      return `

` + gi("#", o) + " " + e + `

`;
  }
};
Ye.blockquote = {
  filter: "blockquote",
  replacement: function(e) {
    return e = e.replace(/^\n+|\n+$/g, ""), e = e.replace(/^/gm, "> "), `

` + e + `

`;
  }
};
Ye.list = {
  filter: ["ul", "ol"],
  replacement: function(e, t) {
    var n = t.parentNode;
    return n.nodeName === "LI" && n.lastElementChild === t ? `
` + e : `

` + e + `

`;
  }
};
Ye.listItem = {
  filter: "li",
  replacement: function(e, t, n) {
    e = e.replace(/^\n+/, "").replace(/\n+$/, `
`).replace(/\n/gm, `
    `);
    var o = n.bulletListMarker + "   ", i = t.parentNode;
    if (i.nodeName === "OL") {
      var r = i.getAttribute("start"), s = Array.prototype.indexOf.call(i.children, t);
      o = (r ? Number(r) + s : s + 1) + ".  ";
    }
    return o + e + (t.nextSibling && !/\n$/.test(e) ? `
` : "");
  }
};
Ye.indentedCodeBlock = {
  filter: function(e, t) {
    return t.codeBlockStyle === "indented" && e.nodeName === "PRE" && e.firstChild && e.firstChild.nodeName === "CODE";
  },
  replacement: function(e, t, n) {
    return `

    ` + t.firstChild.textContent.replace(/\n/g, `
    `) + `

`;
  }
};
Ye.fencedCodeBlock = {
  filter: function(e, t) {
    return t.codeBlockStyle === "fenced" && e.nodeName === "PRE" && e.firstChild && e.firstChild.nodeName === "CODE";
  },
  replacement: function(e, t, n) {
    for (var o = t.firstChild.getAttribute("class") || "", i = (o.match(/language-(\S+)/) || [null, ""])[1], r = t.firstChild.textContent, s = n.fence.charAt(0), l = 3, a = new RegExp("^" + s + "{3,}", "gm"), u; u = a.exec(r); )
      u[0].length >= l && (l = u[0].length + 1);
    var g = gi(s, l);
    return `

` + g + i + `
` + r.replace(/\n$/, "") + `
` + g + `

`;
  }
};
Ye.horizontalRule = {
  filter: "hr",
  replacement: function(e, t, n) {
    return `

` + n.hr + `

`;
  }
};
Ye.inlineLink = {
  filter: function(e, t) {
    return t.linkStyle === "inlined" && e.nodeName === "A" && e.getAttribute("href");
  },
  replacement: function(e, t) {
    var n = t.getAttribute("href"), o = Mo(t.getAttribute("title"));
    return o && (o = ' "' + o + '"'), "[" + e + "](" + n + o + ")";
  }
};
Ye.referenceLink = {
  filter: function(e, t) {
    return t.linkStyle === "referenced" && e.nodeName === "A" && e.getAttribute("href");
  },
  replacement: function(e, t, n) {
    var o = t.getAttribute("href"), i = Mo(t.getAttribute("title"));
    i && (i = ' "' + i + '"');
    var r, s;
    switch (n.linkReferenceStyle) {
      case "collapsed":
        r = "[" + e + "][]", s = "[" + e + "]: " + o + i;
        break;
      case "shortcut":
        r = "[" + e + "]", s = "[" + e + "]: " + o + i;
        break;
      default:
        var l = this.references.length + 1;
        r = "[" + e + "][" + l + "]", s = "[" + l + "]: " + o + i;
    }
    return this.references.push(s), r;
  },
  references: [],
  append: function(e) {
    var t = "";
    return this.references.length && (t = `

` + this.references.join(`
`) + `

`, this.references = []), t;
  }
};
Ye.emphasis = {
  filter: ["em", "i"],
  replacement: function(e, t, n) {
    return e.trim() ? n.emDelimiter + e + n.emDelimiter : "";
  }
};
Ye.strong = {
  filter: ["strong", "b"],
  replacement: function(e, t, n) {
    return e.trim() ? n.strongDelimiter + e + n.strongDelimiter : "";
  }
};
Ye.code = {
  filter: function(e) {
    var t = e.previousSibling || e.nextSibling, n = e.parentNode.nodeName === "PRE" && !t;
    return e.nodeName === "CODE" && !n;
  },
  replacement: function(e) {
    if (!e)
      return "";
    e = e.replace(/\r?\n|\r/g, " ");
    for (var t = /^`|^ .*?[^ ].* $|`$/.test(e) ? " " : "", n = "`", o = e.match(/`+/gm) || []; o.indexOf(n) !== -1; )
      n = n + "`";
    return n + t + e + t + n;
  }
};
Ye.image = {
  filter: "img",
  replacement: function(e, t) {
    var n = Mo(t.getAttribute("alt")), o = t.getAttribute("src") || "", i = Mo(t.getAttribute("title")), r = i ? ' "' + i + '"' : "";
    return o ? "![" + n + "](" + o + r + ")" : "";
  }
};
function Mo(e) {
  return e ? e.replace(/(\n+\s*)+/g, `
`) : "";
}
function Nr(e) {
  this.options = e, this._keep = [], this._remove = [], this.blankRule = {
    replacement: e.blankReplacement
  }, this.keepReplacement = e.keepReplacement, this.defaultRule = {
    replacement: e.defaultReplacement
  }, this.array = [];
  for (var t in e.rules)
    this.array.push(e.rules[t]);
}
Nr.prototype = {
  add: function(e, t) {
    this.array.unshift(t);
  },
  keep: function(e) {
    this._keep.unshift({
      filter: e,
      replacement: this.keepReplacement
    });
  },
  remove: function(e) {
    this._remove.unshift({
      filter: e,
      replacement: function() {
        return "";
      }
    });
  },
  forNode: function(e) {
    if (e.isBlank)
      return this.blankRule;
    var t;
    return (t = Ho(this.array, e, this.options)) || (t = Ho(this._keep, e, this.options)) || (t = Ho(this._remove, e, this.options)) ? t : this.defaultRule;
  },
  forEach: function(e) {
    for (var t = 0; t < this.array.length; t++)
      e(this.array[t], t);
  }
};
function Ho(e, t, n) {
  for (var o = 0; o < e.length; o++) {
    var i = e[o];
    if (vp(i, t, n))
      return i;
  }
}
function vp(e, t, n) {
  var o = e.filter;
  if (typeof o == "string") {
    if (o === t.nodeName.toLowerCase())
      return !0;
  } else if (Array.isArray(o)) {
    if (o.indexOf(t.nodeName.toLowerCase()) > -1)
      return !0;
  } else if (typeof o == "function") {
    if (o.call(e, t, n))
      return !0;
  } else
    throw new TypeError("`filter` needs to be a string, array, or function");
}
function Tp(e) {
  var t = e.element, n = e.isBlock, o = e.isVoid, i = e.isPre || function(d) {
    return d.nodeName === "PRE";
  };
  if (!(!t.firstChild || i(t))) {
    for (var r = null, s = !1, l = null, a = fs(l, t, i); a !== t; ) {
      if (a.nodeType === 3 || a.nodeType === 4) {
        var u = a.data.replace(/[ \r\n\t]+/g, " ");
        if ((!r || / $/.test(r.data)) && !s && u[0] === " " && (u = u.substr(1)), !u) {
          a = Jo(a);
          continue;
        }
        a.data = u, r = a;
      } else if (a.nodeType === 1)
        n(a) || a.nodeName === "BR" ? (r && (r.data = r.data.replace(/ $/, "")), r = null, s = !1) : o(a) || i(a) ? (r = null, s = !0) : r && (s = !1);
      else {
        a = Jo(a);
        continue;
      }
      var g = fs(l, a, i);
      l = a, a = g;
    }
    r && (r.data = r.data.replace(/ $/, ""), r.data || Jo(r));
  }
}
function Jo(e) {
  var t = e.nextSibling || e.parentNode;
  return e.parentNode.removeChild(e), t;
}
function fs(e, t, n) {
  return e && e.parentNode === t || n(t) ? t.nextSibling || t.parentNode : t.firstChild || t.nextSibling || t.parentNode;
}
var br = typeof window < "u" ? window : {};
function kp() {
  var e = br.DOMParser, t = !1;
  try {
    new e().parseFromString("", "text/html") && (t = !0);
  } catch {
  }
  return t;
}
function jp() {
  var e = function() {
  };
  return Sp() ? e.prototype.parseFromString = function(t) {
    var n = new window.ActiveXObject("htmlfile");
    return n.designMode = "on", n.open(), n.write(t), n.close(), n;
  } : e.prototype.parseFromString = function(t) {
    var n = document.implementation.createHTMLDocument("");
    return n.open(), n.write(t), n.close(), n;
  }, e;
}
function Sp() {
  var e = !1;
  try {
    document.implementation.createHTMLDocument("").open();
  } catch {
    window.ActiveXObject && (e = !0);
  }
  return e;
}
var Lp = kp() ? br.DOMParser : jp();
function Ep(e, t) {
  var n;
  if (typeof e == "string") {
    var o = Op().parseFromString(
      // DOM parsers arrange elements in the <head> and <body>.
      // Wrapping in a custom element ensures elements are reliably arranged in
      // a single element.
      '<x-turndown id="turndown-root">' + e + "</x-turndown>",
      "text/html"
    );
    n = o.getElementById("turndown-root");
  } else
    n = e.cloneNode(!0);
  return Tp({
    element: n,
    isBlock: Ei,
    isVoid: Ir,
    isPre: t.preformattedCode ? xp : null
  }), n;
}
var Ko;
function Op() {
  return Ko = Ko || new Lp(), Ko;
}
function xp(e) {
  return e.nodeName === "PRE" || e.nodeName === "CODE";
}
function _p(e, t) {
  return e.isBlock = Ei(e), e.isCode = e.nodeName === "CODE" || e.parentNode.isCode, e.isBlank = Up(e), e.flankingWhitespace = Fp(e, t), e;
}
function Up(e) {
  return !Ir(e) && !Dp(e) && /^\s*$/i.test(e.textContent) && !wp(e) && !zp(e);
}
function Fp(e, t) {
  if (e.isBlock || t.preformattedCode && e.isCode)
    return { leading: "", trailing: "" };
  var n = $p(e.textContent);
  return n.leadingAscii && ys("left", e, t) && (n.leading = n.leadingNonAscii), n.trailingAscii && ys("right", e, t) && (n.trailing = n.trailingNonAscii), { leading: n.leading, trailing: n.trailing };
}
function $p(e) {
  var t = e.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
  return {
    leading: t[1],
    // whole string for whitespace-only strings
    leadingAscii: t[2],
    leadingNonAscii: t[3],
    trailing: t[4],
    // empty for whitespace-only strings
    trailingNonAscii: t[5],
    trailingAscii: t[6]
  };
}
function ys(e, t, n) {
  var o, i, r;
  return e === "left" ? (o = t.previousSibling, i = / $/) : (o = t.nextSibling, i = /^ /), o && (o.nodeType === 3 ? r = i.test(o.nodeValue) : n.preformattedCode && o.nodeName === "CODE" ? r = !1 : o.nodeType === 1 && !Ei(o) && (r = i.test(o.textContent))), r;
}
var Rp = Array.prototype.reduce, Vp = [
  [/\\/g, "\\\\"],
  [/\*/g, "\\*"],
  [/^-/g, "\\-"],
  [/^\+ /g, "\\+ "],
  [/^(=+)/g, "\\$1"],
  [/^(#{1,6}) /g, "\\$1 "],
  [/`/g, "\\`"],
  [/^~~~/g, "\\~~~"],
  [/\[/g, "\\["],
  [/\]/g, "\\]"],
  [/^>/g, "\\>"],
  [/_/g, "\\_"],
  [/^(\d+)\. /g, "$1\\. "]
];
function Ao(e) {
  if (!(this instanceof Ao))
    return new Ao(e);
  var t = {
    rules: Ye,
    headingStyle: "setext",
    hr: "* * *",
    bulletListMarker: "*",
    codeBlockStyle: "indented",
    fence: "```",
    emDelimiter: "_",
    strongDelimiter: "**",
    linkStyle: "inlined",
    linkReferenceStyle: "full",
    br: "  ",
    preformattedCode: !1,
    blankReplacement: function(n, o) {
      return o.isBlock ? `

` : "";
    },
    keepReplacement: function(n, o) {
      return o.isBlock ? `

` + o.outerHTML + `

` : o.outerHTML;
    },
    defaultReplacement: function(n, o) {
      return o.isBlock ? `

` + n + `

` : n;
    }
  };
  this.options = Ap({}, t, e), this.rules = new Nr(this.options);
}
Ao.prototype = {
  /**
   * The entry point for converting a string or DOM node to Markdown
   * @public
   * @param {String|HTMLElement} input The string or DOM node to convert
   * @returns A Markdown representation of the input
   * @type String
   */
  turndown: function(e) {
    if (!Qp(e))
      throw new TypeError(
        e + " is not a string, or an element/document/fragment node."
      );
    if (e === "")
      return "";
    var t = Cr.call(this, new Ep(e, this.options));
    return Bp.call(this, t);
  },
  /**
   * Add one or more plugins
   * @public
   * @param {Function|Array} plugin The plugin or array of plugins to add
   * @returns The Turndown instance for chaining
   * @type Object
   */
  use: function(e) {
    if (Array.isArray(e))
      for (var t = 0; t < e.length; t++)
        this.use(e[t]);
    else if (typeof e == "function")
      e(this);
    else
      throw new TypeError("plugin must be a Function or an Array of Functions");
    return this;
  },
  /**
   * Adds a rule
   * @public
   * @param {String} key The unique key of the rule
   * @param {Object} rule The rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  addRule: function(e, t) {
    return this.rules.add(e, t), this;
  },
  /**
   * Keep a node (as HTML) that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  keep: function(e) {
    return this.rules.keep(e), this;
  },
  /**
   * Remove a node that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  remove: function(e) {
    return this.rules.remove(e), this;
  },
  /**
   * Escapes Markdown syntax
   * @public
   * @param {String} string The string to escape
   * @returns A string with Markdown syntax escaped
   * @type String
   */
  escape: function(e) {
    return Vp.reduce(function(t, n) {
      return t.replace(n[0], n[1]);
    }, e);
  }
};
function Cr(e) {
  var t = this;
  return Rp.call(e.childNodes, function(n, o) {
    o = new _p(o, t.options);
    var i = "";
    return o.nodeType === 3 ? i = o.isCode ? o.nodeValue : t.escape(o.nodeValue) : o.nodeType === 1 && (i = Yp.call(t, o)), wr(n, i);
  }, "");
}
function Bp(e) {
  var t = this;
  return this.rules.forEach(function(n) {
    typeof n.append == "function" && (e = wr(e, n.append(t.options)));
  }), e.replace(/^[\t\r\n]+/, "").replace(/[\t\r\n\s]+$/, "");
}
function Yp(e) {
  var t = this.rules.forNode(e), n = Cr.call(this, e), o = e.flankingWhitespace;
  return (o.leading || o.trailing) && (n = n.trim()), o.leading + t.replacement(n, e, this.options) + o.trailing;
}
function wr(e, t) {
  var n = bp(e), o = Np(t), i = Math.max(e.length - n.length, t.length - o.length), r = `

`.substring(0, i);
  return n + r + o;
}
function Qp(e) {
  return e != null && (typeof e == "string" || e.nodeType && (e.nodeType === 1 || e.nodeType === 9 || e.nodeType === 11));
}
function Pp(e, t) {
  const n = e.getElementsByClassName("mayday-autofill")[0];
  if (n.nodeName === "TEXTAREA") {
    const r = new Ao().turndown(t);
    n.innerHTML = r;
  } else
    n.innerHTML = t;
}
const Is = (e) => e.includes("intercom") ? "INTERCOM" : e.includes("lightning.force.com") ? "SALESFORCE" : e.includes("dynamics.com") ? "DYNAMICS" : e.includes("service-now.com") ? "SERVICE_NOW" : e.includes("mail.google.com") ? "GMAIL" : e.includes("app.frontapp.com") ? "FRONT" : e.includes("ha.iadvize.com") ? "IADVIZE" : null, pi = {
  insert(e, t, n, o) {
    switch (Is(e)) {
      case "INTERCOM":
        gp(t, n);
        break;
      case "SALESFORCE":
        hs.insertAnswer(t, n, o);
        break;
      case "GMAIL":
        fp(t, n);
        break;
      case "FRONT":
        yp(t, n);
        break;
      case "IADVIZE":
        Ip(t, n);
        break;
      default:
        Pp(t, n);
        break;
    }
  },
  refreshTab(e, t) {
    switch (Is(e)) {
      case "SALESFORCE":
        hs.refreshCaseTab(t);
        break;
    }
  }
}, Gp = [
  [
    "intercom",
    /^https?:\/\/(?:www\.)?(?:app.intercom\.com|app.intercom\.io|app.eu.intercom\.com)(?:.*)\/(?:conversations|conversation)\/([0-9]{1,})/i
  ],
  [
    "salesforce",
    /^https?:\/\/(?:www\.)?(?:.*)(?:lightning.force.com)(?:.*)\/r\/Case\/(\w{1,})/i
  ]
], Zp = (e, t) => {
  if (t !== "salesforce")
    return null;
  const { hostname: n } = new URL(e);
  return window.btoa(JSON.stringify({ hostname: n }));
}, Wp = (e) => Gp.reduce(
  (t, n) => {
    const o = n[1].exec(e);
    return o ? {
      tabSource: n[0],
      conversationId: o[1],
      context: Zp(e, n[0])
    } : t;
  },
  {
    context: null,
    tabSource: null,
    conversationId: null
  }
), Hp = T({
  name: "DiagnosticNavigator",
  components: {
    DiagnosticNavigatorTitle: tp,
    ContentViewer: Si,
    DiagnosticNavigatorChildren: ip,
    SatisfactionModule: hr,
    EmptyEntity: ki
  },
  props: {
    source: {
      type: String,
      default: "main"
    },
    config: {
      type: Object,
      default: () => ({})
    },
    diagnosticTitle: {
      type: String
    },
    content: {
      type: Object,
      required: !0
    },
    children: {
      type: Array,
      default: () => []
    },
    parents: {
      type: Array,
      default: () => []
    },
    isFavorite: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      lightbox: !1,
      debounceHandleActionsMessage: Li(() => {
        this.handleActionsMessage();
      }, 200),
      loader: {
        knowledgeAction: !1
      }
    };
  },
  computed: {
    actions() {
      if (this.content && this.content.actions)
        return this.content.actions[0];
    },
    validActions() {
      if (!this.actions)
        return !1;
      const { id: e, payload: t } = this.actions;
      if (!["CUSTOM_MESSAGE", "ZENDESK_MESSAGE"].includes(e))
        return !1;
      const { message: n } = t;
      return !["", "<p></p>"].includes(n);
    },
    knowledgeAction() {
      var t, n;
      if (!((n = (t = this.content) == null ? void 0 : t.actions) != null && n.length))
        return null;
      const e = this.content.actions.find(
        (o) => ["salesforce.caseUpdate"].includes(o.id)
      );
      return e || null;
    },
    answerBody() {
      var e, t;
      return (t = (e = this.actions) == null ? void 0 : e.payload) == null ? void 0 : t.message;
    }
  },
  mounted() {
    this.source === "main" && this.debounceHandleActionsMessage();
  },
  methods: {
    handleActionsMessage(e = !0) {
      var s, l;
      if (!(this.actions && this.validActions))
        return;
      const { id: t, payload: n } = this.actions, { message: o } = n, i = window.location.href;
      if (e && this.config.manuallyTriggerActions || !e)
        return this.$emit("go-to-entity", {
          id: `${t}-${this.content.id}`,
          label: (s = this.content) == null ? void 0 : s.label,
          type: "Answer",
          body: o,
          actions: [{ id: t, payload: n }]
        });
      const r = this.config.salesForceFocusTab ? this.config.salesForceFocusTab.value : null;
      try {
        pi.insert(i, document, o, {
          tab: r
        });
      } catch {
        this.$emit("go-to-entity", {
          id: `${t}-${this.content.id}`,
          label: (l = this.content) == null ? void 0 : l.label,
          type: "Answer",
          body: o,
          actions: [{ id: t, payload: n }]
        });
      }
      return !0;
    },
    async handleKnowledgeActions() {
      if (this.loader.knowledgeAction = !0, !!this.knowledgeAction) {
        try {
          const e = window.location.href, t = Wp(e);
          await this.dispatchKnowledgeAction({
            actionId: this.knowledgeAction.id,
            contentId: this.content.id,
            context: t
          }), pi.refreshTab(e, document);
        } catch {
          this.loader.knowledgeAction = !1;
        }
        this.loader.knowledgeAction = !1;
      }
    },
    onClickInlineContent({
      targetContent: e,
      forceModal: t,
      newTab: n
    }) {
      this.$emit("go-to-entity", {
        ...e,
        deepLoading: !0,
        showBack: !0,
        forceModal: t,
        newTab: n,
        source: "inline"
      });
    },
    ...fe(le, ["dispatchKnowledgeAction"])
  },
  watch: {
    actions() {
      this.source === "main" && this.debounceHandleActionsMessage();
    }
  }
});
const Jp = { class: "container no-side-margin" }, Kp = {
  key: 2,
  class: "bg-blue/10 p-2 rounded my-2"
}, qp = { class: "text-base font-bold text-blue-9" }, Xp = { class: "mt-4" };
function em(e, t, n, o, i, r) {
  var I, z;
  const s = R("DiagnosticNavigatorTitle"), l = R("EmptyEntity"), a = R("ContentViewer"), u = P, g = ye, d = R("SatisfactionModule"), f = R("DiagnosticNavigatorChildren");
  return c(), p("div", Jp, [
    M(s, {
      content: e.content,
      "full-title-preference": e.config.displayFullTitle,
      "is-favorite": e.isFavorite,
      "onClick:back": t[0] || (t[0] = (v) => e.$emit("click:back"))
    }, null, 8, ["content", "full-title-preference", "is-favorite"]),
    !((I = e.content.body) != null && I.length) && !e.children.length ? (c(), C(l, {
      key: 0,
      type: "step",
      onClick: t[1] || (t[1] = (v) => e.$emit("click:back"))
    })) : (z = e.content.body) != null && z.length ? (c(), C(a, {
      key: 1,
      class: "my-2",
      "content-id": e.content.id,
      body: e.content.body,
      mentions: e.content.enrichedMentions,
      hash: e.content.hash,
      config: e.config,
      onOpenLightbox: t[2] || (t[2] = (v) => e.$emit("open-lightbox", v)),
      "onClick:inlineContent": t[3] || (t[3] = (v) => e.onClickInlineContent({ targetContent: v })),
      "onClick:inlineContentModal": t[4] || (t[4] = (v) => e.onClickInlineContent({ targetContent: v, forceModal: !0 })),
      "onClick:inlineContentTab": t[5] || (t[5] = (v) => e.onClickInlineContent({ targetContent: v, newTab: !0 })),
      onGoToEntity: t[6] || (t[6] = (v) => e.$emit("go-to-entity", v))
    }, null, 8, ["content-id", "body", "mentions", "hash", "config"])) : A("", !0),
    e.validActions && e.config.hostApp === "agent-client" ? (c(), p("div", Kp, [
      m("div", qp, N(e.$t("knowledge.answer")), 1),
      M(a, {
        "content-id": e.content.id,
        body: e.answerBody,
        mentions: [],
        config: e.config,
        onOpenLightbox: t[7] || (t[7] = (v) => e.$emit("open-lightbox", v)),
        onGoToEntity: t[8] || (t[8] = (v) => e.$emit("go-to-entity", v))
      }, null, 8, ["content-id", "body", "config"])
    ])) : A("", !0),
    e.validActions && !(e.config.hostApp === "agent-client" && e.config.isMobile) ? (c(), C(g, {
      key: 3,
      type: "custom-secondary",
      outline: "",
      onClick: t[9] || (t[9] = (v) => e.handleActionsMessage(!1))
    }, {
      default: _(() => [
        M(u, {
          icon: ["fas", "message"],
          class: "icon-spinner mr-1"
        }),
        m("span", null, N(e.$t("knowledge.actions.answer")), 1)
      ]),
      _: 1
    })) : A("", !0),
    e.knowledgeAction ? (c(), C(g, {
      key: 4,
      type: "custom-secondary",
      onClick: e.handleKnowledgeActions
    }, {
      default: _(() => [
        e.loader.knowledgeAction ? (c(), C(u, {
          key: 0,
          icon: ["fas", "spinner-third"],
          class: "icon-spinner mr-1",
          spin: ""
        })) : (c(), C(u, {
          key: 1,
          icon: ["fab", "salesforce"],
          class: "icon-spinner mr-1"
        })),
        ne(" " + N(e.$t("knowledge.actions.salesforce-case")), 1)
      ]),
      _: 1
    }, 8, ["onClick"])) : A("", !0),
    m("div", Xp, [
      !e.children.length && e.content.type !== "Answer" ? (c(), C(d, {
        key: 0,
        "content-id": e.content.id,
        onChoice: t[10] || (t[10] = (v) => e.$emit("satisfaction", { thumbType: v, content: e.parents[0] })),
        "onClick:feedback": t[11] || (t[11] = (v) => e.$emit("go-to-feedback", { source: "satisfaction_module" }))
      }, null, 8, ["content-id"])) : A("", !0)
    ]),
    e.children.length ? (c(), C(f, {
      key: 5,
      class: "mt-4",
      children: e.children,
      "onClick:child": t[12] || (t[12] = (v) => e.$emit("focus-child", v))
    }, null, 8, ["children"])) : A("", !0)
  ]);
}
const tm = /* @__PURE__ */ x(Hp, [["render", em], ["__scopeId", "data-v-56940818"]]), nm = { class: "px-2 rounded-full bg-gray-6 pointer-events-none" }, om = { class: "flex items-center justify-center gap-2 relative pointer-events-auto" }, im = {
  key: 0,
  class: "absolute z-20 shadow px-2 py-1 text-2xs bg-gray-9 text-white top-[-24px] rounded whitespace-nowrap"
}, sm = /* @__PURE__ */ T({
  __name: "ActionsBar",
  props: {
    isFavorite: {
      type: Boolean,
      default: !1
    },
    options: {
      type: Object,
      default: () => ({
        copyBody: !0,
        copyLink: !0,
        favorite: !0,
        feedback: !0,
        answer: !1,
        openInWeb: !0
      })
    }
  },
  emits: [
    "copy-body",
    "copy-link",
    "answer",
    "toggle-favorite",
    "go-to-feedback",
    "open-in-web"
  ],
  setup(e, { expose: t, emit: n }) {
    const o = e;
    let i = Y(""), r = Y(null);
    const s = {
      "copy-body": "knowledge.actions.copy-body",
      "copy-link": "knowledge.actions.copy-link",
      answer: "knowledge.actions.answer",
      "favorite-add": "knowledge.actions.favorite-add",
      "favorite-remove": "knowledge.actions.favorite-remove",
      "go-to-feedback": "knowledge.actions.go-to-feedback",
      "open-in-web": "knowledge.actions.open-in-web"
    }, l = [
      "intercom",
      "lightning.force.com",
      "dynamics.com",
      "service-now.com",
      "mail.google.com",
      "app.frontapp.com",
      "ha.iadvize.com"
    ], a = k(() => r.value ? r.value === "favorite" ? s[`${r.value}-${o.isFavorite ? "remove" : "add"}`] : s[r.value] : ""), u = k(() => {
      const f = window.location.hostname;
      for (const I of l)
        if (f.includes(I))
          return !0;
      return !1;
    }), g = (f) => {
      r.value = f;
    }, d = (f, I = "CTA") => {
      i.value = f, n(f, I), setTimeout(() => {
        i.value = "";
      }, 1e3);
    };
    return t({ handleAction: d }), (f, I) => {
      const z = P;
      return c(), p("div", nm, [
        m("div", om, [
          M(Xe, { name: "fade" }, {
            default: _(() => [
              h(r) ? (c(), p("div", im, N(f.$t(h(a))), 1)) : A("", !0)
            ]),
            _: 1
          }),
          e.options.copyBody ? (c(), C(z, {
            key: 0,
            icon: ["fas", h(i) !== "copy-body" ? "copy" : "check"],
            class: "h-9 w-9 !flex items-center justify-center text-white cursor-pointer",
            onMouseenter: I[0] || (I[0] = (v) => g("copy-body")),
            onMouseleave: I[1] || (I[1] = (v) => g(null)),
            onClick: I[2] || (I[2] = (v) => d("copy-body"))
          }, null, 8, ["icon"])) : A("", !0),
          e.options.copyLink ? (c(), C(z, {
            key: 1,
            icon: ["fas", h(i) !== "copy-link" ? "link" : "check"],
            class: "h-9 w-9 !flex items-center justify-center text-white cursor-pointer",
            onMouseenter: I[3] || (I[3] = (v) => g("copy-link")),
            onMouseleave: I[4] || (I[4] = (v) => g(null)),
            onClick: I[5] || (I[5] = (v) => d("copy-link"))
          }, null, 8, ["icon"])) : A("", !0),
          e.options.openInWeb ? (c(), C(z, {
            key: 2,
            icon: ["fas", "arrow-up-right-from-square"],
            class: "h-9 w-9 !flex items-center justify-center text-white cursor-pointer",
            onMouseenter: I[6] || (I[6] = (v) => g("open-in-web")),
            onMouseleave: I[7] || (I[7] = (v) => g(null)),
            onClick: I[8] || (I[8] = (v) => n("open-in-web"))
          })) : A("", !0),
          e.options.answer && h(u) ? (c(), C(z, {
            key: 3,
            icon: ["fas", h(i) !== "answer" ? "rocket-launch" : "check"],
            class: "h-9 w-9 !flex items-center justify-center text-white cursor-pointer",
            onMouseenter: I[9] || (I[9] = (v) => g("answer")),
            onMouseleave: I[10] || (I[10] = (v) => g(null)),
            onClick: I[11] || (I[11] = (v) => d("answer"))
          }, null, 8, ["icon"])) : A("", !0),
          e.options.favorite ? (c(), C(z, {
            key: 4,
            icon: [e.isFavorite ? "fas" : "far", "star"],
            class: "h-9 w-9 !flex items-center justify-center text-white cursor-pointer",
            onMouseenter: I[12] || (I[12] = (v) => g("favorite")),
            onMouseleave: I[13] || (I[13] = (v) => g(null)),
            onClick: I[14] || (I[14] = (v) => n("toggle-favorite"))
          }, null, 8, ["icon"])) : A("", !0),
          e.options.feedback ? (c(), C(z, {
            key: 5,
            icon: ["fas", "megaphone"],
            class: "h-9 w-9 !flex items-center justify-center text-white cursor-pointer",
            onMouseenter: I[15] || (I[15] = (v) => g("go-to-feedback")),
            onMouseleave: I[16] || (I[16] = (v) => g(null)),
            onClick: I[17] || (I[17] = (v) => n("go-to-feedback"))
          })) : A("", !0)
        ])
      ]);
    };
  }
}), rm = { class: "flex gap-2 relative" }, am = {
  key: 1,
  class: "text-lg font-bold whitespace-pre-wrap [word-break:break-word] mt-1"
}, lm = /* @__PURE__ */ T({
  __name: "ArticleTitle",
  props: {
    label: {
      type: String,
      required: !0
    },
    isAnswer: {
      type: Boolean,
      default: !1
    },
    isFavorite: {
      type: Boolean,
      default: !1
    },
    fullTitlePreference: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => {
      const o = ln, i = Le;
      return c(), p("div", rm, [
        e.isAnswer ? A("", !0) : (c(), C(o, {
          key: 0,
          type: "Article",
          isFavorite: e.isFavorite
        }, null, 8, ["isFavorite"])),
        e.fullTitlePreference ? (c(), p("span", am, N(e.label), 1)) : (c(), C(i, {
          key: 2,
          class: "text-lg font-bold mt-1",
          text: e.label
        }, null, 8, ["text"]))
      ]);
    };
  }
}), cm = { class: "flex items-center gap-2 mb-6" }, um = { class: "space-y-2" }, dm = /* @__PURE__ */ T({
  __name: "ContentWrapperSkeleton",
  setup(e) {
    return (t, n) => (c(), p("div", null, [
      m("div", cm, [
        M(Se, { class: "w-[15px] h-4.5" }),
        M(Se, { class: "h-4.5 w-1/2" })
      ]),
      m("div", um, [
        M(Se, { class: "h-5 w-2/3 !mb-4" }),
        M(Se, { class: "h-3 w-full" }),
        M(Se, { class: "h-3 w-full" }),
        M(Se, { class: "h-3 w-full" }),
        M(Se, { class: "h-3 w-1/2 !mb-10" }),
        M(Se, { class: "h-4 w-3/4 !mb-4" }),
        M(Se, { class: "h-3 w-full" }),
        M(Se, { class: "h-3 w-full" }),
        M(Se, { class: "h-3 w-2/3 !mb-10" }),
        M(Se, { class: "h-3 w-full" }),
        M(Se, { class: "h-3 w-full" }),
        M(Se, { class: "h-3 w-2/3" })
      ])
    ]));
  }
}), gm = (e, t, n) => {
  let o;
  e.selection ? (o = e.body.createTextRange(), o.moveToElementText(n), o.select()) : t.getSelection && (o = e.createRange(), o.selectNode(n), t.getSelection().removeAllRanges(), t.getSelection().addRange(o));
};
function pm(e, t, n) {
  gm(e, t, n), e.execCommand("copy"), t.getSelection ? t.getSelection().removeAllRanges() : e.selection && e.selection.empty();
}
function mm(e) {
  return { copyBody: (o = "main") => {
    const i = ji(e), r = i == null ? void 0 : i.getElementById(`${o}-content`), s = r == null ? void 0 : r.getElementsByClassName("me-content-viewer");
    return s ? (pm(document, window, s[0]), !0) : !1;
  }, copyLink: (o, i, r, s) => {
    const l = s ? `/step/${s}` : "", a = new URL(`/web/${r}/content/${o}${l}`, i).href;
    return navigator.clipboard.writeText(a), !0;
  } };
}
const hm = T({
  name: "ContentWrapper",
  components: {
    ContentViewer: Si,
    DiagnosticNavigator: tm,
    SatisfactionModule: hr,
    ActionsBar: sm,
    ArticleTitle: lm,
    ContentWrapperSkeleton: dm
  },
  emits: [
    "go-to-entity",
    "show-zoom",
    "open-lightbox",
    "toggle-favorite",
    "go-to-feedback",
    "update-content-parents",
    "update-path-with-content",
    "update-path",
    "close-modal",
    "open-in-web"
  ],
  setup(e) {
    const { copyBody: t, copyLink: n } = mm(e.config.hostApp);
    return {
      copyBody: t,
      copyLink: n
    };
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    lang: {
      type: String,
      required: !1
    },
    itemIsFavorite: {
      type: Function,
      default: () => !1
    },
    path: {
      type: Array,
      default: () => []
    },
    contentParents: {
      type: Array,
      default: () => []
    },
    content: {
      type: Object,
      default: () => {
      }
    },
    contentChildren: {
      type: Array,
      default: () => []
    },
    contentSiblings: {
      type: Array,
      default: () => []
    },
    showActions: {
      type: Boolean,
      default: !0
    },
    loadingState: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    displayedLanguage() {
      return this.lang || this.selectedLanguage;
    },
    source() {
      return this.$attrs.id.split("-")[0] || "main";
    },
    articleIsFocused() {
      var e;
      return ((e = this.content) == null ? void 0 : e.type) === "Article";
    },
    answerIsFocused() {
      var e;
      return ((e = this.content) == null ? void 0 : e.type) === "Answer";
    },
    diagnosticIsFocused() {
      return this.content ? ["Diagnostic", "Step", "keyStep"].includes(this.content.type) : !1;
    },
    diagnosticTitle() {
      return this.contentParents.length ? this.contentParents[0].label : "";
    },
    activatedActions() {
      const e = {
        copyBody: !0,
        copyLink: !0,
        favorite: !0,
        feedback: !0,
        answer: !0,
        openInWeb: !this.isAgentClient
      }, t = {
        copyLink: !1,
        favorite: !1,
        openInWeb: !1
      };
      return {
        ...e,
        ...this.answerIsFocused ? t : {}
      };
    },
    isAgentClient() {
      return this.config.hostApp === "agent-client";
    },
    hasSummary() {
      return this.content.summary && this.content.summary.isVisible && this.content.summary.body && this.content.summary.body.length || this.content.shortSummary && this.content.shortSummary.isVisible && this.content.shortSummary.body && this.content.shortSummary.body.length;
    },
    hasActionItems() {
      return this.content.actionItems && this.content.actionItems.isVisible && this.content.actionItems.body && this.content.actionItems.body.length;
    },
    summary() {
      if (this.content.summary && this.content.summary.isVisible)
        return this.content.summary;
      if (this.content.shortSummary && this.content.shortSummary.isVisible)
        return this.content.shortSummary;
    },
    actionItems() {
      if (this.hasActionItems)
        return this.content.actionItems;
    },
    headerCover() {
      return this.content.cover ? { "--header-cover": `url('${this.content.cover}')` } : {};
    },
    ...ue(le, ["selectedLanguage"])
  },
  mounted() {
    document.addEventListener("keydown", this.keyboardCommands);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.keyboardCommands);
  },
  methods: {
    getCopyEvent(e, t, n) {
      const { id: o, label: i, type: r } = e;
      return {
        copy: {
          type: t,
          method: n
        },
        content: { id: o, label: i, type: r }
      };
    },
    handleCopy(e, t, n = !1) {
      var s;
      let o = this.content.id, i;
      if (this.content.ancestors && this.content.ancestors.length && (i = o, o = (s = this.content.ancestors[0]) == null ? void 0 : s.split("/")[0]), e === "BODY" ? this.copyBody(this.source) : this.copyLink(o, this.config.subdomainUrl, this.displayedLanguage, i)) {
        n || this.notify(
          e === "BODY" ? "knowledge.notification.copy-body" : "knowledge.notification.copy-link"
        );
        const l = this.getCopyEvent(this.content, e, t);
        this.logs({ topic: "CONTENT_COPY", event: l, url: window.location.href });
      }
    },
    keyboardCommands(e) {
      var t;
      if (e.stopPropagation(), this.config.copyCommandEnable && e.key === "c" && (e.ctrlKey || e.metaKey) && ((t = window.getSelection()) != null && t.toString() ? this.handleCopy("BODY", "SHORTCUT", !0) : this.$refs.refActionsBar.handleAction("copy-body", "SHORTCUT")), this.config && this.config.hasModalClosureShortcut && this.source === "modal" && e.key === "Escape")
        return this.closeModal();
    },
    appearDiagnosticStep(e, t = !1) {
      if (e.redirection) {
        const { entityId: o, entityType: i } = e.redirection;
        return this.$emit("go-to-entity", {
          id: o,
          type: i,
          deepLoading: i !== "Article",
          showBack: !0
        });
      }
      t && this.updatePathWithEntity(e), this.updateParents(
        this.contentParents.concat([{ ...e, children: this.contentChildren }])
      );
      const n = {
        id: e.id,
        type: "Step"
      };
      this.$emit("go-to-entity", n);
    },
    backDiagnosticStep() {
      var n;
      const e = this.contentParents.slice(0, -1);
      this.updateParents(e);
      const t = {
        id: (n = e.at(-1)) == null ? void 0 : n.id,
        type: "Diagnostic"
      };
      this.$emit("go-to-entity", t);
    },
    onClickInlineContent({
      targetContent: e,
      forceModal: t,
      newTab: n
    }) {
      this.$emit("go-to-entity", {
        ...e,
        deepLoading: !0,
        showBack: !0,
        forceModal: t,
        newTab: n,
        source: "inline"
      });
    },
    updateParents(e) {
      this.$emit("update-content-parents", e);
    },
    updatePathWithEntity(e) {
      this.$emit("update-path-with-content", e);
    },
    handleActionsMessage() {
      const { id: e, payload: t } = this.content.actions[0];
      if (!["CUSTOM_MESSAGE", "ZENDESK_MESSAGE"].includes(e))
        return this.closeModal();
      const { message: n } = t;
      if (["", "<p></p>"].includes(n))
        return this.closeModal();
      const o = window.location.href, i = this.config.companyPreferences.find(
        ({ type: s }) => s === "WEB_EXT_SALESFORCE_FOCUS_TAB"
      ), r = i ? i.value : null;
      try {
        pi.insert(o, document, n, {
          tab: r
        });
      } catch {
        return this.closeModal();
      }
      return this.closeModal();
    },
    async handleOnSatisfaction({ thumbType: e, content: t }) {
      const { id: n, knowledgeId: o, type: i } = t, r = {
        content: {
          id: n,
          knowledgeId: o,
          type: i
        },
        satisfaction: e,
        lang: this.displayedLanguage
      };
      await this.addContentSatisfactionMark({
        contentId: this.content.id,
        thumbType: e,
        lang: this.displayedLanguage
      }), this.logs(
        {
          topic: "CONTENT_SATISFACTION",
          event: r
        },
        !0
      ), this.notify("knowledge.notification.satisfaction");
    },
    closeModal() {
      this.$emit("close-modal");
    },
    ...fe(le, [
      "addContentSatisfactionMark",
      "getParentEntity",
      "setAnswerModal",
      "logs",
      "notify"
    ])
  }
});
const fm = { class: "mb-16" }, ym = {
  key: 0,
  class: "mb-4 header-cover-expand"
}, Im = { key: 3 }, Mm = { class: "mt-4" }, Am = { class: "flex justify-center" };
function Nm(e, t, n, o, i, r) {
  const s = R("ContentWrapperSkeleton"), l = R("DiagnosticNavigator"), a = R("ArticleTitle"), u = R("ContentViewer"), g = R("SatisfactionModule"), d = R("ActionsBar");
  return c(), p("div", null, [
    m("div", fm, [
      !e.loadingState && e.content.cover ? (c(), p("div", ym, [
        m("div", {
          class: "header-cover",
          style: Ce(e.headerCover)
        }, null, 4)
      ])) : A("", !0),
      e.loadingState ? (c(), C(s, { key: 1 })) : e.diagnosticIsFocused ? (c(), C(l, {
        key: 2,
        source: e.source,
        children: e.contentChildren,
        config: e.config,
        content: e.content,
        "diagnostic-title": e.diagnosticTitle,
        parents: e.contentParents,
        "is-favorite": e.itemIsFavorite(e.content.id, e.displayedLanguage),
        lang: e.displayedLanguage,
        onFocusChild: e.appearDiagnosticStep,
        onZoom: t[0] || (t[0] = (f) => e.$emit("show-zoom", f)),
        onGoToEntity: t[1] || (t[1] = (f) => e.$emit("go-to-entity", f)),
        onOpenLightbox: t[2] || (t[2] = (f) => e.$emit("open-lightbox", f)),
        onGoToFeedback: t[3] || (t[3] = (f) => e.$emit("go-to-feedback", { ...f, lang: e.displayedLanguage })),
        onSatisfaction: e.handleOnSatisfaction,
        "onClick:back": e.backDiagnosticStep
      }, null, 8, ["source", "children", "config", "content", "diagnostic-title", "parents", "is-favorite", "lang", "onFocusChild", "onSatisfaction", "onClick:back"])) : e.articleIsFocused || e.answerIsFocused ? (c(), p("div", Im, [
        M(a, {
          class: "mb-6",
          label: e.content.label,
          "is-answer": e.answerIsFocused,
          "is-favorite": e.itemIsFavorite(e.content.id, e.displayedLanguage),
          "full-title-preference": e.config.displayFullTitle
        }, null, 8, ["label", "is-answer", "is-favorite", "full-title-preference"]),
        M(u, {
          "content-id": e.content.id,
          body: e.content.body,
          mentions: e.content.enrichedMentions,
          hash: e.content.hash,
          config: e.config,
          lang: e.displayedLanguage,
          "onClick:inlineContent": t[4] || (t[4] = (f) => e.onClickInlineContent({ targetContent: f })),
          "onClick:inlineContentModal": t[5] || (t[5] = (f) => e.onClickInlineContent({ targetContent: f, forceModal: !0 })),
          "onClick:inlineContentTab": t[6] || (t[6] = (f) => e.onClickInlineContent({ targetContent: f, newTab: !0 })),
          onGoToEntity: t[7] || (t[7] = (f) => e.$emit("go-to-entity", f)),
          onOpenLightbox: t[8] || (t[8] = (f) => e.$emit("open-lightbox", f))
        }, null, 8, ["content-id", "body", "mentions", "hash", "config", "lang"]),
        m("div", Mm, [
          M(g, {
            "content-id": e.content.id,
            onChoice: t[9] || (t[9] = (f) => e.handleOnSatisfaction({ thumbType: f, content: e.content })),
            "onClick:feedback": t[10] || (t[10] = (f) => e.$emit("go-to-feedback", { source: "satisfaction_module" }))
          }, null, 8, ["content-id"])
        ])
      ])) : A("", !0)
    ]),
    e.showActions ? (c(), p("div", {
      key: 0,
      class: D(["absolute left-0 right-0 z-10", [
        {
          "bottom-[80px]": e.config.isMobile && e.config.hostApp !== "agent-client",
          "bottom-[40px]": e.config.isMobile && e.config.hostApp === "agent-client" && e.source !== "modal",
          "bottom-[44px]": !e.config.isMobile && e.config.hostApp === "agent-client" && e.source !== "modal",
          "bottom-[15px]": !e.config.isMobile && e.config.hostApp !== "agent-client" || e.config.hostApp === "agent-client" && e.source === "modal"
        }
      ]])
    }, [
      m("div", Am, [
        M(d, {
          ref: "refActionsBar",
          "is-favorite": e.itemIsFavorite(e.content.id, e.displayedLanguage),
          options: e.activatedActions,
          onCopyBody: t[11] || (t[11] = (f) => e.handleCopy("BODY", f)),
          onCopyLink: t[12] || (t[12] = (f) => e.handleCopy("URL", f)),
          onToggleFavorite: t[13] || (t[13] = (f) => e.$emit("toggle-favorite", e.content.id)),
          onGoToFeedback: t[14] || (t[14] = (f) => e.$emit("go-to-feedback", { source: "action_bar" })),
          onOpenInWeb: t[15] || (t[15] = (f) => {
            var I;
            return e.$emit("open-in-web", {
              entityId: e.content.id,
              entityType: e.content.type,
              entityAncestors: (I = e.content.ancestors) == null ? void 0 : I[0]
            });
          }),
          onAnswer: e.handleActionsMessage
        }, null, 8, ["is-favorite", "options", "onAnswer"])
      ])
    ], 2)) : A("", !0)
  ]);
}
const Dr = /* @__PURE__ */ x(hm, [["render", Nm]]), bm = ["Article", "Diagnostic", "Step", "keyStep", "Answer"], Cm = T({
  name: "MainContentWrapper",
  components: {
    ContentWrapper: Dr
  },
  emits: [
    "go-to-entity",
    "show-zoom",
    "open-lightbox",
    "toggle-favorite",
    "go-to-feedback",
    "open-in-web",
    "empty-view"
  ],
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    itemIsFavorite: {
      type: Function,
      default: () => !1
    },
    modalIsOpen: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      contentTypes: bm
    };
  },
  computed: {
    copyCommandEnable() {
      return !this.config || this.modalIsOpen ? !1 : this.mainContent.type !== "Article" && this.config.hasAnswerCopyPasteShortcut || this.mainContent.type === "Article" && this.config.hasArticleCopyPasteShortcut;
    },
    ...ue(le, [
      "path",
      "contentParents",
      "mainContent",
      "mainContentChildren",
      "contentSiblings",
      "appIsLoading",
      "mainIsLoading"
    ])
  },
  methods: {
    addContentToPath(e) {
      this.updatePath(this.path.concat([e]));
    },
    ...fe(le, ["updateContentParents", "updatePath"])
  }
});
function wm(e, t, n, o, i, r) {
  const s = _n, l = R("ContentWrapper");
  return !e.contentTypes.includes(e.mainContent.type) && !e.appIsLoading ? (c(), C(s, {
    key: 0,
    class: "h-full justify-center text-center",
    illustrationType: "filtered-notifications",
    title: e.$t("knowledge.empty-state.title"),
    "action-cta-label": e.$t("knowledge.empty-state.cta"),
    onAction: t[0] || (t[0] = (a) => e.$emit("empty-view"))
  }, null, 8, ["title", "action-cta-label"])) : (c(), C(l, {
    key: 1,
    id: "main-content",
    config: { ...e.config, copyCommandEnable: e.copyCommandEnable },
    "item-is-favorite": e.itemIsFavorite,
    path: e.path,
    content: e.mainContent,
    contentParents: e.contentParents,
    contentChildren: e.mainContentChildren,
    contentSiblings: e.contentSiblings,
    "show-actions": !e.modalIsOpen,
    "loading-state": e.mainIsLoading,
    onGoToEntity: t[1] || (t[1] = (a) => e.$emit("go-to-entity", a)),
    onToggleFavorite: t[2] || (t[2] = (a) => e.$emit("toggle-favorite", a)),
    onGoToFeedback: t[3] || (t[3] = (a) => e.$emit("go-to-feedback", a)),
    onOpenInWeb: t[4] || (t[4] = (a) => e.$emit("open-in-web", a)),
    onOpenLightbox: t[5] || (t[5] = (a) => e.$emit("open-lightbox", a)),
    onUpdateContentParents: e.updateContentParents,
    onUpdatePathWithContent: e.addContentToPath,
    onUpdatePath: e.updatePath
  }, null, 8, ["config", "item-is-favorite", "path", "content", "contentParents", "contentChildren", "contentSiblings", "show-actions", "loading-state", "onUpdateContentParents", "onUpdatePathWithContent", "onUpdatePath"]));
}
const Dm = /* @__PURE__ */ x(Cm, [["render", wm]]), zm = T({
  name: "ModalContentWrapper",
  components: {
    ContentWrapper: Dr
  },
  emits: [
    "go-to-entity",
    "show-zoom",
    "open-lightbox",
    "toggle-favorite",
    "go-to-feedback",
    "open-in-web",
    "close-modal"
  ],
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    itemIsFavorite: {
      type: Function,
      default: () => !1
    },
    // Modal can have a different language than the focus one (for example open content in favorites)
    // This props is used to display favorite status
    lang: {
      type: String,
      required: !1
    }
  },
  computed: {
    copyCommandEnable() {
      return this.config ? this.modalContent.type !== "Article" && this.config.hasAnswerCopyPasteShortcut || this.modalContent.type === "Article" && this.config.hasArticleCopyPasteShortcut : !1;
    },
    ...ue(le, [
      "modalPath",
      "modalContentParents",
      "modalContent",
      "modalContentChildren",
      "modalContentSiblings",
      "modalIsLoading",
      "selectedLanguage",
      "modalIsError"
    ])
  },
  methods: {
    addContentToPath(e) {
      this.updateModalPath(this.modalPath.concat([e]));
    },
    ...fe(le, ["updateModalContentParents", "updateModalPath"])
  }
});
function vm(e, t, n, o, i, r) {
  const s = _n, l = R("ContentWrapper");
  return e.modalIsError && !e.modalIsLoading ? (c(), C(s, {
    key: 0,
    class: "h-full justify-center text-center",
    illustrationType: "filtered-notifications",
    title: e.$t("knowledge.empty-state.no-content"),
    "action-cta-label": e.$t("knowledge.empty-state.cta-close"),
    onAction: t[0] || (t[0] = (a) => e.$emit("close-modal"))
  }, null, 8, ["title", "action-cta-label"])) : (c(), C(l, {
    key: 1,
    id: "modal-content",
    config: { ...e.config, copyCommandEnable: e.copyCommandEnable },
    "item-is-favorite": e.itemIsFavorite,
    path: e.modalPath,
    content: e.modalContent,
    lang: e.lang,
    contentParents: e.modalContentParents,
    contentChildren: e.modalContentChildren,
    contentSiblings: e.modalContentSiblings,
    "loading-state": e.modalIsLoading,
    onGoToEntity: t[1] || (t[1] = (a) => e.$emit("go-to-entity", a)),
    onToggleFavorite: t[2] || (t[2] = (a) => e.$emit("toggle-favorite", a)),
    onGoToFeedback: t[3] || (t[3] = (a) => e.$emit("go-to-feedback", a)),
    onOpenInWeb: t[4] || (t[4] = (a) => e.$emit("open-in-web", a)),
    onCloseModal: t[5] || (t[5] = (a) => e.$emit("close-modal")),
    onOpenLightbox: t[6] || (t[6] = (a) => e.$emit("open-lightbox", a)),
    onUpdateContentParents: e.updateModalContentParents,
    onUpdatePathWithContent: e.addContentToPath,
    onUpdatePath: e.updateModalPath
  }, null, 8, ["config", "item-is-favorite", "path", "content", "lang", "contentParents", "contentChildren", "contentSiblings", "loading-state", "onUpdateContentParents", "onUpdatePathWithContent", "onUpdatePath"]));
}
const Tm = /* @__PURE__ */ x(zm, [["render", vm]]), km = T({
  name: "PanelCollectionWrapper",
  components: {
    KnowledgeDropdown: ko,
    LanguageSwitcher: jo,
    EntityItem: Un,
    EmptyEntity: ki,
    EntityItemSkeleton: cn
  },
  emits: ["go-to-entity", "toggle-favorite", "copy-link", "change-language"],
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    itemIsFavorite: {
      type: Function,
      default: () => !1
    }
  },
  data() {
    return {
      hovered: -1
    };
  },
  computed: {
    entityOptions() {
      return {
        copy: !0,
        open: this.config.hostApp === "chrome-extension",
        overview: this.config.hostApp === "agent-client"
      };
    },
    ...ue(le, [
      "modalPath",
      "panelContent",
      "modalIsLoading",
      "panelContentChildren",
      "modalContentParents",
      "panelCollectionIsEmpty",
      "selectedLanguage"
    ])
  },
  methods: {
    onHover(e) {
      this.hovered = e;
    },
    castEntities(e) {
      return e;
    },
    handleClickOnEntity(e) {
      const { type: t, label: n, id: o } = e;
      if (t === "Case" || t === "Article") {
        const i = {
          id: o,
          type: t,
          label: n
        };
        return this.updateModalPathWithChildEntity(i), this.$emit("go-to-entity", e);
      }
      this.appearDiagnosticStep(e, !0);
    },
    appearDiagnosticStep(e, t = !1) {
      if (e.redirection) {
        const { entityId: o, entityType: i } = e.redirection;
        return this.$emit("go-to-entity", { id: o, type: i, deepLoading: !0, showBack: !0 });
      }
      t && this.updateModalPathWithChildEntity(e), this.updateModalContentParents(
        this.modalContentParents.concat([{ ...e, children: this.panelContentChildren }])
      );
      const n = {
        id: e.id,
        type: "Step"
      };
      this.$emit("go-to-entity", n);
    },
    async reachParentEntity(e) {
      const t = await this.getParentEntity(
        e,
        this.panelContent.knowledgeId,
        this.modalPath
      );
      this.updateModalPath(this.modalPath.slice(0, e + 1)), this.$emit("go-to-entity", t);
    },
    ...fe(le, [
      "updateModalContentParents",
      "updateModalPath",
      "updateModalPathWithChildEntity",
      "getParentEntity"
    ])
  }
});
const jm = { class: "w-full" }, Sm = {
  key: 0,
  class: "space-y-2"
}, Lm = { key: 1 }, Em = { class: "relative md:hidden mb-4 flex items-center gap-2" }, Om = {
  key: 1,
  class: "space-y-2"
};
function xm(e, t, n, o, i, r) {
  const s = cn, l = R("KnowledgeDropdown"), a = R("LanguageSwitcher"), u = R("EmptyEntity"), g = Un;
  return c(), p("div", jm, [
    e.modalIsLoading ? (c(), p("div", Sm, [
      (c(), p(X, null, te(7, (d) => M(s, {
        key: d,
        index: d
      }, null, 8, ["index"])), 64))
    ])) : (c(), p("div", Lm, [
      m("div", Em, [
        M(l, {
          class: "w-full",
          onGoToEntity: t[0] || (t[0] = (d) => e.$emit("go-to-entity", d)),
          altStyle: ""
        }),
        M(a, {
          class: "w-[88px]",
          mobile: "",
          onChange: t[1] || (t[1] = (d) => e.$emit("change-language", d)),
          altStyle: ""
        })
      ]),
      e.panelCollectionIsEmpty ? (c(), C(u, {
        key: 0,
        onBack: t[2] || (t[2] = (d) => e.reachParentEntity(e.modalPath.length - 2)),
        class: "mt-4"
      })) : (c(), p("div", Om, [
        (c(!0), p(X, null, te(e.castEntities(e.panelContentChildren), (d, f) => (c(), C(g, {
          key: d.id,
          item: d,
          hovered: f === e.hovered,
          "is-favorite": e.itemIsFavorite(d.id, e.selectedLanguage),
          "full-title-preference": e.config.displayFullTitle,
          options: e.entityOptions,
          onMouseenter: (I) => e.onHover(f),
          onMouseleave: t[3] || (t[3] = (I) => e.onHover(-1)),
          onGoToDocument: (I) => e.handleClickOnEntity(d),
          onToggleFavorite: t[4] || (t[4] = (I) => e.$emit("toggle-favorite", I)),
          onCopyLink: t[5] || (t[5] = (I) => e.$emit("copy-link", I))
        }, null, 8, ["item", "hovered", "is-favorite", "full-title-preference", "options", "onMouseenter", "onGoToDocument"]))), 128))
      ]))
    ]))
  ]);
}
const _m = /* @__PURE__ */ x(km, [["render", xm], ["__scopeId", "data-v-d11616fd"]]), Um = { class: "w-full flex flex-none text-sm border-b border-gray-6" }, Fm = ["onClick"], zr = /* @__PURE__ */ T({
  __name: "BaseMenu",
  props: {
    tabs: {},
    activeTab: {}
  },
  emits: ["update-tab"],
  setup(e, { emit: t }) {
    const n = e, o = (i) => t("update-tab", i);
    return (i, r) => {
      const s = P;
      return c(), p("menu", Um, [
        (c(!0), p(X, null, te(n.tabs, (l, a) => (c(), p("button", {
          key: l.key,
          class: D(["flex items-center gap-2 font-bold transition-colors cursor-pointer px-1 py-2 box-border -mb-[1px] relative", [
            n.activeTab === l.key ? "!text-purple !border-purple border-b-2" : "text-gray-6 border-gray-6 hover:border-purple-3 hover:text-purple border-b",
            { "pr-4": a < n.tabs.length - 1 }
          ]]),
          onClick: be((u) => o(l.key), ["stop"])
        }, [
          M(s, {
            icon: l.icon
          }, null, 8, ["icon"]),
          m("div", null, N(i.$t(l.label)), 1)
        ], 10, Fm))), 128))
      ]);
    };
  }
}), $m = { class: "h-full w-full flex flex-col overflow-hidden" }, Rm = { class: "w-full h-full overflow-auto py-2 text-sm max-h-28" }, Vm = { key: 0 }, Bm = {
  key: 1,
  class: "flex flex-col gap-1"
}, Ym = ["id", "name"], Qm = ["for"], Pm = /* @__PURE__ */ T({
  __name: "AiAgentCollapse",
  props: {
    content: {},
    summary: {},
    actionItems: {}
  },
  setup(e) {
    const t = e, n = k(() => {
      const a = [];
      return t.summary && a.push({
        icon: ["fal", "file-alt"],
        label: "knowledge.ai-collapse.summary",
        key: "summary"
      }), t.actionItems && a.push({
        icon: ["fal", "file-check"],
        label: "knowledge.ai-collapse.action-items",
        key: "action-items"
      }), a;
    }), o = Y(!1), i = Y("summary"), r = (a) => {
      i.value = a, o.value || (o.value = !0);
    }, s = le(), l = () => {
      let a = i.value === "summary" ? t.summary.type : "action_items";
      return a = a == null ? void 0 : a.toUpperCase(), {
        metaType: a,
        content: {
          id: t.content.id,
          type: t.content.type
        }
      };
    };
    return _t(() => {
      t.summary ? i.value = "summary" : t.actionItems && (i.value = "action-items"), (t.summary || t.actionItems) && s.logs({
        topic: "CONTENT_META_VIEW",
        event: l()
      });
    }), (a, u) => {
      const g = zr;
      return c(), p("div", $m, [
        M(g, {
          tabs: h(n),
          activeTab: h(i),
          onUpdateTab: r
        }, null, 8, ["tabs", "activeTab"]),
        m("div", Rm, [
          a.summary && h(i) === "summary" ? (c(), p("div", Vm, N(a.summary.body), 1)) : A("", !0),
          h(i) === "action-items" ? (c(), p("div", Bm, [
            (c(!0), p(X, null, te(a.actionItems.body, (d, f) => (c(), p("div", {
              key: f,
              class: "flex items-center gap-2 accent-purple"
            }, [
              m("input", {
                id: String(f),
                name: String(f),
                type: "checkbox",
                class: "cursor-pointer"
              }, null, 8, Ym),
              m("label", {
                for: String(f),
                class: "cursor-pointer"
              }, N(d), 9, Qm)
            ]))), 128))
          ])) : A("", !0)
        ])
      ]);
    };
  }
}), Gm = T({
  name: "DiagnosticNavigatorBreadcrumb",
  components: {
    TextEllipsis: Le
  },
  props: {
    customWidth: {
      type: Number,
      required: !0
    },
    siblings: {
      type: Array,
      default: () => []
    },
    focusContentId: {
      type: String,
      default: ""
    },
    contentParents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dropdown: !1
    };
  },
  computed: {
    root() {
      return this.contentParents.length ? this.contentParents[0] : void 0;
    },
    hasChildren() {
      return this.contentParents.length > 1;
    },
    parents() {
      return this.contentParents.slice(1, -1);
    },
    maxWidth() {
      return this.customWidth - 42 - 72;
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdown = !this.dropdown;
    },
    handleClick(e) {
      return this.dropdown = !1, this.$emit("click:content", e);
    },
    handleFocusSibling(e) {
      return this.dropdown = !1, this.$emit("click:sibling", e);
    }
  }
});
const Zm = ["onClick"], Wm = ["onClick"], Hm = { key: 0 };
function Jm(e, t, n, o, i, r) {
  var u;
  const s = Le, l = P, a = It("click-outside");
  return c(), p("div", {
    class: "h-5.5 md:h-7.5 text-xs md:text-base flex border border-blue relative rounded min-w-0",
    style: Ce(`max-width: ${e.maxWidth}px`)
  }, [
    m("button", {
      class: D(["whitespace-nowrap truncate px-2.5 py-1 text-blue bg-blue/10 cursor-default", {
        " hover:text-white hover:bg-blue transition-colors cursor-pointer": e.hasChildren
      }]),
      onClick: t[0] || (t[0] = (g) => e.hasChildren ? e.handleClick(0) : "")
    }, [
      M(s, {
        text: (u = e.root) == null ? void 0 : u.label
      }, null, 8, ["text"])
    ], 2),
    e.hasChildren ? (c(), p("button", {
      key: 0,
      class: "border-l border-blue text-blue bg-blue/10 flex flex-nowrap justify-center items-center w-5 md:w-7 h-5 md:h-7 flex-none hover:text-white hover:bg-blue transition-colors",
      onClick: t[1] || (t[1] = (...g) => e.toggleDropdown && e.toggleDropdown(...g))
    }, [
      M(l, {
        icon: ["fas", "chevron-down"],
        class: D(["diagnostic-breadcrumb-chevron-icon", { "diagnostic-breadcrumb-chevron-icon-active": e.dropdown }])
      }, null, 8, ["class"])
    ])) : A("", !0),
    e.dropdown ? Ze((c(), p("div", {
      key: 1,
      class: "absolute top-6 md:top-9 -left-px bg-white rounded shadow-lg p-2 z-10",
      style: Ce(`max-width: ${e.maxWidth - 15}px`)
    }, [
      (c(!0), p(X, null, te(e.parents, (g, d) => (c(), p("div", {
        key: d,
        class: D(["diagnostic-breadcrumb-dropdown-item md:text-base", [`diagnostic-breadcrumb-dropdown-item-${d}`]]),
        style: Ce({ marginLeft: `${d * 4}px` }),
        onClick: (f) => e.handleClick(d + 1)
      }, [
        M(s, {
          text: g.label,
          width: `${e.maxWidth}px`
        }, null, 8, ["text", "width"])
      ], 14, Zm))), 128)),
      (c(!0), p(X, null, te(e.siblings, (g, d) => (c(), p("div", {
        key: d,
        class: D(["diagnostic-breadcrumb-dropdown-item md:text-base", {
          "diagnostic-breadcrumb-dropdown-item-active": g.id === e.focusContentId
        }]),
        style: Ce({ marginLeft: `${e.parents.length * 4}px` }),
        onClick: (f) => e.handleFocusSibling(g)
      }, [
        M(s, {
          text: g.label,
          width: `${e.maxWidth}px`
        }, null, 8, ["text", "width"]),
        g.id === e.focusContentId ? (c(), p("span", Hm, [
          M(l, { icon: ["fal", "check"] })
        ])) : A("", !0)
      ], 14, Wm))), 128))
    ], 4)), [
      [a, e.toggleDropdown]
    ]) : A("", !0)
  ], 4);
}
const Km = /* @__PURE__ */ x(Gm, [["render", Jm], ["__scopeId", "data-v-46637d31"]]), qm = { class: "relative" }, Xm = ["onClick"], e0 = 32, t0 = /* @__PURE__ */ T({
  __name: "KnowledgeBreadcrumbDropdown",
  props: {
    customWidth: {},
    hiddenParents: {},
    forceMobileSize: { type: Boolean }
  },
  setup(e) {
    const t = e, n = Y(!1), o = () => {
      n.value = !1;
    }, i = k(() => t.forceMobileSize ? 40 : 70), r = k(() => t.customWidth - e0 - i.value);
    return (s, l) => {
      const a = Le, u = It("click-outside");
      return Ze((c(), p("span", qm, [
        m("button", {
          class: "text-base flex items-end font-bold rounded tracking-widest w-5.5 mr-[-0.1em]",
          onClick: l[0] || (l[0] = (g) => n.value = !h(n))
        }, " ... "),
        s.hiddenParents.length && h(n) ? (c(), p("div", {
          key: 0,
          class: D(["bg-white text-black rounded shadow-lg absolute top-[calc(100%+4px)] z-10 overflow-hidden", [{ "md:rounded-lg": !s.forceMobileSize }]]),
          style: Ce(`max-width: ${h(r)}px`)
        }, [
          (c(!0), p(X, null, te(s.hiddenParents, (g, d) => (c(), p("button", {
            key: d,
            class: D(["whitespace-nowrap text-start w-full px-2 py-1 text-xs hover:bg-gray-1 transition-colors flex items-center", [{ "md:text-base": !s.forceMobileSize }]]),
            onClick: (f) => s.$emit("click:folder", d + 1)
          }, [
            M(a, {
              text: g.label,
              width: `${h(r)}px`
            }, null, 8, ["text", "width"])
          ], 10, Xm))), 128))
        ], 6)) : A("", !0)
      ])), [
        [u, o]
      ]);
    };
  }
}), n0 = /* @__PURE__ */ T({
  __name: "KnowledgeBreadcrumbLink",
  props: {
    link: { type: Boolean },
    item: {},
    disabled: { type: Boolean }
  },
  setup(e) {
    const t = e, n = le(), { selectedLanguage: o } = De(n), i = k(() => {
      if (!t.disabled)
        return So(t.item, o.value);
    });
    return (r, s) => r.link ? (c(), C(xt(t.disabled ? "span" : "router-link"), {
      key: 0,
      to: h(i)
    }, {
      default: _(() => [
        Te(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["to"])) : (c(), p("button", {
      key: 1,
      onClick: s[0] || (s[0] = (l) => t.disabled ? "" : r.$emit("go-to-document", r.item))
    }, [
      Te(r.$slots, "default")
    ]));
  }
}), o0 = T({
  name: "KnowledgeBreadcrumb",
  components: {
    DiagnosticNavigatorBreadcrumb: Km,
    KnowledgeBreadcrumbDropdown: t0,
    KnowledgeBreadcrumbLink: n0
  },
  props: {
    customWidth: {
      type: Number,
      required: !0
    },
    hostApp: {
      type: String,
      default: "chrome-extension"
    },
    parents: {
      type: Array,
      default: () => []
    },
    contentParents: {
      type: Array,
      default: () => []
    },
    contentSiblings: {
      type: Array,
      default: () => []
    },
    forceMobileSize: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      isOverflow: !1
    };
  },
  mounted() {
    this.computeOverflow();
  },
  computed: {
    renderedPath() {
      return !this.isOverflow || this.parents.length === 2 ? this.parents : [
        this.parents[0],
        { id: "", label: "...", type: "" },
        this.parents.at(-1)
      ];
    },
    hiddenParents() {
      return !this.isOverflow || this.parents.length === 2 ? [] : this.parents.slice(1, -1);
    },
    maxWidth() {
      const t = 36 * (this.renderedPath.length - 1);
      return this.customWidth - 48 - t;
    },
    firstParent() {
      return { ...this.focusKnowledge, type: "Knowledge" };
    },
    ...ue(le, ["mainContent", "focusKnowledge"])
  },
  methods: {
    computeOverflow() {
      this.isOverflow = !1, this.$nextTick(() => {
        const e = this.$refs.breadcrumb;
        e && (this.isOverflow = e.scrollWidth > e.clientWidth);
      });
    },
    handleClick(e) {
      return e + 1 !== this.parents.length ? this.$emit("click:folder", e) : "";
    }
  },
  watch: {
    parents() {
      this.computeOverflow();
    },
    customWidth() {
      this.computeOverflow();
    }
  }
}), i0 = { class: "relative" }, s0 = {
  key: 0,
  class: "flex items-center w-full h-5.5",
  ref: "breadcrumb"
}, r0 = { class: "group-hover:text-black" };
function a0(e, t, n, o, i, r) {
  const s = P, l = R("KnowledgeBreadcrumbLink"), a = R("KnowledgeBreadcrumbDropdown"), u = Le, g = R("DiagnosticNavigatorBreadcrumb");
  return c(), p("div", i0, [
    e.parents.length > 0 ? (c(), p("div", s0, [
      (c(!0), p(X, null, te(e.renderedPath, (d, f) => (c(), p("button", {
        key: f,
        class: "flex items-center text-base text-gray-9.5 transition-colors group"
      }, [
        f === 0 ? (c(), C(l, {
          key: 0,
          class: "flex",
          link: e.hostApp === "agent-client",
          item: e.firstParent,
          onGoToDocument: (I) => e.handleClick(f)
        }, {
          default: _(() => [
            m("span", r0, [
              M(s, { icon: ["fal", "home"] })
            ])
          ]),
          _: 2
        }, 1032, ["link", "item", "onGoToDocument"])) : (d == null ? void 0 : d.label) === "..." ? (c(), C(a, {
          key: 1,
          class: D(["group-hover:text-black w-3.5", [e.forceMobileSize ? "" : "md:w-4.5"]]),
          "custom-width": e.customWidth,
          "hidden-parents": e.hiddenParents,
          forceMobileSize: e.forceMobileSize,
          "onClick:folder": e.handleClick
        }, null, 8, ["class", "custom-width", "hidden-parents", "forceMobileSize", "onClick:folder"])) : (d == null ? void 0 : d.type) === "Case" || (d == null ? void 0 : d.type) === "Article" ? (c(), C(l, {
          key: 2,
          class: D(["flex", {
            "cursor-default": f + 1 === e.renderedPath.length
          }]),
          link: e.hostApp === "agent-client",
          item: d,
          disabled: f + 1 === e.renderedPath.length,
          onGoToDocument: (I) => e.handleClick(f)
        }, {
          default: _(() => [
            M(u, {
              class: D(["group-hover:text-black", {
                "!text-gray-7 group-hover:!text-gray-7": f + 1 === e.renderedPath.length
              }]),
              width: `${e.maxWidth}px`,
              text: d.label
            }, null, 8, ["class", "width", "text"])
          ]),
          _: 2
        }, 1032, ["link", "item", "class", "disabled", "onGoToDocument"])) : (c(), C(g, {
          key: 3,
          "custom-width": e.customWidth,
          "content-parents": e.contentParents,
          "focus-content-id": e.mainContent.id,
          siblings: e.contentSiblings,
          "onClick:content": t[0] || (t[0] = (I) => e.$emit("click:content", I)),
          "onClick:sibling": t[1] || (t[1] = (I) => e.$emit("click:sibling", I))
        }, null, 8, ["custom-width", "content-parents", "focus-content-id", "siblings"])),
        f + 1 !== e.renderedPath.length ? (c(), C(s, {
          key: 4,
          class: "text-xs mx-2 text-gray-7",
          icon: ["fas", "chevron-right"]
        })) : A("", !0)
      ]))), 128))
    ], 512)) : A("", !0)
  ]);
}
const vr = /* @__PURE__ */ x(o0, [["render", a0]]), l0 = T({
  name: "MainKnowledgeBreadcrumbWrapper",
  components: {
    KnowledgeBreadcrumb: vr
  },
  emits: ["go-to-entity"],
  props: {
    customWidth: {
      type: Number,
      required: !0
    },
    hostApp: {
      type: String,
      default: "chrome-extension"
    },
    search: Boolean
  },
  computed: {
    displayedPath() {
      return this.search ? [
        this.path[0],
        {
          id: "2",
          type: "Case",
          label: this.$t("search.breadcrumb"),
          knowledgeId: "-1"
        }
      ] : this.path;
    },
    ...ue(le, [
      "path",
      "contentParents",
      "contentSiblings",
      "mainContent",
      "modalContent"
    ])
  },
  methods: {
    appearDiagnosticStepParent(e) {
      const t = this.contentParents[e], n = this.contentParents.slice(0, e + 1);
      this.updateContentParents(n);
      const o = {
        id: t.id,
        type: t.type || "Step"
      };
      this.$emit("go-to-entity", o);
    },
    focusContentSibling(e) {
      if (e.redirection) {
        const { entityId: o, entityType: i } = e.redirection;
        return this.$emit("go-to-entity", { id: o, type: i });
      }
      const t = this.contentParents.slice(0, -1).concat({ ...e, children: this.contentSiblings });
      this.updateContentParents(t);
      const n = {
        id: e.id,
        type: e.type || "Step"
      };
      this.$emit("go-to-entity", n);
    },
    handleClickFolder(e) {
      const t = this.getParentEntity(e, this.mainContent.knowledgeId, this.path);
      this.updatePath(this.path.slice(0, e + 1)), this.$emit("go-to-entity", t);
    },
    ...fe(le, ["updateContentParents", "getParentEntity", "updatePath"])
  }
});
function c0(e, t, n, o, i, r) {
  const s = R("KnowledgeBreadcrumb");
  return c(), C(s, {
    "custom-width": e.customWidth,
    "host-app": e.hostApp,
    search: e.search,
    parents: e.displayedPath,
    "content-parents": e.contentParents,
    "content-siblings": e.contentSiblings,
    "onClick:folder": e.handleClickFolder,
    "onClick:content": e.appearDiagnosticStepParent,
    "onClick:sibling": e.focusContentSibling
  }, null, 8, ["custom-width", "host-app", "search", "parents", "content-parents", "content-siblings", "onClick:folder", "onClick:content", "onClick:sibling"]);
}
const u0 = /* @__PURE__ */ x(l0, [["render", c0]]), d0 = T({
  name: "ModalKnowledgeBreadcrumbWrapper",
  components: {
    KnowledgeBreadcrumb: vr
  },
  emits: ["go-to-entity"],
  props: {
    customWidth: {
      type: Number,
      required: !0
    },
    forceMobileSize: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    ...ue(le, [
      "modalPath",
      "modalContentParents",
      "modalContentSiblings",
      "modalContent"
    ])
  },
  methods: {
    appearDiagnosticStepParent(e) {
      const t = this.modalContentParents[e], n = this.modalContentParents.slice(0, e + 1);
      this.updateContentParents(n);
      const o = {
        id: t.id,
        type: t.type || "Step"
      };
      this.$emit("go-to-entity", o);
    },
    focusContentSibling(e) {
      if (e.redirection) {
        const { entityId: o, entityType: i } = e.redirection;
        return this.$emit("go-to-entity", { id: o, type: i });
      }
      const t = this.modalContentParents.slice(0, -1).concat({ ...e, children: this.modalContentSiblings });
      this.updateContentParents(t);
      const n = {
        id: e.id,
        type: e.type || "Step"
      };
      this.$emit("go-to-entity", n);
    },
    handleClickFolder(e) {
      const t = this.getParentEntity(e, this.modalContent.knowledgeId, this.modalPath);
      this.updateModalPath(this.modalPath.slice(0, e + 1)), this.$emit("go-to-entity", t);
    },
    ...fe(le, [
      "updateModalContentParents",
      "getParentEntity",
      "updateModalPath"
    ])
  }
});
function g0(e, t, n, o, i, r) {
  const s = R("KnowledgeBreadcrumb");
  return c(), C(s, {
    "custom-width": e.customWidth,
    parents: e.modalPath,
    "content-parents": e.modalContentParents,
    "content-siblings": e.modalContentSiblings,
    "force-mobile-size": e.forceMobileSize,
    "onClick:folder": e.handleClickFolder,
    "onClick:content": e.appearDiagnosticStepParent,
    "onClick:sibling": e.focusContentSibling
  }, null, 8, ["custom-width", "parents", "content-parents", "content-siblings", "force-mobile-size", "onClick:folder", "onClick:content", "onClick:sibling"]);
}
const p0 = /* @__PURE__ */ x(d0, [["render", g0]]), m0 = { class: "flex-none flex items-center justify-center w-6 h-6 bg-white rounded relative" }, h0 = {
  key: 0,
  class: "h-3 w-3 rounded-full border border-gray-2 dark:border-gray-8 absolute -top-1 -right-1 bg-white dark:bg-black flex items-center justify-center"
}, f0 = ["src"], y0 = /* @__PURE__ */ T({
  __name: "EntityIconSmall",
  props: {
    type: {},
    typename: {},
    isFavorite: { type: Boolean }
  },
  setup(e) {
    const t = e, n = {
      Article: {
        type: "url",
        value: On
      },
      Diagnostic: {
        type: "url",
        value: xn
      },
      Step: {
        type: "url",
        value: Ti
      },
      keyStep: {
        type: "icon",
        value: ["fas", "key"],
        class: "text-blue fa-rotate-90"
      },
      Product: {
        type: "icon",
        value: ["fas", "barcode-scan"],
        class: "text-gray-7"
      },
      Case: {
        type: "icon",
        value: ["fal", "folder"],
        class: "text-black"
      },
      Knowledge: {
        type: "icon",
        value: ["fal", "home"],
        class: "text-black"
      }
    }, o = k(() => t.type && (t == null ? void 0 : t.typename) === "Content" ? n[t.type] : n[t.typename || t.type || "Case"]), i = k(() => o.value.value), r = k(() => o.value.value);
    return (s, l) => {
      const a = P;
      return c(), p("div", m0, [
        s.isFavorite ? (c(), p("div", h0, [
          M(a, {
            icon: ["fas", "star"],
            class: "text-yellow text-[7px]"
          })
        ])) : A("", !0),
        h(o).type === "url" ? (c(), p("img", {
          key: 1,
          src: h(i),
          class: "w-auto h-3.5 select-none"
        }, null, 8, f0)) : h(o).type === "icon" ? (c(), C(a, {
          key: 2,
          icon: h(r),
          class: D(["text-sm", h(o).class])
        }, null, 8, ["icon", "class"])) : A("", !0)
      ]);
    };
  }
}), I0 = {
  key: 0,
  class: "mt-px whitespace-pre-wrap [word-break:break-word]"
}, Ms = /* @__PURE__ */ T({
  __name: "CaseNavigationItem",
  props: {
    item: {},
    focus: { type: Boolean },
    isFavorite: { type: Boolean },
    fullTitlePreference: { type: Boolean }
  },
  setup(e) {
    const t = e, n = le(), { selectedLanguage: o } = De(n), i = k(() => So(t.item, o.value));
    return (r, s) => {
      const l = y0, a = Le, u = R("RouterLink");
      return c(), C(u, {
        to: h(i),
        class: D(["flex items-start gap-2 text-start p-2 rounded transition-colors w-full", [
          t.focus ? "bg-primary text-primary-contrast alt:border alt:border-gray-3" : "bg-transparent text-black hover:bg-gray-2"
        ]])
      }, {
        default: _(() => [
          M(l, {
            type: t.item.type || "Case",
            isFavorite: r.isFavorite
          }, null, 8, ["type", "isFavorite"]),
          r.fullTitlePreference ? (c(), p("span", I0, N(t.item.label), 1)) : (c(), C(a, {
            key: 1,
            text: t.item.label,
            class: "flex items-center mt-px"
          }, null, 8, ["text"]))
        ]),
        _: 1
      }, 8, ["to", "class"]);
    };
  }
}), M0 = { class: "w-full" }, A0 = { class: "ml-4 flex flex-col" }, N0 = /* @__PURE__ */ T({
  __name: "CaseNavigation",
  props: {
    itemIsFavorite: { type: Function },
    displayFullTitle: { type: Boolean }
  },
  setup(e) {
    const t = e, n = le(), { parents: o, path: i, selectedLanguage: r, focusKnowledge: s } = De(n), l = k(() => i.value[i.value.length - 1]), a = k(() => !i.value.length || i.value.length === 2 ? { ...s.value, type: "Knowledge" } : i.value[i.value.length - 2]);
    return (u, g) => (c(), p("div", M0, [
      h(a) ? (c(), C(Ms, {
        key: 0,
        item: h(a),
        "full-title-preference": u.displayFullTitle,
        class: "mb-4"
      }, null, 8, ["item", "full-title-preference"])) : A("", !0),
      m("div", A0, [
        (c(!0), p(X, null, te(h(o), (d) => (c(), C(Ms, {
          key: d.id,
          item: d,
          focus: d.id === h(l).id,
          "is-favorite": t.itemIsFavorite(d.id, h(r)),
          "full-title-preference": u.displayFullTitle
        }, null, 8, ["item", "focus", "is-favorite", "full-title-preference"]))), 128))
      ])
    ]));
  }
}), b0 = {
  key: 0,
  class: "relative"
}, C0 = { class: "text-black font-bold uppercase text-base mb-3" }, w0 = { class: "relative ml-4" }, D0 = /* @__PURE__ */ m("div", { class: "absolute bg-gray-3 h-full w-0.5 -left-4 top-0 z-[1]" }, null, -1), z0 = /* @__PURE__ */ m("div", { class: "opacity-0 absolute h-8 w-0.5 bg-gray-5 -left-4 top-0 transition-opacity group-hover:opacity-100" }, null, -1), As = 76, v0 = /* @__PURE__ */ T({
  __name: "TableOfContents",
  props: {
    route: {}
  },
  setup(e) {
    const t = e, n = le(), { tableOfContents: o } = De(n), i = {
      1: "",
      2: "ml-1",
      3: "ml-2",
      4: "ml-3"
    }, r = vn(t, "route");
    _e(
      () => r.value.hash,
      (I) => {
        u(I);
      }
    ), _t(() => {
      const I = document.getElementById("main");
      I == null || I.addEventListener("scroll", g), setTimeout(() => {
        u(r.value.hash);
      }, 500);
    }), xs(() => {
      const I = document.getElementById("main");
      I == null || I.removeEventListener("scroll", g);
    });
    const s = Y(!1), l = Y(-1), a = k(() => l.value > -1 ? `transform: translateY(calc(32px * ${l.value}))` : "opacity: 0"), u = (I) => {
      if (!I)
        return;
      const z = document.getElementById(I.slice(1));
      z && (s.value = !0, setTimeout(() => {
        s.value = !1;
      }, 1e3), l.value = o.value.findIndex(({ id: v }) => v === I.slice(1)), z.scrollIntoView({ behavior: "smooth" }));
    }, g = () => {
      if (s.value)
        return;
      let z = d().findIndex(({ top: v, bottom: Q }) => v <= As && As < Q);
      l.value = z;
    }, d = () => o.value.reduce((I, { id: z }, v, Q) => {
      var V;
      const H = document.getElementById(z);
      if (!H)
        return I;
      const { top: ee } = H.getBoundingClientRect(), j = ee;
      let G;
      if (v === Q.length - 1)
        G = j + ((V = document.getElementById("main")) == null ? void 0 : V.getBoundingClientRect().height);
      else {
        const K = document.getElementById(Q[v + 1].id);
        if (!K)
          return I;
        const { top: U } = K.getBoundingClientRect();
        G = U;
      }
      return I.push({ top: j, bottom: G }), I;
    }, []), f = () => {
      s.value = !1, l.value = -1;
    };
    return _e(o, () => {
      f();
    }), (I, z) => {
      const v = Le, Q = R("RouterLink");
      return h(o).length ? (c(), p("div", b0, [
        m("div", C0, N(I.$t("toc.title")), 1),
        m("div", w0, [
          D0,
          m("div", {
            class: "absolute bg-black h-8 w-0.5 transition-transform duration-200 ease-in-out -left-4 top-0 z-[2]",
            style: Ce(h(a))
          }, null, 4),
          (c(!0), p(X, null, te(h(o), (H, ee) => (c(), C(Q, {
            key: H.id,
            class: "group relative select-none w-full cursor-pointer text-base h-8 flex items-center",
            to: `#${H.id}`
          }, {
            default: _(() => [
              z0,
              M(v, {
                text: H.name,
                class: D(["transition-colors", [
                  ee === h(l) ? "text-black font-bold" : "text-gray-7",
                  [i[H.level]]
                ]])
              }, null, 8, ["text", "class"])
            ]),
            _: 2
          }, 1032, ["to"]))), 128))
        ])
      ])) : A("", !0);
    };
  }
}), T0 = {
  key: 0,
  class: "flex items-center gap-2 text-gray-9"
}, k0 = { class: "text-sm leading-[16px]" }, j0 = /* @__PURE__ */ T({
  __name: "CaseDescriptionRow",
  setup(e) {
    const t = le(), { mainContent: n, mainIsLoading: o } = De(t), i = k(() => n.value.body);
    return (r, s) => {
      const l = P;
      return h(i) && !h(o) ? (c(), p("div", T0, [
        M(l, {
          class: "w-6 h-6 flex-none bg-gray-3 rounded-lg text-sm",
          icon: ["fas", "info"]
        }),
        m("div", k0, N(h(i)), 1)
      ])) : A("", !0);
    };
  }
}), S0 = { class: "opacity-80 font-semibold flex grow text-start" }, L0 = { class: "mr-1 text-black font-semibold grow-0 overflow-hidden text-ellipsis" }, Tr = /* @__PURE__ */ T({
  __name: "SortDropdown",
  props: {
    filteredLength: {},
    resultsLength: {},
    sortOptionId: {},
    hasFilters: {}
  },
  emits: ["update"],
  setup(e, { emit: t }) {
    const n = e, o = Y(n.sortOptionId), i = (l) => {
      t("update", l);
    }, r = [{ key: "recommended" }, { key: "alpha-asc" }, { key: "alpha-desc" }], s = () => r.map((l) => ({
      key: l.key,
      label: `dropdown.options.${l.key}`
    }));
    return (l, a) => {
      const u = wi;
      return c(), C(u, {
        options: s(),
        value: h(o),
        onUpdate: i,
        removeBorder: "",
        class: "inline-block bg-white font-semibold w-[260px]"
      }, {
        trigger: _(({ selectedOption: g }) => [
          m("p", S0, N(l.$t("dropdown.collection", { count: n.filteredLength })), 1),
          m("span", L0, N(l.$t(`dropdown.options.${g.key}`)), 1)
        ]),
        _: 1
      }, 8, ["options", "value"]);
    };
  }
}), E0 = /* @__PURE__ */ T({
  __name: "KnowledgeSortDropdown",
  props: {
    filterPref: { type: Boolean }
  },
  setup(e) {
    const t = e, n = le(), { sortOptionId: o, contentChildren: i, filteredLength: r } = De(n), s = (l) => {
      n.updateSortOption(l);
    };
    return (l, a) => {
      const u = Tr;
      return c(), C(u, {
        resultsLength: h(i).length,
        filteredLength: h(r)(t.filterPref),
        onUpdate: s,
        sortOptionId: h(o)
      }, null, 8, ["resultsLength", "filteredLength", "sortOptionId"]);
    };
  }
}), O0 = T({
  name: "TagFilter",
  emits: ["select-tag"],
  props: {
    tag: {
      type: Object,
      default: () => ({
        id: null,
        value: "content",
        type: "type",
        label: "super-search.content",
        icon: ["fas", "barcode-scan"],
        trad: !0
      })
    },
    selectedTags: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    iconColor() {
      return `color: ${this.tag.color}`;
    },
    tagIcon() {
      return this.tag.icon ? typeof this.tag.icon == "string" ? ["fas", this.tag.icon] : this.tag.icon : ["fas", ""];
    },
    isSelected() {
      return this.selectedTags.map((e) => e.id).includes(this.tag.id);
    }
  }
}), x0 = {
  key: 0,
  class: "w-3 h-3 rounded-sm bg-white p-0.5 flex items-center justify-center"
}, _0 = ["src"], U0 = {
  key: 1,
  class: "w-3 h-3 text-3xs leading-none rounded-sm bg-white p-[2px] flex justify-center items-center"
}, F0 = { class: "leading-3" };
function $0(e, t, n, o, i, r) {
  const s = P;
  return c(), p("button", {
    class: D(["flex items-center gap-1 p-1 pr-3 text-xs bg-gray-2 transition-colors text-black rounded-sm hover:bg-gray-3 active:!bg-primary active:text-white", { "!bg-primary text-primary-contrast": e.isSelected }]),
    onClick: t[0] || (t[0] = be((l) => e.$emit("select-tag", e.tag), ["stop"]))
  }, [
    e.tag.iconUrl ? (c(), p("div", x0, [
      m("img", {
        src: e.tag.iconUrl,
        class: "h-full"
      }, null, 8, _0)
    ])) : e.tag.icon ? (c(), p("div", U0, [
      M(s, {
        icon: e.tagIcon,
        style: Ce(e.iconColor)
      }, null, 8, ["icon", "style"])
    ])) : A("", !0),
    m("span", F0, N(e.tag.trad ? e.$t(e.tag.label) : e.tag.label), 1)
  ], 2);
}
const kr = /* @__PURE__ */ x(O0, [["render", $0]]), R0 = T({
  name: "TagsGroup",
  components: { TagFilter: kr },
  props: {
    groupLabel: {
      type: String,
      required: !0
    },
    tags: {
      type: Array,
      required: !0
    },
    selectedTags: {
      type: Array,
      required: !0
    }
  },
  emits: ["select-tag", "reset-group"],
  data: () => ({
    isExpanded: !1,
    isMounted: !1
  }),
  computed: {
    hasMultipleLines() {
      if (!this.isMounted || !this.$refs.tagsContainer)
        return !1;
      const e = this.$refs.tagsContainer.lastElementChild, t = e == null ? void 0 : e.getBoundingClientRect(), n = this.$refs.tagsContainer.getBoundingClientRect();
      return !t || !n ? !1 : t.top > n.bottom;
    },
    tagsCount() {
      return this.selectedTags.filter((e) => e.groupLabel === this.groupLabel).length;
    }
  },
  mounted() {
    this.isMounted = !0, kt().hasSearchFilters && (this.isExpanded = !0);
  }
});
const V0 = { class: "text-gray-7 text-2xs font-semibold flex items-center justify-between gap-2" }, B0 = { class: "flex gap-2 cursor-pointer items-center" }, Y0 = { class: "text-gray-8 text-xs uppercase" }, Q0 = { class: "relative flex items-center justify-center" }, P0 = { class: "absolute bg-gray-8 text-white opacity-0 group-hover/reset:opacity-100 transition-all p-1 rounded-sm tooltip" };
function G0(e, t, n, o, i, r) {
  const s = P, l = R("TagFilter");
  return c(), p(X, null, [
    m("div", V0, [
      m("div", B0, [
        m("span", Y0, N(e.groupLabel), 1),
        e.hasMultipleLines ? (c(), p("button", {
          key: 0,
          class: "flex items-center gap-2 whitespace-nowrap",
          onClick: t[0] || (t[0] = be((a) => e.isExpanded = !e.isExpanded, ["stop"]))
        }, [
          m("div", Q0, [
            M(s, {
              icon: ["fas", "minus"],
              class: "absolute"
            }),
            M(s, {
              icon: ["fas", "minus"],
              class: D(["transition-transform absolute", e.isExpanded ? "" : "-rotate-90 ml-[1px]"])
            }, null, 8, ["class"])
          ]),
          m("span", null, N(e.$t(`search.filters.see-${e.isExpanded ? "less" : "more"}`)), 1)
        ])) : A("", !0)
      ]),
      e.tagsCount ? (c(), p("button", {
        key: 0,
        class: "cursor-pointer flex items-center gap-1 hover:text-primary transition-colors group/reset relative",
        onClick: t[1] || (t[1] = be((a) => e.$emit("reset-group", e.groupLabel), ["stop"]))
      }, [
        m("div", P0, N(e.$t("search.filters.reset")), 1),
        m("div", null, N(e.$t("search.filters.filters-count", e.tagsCount)), 1),
        M(s, { icon: ["fas", "rotate-left"] })
      ])) : A("", !0)
    ]),
    m("div", {
      ref: "tagsContainer",
      class: D(["flex items-center gap-2 w-full flex-wrap transition-all", e.isExpanded ? "max-h-60 overflow-auto" : "max-h-6 overflow-hidden"])
    }, [
      (c(!0), p(X, null, te(e.tags, (a) => (c(), C(l, {
        tag: a,
        key: a.id,
        selectedTags: e.selectedTags,
        onSelectTag: (u) => e.$emit("select-tag", a)
      }, null, 8, ["tag", "selectedTags", "onSelectTag"]))), 128))
    ], 2)
  ], 64);
}
const Z0 = /* @__PURE__ */ x(R0, [["render", G0], ["__scopeId", "data-v-5022a064"]]), W0 = { class: "text-gray-8 uppercase text-xs font-semibold" }, H0 = { class: "flex flex-col" }, J0 = ["onChange", "checked"], K0 = /* @__PURE__ */ T({
  __name: "SearchAdvancedFilters",
  props: {
    tags: {},
    selectedTags: {}
  },
  emits: ["select-tag"],
  setup(e, { emit: t }) {
    const n = e, o = (i) => !n.selectedTags || n.selectedTags.length === 0 ? !1 : n.selectedTags.map((r) => r.id).includes(i);
    return (i, r) => {
      const s = Le;
      return c(), p(X, null, [
        m("span", W0, N(i.$t("search.filters.advanced", i.tags.length)), 1),
        m("div", H0, [
          (c(!0), p(X, null, te(i.tags, (l) => (c(), p("div", {
            key: l.id,
            class: "flex flex-row gap-1"
          }, [
            m("input", {
              type: "checkbox",
              class: "cursor-pointer",
              onChange: (a) => t("select-tag", l),
              checked: o(l.id)
            }, null, 40, J0),
            M(s, {
              text: l.advancedLabel,
              "custom-class": "text-[13px]"
            }, null, 8, ["text"])
          ]))), 128))
        ])
      ], 64);
    };
  }
}), q0 = T({
  name: "SearchFilters",
  components: {
    TagsGroup: Z0,
    SearchAdvancedFilters: K0
  },
  props: {
    selectedTags: {
      type: Array,
      default: () => []
    },
    display: {
      type: Boolean,
      default: !0
    },
    fullSize: {
      type: Boolean,
      default: !1
    },
    isCollection: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      entities: [
        {
          id: "content",
          key: "entity",
          value: "attached-contents",
          label: "super-search.content",
          icon: ["fal", "file-alt"],
          trad: !0
        },
        {
          id: "product",
          key: "entity",
          value: "new-products",
          label: "super-search.product",
          icon: ["fal", "barcode-scan"],
          trad: !0
        }
      ],
      chosenEntity: [],
      types: [
        {
          id: "article",
          key: "type",
          value: "Article",
          label: "super-search.article",
          groupLabel: "search.filters.types",
          iconUrl: On,
          color: $e.yellow.DEFAULT,
          trad: !0
        },
        {
          id: "diagnostic",
          key: "type",
          value: "Diagnostic",
          label: "super-search.diagnostic",
          groupLabel: "search.filters.types",
          iconUrl: xn,
          color: $e.blue.DEFAULT,
          trad: !0
        }
      ],
      chosenTypes: [],
      status: [
        {
          id: "draft",
          key: "published",
          value: "false",
          label: "super-search.draft",
          icon: ["fas", "ruler-triangle"],
          color: $e.gray[5],
          trad: !0
        },
        {
          id: "published",
          key: "published",
          value: "true",
          label: "super-search.published",
          icon: ["fas", "file-check"],
          color: $e.blue.DEFAULT,
          trad: !0
        },
        {
          id: "checked",
          key: "isOutdated",
          value: "false",
          label: "super-search.verified",
          icon: ["fas", "check-circle"],
          color: $e.green.DEFAULT,
          trad: !0
        },
        {
          id: "warning",
          key: "isOutdated",
          value: "true",
          label: "super-search.to-be-verified",
          icon: ["fas", "times-circle"],
          color: $e.red.DEFAULT,
          trad: !0
        }
      ],
      chosenStatus: [],
      labels: [],
      chosenLabels: [],
      univers: [],
      chosenUnivers: [],
      families: [],
      chosenFamilies: [],
      brands: [],
      chosenBrands: [],
      chosenAdvanced: [],
      isParametric: !1,
      hasContributions: !1,
      loadingLabels: !1,
      showMoreFilters: !1
    };
  },
  computed: {
    showEntities() {
      return !this.chosenEntity.length && this.isParametric;
    },
    showTypes() {
      return this.chosenEntity.length && this.chosenEntity[0].value === "attached-contents" || !this.isParametric;
    },
    searchEntity() {
      return this.chosenEntity[0] ? this.chosenEntity[0].value : "";
    },
    newSelectedTags() {
      return [
        ...this.chosenEntity,
        ...this.chosenTypes,
        ...this.chosenLabels,
        ...this.chosenStatus,
        ...this.chosenUnivers,
        ...this.chosenFamilies,
        ...this.chosenBrands,
        ...this.chosenAdvanced
      ];
    },
    labelsByCategories() {
      const e = this.labels.reduce((t, n) => {
        const o = n.groupLabel || "Autres";
        return t[o] || (t[o] = {
          name: o,
          labels: []
        }), t[o].labels.push(n), t;
      }, {});
      return Object.keys(e).forEach((t) => {
        e[t].labels.sort((n, o) => n.label.localeCompare(o.label));
      }), e;
    },
    displayedFilters() {
      if (this.showMoreFilters)
        return this.labelsByCategories;
      {
        const e = {};
        return Object.keys(this.labelsByCategories).slice(0, 2).forEach((n) => {
          e[n] = this.labelsByCategories[n];
        }), e;
      }
    },
    displayAdvancedFilters() {
      return this.advanced.length && !this.isCollection && !this.fullSize;
    },
    displayMoreButton() {
      return this.labelsByCategories && Object.keys(this.labelsByCategories).length > 2;
    },
    advanced() {
      return [
        ...this.content.type === "Case" ? [
          {
            id: "focusCase",
            key: "caseId",
            value: this.content.id,
            label: this.content.label,
            advancedLabel: this.$t("search.filters.focus-case", { label: this.content.label }),
            icon: "folder",
            color: $e.gray[5],
            trad: !1
          }
        ] : []
      ];
    },
    ...ue(le, ["content"])
  },
  watch: {
    selectedTags: {
      handler(e) {
        this.chosenEntity = e.filter((t) => t.key === "entity"), this.chosenTypes = e.filter((t) => t.key === "type"), this.chosenStatus = e.filter(
          (t) => t.key === "published" || t.key === "isOutdated" || t.key === "contribution"
        ), this.chosenUnivers = e.filter((t) => t.key === "knowledge"), this.chosenFamilies = e.filter((t) => t.key === "family"), this.chosenBrands = e.filter((t) => t.key === "brand"), this.chosenLabels = e.filter((t) => t.key === "categories"), this.chosenAdvanced = e.filter((t) => t.key === "caseId");
      },
      immediate: !0
    },
    content: {
      handler() {
        const e = this.chosenAdvanced.findIndex((t) => t.id === "focusCase");
        e !== -1 && (this.chosenAdvanced.splice(e, 1), this.updateSelectedTags());
      },
      deep: !0
    }
  },
  async mounted() {
    this.isParametric || (this.loadingLabels = !0, await this.loadLabels(), this.loadingLabels = !1), this.hasContributions && this.status.push({
      id: "contribution",
      key: "contribution",
      value: "true",
      label: "Contributions externes",
      icon: ["fas", "inbox-in"]
    });
  },
  methods: {
    handleAdvanced(e) {
      const t = this.chosenAdvanced.findIndex((n) => n.key === e.key);
      t === -1 ? this.chosenAdvanced.push(e) : this.chosenAdvanced.splice(t, 1), this.updateSelectedTags();
    },
    async handleEntity(e) {
      await this.loadEntityNextLevel(e), this.updateSelectedTags();
    },
    async handleUnivers(e) {
      this.chosenUnivers.findIndex((n) => n.value === e.value) === -1 ? await this.loadUniversNextLevel(e) : this.chosenUnivers = [], this.updateSelectedTags();
    },
    handleType(e) {
      const t = this.chosenTypes.findIndex((n) => n.value === e.value);
      t === -1 ? this.chosenTypes.push(e) : this.chosenTypes.splice(t, 1), this.updateSelectedTags();
    },
    handleClearTypes() {
      this.chosenTypes = [], this.updateSelectedTags();
    },
    handleLabel(e) {
      const t = this.chosenLabels.findIndex((n) => n.value === e.value);
      t === -1 ? this.chosenLabels.push(e) : this.chosenLabels.splice(t, 1), this.updateSelectedTags();
    },
    handleClearLabels() {
      this.chosenLabels = [], this.updateSelectedTags();
    },
    handleClearGroup(e) {
      this.$emit(
        "update-selected-tags",
        this.newSelectedTags.filter((t) => t.groupLabel !== e)
      );
    },
    handleStatus(e) {
      const t = this.chosenStatus.findIndex(
        (n) => n.value === e.value && n.key === e.key
      );
      t === -1 ? this.chosenStatus.push(e) : this.chosenStatus.splice(t, 1), this.updateSelectedTags();
    },
    async handleFamily(e) {
      const t = this.chosenFamilies.findIndex((n) => n.value === e.value);
      t === -1 ? (e.key = "family", this.chosenFamilies.push(e)) : (this.chosenFamilies.splice(t, 1), this.chosenBrands = []), await this.loadFamilyNextLevel(this.chosenFamilies), this.updateSelectedTags();
    },
    handleBrand(e) {
      const t = this.chosenBrands.findIndex((n) => n.value === e.value);
      t === -1 ? (e.key = "brand", this.chosenBrands.push(e)) : this.chosenBrands.splice(t, 1), this.updateSelectedTags();
    },
    async loadEntityNextLevel(e) {
      this.chosenEntity = [e];
    },
    async loadUniversNextLevel(e) {
      this.chosenUnivers = [e];
    },
    async loadFamilyNextLevel(e) {
    },
    async loadLabels() {
      const e = await this.getContentParameterLabels();
      this.labels = e.map((t) => ({
        key: "categories",
        label: t.labelName,
        value: t.id,
        id: t.id,
        color: t.color,
        icon: t.icon,
        groupLabel: t.categoryName
      }));
    },
    updateSelectedTags() {
      this.$emit("update-selected-tags", this.newSelectedTags);
    },
    enrichTags() {
      const e = [
        ...this.entities,
        ...this.types,
        ...this.status,
        ...this.labels,
        ...this.univers,
        ...this.families,
        ...this.brands
      ];
      return this.newSelectedTags.reduce((t, n) => {
        const o = e.find((i) => i.key === n.key && i.value === n.value);
        return o && t.push(o), t;
      }, []);
    },
    ...fe(kt, ["getContentParameterLabels"])
  }
}), X0 = { class: "flex flex-col gap-2" }, eh = {
  key: 2,
  class: "flex flex-col gap-2"
};
function th(e, t, n, o, i, r) {
  const s = R("SearchAdvancedFilters"), l = R("TagsGroup");
  return e.display ? (c(), p("div", {
    key: 0,
    class: D(["transition-height p-2 overflow-auto flex-none min-h-40 flex flex-col gap-2", e.showMoreFilters || e.fullSize ? "max-h-80 " : " max-h-44"])
  }, [
    m("div", X0, [
      e.displayAdvancedFilters ? (c(), C(s, {
        key: 0,
        tags: e.advanced,
        "selected-tags": e.selectedTags,
        onSelectTag: e.handleAdvanced
      }, null, 8, ["tags", "selected-tags", "onSelectTag"])) : A("", !0),
      e.showTypes ? (c(), C(l, {
        key: 1,
        "selected-tags": e.chosenTypes,
        tags: e.types,
        "group-label": "Types",
        onSelectTag: e.handleType,
        onResetGroup: e.handleClearTypes
      }, null, 8, ["selected-tags", "tags", "onSelectTag", "onResetGroup"])) : A("", !0),
      e.labels.length || e.loadingLabels ? (c(), p("div", eh, [
        (c(!0), p(X, null, te(e.displayedFilters, (a, u) => (c(), p("div", {
          key: u,
          class: "flex flex-col gap-1"
        }, [
          M(l, {
            "selected-tags": e.chosenLabels,
            tags: a.labels,
            "group-label": a.name,
            onSelectTag: e.handleLabel,
            onResetGroup: e.handleClearGroup
          }, null, 8, ["selected-tags", "tags", "group-label", "onSelectTag", "onResetGroup"])
        ]))), 128))
      ])) : A("", !0)
    ]),
    e.displayMoreButton ? (c(), p("p", {
      key: 0,
      class: "text-xs text-gray-6 font-semibold cursor-pointer",
      onClick: t[0] || (t[0] = (a) => e.showMoreFilters = !e.showMoreFilters)
    }, N(e.showMoreFilters ? e.$t("super-search.less-filters") : e.$t("super-search.more-filters")), 1)) : A("", !0)
  ], 2)) : A("", !0);
}
const xi = /* @__PURE__ */ x(q0, [["render", th]]), nh = {
  key: 0,
  class: "flex border-b border-gray-3 gap-4 pb-3 justify-between px-3 w-[300px]"
}, oh = { class: "font-bold" }, ih = /* @__PURE__ */ T({
  __name: "KnowledgeFilters",
  emits: ["update-filters"],
  setup(e, { emit: t }) {
    const n = le(), { filters: o, mainContentChildren: i, hasKnowledgeFilters: r } = De(n), s = k(() => Di(o.value)), l = (a) => {
      const u = a.filter((d) => d.key === "categories").map((d) => d.id), g = a.filter((d) => d.key === "type").map((d) => d.value);
      t("update-filters", {
        labels: u,
        types: g
      });
    };
    return (a, u) => {
      const g = P, d = P;
      return c(), p(X, null, [
        h(i).length > 1 || h(r) ? (c(), p("div", nh, [
          m("div", null, [
            M(g, {
              icon: ["fal", "sliders-v"],
              class: "mr-3"
            }),
            m("span", oh, N(a.$t("list-item.actions.filter")), 1)
          ]),
          m("div", null, [
            h(r) ? (c(), p("button", {
              key: 0,
              onClick: u[0] || (u[0] = (f) => l([])),
              class: "text-xs text-gray-7 hover:text-black"
            }, [
              M(d, {
                icon: ["fal", "arrow-rotate-left"],
                style: { "font-size": "12px" }
              }),
              ne(" " + N(a.$t("list-item.actions.reset")), 1)
            ])) : A("", !0)
          ])
        ])) : A("", !0),
        M(xi, {
          onUpdateSelectedTags: l,
          "selected-tags": h(s),
          fullSize: "",
          isCollection: ""
        }, null, 8, ["selected-tags"])
      ], 64);
    };
  }
}), sh = {
  async install(e, t = {}) {
    const n = ze.KNOWLEDGE;
    if (t.pinia === void 0) {
      console.error(`[${n}] 🍍 pinia store instance not provided`);
      return;
    }
    if (t.knowledgeClient === void 0) {
      console.error(`[${n}] 🛰 axios instance not provided`);
      return;
    }
    t.i18n === void 0 && console.error(`[${n}] 🇫🇷 i18n instance not provided`);
    const { pinia: o, knowledgeClient: i, adminClient: r } = t;
    o.use(({ store: s }) => {
      if (s.$id === n)
        if (s.$knowledgeService = pr(i, r), t.appFunctions !== void 0) {
          const { logs: l, notify: a } = t.appFunctions;
          s.$logs = l || (() => {
            console.error(`[${n}] 🛠 log function not provided`);
          }), s.$notify = a || (() => {
            console.error(`[${n}] 🛠 notify function not provided`);
          });
        } else
          console.error(`[${n}] 🛠 app functions not provided`);
    }), Object.keys(et).forEach((s) => {
      var l;
      (l = t.i18n) == null || l.global.mergeLocaleMessage(s, et[s]);
    }), e.component("knowledge-view", Fd), e.component("collection-view", kg), e.component("main-content-view", Dm), e.component("modal-content-view", Tm), e.component("panel-collection-view", _m), e.component("content-viewer", Si), e.component("ai-agent-collapse", Pm), e.component("language-switcher", jo), e.component("knowledge-dropdown", ko), e.component("main-knowledge-breadcrumb-wrapper", u0), e.component("modal-knowledge-breadcrumb-wrapper", p0), e.component("case-navigation", N0), e.component("table-of-contents", v0), e.component("case-description-row", j0), e.component("knowledge-sort-dropdown", E0), e.component("knowledge-filters", ih);
  }
}, nN = {
  plugin: sh,
  useStore: le,
  attachService: pr
}, rh = {
  favoriteIds: (e) => e.userFavorites.map((t) => t.entity ? t.entity.id : null).filter(Boolean),
  itemIsFavorite: (e) => (t, n) => !!e.userFavorites.find((o) => o.entity.id === t && o.lang === n)
}, ah = {
  userFavorites: [],
  userTabs: [],
  currentTab: [],
  currentTabId: null,
  currentTabType: null,
  loadingUserTabs: !1,
  loadingCurrentTab: !1,
  loadingFavorites: !1,
  searchResults: [],
  loadingSearch: !1,
  searchDisplay: !1,
  searchQuery: !1
};
function Ns() {
  return Object.assign({}, {}, ah);
}
const Ot = Wt(ze.FAVORITES, {
  state: Ns,
  getters: { ...rh },
  actions: {
    mutate(e) {
      this.$patch((t) => {
        Object.keys(e).forEach((n) => {
          t[n] = e[n];
        });
      });
    },
    // patch object will not be synced
    unsyncedMutate(e) {
      this.$patch(e);
    },
    reset() {
      this.mutate(Ns());
    },
    logs(e) {
      this.$logs(e);
    },
    logAddFavorite(e) {
      const t = e.at(-1);
      if (!t)
        return;
      const n = {
        favorite: {
          id: t.entity.id,
          type: t.entity.type,
          lang: t.lang,
          totalFavorites: e.length
        },
        favoriteType: "USER_FAVORITE"
      };
      this.logs({
        topic: "CONTENT_FAVORITE_ADD",
        event: n
      });
    },
    logRemoveFavorite(e) {
      const t = {
        favorite: {
          id: e.entity.id,
          type: e.entity.type,
          lang: e.lang,
          totalFavorites: this.userFavorites.length
        },
        favoriteType: "USER_FAVORITE"
      };
      this.logs({
        topic: "CONTENT_FAVORITE_REMOVE",
        event: t
      });
    },
    async updateUserFavoritesOrder(e) {
      await this.$userDirectoryService.updateUserFavoritesOrder(e);
    },
    async fetchUserFavorites() {
      const { enrichedChildren: e } = await this.$userDirectoryService.getUserFavorites(), t = this.filterEmptyEnrichedChildren(e);
      this.mutate({ userFavorites: t });
    },
    async fetchUserTabs() {
      this.mutate({ loadingUserTabs: !0 });
      const { userTabs: e } = await this.$userDirectoryService.getUserTabs();
      this.mutate({ userTabs: e.tabs }), this.mutate({ loadingUserTabs: !1 });
    },
    async fetchCurrentTab() {
      if (!this.currentTabId)
        return;
      this.mutate({ loadingCurrentTab: !0 });
      const { tab: e } = await this.$userDirectoryService.getCurrentTab(this.currentTabId), t = this.filterEmptyEnrichedChildren(e.enrichedChildren);
      this.mutate({ currentTab: t }), this.mutate({ loadingCurrentTab: !1 });
    },
    setCurrentTabType(e) {
      this.mutate({ currentTabType: e });
    },
    setCurrentTabId(e) {
      this.mutate({ currentTabId: e });
    },
    async addUserFavorite(e, t) {
      this.mutate({ loadingCurrentTab: !0 });
      const { enrichedChildren: n } = await this.$userDirectoryService.addUserFavorite(e, t), o = this.filterEmptyEnrichedChildren(n);
      this.logAddFavorite(o), this.mutate({ userFavorites: o }), this.currentTab[0] && this.currentTab[0].type === "UserFavoriteEntity" && this.mutate({ currentTab: o }), this.mutate({ loadingCurrentTab: !1 });
    },
    async removeUserFavorite(e) {
      this.mutate({ loadingCurrentTab: !0 });
      const { enrichedChildren: t } = await this.$userDirectoryService.removeUserFavorite(e), n = this.filterEmptyEnrichedChildren(t);
      this.currentTab[0] && this.currentTab[0].type === "UserFavoriteEntity" && this.mutate({ currentTab: n }), this.removeFavorite(e), this.mutate({ loadingCurrentTab: !1 });
    },
    removeFavorite(e) {
      const t = [...this.userFavorites], n = t.findIndex((i) => i.id === e);
      if (n === -1)
        return;
      const o = t.splice(n, 1)[0];
      this.mutate({ userFavorites: t }), this.logRemoveFavorite(o);
    },
    async removeFavoriteContent(e, t) {
      const n = this.userFavorites.find((o) => o.entity.id === e && o.lang === t);
      n && this.removeUserFavorite(n.id);
    },
    async searchFavorites(e) {
      this.mutate({ loadingSearch: !0 });
      const t = this.currentTab.filter(
        (n) => n.entity.label.toLowerCase().includes(e.query.toLowerCase())
      );
      this.mutate({ searchResults: t }), this.mutate({ loadingSearch: !1 });
    },
    setSearchQuery(e) {
      this.mutate({ searchQuery: e });
    },
    openSearch() {
      this.mutate({ searchDisplay: !0 });
    },
    async closeSearch() {
      this.mutate({ loadingSearch: !1 }), this.mutate({ searchDisplay: !1 }), this.mutate({ searchResults: [] });
    },
    filterEmptyEnrichedChildren(e) {
      return e.reduce((t, n) => (n.entity && t.push(n), t), []);
    }
  },
  persist: {
    key: `md-${ze.FAVORITES}`
  },
  share: {
    enable: !1
  }
});
class lh {
  constructor(t) {
    xe(this, "apiClient");
    this.apiClient = t;
  }
  async getUserTabs() {
    const t = await this.apiClient.get("user-tabs");
    return t.data || t;
  }
  async getCurrentTab(t) {
    const n = await this.apiClient.get(`tab/${t}`);
    return n.data || n;
  }
  async getUserFavorites() {
    const t = await this.apiClient.get("user-favorites-tab");
    return t.data || t;
  }
  async addUserFavorite(t, n) {
    const o = await this.apiClient.post("user-favorites", { entityId: t, lang: n });
    return o.data || o;
  }
  async removeUserFavorite(t) {
    const n = await this.apiClient.delete(`user-favorites/${t}`);
    return n.data || n;
  }
  async updateUserFavoritesOrder(t) {
    const n = await this.apiClient.patch("user-favorites-tab", {
      favorites: t
    });
    return n.data || n;
  }
  async search({ lang: t, query: n, filters: o }) {
    const i = await this.apiClient.post(`favorites/search?q=${n}&lang=${t}`, {
      filters: o
    });
    return i.data || i;
  }
}
const jr = (e) => new lh(e), ch = T({
  name: "FavoritesItem",
  components: {
    EntityIcon: ln
  },
  props: {
    item: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      required: !0
    },
    editable: {
      type: Boolean,
      default: !1
    },
    notDraggable: {
      type: Boolean,
      default: !1
    },
    lang: {
      type: String,
      required: !0
    }
  },
  emits: ["delete-item"],
  computed: {
    ...ue(Ot, ["itemIsFavorite"])
  }
}), uh = { class: "flex-none flex items-center justify-center" };
function dh(e, t, n, o, i, r) {
  const s = ln, l = P, a = ye, u = Le;
  return c(), p("button", {
    class: D(["relative flex items-center gap-2 py-3 px-2 rounded bg-white dark:bg-black text-gray-8 dark:text-gray-1 w-full transition-all overflow-hidden border-gray-2 dark:border-gray-8 border hover:shadow-sm", { group: e.editable }])
  }, [
    m("div", uh, [
      M(s, {
        class: "flex group-hover:hidden",
        type: e.item.type,
        typename: "Content",
        isFavorite: e.type === "UserFavoriteEntity" || e.itemIsFavorite(e.item.id, e.lang)
      }, null, 8, ["type", "isFavorite"]),
      M(a, {
        type: "secondary",
        icon: "",
        size: "mini",
        class: "!w-7 !h-7 !min-w-7 !hidden group-hover:!flex items-center justify-center text-xs border border-gray-2 dark:border-gray-8",
        onClick: t[0] || (t[0] = be((g) => e.$emit("delete-item"), ["prevent", "stop"]))
      }, {
        default: _(() => [
          M(l, { icon: ["fal", "trash"] })
        ]),
        _: 1
      })
    ]),
    M(u, {
      text: e.item.label,
      class: "text-blue-9 text-sm"
    }, null, 8, ["text"]),
    e.notDraggable ? A("", !0) : (c(), C(l, {
      key: 0,
      class: "flex-none text-xs ml-auto",
      icon: ["fal", "bars"]
    }))
  ], 2);
}
const gh = /* @__PURE__ */ x(ch, [["render", dh]]), ph = {}, mh = { class: "bg-white/50 flex items-center justify-center h-full w-full absolute inset-0 z-50" };
function hh(e, t) {
  const n = P;
  return c(), p("div", mh, [
    M(n, {
      icon: ["fas", "spinner-third"],
      class: "text-primary text-2xl",
      spin: ""
    })
  ]);
}
const Lo = /* @__PURE__ */ x(ph, [["render", hh]]), fh = T({
  name: "FavoritesList",
  components: {
    FavoritesItem: gh,
    LoaderSpinner: Lo
  },
  props: {
    favorites: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: !1
    },
    searchInProgress: {
      type: Boolean,
      default: !1
    },
    showEdition: {
      type: Boolean,
      default: !0
    },
    currentTabType: {
      type: String,
      default: "UserFavoritesTab"
    }
  },
  emits: ["update-order", "select-item", "delete-favorite"],
  data() {
    return {
      editable: !1,
      userFavorites: []
    };
  },
  computed: {
    hideEdition() {
      return !this.userFavorites.length || this.searchInProgress;
    },
    draggableDisabled() {
      return !this.editable || this.searchInProgress;
    },
    emptyState() {
      if (this.searchInProgress)
        return {
          title: "favorites.search-empty-state.title",
          subtitle: "favorites.search-empty-state.subtitle"
        };
      switch (this.currentTabType) {
        case "UserFavoritesTab":
          return {
            title: "favorites.empty-state.user-favorites.title",
            subtitle: "favorites.empty-state.user-favorites.subtitle"
          };
        case "CompanyFavoritesTab":
          return {
            title: "favorites.empty-state.company-favorites.title",
            subtitle: "favorites.empty-state.company-favorites.subtitle"
          };
        default:
          return {
            title: "favorites.empty-state.user-favorites.title",
            subtitle: "favorites.empty-state.user-favorites.subtitle"
          };
      }
    }
  },
  watch: {
    favorites: {
      immediate: !0,
      deep: !0,
      handler(e) {
        this.userFavorites = e;
      }
    },
    showEdition(e) {
      e || (this.editable = !1);
    }
  },
  methods: {
    handleDraggable() {
      const e = this.userFavorites.map((t) => t.id);
      this.$emit("update-order", e);
    }
  }
}), yh = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xml:space='preserve'%20id='Calque_1'%20x='0'%20y='0'%20style='enable-background:new%200%200%20139%20106.8'%20version='1.1'%20viewBox='0%200%20139%20106.8'%3e%3cstyle%3e.st0%7bfill:%23eaeef9%7d.st2%7bfill:%23d5ddea%7d%3c/style%3e%3cpath%20d='M69.4%20103.9c27.5%200%2049.7-22.3%2049.7-49.8%200-27.6-22.4-49.8-49.7-49.8-27.4%200-49.7%2022.2-49.7%2049.8s22.3%2049.8%2049.7%2049.8zM23.8%2016.2c0-.2-.2-.2-.3-.2s-.3.1-.3.2l-.7%201.6-1.7.2c-.1%200-.2.1-.3.3%200%20.1%200%20.3.1.4l1.2%201.2-.3%201.7c0%20.1%200%20.3.1.4s.3.1.4%200l1.5-.8%201.5.8c.1.1.3.1.4%200s.2-.2.1-.4l-.3-1.7%201.2-1.2c.1-.1.1-.2.1-.4%200-.1-.2-.2-.3-.3l-1.6-.2-.8-1.6z'%20class='st0'/%3e%3clinearGradient%20id='SVGID_1_'%20x1='69.3'%20x2='69.3'%20y1='721.36'%20y2='813.211'%20gradientTransform='translate(0%20-716.089)'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0'%20style='stop-color:%23fdfeff'/%3e%3cstop%20offset='.996'%20style='stop-color:%23ecf0f5'/%3e%3c/linearGradient%3e%3cpath%20d='m103.2%2029.2.8%2063.1c0%202.2-1.8%203.8-3.9%203.8H38.5c-2.2%200-3.9-1.8-3.9-3.8V11.2c0-2.2%201.8-3.8%203.9-3.8h44.6l20.1%2021.8z'%20style='fill:url(%23SVGID_1_)'/%3e%3cpath%20d='M64.6%2083.5h-12c-.5%200-.9-.5-.9-1.1s.4-1.1.9-1.1h12.1c.5%200%20.9.5.9%201.1-.1.7-.5%201.1-1%201.1z'%20class='st2'/%3e%3cpath%20d='M57.7%2083.5H44.6c-.5%200-.9-.5-.9-1.1s.4-1.1.9-1.1h13.1c.5%200%20.9.5.9%201.1%200%20.7-.4%201.1-.9%201.1zm16.8-62.9H45c-.7%200-1.3-.6-1.3-1.3%200-.7.6-1.3%201.3-1.3h29.5c.7%200%201.3.6%201.3%201.3s-.6%201.3-1.3%201.3zm-18.1%207H45c-.7%200-1.3-.6-1.3-1.3%200-.7.6-1.3%201.3-1.3h11.3c.7%200%201.3.6%201.3%201.3s-.6%201.3-1.2%201.3zM83.1%207.3v17.5c0%202.5%202.2%204.4%204.6%204.4h15.5'%20class='st2'/%3e%3cpath%20d='M89.9%2019.4c-.1-.2-.2-.3-.4-.3s-.4.1-.4.3l-1%202.1-2.2.3c-.2%200-.3.2-.4.3-.1.2%200%20.4.1.5l1.6%201.6-.4%202.3c0%20.2%200%20.4.2.5s.3.1.5%200l1.9-1.1%201.9%201.1c.2.1.4.1.5%200%20.2-.1.2-.3.2-.5l-.4-2.3%201.6-1.6c.1-.1.2-.3.1-.5s-.2-.3-.4-.3l-2.2-.3-.8-2.1z'%20style='fill:white'/%3e%3cpath%20d='M94.5%2066.5H45.4c-.5%200-.9.5-.9%201.1%200%20.5.4%201.1.9%201.1h49c.5%200%20.9-.5.9-1.1s-.4-1.1-.8-1.1zm-.1-7.9h-49c-.5%200-.9.5-.9%201.1%200%20.5.4%201.1.9%201.1h49c.5%200%20.9-.5.9-1.1-.1-.7-.5-1.1-.9-1.1zm.3-8.1H45.4c-.5%200-.9.5-.9%201.1%200%20.5.4%201.1.9%201.1h49.2c.5%200%20.9-.5.9-1.1.1-.5-.4-1.1-.8-1.1z'%20class='st2'/%3e%3cpath%20d='M58.8%2084.3H45.4c-.5%200-.9-.5-.9-1.1%200-.5.4-1.1.9-1.1h13.4c.5%200%20.9.5.9%201.1%200%20.8-.4%201.1-.9%201.1z'%20style='fill:%23e3eaf2'/%3e%3cpath%20d='M95%2042.5H45.4c-.5%200-.9.5-.9%201.1%200%20.5.4%201.1.9%201.1H95c.6%200%201-.5%201-1.1-.1-.5-.4-1.1-1-1.1z'%20class='st2'/%3e%3cpath%20d='M120.9%2015.2c-.1-.2-.2-.3-.4-.3s-.4.1-.4.3l-1%202.1-2.2.3c-.2%200-.3.2-.4.3-.1.2%200%20.4.1.5l1.6%201.6-.4%202.3c0%20.2%200%20.4.2.5.1.1.3.1.5%200l1.9-1.1%201.9%201.1c.2.1.4.1.5%200%20.2-.1.2-.3.2-.5l-.4-2.3%201.6-1.6c.1-.1.2-.3.1-.5s-.2-.3-.4-.3l-2.2-.3-.8-2.1zM7.1%2063.4c-.1-.3-.3-.4-.6-.4s-.5.2-.7.4l-1.5%203.1-3.2.5c-.3%200-.5.2-.6.5s0%20.6.2.8l2.4%202.4-.6%203.4c0%20.3.1.6.3.7.2.2.5.2.8.1l2.9-1.6%202.9%201.6c.3.1.6.1.8-.1s.3-.5.3-.7l-.6-3.4%202.4-2.4c.2-.2.3-.5.2-.8s-.3-.5-.6-.5l-3.3-.5-1.5-3.1zM136.2.7c-.1-.2-.2-.2-.3-.2-.2%200-.3.1-.3.2l-.8%201.6-1.7.2c-.2%200-.2.2-.3.2-.1.2%200%20.3.1.4l1.2%201.2-.3%201.8c0%20.2%200%20.3.2.4.1.1.2.1.4%200l1.4-.8%201.4.8c.2.1.3.1.4%200%20.2-.1.2-.2.2-.4l-.3-1.8%201.2-1.2c.1-.1.2-.2.1-.4s-.2-.2-.3-.2l-1.7-.2-.6-1.6z'%20class='st0'/%3e%3c/svg%3e", Ih = {
  key: 0,
  class: "flex items-center justify-end pb-2 px-2"
}, Mh = { class: "px-4 max-h-[calc(100%-32px)] overflow-y-auto overflow-x-hidden" }, Ah = {
  key: 0,
  class: "relative mb-2"
}, Nh = {
  key: 0,
  class: "space-y-2"
}, bh = {
  key: 1,
  class: "text-center py-16"
}, Ch = /* @__PURE__ */ m("img", {
  alt: "favorites empty state",
  class: "w-24 mx-auto",
  src: yh
}, null, -1), wh = { class: "font-bold mt-6 mb-2" }, Dh = { class: "text-sm text-gray-7" };
function zh(e, t, n, o, i, r) {
  const s = P, l = ye, a = cn, u = R("FavoritesItem"), g = R("draggable");
  return c(), p("div", {
    class: D(["h-full bg-gray-1", [e.showEdition ? "pt-2" : "pt-4"]])
  }, [
    e.showEdition ? (c(), p("div", Ih, [
      M(l, {
        type: "secondary",
        size: "mini",
        hyperlink: "",
        class: D([{ editable: e.editable, invisible: e.hideEdition }, "!text-right hover:!text-blue"]),
        onClick: t[0] || (t[0] = (d) => e.editable = !e.editable)
      }, {
        default: _(() => [
          M(s, {
            icon: ["fal", `${e.editable ? "check" : "pen"}`]
          }, null, 8, ["icon"]),
          ne(" " + N(e.editable ? e.$t("favorites.done") : e.$t("favorites.edit")), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ])) : A("", !0),
    m("div", Mh, [
      e.userFavorites.length || e.loading ? (c(), p("div", Ah, [
        e.loading ? (c(), p("div", Nh, [
          (c(), p(X, null, te(7, (d) => M(a, {
            key: d,
            index: d
          }, null, 8, ["index"])), 64))
        ])) : (c(), C(g, {
          key: 1,
          class: D(["space-y-2", { "min-h-[128px]": !e.userFavorites.length }]),
          modelValue: e.userFavorites,
          "onUpdate:modelValue": t[1] || (t[1] = (d) => e.userFavorites = d),
          animation: 200,
          disabled: e.draggableDisabled,
          handle: ".md-item",
          onEnd: e.handleDraggable,
          "item-key": "id"
        }, {
          item: _(({ element: d }) => [
            (c(), C(u, {
              class: "md-item",
              key: d.id,
              editable: d.type !== "CompanyFavoriteEntity" || e.editable,
              item: d.entity,
              type: d.type,
              lang: d.lang,
              "not-draggable": e.draggableDisabled,
              onClick: (f) => e.$emit("select-item", { ...d.entity, lang: d.lang }),
              onDeleteItem: (f) => e.$emit("delete-favorite", d.id)
            }, null, 8, ["editable", "item", "type", "lang", "not-draggable", "onClick", "onDeleteItem"]))
          ]),
          _: 1
        }, 8, ["modelValue", "class", "disabled", "onEnd"]))
      ])) : (c(), p("div", bh, [
        Ch,
        m("div", wh, N(e.$t(e.emptyState.title)), 1),
        m("div", Dh, N(e.$t(e.emptyState.subtitle)), 1)
      ]))
    ])
  ], 2);
}
const vh = /* @__PURE__ */ x(fh, [["render", zh]]), Sr = {
  UserFavoritesTab: { type: "UserFavoriteEntity", isUserDependant: !0 },
  CompanyFavoritesTab: {
    type: "CompanyFavoriteEntity",
    isUserDependant: !1
  }
}, Th = {
  UserFavoritesTab: ["fal", "star"],
  CompanyFavoritesTab: ["fal", "thumbtack"]
}, kh = T({
  name: "FavoritesListView",
  components: {
    FavoritesList: vh
  },
  emits: ["select-item"],
  computed: {
    favoritesToDisplay() {
      return this.searchQuery && (!this.searchResults || !this.searchResults.length) ? [] : this.searchResults && this.searchResults.length ? this.searchResults : this.currentTab;
    },
    listLoading() {
      return !this.loadingUserTabs && this.loadingCurrentTab || this.loadingSearch;
    },
    currentTabIsEditable() {
      return this.currentTabType ? Sr[this.currentTabType].isUserDependant : !0;
    },
    ...ue(Ot, [
      "currentTab",
      "searchResults",
      "loadingUserTabs",
      "loadingCurrentTab",
      "loadingSearch",
      "searchDisplay",
      "searchQuery",
      "currentTabType"
    ]),
    ...wo(Ot)
  },
  methods: {
    async handleRemoveUserFavorite(e) {
      return this.removeUserFavorite(e);
    },
    ...fe(Ot, ["removeUserFavorite", "updateUserFavoritesOrder"])
  }
});
function jh(e, t, n, o, i, r) {
  const s = R("FavoritesList");
  return c(), C(s, {
    favorites: e.favoritesToDisplay,
    loading: e.listLoading,
    "show-edition": e.currentTabIsEditable,
    "search-in-progress": e.searchDisplay,
    "current-tab-type": e.currentTabType,
    onDeleteFavorite: e.handleRemoveUserFavorite,
    onUpdateOrder: e.updateUserFavoritesOrder,
    onSelectItem: t[0] || (t[0] = (l) => e.$emit("select-item", { ...l, source: "favorites" }))
  }, null, 8, ["favorites", "loading", "show-edition", "search-in-progress", "current-tab-type", "onDeleteFavorite", "onUpdateOrder"]);
}
const Sh = /* @__PURE__ */ x(kh, [["render", jh]]), Lh = T({
  name: "FavoritesTabs",
  props: {
    tabs: {
      type: Array,
      required: !0
    },
    activeTab: {
      type: String,
      default: null
    },
    altStyle: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update-active-tab"],
  computed: {
    enrichedActiveTab() {
      return this.tabs.find((e) => e.id === this.activeTab);
    },
    enrichedTabs() {
      return this.tabs.map((t) => ({
        ...t,
        icon: Th[t.type]
      }));
    }
  },
  methods: {
    setActiveTab(e) {
      this.$emit("update-active-tab", e);
    }
  }
}), Eh = { class: "flex flex-col h-full w-full flex-1" }, Oh = { class: "flex items-center gap-3 h-full w-full mt-2" }, xh = ["onClick"], _h = {
  key: 0,
  class: "bg-white flex flex-col overflow-auto h-fit w-full flex-1"
};
function Uh(e, t, n, o, i, r) {
  const s = P;
  return c(), p("div", Eh, [
    m("div", Oh, [
      (c(!0), p(X, null, te(e.enrichedTabs, (l) => (c(), p("button", {
        key: l.id,
        class: D(["flex items-center justify-center w-8.5 h-8.5 text-sm rounded transition-colors", [
          e.altStyle ? "text-primary hover:bg-primary/10 alt:text-gray-9.5" : "text-primary-contrast bg-transparent hover:bg-primary-contrast/10",
          {
            "!text-primary !bg-primary-contrast": l.id === e.activeTab && !e.altStyle,
            "!bg-primary !text-primary-contrast hover:!bg-primary alt:!bg-gray-9.5 alt:!text-white": l.id === e.activeTab && e.altStyle
          }
        ]]),
        onClick: (a) => e.setActiveTab(l.id)
      }, [
        M(s, {
          icon: l.icon
        }, null, 8, ["icon"])
      ], 10, xh))), 128))
    ]),
    e.enrichedActiveTab ? (c(), p("div", _h, [
      Te(e.$slots, e.enrichedActiveTab.label)
    ])) : A("", !0)
  ]);
}
const Fh = /* @__PURE__ */ x(Lh, [["render", Uh]]), $h = T({
  name: "FavoritesBar",
  components: {
    FavoritesTabs: Fh
  },
  props: {
    userTabs: {
      type: Array,
      default: () => []
    },
    loadingUserTabs: {
      type: Boolean,
      default: !1
    },
    currentTabId: {
      type: String,
      default: null
    },
    altStyle: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["search", "close-search", "update-current-tab"],
  data() {
    return {
      searchActive: !1,
      searchInput: ""
    };
  },
  watch: {
    searchInput(e) {
      this.$emit("search", e);
    }
  },
  methods: {
    focusSearch() {
      this.searchActive = !0, this.$refs["fav-input"].focus();
    },
    closeSearch() {
      this.searchActive = !1, this.searchInput = "", this.$emit("close-search");
    },
    closeEmptySearch() {
      this.searchInput || this.closeSearch();
    }
  }
});
const Rh = (e) => (Sn("data-v-a906b542"), e = e(), Ln(), e), Vh = { class: "md-translate-container" }, Bh = { class: "md-search-bar" }, Yh = { class: "md-search-input" }, Qh = { class: "md-search-actions" }, Ph = { class: "md-close-container" }, Gh = /* @__PURE__ */ Rh(() => /* @__PURE__ */ m("div", { class: "md-grow-space" }, null, -1));
function Zh(e, t, n, o, i, r) {
  const s = R("FavoritesTabs"), l = P, a = It("click-outside");
  return c(), p("div", {
    class: D(["md-favorites-bar", { "md-search-active": e.searchActive }])
  }, [
    m("div", Vh, [
      M(s, {
        tabs: e.userTabs,
        activeTab: e.currentTabId,
        altStyle: e.altStyle,
        onUpdateActiveTab: t[0] || (t[0] = (u) => e.$emit("update-current-tab", u))
      }, null, 8, ["tabs", "activeTab", "altStyle"])
    ]),
    Ze((c(), p("div", Bh, [
      m("div", Yh, [
        Ze(m("input", {
          ref: "fav-input",
          type: "text",
          class: "md-input",
          "onUpdate:modelValue": t[1] || (t[1] = (u) => e.searchInput = u),
          onKeyup: t[2] || (t[2] = Co((...u) => e.closeSearch && e.closeSearch(...u), ["escape"]))
        }, null, 544), [
          [yi, e.searchInput]
        ])
      ]),
      m("div", Qh, [
        m("button", {
          class: D(["md-search-button", {
            "!bg-primary !text-primary-contrast hover:!bg-primary-6 alt:!bg-gray-9.5 alt:!text-white": e.altStyle
          }]),
          onClick: t[3] || (t[3] = (...u) => e.focusSearch && e.focusSearch(...u))
        }, [
          M(l, {
            class: "md-search-icon",
            icon: ["fal", "search"]
          })
        ], 2),
        m("button", Ph, [
          M(l, {
            onClick: be(e.closeSearch, ["stop"]),
            class: D(["md-close-icon", { "!text-primary alt:!text-gray-9.5": e.altStyle }]),
            icon: ["fal", "times"]
          }, null, 8, ["onClick", "class"])
        ])
      ]),
      Gh
    ])), [
      [a, e.closeEmptySearch]
    ])
  ], 2);
}
const Wh = /* @__PURE__ */ x($h, [["render", Zh], ["__scopeId", "data-v-a906b542"]]), Hh = T({
  name: "FavoritesBarView",
  components: {
    FavoritesBar: Wh
  },
  props: {
    language: {
      type: String,
      required: !0
    },
    altStyle: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      debounceSearch: Li((e) => {
        this.handleSearch(e);
      }, 200)
    };
  },
  async created() {
    await this.fetchUserTabs(), await this.handleUpdateCurrentTab(this.userTabs[0].id);
  },
  computed: {
    ...ue(Ot, [
      "userTabs",
      "currentTabId",
      "loadingUserTabs",
      "searchQuery",
      "currentTabType"
    ]),
    ...wo(Ot)
  },
  methods: {
    handleSearch(e) {
      this.setSearchQuery(e), this.openSearch(), e && this.searchFavorites({
        lang: this.language,
        query: e,
        filters: {
          ...this.currentTabType ? Sr[this.currentTabType] : {},
          ancestorId: this.currentTabId
        }
      });
    },
    handleCloseSearch() {
      this.closeSearch();
    },
    async handleUpdateCurrentTab(e) {
      this.setCurrentTabId(e);
      const t = this.userTabs.find((n) => n.id === e);
      t && this.setCurrentTabType(t.type), await this.fetchCurrentTab();
    },
    ...fe(Ot, [
      "fetchUserTabs",
      "fetchCurrentTab",
      "setCurrentTabType",
      "setCurrentTabId",
      "searchFavorites",
      "closeSearch",
      "openSearch",
      "setSearchQuery"
    ])
  },
  watch: {
    searchQuery: {
      handler(e) {
        e === "" && this.closeSearch();
      }
    }
  }
});
function Jh(e, t, n, o, i, r) {
  const s = R("FavoritesBar");
  return c(), C(s, {
    "user-tabs": e.userTabs,
    "current-tab-id": e.currentTabId,
    "loading-user-tabs": e.loadingUserTabs,
    altStyle: e.altStyle,
    onSearch: e.debounceSearch,
    onUpdateCurrentTab: e.handleUpdateCurrentTab,
    onCloseSearch: e.handleCloseSearch
  }, null, 8, ["user-tabs", "current-tab-id", "loading-user-tabs", "altStyle", "onSearch", "onUpdateCurrentTab", "onCloseSearch"]);
}
const Kh = /* @__PURE__ */ x(Hh, [["render", Jh]]), qh = {
  async install(e, t = {}) {
    const n = ze.FAVORITES;
    if (t.pinia === void 0) {
      console.error(`[${n}] 🍍 pinia store instance not provided`);
      return;
    }
    if (t.knowledgeClient === void 0) {
      console.error(`[${n}] 🛰 axios instance not provided`);
      return;
    }
    t.i18n === void 0 && console.error(`[${n}] 🇫🇷 i18n instance not provided`);
    const { pinia: o, knowledgeClient: i } = t;
    o.use(({ store: r }) => {
      if (r.$id === n)
        if (r.$userDirectoryService = jr(i), t.appFunctions !== void 0) {
          const { logs: s } = t.appFunctions;
          r.$logs = s || (() => {
            console.error(`[${n}] 🛠 log function not provided`);
          });
        } else
          console.error(`[${n}] 🛠 app functions not provided`);
    }), Object.keys(et).forEach((r) => {
      var s;
      (s = t.i18n) == null || s.global.mergeLocaleMessage(r, et[r]);
    }), e.component("favorites-list-view", Sh), e.component("favorites-bar-view", Kh);
  }
}, oN = {
  plugin: qh,
  useStore: Ot,
  attachService: jr
};
var No = /* @__PURE__ */ ((e) => (e.Agent = "Agent", e.Feedback = "Feedback", e.TaskComment = "TaskComment", e.InternalTaskComment = "InternalTaskComment", e.TaskMoved = "TaskMoved", e.TaskUpvoted = "TaskUpvoted", e.TaskAssigned = "TaskAssigned", e.ContentToVerify = "ContentToVerify", e.ContentMention = "ContentMention", e))(No || {});
const Xh = (e, t) => {
  const { authorId: n } = e, { type: o } = e.metadata;
  if (o === "Agent") {
    const {
      entityId: s,
      entityType: l,
      lang: a,
      label: u,
      body: g,
      tags: d,
      attachments: f,
      urgent: I
    } = e.metadata, z = ef(u, I), v = tf(
      e.updatedAt,
      d,
      g,
      "notifications.info.attached-content",
      s || "",
      l || "",
      a || "",
      f
    );
    return {
      title: z,
      body: v
    };
  }
  if (o === "TaskComment") {
    const { entityId: s, entityType: l, lang: a, thread: u, mentions: g } = e.metadata, d = n === t;
    let f = !1;
    g && (f = g.map((ee) => {
      const j = ee.split("/");
      return j[0] === "user" && j[1] === t;
    }).includes(!0));
    let I = !1;
    !f && u && u.length && (I = u.map((ee) => !ee.mentions || !ee.mentions.length ? !1 : ee.mentions.map((j) => {
      const G = j.split("/");
      return G[0] === "user" && G[1] === t;
    }).includes(!0)).includes(!0));
    const Q = mt(
      n,
      `notifications.feedback.title.${d ? "TaskMineComment" : f ? "MentionTaskComment" : I ? "UsedToBeMentionTaskComment" : "TaskComment"}`,
      s || "",
      l || "",
      a || "",
      d
    ), H = rf(e.updatedAt, u, e._id);
    return { title: Q, body: H };
  }
  if (o === "InternalTaskComment") {
    const { entityId: s, entityType: l, lang: a, body: u, attachments: g, mentions: d } = e.metadata, f = n === t;
    let I = !1;
    d && (I = d.map((ee) => {
      const j = ee.split("/");
      return j[0] === "user" && j[1] === t;
    }).includes(!0));
    const Q = mt(
      n,
      `notifications.feedback.title.${f ? "InternalTaskMineComment" : I ? "MentionInternalTaskComment" : "InternalTaskComment"}`,
      s || "",
      l || "",
      a || "",
      f
    ), H = af(e.updatedAt, u, g);
    return {
      title: Q,
      body: H
    };
  }
  if (o === "TaskMoved" || o === "TaskUpvoted") {
    const { entityId: s, entityType: l, lang: a, taskId: u } = e.metadata, g = `notifications.feedback.title.${o}`, d = mt(n, g, s || "", l || "", a || ""), f = sf(e.updatedAt, u);
    return { title: d, body: f };
  }
  if (o === "TaskAssigned") {
    const { entityId: s, entityType: l, lang: a, taskId: u } = e.metadata, g = `notifications.feedback.title.${o}`, d = mt(n, g, s || "", l || "", a || ""), f = nf(e.updatedAt, u, "notifications.info.task");
    return {
      title: d,
      body: f
      // lottiePath: "lottie/94640-checkbox.json"
    };
  }
  if (o === "Feedback") {
    const { entityId: s, entityType: l, lang: a, body: u, attachments: g } = e.metadata, f = mt(n, "notifications.feedback.title.Feedback", s || "", l || "", a || ""), I = of(e.updatedAt, u, g);
    return {
      title: f,
      body: I
    };
  }
  if (o === "ContentToVerify") {
    const { entityId: s, entityType: l, lang: a } = e.metadata, g = mt(n, "notifications.feedback.title.ContentToVerify", s || "", l || "", a || "", !0), d = qo(e.createdAt);
    return {
      title: g,
      body: d,
      icon: { iconType: "fal", value: "shield-check", color: null }
    };
  }
  if (o === "ContentMention") {
    const { entityId: s, entityType: l, lang: a } = e.metadata, u = `notifications.feedback.title.${o}`, g = mt(
      n,
      u,
      s || "",
      l || "",
      a || "",
      !1
    ), d = qo(e.createdAt);
    return {
      title: g,
      body: d
    };
  }
  if (o === "ContentThreadMessage") {
    const { entityId: s, entityType: l, lang: a, message: u, type: g } = e.metadata, f = u.mentions.find(({ targetId: v }) => v === t) ? "notifications.feedback.title.ContentThreadMention" : `notifications.feedback.title.${g}`, I = mt(
      n,
      f,
      s || "",
      l || "",
      a || "",
      !1
    ), z = bs(u);
    return { title: I, body: z };
  }
  if (o === "ContentThreadVote") {
    const { entityId: s, entityType: l, lang: a, message: u } = e.metadata, d = mt(
      n,
      "notifications.feedback.title.ContentThreadVote",
      s || "",
      l || "",
      a || "",
      !1
    ), f = bs(u, e.createdAt);
    return { title: d, body: f };
  }
  if (o === "ContentThreadStatus") {
    const { entityId: s, entityType: l, lang: a, status: u } = e.metadata, g = `notifications.feedback.title.ContentThreadStatus.${u}`, d = mt(
      n,
      g,
      s || "",
      l || "",
      a || "",
      !1
    ), f = qo(e.createdAt);
    return { title: d, body: f };
  }
  const i = [
    {
      name: "NotificationTitleAuthor",
      props: { authorId: n }
    }
  ], r = [
    {
      name: "NotificationHeader",
      props: { date: e.updatedAt }
    }
  ];
  return { title: i, body: r };
}, mt = (e, t, n, o, i, r) => [
  {
    name: "NotificationTitleAuthor",
    props: {
      authorId: e,
      isMine: r
    }
  },
  {
    name: "NotificationTitleText",
    props: { text: t, trad: !0, plural: n ? 1 : 0 }
  },
  {
    name: "NotificationTitleContent",
    props: { entityId: n, entityType: o, lang: i }
  }
], ef = (e, t) => [
  {
    name: "NotificationTitleText",
    props: { text: e, trad: !1, bold: !0 }
  },
  ...t ? [{ name: "NotificationTitleUrgentTag", props: {} }] : [{}]
], tf = (e, t, n, o, i, r, s, l) => [
  {
    name: "NotificationHeader",
    props: { date: e }
  },
  {
    name: "NotificationTags",
    props: { tags: t }
  },
  {
    name: "NotificationEditor",
    props: { message: n, messageOptions: !0 }
  },
  {
    name: "NotificationRedirection",
    props: { text: o, entityId: i, entityType: r, lang: s, trad: !0 }
  },
  {
    name: "NotificationAttachments",
    props: { attachments: l }
  }
], nf = (e, t, n) => [
  {
    name: "NotificationHeader",
    props: { date: e }
  },
  {
    name: "NotificationMessage",
    props: { userId: null, isHighlight: !0, taskId: t }
  },
  {
    name: "NotificationRedirection",
    props: { text: n, entityId: t, entityType: "Task", trad: !0 }
  }
], of = (e, t, n) => [
  {
    name: "NotificationHeader",
    props: { date: e }
  },
  {
    name: "NotificationMessage",
    props: { userId: null, message: t, isHighlight: !0 }
  },
  {
    name: "NotificationAttachments",
    props: { attachments: n }
  }
], sf = (e, t) => [
  {
    name: "NotificationHeader",
    props: { date: e }
  },
  {
    name: "NotificationMessage",
    props: { userId: null, taskId: t, isHighlight: !0 }
  }
], rf = (e, t, n) => [
  {
    name: "NotificationHeader",
    props: { date: e }
  },
  {
    name: "NotificationThread",
    props: { thread: t }
  },
  {
    name: "NotificationResponse",
    props: { notificationId: n, showAttachments: !0 }
  }
], af = (e, t, n) => [
  {
    name: "NotificationMessage",
    props: {
      authorId: null,
      isHighlight: !0,
      message: t,
      date: e,
      messageOptions: !0
    }
  },
  {
    name: "NotificationAttachments",
    props: { attachments: n }
  }
], bs = (e, t) => {
  const { body: n, createdAt: o, edited: i, editedDate: r, attachments: s } = e;
  return [
    {
      name: "NotificationMessage",
      props: {
        authorId: null,
        isHighlight: !0,
        message: n,
        date: t || (i ? r : o),
        edited: i,
        messageOptions: !0
      }
    },
    {
      name: "NotificationAttachments",
      props: { attachments: s }
    }
  ];
}, qo = (e) => [
  {
    name: "NotificationHeader",
    props: { date: e }
  }
];
/*! @license DOMPurify 3.0.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.0.6/LICENSE */
const {
  entries: Lr,
  setPrototypeOf: Cs,
  isFrozen: lf,
  getPrototypeOf: cf,
  getOwnPropertyDescriptor: Er
} = Object;
let {
  freeze: We,
  seal: gt,
  create: Or
} = Object, {
  apply: mi,
  construct: hi
} = typeof Reflect < "u" && Reflect;
We || (We = function(t) {
  return t;
});
gt || (gt = function(t) {
  return t;
});
mi || (mi = function(t, n, o) {
  return t.apply(n, o);
});
hi || (hi = function(t, n) {
  return new t(...n);
});
const ro = lt(Array.prototype.forEach), ws = lt(Array.prototype.pop), Nn = lt(Array.prototype.push), go = lt(String.prototype.toLowerCase), Xo = lt(String.prototype.toString), uf = lt(String.prototype.match), bn = lt(String.prototype.replace), df = lt(String.prototype.indexOf), gf = lt(String.prototype.trim), nt = lt(RegExp.prototype.test), Cn = pf(TypeError);
function lt(e) {
  return function(t) {
    for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      o[i - 1] = arguments[i];
    return mi(e, t, o);
  };
}
function pf(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
      n[o] = arguments[o];
    return hi(e, n);
  };
}
function ie(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : go;
  Cs && Cs(e, null);
  let o = t.length;
  for (; o--; ) {
    let i = t[o];
    if (typeof i == "string") {
      const r = n(i);
      r !== i && (lf(t) || (t[o] = r), i = r);
    }
    e[i] = !0;
  }
  return e;
}
function sn(e) {
  const t = Or(null);
  for (const [n, o] of Lr(e))
    Er(e, n) !== void 0 && (t[n] = o);
  return t;
}
function ao(e, t) {
  for (; e !== null; ) {
    const o = Er(e, t);
    if (o) {
      if (o.get)
        return lt(o.get);
      if (typeof o.value == "function")
        return lt(o.value);
    }
    e = cf(e);
  }
  function n(o) {
    return console.warn("fallback value for", o), null;
  }
  return n;
}
const Ds = We(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), ei = We(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), ti = We(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), mf = We(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), ni = We(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), hf = We(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), zs = We(["#text"]), vs = We(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), oi = We(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Ts = We(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), lo = We(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), ff = gt(/\{\{[\w\W]*|[\w\W]*\}\}/gm), yf = gt(/<%[\w\W]*|[\w\W]*%>/gm), If = gt(/\${[\w\W]*}/gm), Mf = gt(/^data-[\-\w.\u00B7-\uFFFF]/), Af = gt(/^aria-[\-\w]+$/), xr = gt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Nf = gt(/^(?:\w+script|data):/i), bf = gt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), _r = gt(/^html$/i);
var ks = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: ff,
  ERB_EXPR: yf,
  TMPLIT_EXPR: If,
  DATA_ATTR: Mf,
  ARIA_ATTR: Af,
  IS_ALLOWED_URI: xr,
  IS_SCRIPT_OR_DATA: Nf,
  ATTR_WHITESPACE: bf,
  DOCTYPE_NAME: _r
});
const Cf = function() {
  return typeof window > "u" ? null : window;
}, wf = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let o = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (o = n.getAttribute(i));
  const r = "dompurify" + (o ? "#" + o : "");
  try {
    return t.createPolicy(r, {
      createHTML(s) {
        return s;
      },
      createScriptURL(s) {
        return s;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + r + " could not be created."), null;
  }
};
function Ur() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Cf();
  const t = (Z) => Ur(Z);
  if (t.version = "3.0.6", t.removed = [], !e || !e.document || e.document.nodeType !== 9)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const o = n, i = o.currentScript, {
    DocumentFragment: r,
    HTMLTemplateElement: s,
    Node: l,
    Element: a,
    NodeFilter: u,
    NamedNodeMap: g = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: d,
    DOMParser: f,
    trustedTypes: I
  } = e, z = a.prototype, v = ao(z, "cloneNode"), Q = ao(z, "nextSibling"), H = ao(z, "childNodes"), ee = ao(z, "parentNode");
  if (typeof s == "function") {
    const Z = n.createElement("template");
    Z.content && Z.content.ownerDocument && (n = Z.content.ownerDocument);
  }
  let j, G = "";
  const {
    implementation: V,
    createNodeIterator: K,
    createDocumentFragment: U,
    getElementsByTagName: he
  } = n, {
    importNode: se
  } = o;
  let F = {};
  t.isSupported = typeof Lr == "function" && typeof ee == "function" && V && V.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: $,
    ERB_EXPR: oe,
    TMPLIT_EXPR: pe,
    DATA_ATTR: Qe,
    ARIA_ATTR: ot,
    IS_SCRIPT_OR_DATA: Mt,
    ATTR_WHITESPACE: q
  } = ks;
  let {
    IS_ALLOWED_URI: B
  } = ks, ae = null;
  const re = ie({}, [...Ds, ...ei, ...ti, ...ni, ...zs]);
  let de = null;
  const ke = ie({}, [...vs, ...oi, ...Ts, ...lo]);
  let ce = Object.seal(Or(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), O = null, ge = null, At = !0, Ut = !0, Ht = !1, Ft = !0, He = !1, Je = !1, Ie = !1, un = !1, Nt = !1, $t = !1, jt = !1, dn = !0, $n = !1;
  const Oo = "user-content-";
  let St = !0, bt = !1, Ct = {}, wt = null;
  const ut = ie({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Rt = null;
  const Rn = ie({}, ["audio", "video", "img", "source", "image", "track"]);
  let Jt = null;
  const gn = ie({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Vt = "http://www.w3.org/1998/Math/MathML", Kt = "http://www.w3.org/2000/svg", dt = "http://www.w3.org/1999/xhtml";
  let Lt = dt, pn = !1, qt = null;
  const xo = ie({}, [Vt, Kt, dt], Xo);
  let Dt = null;
  const mn = ["application/xhtml+xml", "text/html"], Bt = "text/html";
  let we = null, pt = null;
  const hn = n.createElement("form"), Et = function(b) {
    return b instanceof RegExp || b instanceof Function;
  }, fn = function() {
    let b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(pt && pt === b)) {
      if ((!b || typeof b != "object") && (b = {}), b = sn(b), Dt = // eslint-disable-next-line unicorn/prefer-includes
      mn.indexOf(b.PARSER_MEDIA_TYPE) === -1 ? Dt = Bt : Dt = b.PARSER_MEDIA_TYPE, we = Dt === "application/xhtml+xml" ? Xo : go, ae = "ALLOWED_TAGS" in b ? ie({}, b.ALLOWED_TAGS, we) : re, de = "ALLOWED_ATTR" in b ? ie({}, b.ALLOWED_ATTR, we) : ke, qt = "ALLOWED_NAMESPACES" in b ? ie({}, b.ALLOWED_NAMESPACES, Xo) : xo, Jt = "ADD_URI_SAFE_ATTR" in b ? ie(
        sn(gn),
        // eslint-disable-line indent
        b.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        we
        // eslint-disable-line indent
      ) : gn, Rt = "ADD_DATA_URI_TAGS" in b ? ie(
        sn(Rn),
        // eslint-disable-line indent
        b.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        we
        // eslint-disable-line indent
      ) : Rn, wt = "FORBID_CONTENTS" in b ? ie({}, b.FORBID_CONTENTS, we) : ut, O = "FORBID_TAGS" in b ? ie({}, b.FORBID_TAGS, we) : {}, ge = "FORBID_ATTR" in b ? ie({}, b.FORBID_ATTR, we) : {}, Ct = "USE_PROFILES" in b ? b.USE_PROFILES : !1, At = b.ALLOW_ARIA_ATTR !== !1, Ut = b.ALLOW_DATA_ATTR !== !1, Ht = b.ALLOW_UNKNOWN_PROTOCOLS || !1, Ft = b.ALLOW_SELF_CLOSE_IN_ATTR !== !1, He = b.SAFE_FOR_TEMPLATES || !1, Je = b.WHOLE_DOCUMENT || !1, Nt = b.RETURN_DOM || !1, $t = b.RETURN_DOM_FRAGMENT || !1, jt = b.RETURN_TRUSTED_TYPE || !1, un = b.FORCE_BODY || !1, dn = b.SANITIZE_DOM !== !1, $n = b.SANITIZE_NAMED_PROPS || !1, St = b.KEEP_CONTENT !== !1, bt = b.IN_PLACE || !1, B = b.ALLOWED_URI_REGEXP || xr, Lt = b.NAMESPACE || dt, ce = b.CUSTOM_ELEMENT_HANDLING || {}, b.CUSTOM_ELEMENT_HANDLING && Et(b.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (ce.tagNameCheck = b.CUSTOM_ELEMENT_HANDLING.tagNameCheck), b.CUSTOM_ELEMENT_HANDLING && Et(b.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (ce.attributeNameCheck = b.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), b.CUSTOM_ELEMENT_HANDLING && typeof b.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (ce.allowCustomizedBuiltInElements = b.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), He && (Ut = !1), $t && (Nt = !0), Ct && (ae = ie({}, [...zs]), de = [], Ct.html === !0 && (ie(ae, Ds), ie(de, vs)), Ct.svg === !0 && (ie(ae, ei), ie(de, oi), ie(de, lo)), Ct.svgFilters === !0 && (ie(ae, ti), ie(de, oi), ie(de, lo)), Ct.mathMl === !0 && (ie(ae, ni), ie(de, Ts), ie(de, lo))), b.ADD_TAGS && (ae === re && (ae = sn(ae)), ie(ae, b.ADD_TAGS, we)), b.ADD_ATTR && (de === ke && (de = sn(de)), ie(de, b.ADD_ATTR, we)), b.ADD_URI_SAFE_ATTR && ie(Jt, b.ADD_URI_SAFE_ATTR, we), b.FORBID_CONTENTS && (wt === ut && (wt = sn(wt)), ie(wt, b.FORBID_CONTENTS, we)), St && (ae["#text"] = !0), Je && ie(ae, ["html", "head", "body"]), ae.table && (ie(ae, ["tbody"]), delete O.tbody), b.TRUSTED_TYPES_POLICY) {
        if (typeof b.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Cn('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof b.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Cn('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        j = b.TRUSTED_TYPES_POLICY, G = j.createHTML("");
      } else
        j === void 0 && (j = wf(I, i)), j !== null && typeof G == "string" && (G = j.createHTML(""));
      We && We(b), pt = b;
    }
  }, Vn = ie({}, ["mi", "mo", "mn", "ms", "mtext"]), Bn = ie({}, ["foreignobject", "desc", "title", "annotation-xml"]), _o = ie({}, ["title", "style", "font", "a", "script"]), Xt = ie({}, ei);
  ie(Xt, ti), ie(Xt, mf);
  const en = ie({}, ni);
  ie(en, hf);
  const Yn = function(b) {
    let E = ee(b);
    (!E || !E.tagName) && (E = {
      namespaceURI: Lt,
      tagName: "template"
    });
    const W = go(b.tagName), me = go(E.tagName);
    return qt[b.namespaceURI] ? b.namespaceURI === Kt ? E.namespaceURI === dt ? W === "svg" : E.namespaceURI === Vt ? W === "svg" && (me === "annotation-xml" || Vn[me]) : !!Xt[W] : b.namespaceURI === Vt ? E.namespaceURI === dt ? W === "math" : E.namespaceURI === Kt ? W === "math" && Bn[me] : !!en[W] : b.namespaceURI === dt ? E.namespaceURI === Kt && !Bn[me] || E.namespaceURI === Vt && !Vn[me] ? !1 : !en[W] && (_o[W] || !Xt[W]) : !!(Dt === "application/xhtml+xml" && qt[b.namespaceURI]) : !1;
  }, Pe = function(b) {
    Nn(t.removed, {
      element: b
    });
    try {
      b.parentNode.removeChild(b);
    } catch {
      b.remove();
    }
  }, yn = function(b, E) {
    try {
      Nn(t.removed, {
        attribute: E.getAttributeNode(b),
        from: E
      });
    } catch {
      Nn(t.removed, {
        attribute: null,
        from: E
      });
    }
    if (E.removeAttribute(b), b === "is" && !de[b])
      if (Nt || $t)
        try {
          Pe(E);
        } catch {
        }
      else
        try {
          E.setAttribute(b, "");
        } catch {
        }
  }, Qn = function(b) {
    let E = null, W = null;
    if (un)
      b = "<remove></remove>" + b;
    else {
      const Me = uf(b, /^[\r\n\t ]+/);
      W = Me && Me[0];
    }
    Dt === "application/xhtml+xml" && Lt === dt && (b = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + b + "</body></html>");
    const me = j ? j.createHTML(b) : b;
    if (Lt === dt)
      try {
        E = new f().parseFromString(me, Dt);
      } catch {
      }
    if (!E || !E.documentElement) {
      E = V.createDocument(Lt, "template", null);
      try {
        E.documentElement.innerHTML = pn ? G : me;
      } catch {
      }
    }
    const Ee = E.body || E.documentElement;
    return b && W && Ee.insertBefore(n.createTextNode(W), Ee.childNodes[0] || null), Lt === dt ? he.call(E, Je ? "html" : "body")[0] : Je ? E.documentElement : Ee;
  }, Pn = function(b) {
    return K.call(
      b.ownerDocument || b,
      b,
      // eslint-disable-next-line no-bitwise
      u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT,
      null
    );
  }, Uo = function(b) {
    return b instanceof d && (typeof b.nodeName != "string" || typeof b.textContent != "string" || typeof b.removeChild != "function" || !(b.attributes instanceof g) || typeof b.removeAttribute != "function" || typeof b.setAttribute != "function" || typeof b.namespaceURI != "string" || typeof b.insertBefore != "function" || typeof b.hasChildNodes != "function");
  }, Gn = function(b) {
    return typeof l == "function" && b instanceof l;
  }, je = function(b, E, W) {
    F[b] && ro(F[b], (me) => {
      me.call(t, E, W, pt);
    });
  }, Zn = function(b) {
    let E = null;
    if (je("beforeSanitizeElements", b, null), Uo(b))
      return Pe(b), !0;
    const W = we(b.nodeName);
    if (je("uponSanitizeElement", b, {
      tagName: W,
      allowedTags: ae
    }), b.hasChildNodes() && !Gn(b.firstElementChild) && nt(/<[/\w]/g, b.innerHTML) && nt(/<[/\w]/g, b.textContent))
      return Pe(b), !0;
    if (!ae[W] || O[W]) {
      if (!O[W] && Hn(W) && (ce.tagNameCheck instanceof RegExp && nt(ce.tagNameCheck, W) || ce.tagNameCheck instanceof Function && ce.tagNameCheck(W)))
        return !1;
      if (St && !wt[W]) {
        const me = ee(b) || b.parentNode, Ee = H(b) || b.childNodes;
        if (Ee && me) {
          const Me = Ee.length;
          for (let Re = Me - 1; Re >= 0; --Re)
            me.insertBefore(v(Ee[Re], !0), Q(b));
        }
      }
      return Pe(b), !0;
    }
    return b instanceof a && !Yn(b) || (W === "noscript" || W === "noembed" || W === "noframes") && nt(/<\/no(script|embed|frames)/i, b.innerHTML) ? (Pe(b), !0) : (He && b.nodeType === 3 && (E = b.textContent, ro([$, oe, pe], (me) => {
      E = bn(E, me, " ");
    }), b.textContent !== E && (Nn(t.removed, {
      element: b.cloneNode()
    }), b.textContent = E)), je("afterSanitizeElements", b, null), !1);
  }, Wn = function(b, E, W) {
    if (dn && (E === "id" || E === "name") && (W in n || W in hn))
      return !1;
    if (!(Ut && !ge[E] && nt(Qe, E))) {
      if (!(At && nt(ot, E))) {
        if (!de[E] || ge[E]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Hn(b) && (ce.tagNameCheck instanceof RegExp && nt(ce.tagNameCheck, b) || ce.tagNameCheck instanceof Function && ce.tagNameCheck(b)) && (ce.attributeNameCheck instanceof RegExp && nt(ce.attributeNameCheck, E) || ce.attributeNameCheck instanceof Function && ce.attributeNameCheck(E)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            E === "is" && ce.allowCustomizedBuiltInElements && (ce.tagNameCheck instanceof RegExp && nt(ce.tagNameCheck, W) || ce.tagNameCheck instanceof Function && ce.tagNameCheck(W)))
          )
            return !1;
        } else if (!Jt[E]) {
          if (!nt(B, bn(W, q, ""))) {
            if (!((E === "src" || E === "xlink:href" || E === "href") && b !== "script" && df(W, "data:") === 0 && Rt[b])) {
              if (!(Ht && !nt(Mt, bn(W, q, "")))) {
                if (W)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Hn = function(b) {
    return b.indexOf("-") > 0;
  }, Jn = function(b) {
    je("beforeSanitizeAttributes", b, null);
    const {
      attributes: E
    } = b;
    if (!E)
      return;
    const W = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: de
    };
    let me = E.length;
    for (; me--; ) {
      const Ee = E[me], {
        name: Me,
        namespaceURI: Re,
        value: zt
      } = Ee, Yt = we(Me);
      let Ve = Me === "value" ? zt : gf(zt);
      if (W.attrName = Yt, W.attrValue = Ve, W.keepAttr = !0, W.forceKeepAttr = void 0, je("uponSanitizeAttribute", b, W), Ve = W.attrValue, W.forceKeepAttr || (yn(Me, b), !W.keepAttr))
        continue;
      if (!Ft && nt(/\/>/i, Ve)) {
        yn(Me, b);
        continue;
      }
      He && ro([$, oe, pe], (qn) => {
        Ve = bn(Ve, qn, " ");
      });
      const Kn = we(b.nodeName);
      if (Wn(Kn, Yt, Ve)) {
        if ($n && (Yt === "id" || Yt === "name") && (yn(Me, b), Ve = Oo + Ve), j && typeof I == "object" && typeof I.getAttributeType == "function" && !Re)
          switch (I.getAttributeType(Kn, Yt)) {
            case "TrustedHTML": {
              Ve = j.createHTML(Ve);
              break;
            }
            case "TrustedScriptURL": {
              Ve = j.createScriptURL(Ve);
              break;
            }
          }
        try {
          Re ? b.setAttributeNS(Re, Me, Ve) : b.setAttribute(Me, Ve), ws(t.removed);
        } catch {
        }
      }
    }
    je("afterSanitizeAttributes", b, null);
  }, Fo = function Z(b) {
    let E = null;
    const W = Pn(b);
    for (je("beforeSanitizeShadowDOM", b, null); E = W.nextNode(); )
      je("uponSanitizeShadowNode", E, null), !Zn(E) && (E.content instanceof r && Z(E.content), Jn(E));
    je("afterSanitizeShadowDOM", b, null);
  };
  return t.sanitize = function(Z) {
    let b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, E = null, W = null, me = null, Ee = null;
    if (pn = !Z, pn && (Z = "<!-->"), typeof Z != "string" && !Gn(Z))
      if (typeof Z.toString == "function") {
        if (Z = Z.toString(), typeof Z != "string")
          throw Cn("dirty is not a string, aborting");
      } else
        throw Cn("toString is not a function");
    if (!t.isSupported)
      return Z;
    if (Ie || fn(b), t.removed = [], typeof Z == "string" && (bt = !1), bt) {
      if (Z.nodeName) {
        const zt = we(Z.nodeName);
        if (!ae[zt] || O[zt])
          throw Cn("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Z instanceof l)
      E = Qn("<!---->"), W = E.ownerDocument.importNode(Z, !0), W.nodeType === 1 && W.nodeName === "BODY" || W.nodeName === "HTML" ? E = W : E.appendChild(W);
    else {
      if (!Nt && !He && !Je && // eslint-disable-next-line unicorn/prefer-includes
      Z.indexOf("<") === -1)
        return j && jt ? j.createHTML(Z) : Z;
      if (E = Qn(Z), !E)
        return Nt ? null : jt ? G : "";
    }
    E && un && Pe(E.firstChild);
    const Me = Pn(bt ? Z : E);
    for (; me = Me.nextNode(); )
      Zn(me) || (me.content instanceof r && Fo(me.content), Jn(me));
    if (bt)
      return Z;
    if (Nt) {
      if ($t)
        for (Ee = U.call(E.ownerDocument); E.firstChild; )
          Ee.appendChild(E.firstChild);
      else
        Ee = E;
      return (de.shadowroot || de.shadowrootmode) && (Ee = se.call(o, Ee, !0)), Ee;
    }
    let Re = Je ? E.outerHTML : E.innerHTML;
    return Je && ae["!doctype"] && E.ownerDocument && E.ownerDocument.doctype && E.ownerDocument.doctype.name && nt(_r, E.ownerDocument.doctype.name) && (Re = "<!DOCTYPE " + E.ownerDocument.doctype.name + `>
` + Re), He && ro([$, oe, pe], (zt) => {
      Re = bn(Re, zt, " ");
    }), j && jt ? j.createHTML(Re) : Re;
  }, t.setConfig = function() {
    let Z = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    fn(Z), Ie = !0;
  }, t.clearConfig = function() {
    pt = null, Ie = !1;
  }, t.isValidAttribute = function(Z, b, E) {
    pt || fn({});
    const W = we(Z), me = we(b);
    return Wn(W, me, E);
  }, t.addHook = function(Z, b) {
    typeof b == "function" && (F[Z] = F[Z] || [], Nn(F[Z], b));
  }, t.removeHook = function(Z) {
    if (F[Z])
      return ws(F[Z]);
  }, t.removeHooks = function(Z) {
    F[Z] && (F[Z] = []);
  }, t.removeAllHooks = function() {
    F = {};
  }, t;
}
var Df = Ur();
const jn = (e) => Df.sanitize(e, { FORBID_TAGS: ["script"] }), po = [
  "TaskComment",
  "Feedback",
  "TaskUpvoted",
  "TaskMoved"
], mo = ["Agent"], zf = {
  getUsername: (e) => (t) => !t || !e.users[t] ? null : e.users[t].username,
  getUser: (e) => (t) => !t || !e.users[t] ? { username: "", isDeleted: !0 } : e.users[t],
  unreadCountDisplay(e) {
    return e.unreadCount < 1 ? null : e.unreadCount > 99 ? "99+" : String(e.unreadCount);
  },
  getTaskBody: (e) => (t) => e.tasks[t] ? e.tasks[t].body : "",
  getEntityInfo: (e) => (t, n, o) => {
    var s;
    const r = e[n === "Case" ? "cases" : "contents"][t];
    return r ? { label: ((s = r.labelTranslations) == null ? void 0 : s[o]) || r.label, type: r.type } : { label: "", type: "NotFound" };
  },
  resolveNotification: (e) => (t) => Xh(t, e.userId),
  createdAgentNotificationsEnriched: (e) => (t) => {
    const { createdAgentNotifications: n } = e;
    return n.map((o) => {
      const i = o.targets.map((a) => {
        const u = a.split("/")[1];
        return t.find((g) => g.id === u);
      }).filter(Boolean), r = i.reduce((a, u) => (u.users.forEach((g) => a.add(g.id)), a), /* @__PURE__ */ new Set()), s = r.size || 1, l = o.userReads.reduce((a, { userId: u }) => (r.has(u) && a.add(u), a), /* @__PURE__ */ new Set());
      return {
        ...o,
        groups: i,
        agent_readers_percentage: l.size / s * 100
      };
    });
  },
  getToastNotifications(e) {
    return e.notifications.filter(
      (t) => t.metadata.type === No.Agent && !t.metadata.urgent && t.userReads.every((n) => n.userId !== e.userId)
    );
  },
  // This is a TMP getter for admin-client and notificationModule as a web component
  // It basically just formats agent notifications for admin-client to directly use them
  getWebToastNotifications(e) {
    return this.getToastNotifications.map((t) => {
      var i;
      const o = this.resolveNotification(t).body.find(
        (r) => r.name === "NotificationRedirection"
      );
      return {
        author: this.getUsername(t.authorId),
        body: jn(t.metadata.body),
        title: t.metadata.label,
        id: t.id,
        timestamp: t.createdAt,
        urgent: t.metadata.urgent,
        content: (i = o == null ? void 0 : o.props) != null && i.entityId ? this.getEntityInfo(
          o.props.entityId,
          o.props.entityType,
          o.props.lang
        ) : null,
        tags: t.metadata.tags,
        attachments: t.metadata.attachments,
        metadata: t.metadata
        // used for goToContent
      };
    });
  },
  filtersCount(e) {
    const { filters: t } = e;
    let n = 0;
    return t.unreadOnly && n++, t.types.length > 0 && (t.types.some((o) => po.includes(o)) && n++, t.types.some((o) => mo.includes(o)) && n++), t.dateRange[0] !== null && n++, n;
  }
}, vf = {
  /**
   * User
   */
  userId: "",
  /**
   * General
   */
  notifications: [],
  unreadCount: 0,
  hasMoreNotifications: !0,
  urgentNotifications: [],
  isLoading: !1,
  cursor: 5,
  taskCommentIsLoading: !1,
  currentPage: null,
  notificationIndex: 0,
  // Used for watcher for Widget lottie animation
  soundPlayable: !1,
  /**
   * Cache
   */
  users: {},
  contents: {},
  tasks: {},
  cases: {},
  /**
   * Filters
   */
  filters: {
    currentPage: 1,
    searchInput: "",
    targetGroups: [],
    types: [],
    unreadOnly: !1,
    dateRange: [null, null]
  },
  filtersOpened: !1,
  /**
   * Admin panel
   */
  createdAgentNotifications: [],
  total: 0,
  isLoadingAgentNotifications: !1,
  isDeletingAgentNotification: !1,
  /**
   * Urgent Notification
   */
  isDetailedView: !1
};
function js() {
  return Ai(vf);
}
async function Fr(e, t) {
  const n = new FormData();
  t.forEach((i) => n.append("files", i));
  const o = await e.request({
    url: "../contents/attach-files",
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data: n
  });
  return Ne(o);
}
const ve = Wt(ze.NOTIFICATIONS, {
  state: js,
  getters: { ...zf },
  actions: {
    mutate(e) {
      this.$patch((t) => {
        Object.keys(e).forEach((n) => {
          t[n] = e[n];
        });
      });
    },
    // patch object will not be synced
    unsyncedMutate(e) {
      this.$patch(e);
    },
    reset() {
      this.mutate(js());
    },
    logs(e) {
      this.$logs(e);
    },
    logNotificationReceive(e) {
      this.logs({
        topic: "NOTIFICATION_RECEIVE",
        event: {
          notification: e
        }
      });
    },
    logNotificationsRead(e) {
      this.logs({
        topic: "NOTIFICATION_READ",
        event: {
          read: {
            notificationIds: e
          }
        }
      });
    },
    mutateNotifications(e) {
      this.mutate({ notifications: JSON.parse(JSON.stringify(e)) });
    },
    mutateAgentNotifications(e) {
      this.mutate({ createdAgentNotifications: e });
    },
    mutateUnreadCount(e) {
      e < 0 || this.mutate({ unreadCount: e });
    },
    async uploadFiles(e) {
      return this.$notificationsService.uploadFiles(e);
    },
    initUserId(e) {
      this.mutate({ userId: e });
    },
    async initNotifications(e) {
      this.initUserId(e), await this.getNotifications(), await this.getUrgentNotifications();
    },
    async getNotifications(e = 0) {
      if (!this.isLoading)
        try {
          this.mutate({ isLoading: !0 });
          const { types: t, unreadOnly: n, dateRange: o } = this.filters, i = this.cursor + e, { results: r, hasMore: s } = await this.$notificationsService.get(
            t,
            i < 10 ? 10 : i,
            1,
            n,
            o
          );
          this.mutateNotifications(r), await this.resolveData("notifications"), this.mutate({
            hasMoreNotifications: s,
            cursor: r.length
          }), await this.getUnreadCount();
        } catch (t) {
          this.mutate({ isLoading: !1 }), console.error(t);
        }
    },
    async getUrgentNotifications({ shouldTrigger: e } = {}) {
      const t = await this.$notificationsService.getUrgents();
      e && t.length > this.urgentNotifications.length && this.mutate({ notificationIndex: this.notificationIndex + 1 }), this.mutate({ urgentNotifications: t }), await this.resolveData("urgentNotifications");
    },
    async getNotificationById(e, t = !1, n = !1) {
      var o;
      if (!this.isLoading)
        try {
          this.mutate({ isLoading: !0 });
          const i = await this.$notificationsService.getById(e);
          if (!i)
            return;
          const { metadata: r, authorId: s } = i;
          r.type === "Agent" && t && this.getCreatedAgentNotifications();
          const l = {
            id: e,
            type: r.type,
            hasAttachment: !!((o = r.attachments) != null && o.length),
            isUrgent: r.urgent
          };
          if (r.urgent)
            return this.logNotificationReceive(l), this.getUrgentNotifications({ shouldTrigger: !0 });
          if (r.type === "Agent" && !r.isVisible)
            return this.deleteNotificationFromStore(e);
          r.isVisible && this.logNotificationReceive(l), this.getUnreadCount(), s !== this.userId && this.mutate({
            notificationIndex: this.notificationIndex + 1,
            soundPlayable: n
          });
          const a = [...this.notifications];
          let u = this.cursor;
          const g = a.findIndex(({ id: d }) => d === e);
          return g > -1 ? a[g] = i : (a.unshift(i), u++), this.mutateNotifications(a), await this.resolveData("notifications"), this.mutate({
            hasMoreNotifications: !0,
            cursor: u
          }), i;
        } finally {
          this.mutate({ isLoading: !1 });
        }
    },
    async deleteNotificationFromStore(e) {
      const t = [...this.notifications].filter((n) => n.id !== e);
      this.mutateNotifications(t), this.mutate({
        cursor: t.length
      }), this.getUnreadCount(), this.urgentNotifications.findIndex((n) => n.id === e) > -1 && this.getUrgentNotifications();
    },
    async getUnreadCount() {
      try {
        this.mutate({ isLoading: !0 });
        const e = await this.$notificationsService.getUnreadCount();
        this.mutateUnreadCount(Number(e)), this.mutate({ isLoading: !1 });
      } catch (e) {
        throw this.mutate({ isLoading: !1 }), e;
      }
    },
    async readNotifications(e, t = !0) {
      try {
        if (await this.$notificationsService.read(e)) {
          const o = [...this.notifications];
          e.forEach((r) => {
            const s = o.findIndex(({ _id: l }) => l === r);
            o[s].userReads.push({
              userId: this.userId,
              createdAt: String(Date.now())
            });
          }), this.mutateNotifications(o), this.mutate({
            cursor: o.length
          });
          const i = this.unreadCount - e.length;
          this.mutateUnreadCount(i), t && this.logNotificationsRead(e);
        }
      } catch (n) {
        console.error(n);
      }
    },
    async readAllNotifications() {
      if (this.unreadCount === 0)
        return;
      if (await this.$notificationsService.readAll()) {
        const t = [...this.notifications];
        t.forEach(({ userReads: n }) => {
          n.findIndex((o) => o.userId === this.userId) < 0 && n.push({
            userId: this.userId,
            createdAt: String(Date.now())
          });
        }), this.mutateUnreadCount(0), this.mutateNotifications(t), this.mutate({
          cursor: t.length
        });
      }
    },
    async commentNotification({
      taskId: e,
      comment: t,
      attachments: n,
      notificationId: o
    }) {
      this.mutate({ taskCommentIsLoading: !0 });
      const i = [...this.notifications], r = await this.$notificationsService.comment(e, t, n), s = i.findIndex(({ id: l }) => l === o);
      s !== -1 && (i[s].metadata.thread.push({
        taskCommentId: r.id,
        body: r.comment,
        attachments: r.attachments,
        authorId: this.userId,
        createdAt: r.createdAt
      }), i[s].authorId = this.userId, this.mutateNotifications(i), this.mutate({ taskCommentIsLoading: !1 }));
    },
    async resolveData(e) {
      return Promise.all([
        this.fetchUsers(e),
        this.fetchContents(),
        this.fetchCases(),
        this.fetchTasks()
      ]);
    },
    async fetchUsers(e) {
      const t = Object.keys(this.users), n = [];
      this[e].forEach((s) => {
        const { thread: l, mentions: a, message: u } = s.metadata;
        n.push(s.authorId), u && u.mentions && u.mentions.forEach((g) => {
          g.targetType === "User" && n.push(g.targetId);
        }), a && a.forEach((g) => {
          const d = g.split("/");
          d[0] === "user" && n.push(d[1]);
        }), l && l.forEach((g) => {
          n.push(g.authorId), g.mentions && g.mentions.forEach((d) => {
            const f = d.split("/");
            f[0] === "user" && n.push(f[1]);
          });
        });
      });
      const i = [...new Set(n)].reduce((s, l) => (l && !t.includes(l) && s.push(l), s), []);
      if (i.length === 0)
        return;
      const r = await this.$notificationsService.getUsers(i);
      i.forEach((s) => {
        const l = r.findIndex((u) => String(s) === String(u.id)), a = l === -1 ? {
          id: s,
          username: ""
        } : r[l];
        this.addUser(a);
      });
    },
    async fetchContents() {
      const e = Object.keys(this.contents), t = this.notifications.filter(
        (o) => ["Article", "Diagnostic", "Step", "keyStep"].includes(
          o.metadata.entityType || ""
        )
      ).reduce((o, i) => {
        const r = i.metadata.entityId;
        return r && !e.includes(r) && !o.includes(r) && o.push(r), o;
      }, []);
      if (!t.length)
        return;
      const n = await this.$notificationsService.getContents(t);
      t.forEach((o) => {
        const i = n.findIndex((s) => o === s.id), r = i === -1 ? {
          id: o,
          label: "",
          type: "NotFound"
        } : n[i];
        this.addContent(r);
      });
    },
    async fetchCases() {
      const e = Object.keys(this.cases), t = this.notifications.filter((o) => ["Case"].includes(o.metadata.entityType || "")).reduce((o, i) => {
        const r = i.metadata.entityId;
        return r && !e.includes(r) && !o.includes(r) && o.push(r), o;
      }, []);
      if (!t.length)
        return;
      const n = await this.$notificationsService.getCases(t);
      t.forEach((o) => {
        const i = n.findIndex((s) => o === s.id), r = i === -1 ? {
          id: o,
          label: "",
          type: "NotFound"
        } : n[i];
        this.addCase(r);
      });
    },
    async fetchTasks() {
      const e = Object.keys(this.tasks), t = this.notifications.filter(
        (o) => ["TaskMoved", "TaskUpvoted", "TaskAssigned"].includes(o.metadata.type)
      ).reduce((o, i) => {
        const { taskId: r } = i.metadata;
        return r && !e.includes(r) && !o.includes(r) && o.push(r), o;
      }, []);
      if (!t.length)
        return;
      const n = await this.$notificationsService.getTasks(t);
      t.forEach((o) => {
        const i = n.findIndex((r) => o === String(r.id));
        i > -1 && this.addTask(n[i]);
      });
    },
    // CACHE MUTATIONS
    addUser(e) {
      this.mutate({ users: Object.assign({}, this.users, { [e.id]: e }) });
    },
    addContent(e) {
      this.mutate({ contents: Object.assign({}, this.contents, { [e.id]: e }) });
    },
    addCase(e) {
      this.mutate({ cases: Object.assign({}, this.cases, { [e.id]: e }) });
    },
    addTask(e) {
      this.mutate({ tasks: Object.assign({}, this.tasks, { [e.id]: e }) });
    },
    async getCreatedAgentNotifications() {
      const { currentPage: e, searchInput: t, targetGroups: n } = this.filters;
      try {
        this.mutate({ isLoadingAgentNotifications: !0 });
        const { results: o, total: i } = await this.$notificationsService.getCreatedAgentNotifications(
          10,
          e,
          "createdAt",
          "desc",
          t,
          n.map((r) => r.id)
        );
        this.mutateAgentNotifications(o), this.mutate({ total: i });
      } catch (o) {
        console.error(o);
      } finally {
        this.mutate({ isLoadingAgentNotifications: !1 });
      }
    },
    async addAgentNotification(e) {
      const { targetGroupIds: t, companyId: n, ...o } = e;
      await this.$notificationsService.create({
        targetGroupIds: t,
        metadata: o,
        authorId: this.userId,
        companyId: n,
        type: No.Agent
      });
    },
    async updateAgentNotification({
      notificationId: e,
      metadata: t
    }) {
      const { currentPage: n } = this.filters, o = [...this.createdAgentNotifications], i = await this.$notificationsService.update(e, {
        type: No.Agent,
        metadata: t
      }), r = o.findIndex(
        (s) => s.id === e
      );
      r !== -1 && (o[r] = i, this.mutateAgentNotifications(o), this.mutate({
        currentPage: n
      }));
    },
    async deleteAgentNotification(e) {
      try {
        this.mutate({ isDeletingAgentNotification: !0 }), await this.$notificationsService.delete(e) && this.getCreatedAgentNotifications();
      } catch (t) {
        console.error(t);
      } finally {
        this.mutate({ isDeletingAgentNotification: !1 });
      }
    },
    async updateFilters({ field: e, value: t }, n = !1) {
      const o = { ...this.filters, [e]: t };
      this.mutate({ filters: o }), n ? this.getCreatedAgentNotifications() : this.getNotifications();
    },
    async resetFilters(e = !1) {
      const t = {
        currentPage: 1,
        searchInput: "",
        targetGroups: [],
        types: [],
        unreadOnly: !1,
        dateRange: [null, null]
      };
      this.mutate({ filters: t }), e ? this.getCreatedAgentNotifications() : this.getNotifications();
    },
    toggleFilters() {
      this.mutate({ filtersOpened: !this.filtersOpened });
    },
    // INLINE CONTENTS
    async getContent(e) {
      return (await this.$notificationsService.getContents([e]))[0];
    },
    // RESET
    clearCache() {
      this.mutate({ contents: {}, cases: {}, users: {}, tasks: {} });
    },
    mutateIsDetailedView() {
      this.mutate({ isDetailedView: !this.isDetailedView });
    }
  },
  persist: {
    key: `md-${ze.NOTIFICATIONS}`
  },
  // @ts-ignore
  share: {
    omit: [
      "userId",
      // 'notifications',
      // 'unreadCount',
      // 'hasMoreNotifications',
      // 'urgentNotifications',
      // 'isLoading',
      // 'cursor',
      "taskCommentIsLoading",
      "currentPage",
      "notificationIndex",
      "soundPlayable",
      "users",
      "contents",
      "tasks",
      "cases",
      "filters",
      "filtersOpened",
      "createdAgentNotifications",
      "total",
      "isLoadingAgentNotifications",
      "isDeletingAgentNotification",
      "isDetailedView"
    ]
  }
}), Tf = ["mutateNotifications"], kf = ["mutateAgentNotifications"], jf = "notifications", Sf = () => ({ store: e }) => {
  e.$onAction(({ name: t, store: n, args: o }) => {
    n.$id === jf && (Tf.includes(t) && (n.fetchUsers("notifications"), n.fetchContents(), n.fetchCases(), n.fetchTasks()), kf.includes(t) && n.fetchUsers("createdAgentNotifications"));
  });
};
async function $r(e, t) {
  const n = new URLSearchParams();
  return t && t.length && t.forEach((o) => n.append("contentIds[]", o)), e.get(`content?${n.toString()}`).then((o) => Ne(o).results);
}
class Lf {
  constructor(t) {
    xe(this, "data");
    this.data = t;
  }
  /**
   * CREATE METHODS
   */
  async create(t) {
    return this.data.create(t);
  }
  async comment(t, n, o) {
    return this.data.commentNotification(t, n, o);
  }
  async uploadFiles(t) {
    return this.data.uploadFiles(t);
  }
  /**
   * READ METHODS
   */
  async get(t, n, o, i, r) {
    return this.data.getNotifications(t, n, o, i, r[0], r[1]);
  }
  async getUrgents() {
    return this.data.getUrgentNotifications();
  }
  async getById(t) {
    return this.data.getNotificationById(t);
  }
  async getUnreadCount() {
    return this.data.getUnreadCount();
  }
  async getCreatedAgentNotifications(t, n, o = "updatedAt", i = "desc", r = "", s = []) {
    return this.data.getCreatedAgentNotifications(
      t,
      n,
      o,
      i,
      r,
      s
    );
  }
  /**
   * CACHE METHODS
   */
  async getUsers(t) {
    return this.data.getUsers(t);
  }
  async getContents(t) {
    return this.data.getContents(t);
  }
  async getCases(t) {
    return this.data.getCases(t);
  }
  async getTasks(t) {
    return this.data.getTasks(t);
  }
  /**
   * UPDATE METHODS
   */
  async read(t) {
    return this.data.readNotifications(t);
  }
  async readAll() {
    return this.data.readAllNotifications();
  }
  async update(t, n) {
    return this.data.update(t, n);
  }
  /**
   * DELETE METHODS
   */
  async delete(t) {
    return this.data.delete(t);
  }
}
class Ef {
  constructor(t, n, o) {
    xe(this, "notificationClient");
    xe(this, "adminClient");
    xe(this, "knowledgeClient");
    this.notificationClient = t, this.adminClient = n, this.knowledgeClient = o;
  }
  /**
   * CREATE METHODS
   */
  async create(t) {
    return this.notificationClient.post("notifications", t).then((n) => Ne(n));
  }
  async commentNotification(t, n, o) {
    return this.adminClient.post("comment-notification", { taskId: t, comment: n, attachments: o }).then((i) => Ne(i));
  }
  async uploadFiles(t) {
    return Fr(this.knowledgeClient, t);
  }
  /**
   * READ METHODS
   */
  async getNotifications(t, n, o, i, r, s) {
    const l = new URLSearchParams({
      size: n.toString(),
      page: o.toString(),
      unreadOnly: i.toString(),
      ...i ? {} : { withUrgents: "true" }
    });
    return t && t.length && t.forEach((a) => l.append("types[]", a)), r && l.append("startDate", r.toISOString()), s && l.append("endDate", s.toISOString()), this.notificationClient.get(`notifications?${l.toString()}`).then((a) => Ne(a));
  }
  async getUrgentNotifications() {
    return this.notificationClient.get("notifications/urgents").then((t) => Ne(t));
  }
  async getCreatedAgentNotifications(t, n, o, i, r, s) {
    const l = new URLSearchParams({
      size: t.toString(),
      page: n.toString(),
      sortOption: o,
      sortDirection: i,
      searchInput: r
    });
    return s && s.length && s.forEach(
      (a) => l.append("targetGroupIds[]", a)
    ), this.notificationClient.get(`notifications/agents?${l.toString()}`).then((a) => Ne(a));
  }
  async getNotificationById(t) {
    return this.notificationClient.get(`notifications/${t}`).then((n) => Ne(n));
  }
  async getUnreadCount() {
    return this.notificationClient.get("notifications/unread-count").then((t) => Ne(t));
  }
  /**
   * CACHE METHODS
   */
  async getUsers(t) {
    const n = new URLSearchParams();
    return t && t.length && t.forEach((o) => n.append("userIds[]", o)), this.adminClient.get(`users-or-deleted-users?${n.toString()}`).then((o) => Ne(o));
  }
  async getCases(t) {
    const n = new URLSearchParams();
    return t && t.length && t.forEach((o) => n.append("caseIds[]", o)), this.knowledgeClient.get(`case?${n.toString()}`).then((o) => Ne(o).results);
  }
  async getContents(t) {
    return $r(this.knowledgeClient, t);
  }
  async getTasks(t) {
    const n = new URLSearchParams();
    return t && t.length && t.forEach((o) => n.append("taskIds[]", o)), this.adminClient.get(`tasks?${n.toString()}`).then((o) => Ne(o));
  }
  /**
   * UPDATE METHODS
   */
  async readNotifications(t) {
    return this.notificationClient.post("notifications/read", {
      ids: t
    }).then((n) => Ne(n));
  }
  async readAllNotifications() {
    return this.notificationClient.post("notifications/read-all").then((t) => Ne(t));
  }
  async update(t, n) {
    return this.notificationClient.put(`notifications/${t}`, n).then((o) => Ne(o));
  }
  /**
   * DELETE METHODS
   */
  async delete(t) {
    return this.notificationClient.delete(`notifications/${t}`).then((n) => Ne(n));
  }
}
const Rr = (e, t, n) => new Lf(
  new Ef(e, t, n)
), Of = T({
  name: "NotificationTitleText",
  props: {
    text: {
      type: String,
      required: !0
    },
    trad: {
      type: Boolean,
      default: !1
    },
    plural: {
      type: Number,
      default: 0
    },
    bold: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    displayText() {
      return this.trad ? this.$t(this.text, this.plural) : this.text;
    }
  }
});
function xf(e, t, n, o, i, r) {
  return c(), p("span", {
    class: D([{ "font-bold": e.bold }])
  }, N(e.displayText), 3);
}
const _f = /* @__PURE__ */ x(Of, [["render", xf]]), Uf = T({
  name: "NotificationTitleContent",
  props: {
    entityId: {
      type: String,
      default: ""
    },
    entityType: {
      type: String,
      default: ""
    },
    lang: {
      type: String,
      default: ""
    }
  },
  emits: ["go-to-content", "loading"],
  data() {
    return {
      imgClass: "inline-block align-middle h-3.5"
    };
  },
  computed: {
    contentError() {
      return this.entity.type === "NotFound" || !this.entityType;
    },
    entity() {
      return this.getEntityInfo(this.entityId, this.entityType, this.lang);
    },
    ...ue(ve, ["getEntityInfo"])
  },
  methods: {
    handleClick() {
      this.contentError || this.$emit("go-to-content");
    }
  },
  watch: {
    label() {
      return this.$emit("loading", this.entity.label === null);
    }
  }
}), Ff = { key: 4 };
function $f(e, t, n, o, i, r) {
  const s = P, l = Le;
  return e.entityId ? (c(), p("div", {
    key: 0,
    role: "button",
    class: D(["bg-gray-2 hover:bg-gray-3 transition-colors font-bold rounded-sm px-1 flex items-center gap-1", [{ "cursor-not-allowed text-gray-7": e.contentError }]]),
    onClick: t[0] || (t[0] = (...a) => e.handleClick && e.handleClick(...a))
  }, [
    e.entityType === "Diagnostic" ? (c(), p("img", {
      key: 0,
      class: D(e.imgClass),
      src: xn
    }, null, 2)) : e.entityType === "Article" ? (c(), p("img", {
      key: 1,
      class: D(e.imgClass),
      src: On
    }, null, 2)) : e.entityType === "Step" || e.entityType === "keyStep" ? (c(), p("img", {
      key: 2,
      class: D(e.imgClass),
      src: Ti
    }, null, 2)) : e.entityType === "Case" ? (c(), C(s, {
      key: 3,
      icon: ["fas", "folder"],
      class: "text-gray-5"
    })) : A("", !0),
    e.contentError ? (c(), p("span", Ff, N(e.$t("notifications.info.content-error")), 1)) : (c(), C(l, {
      key: 5,
      text: e.entity.label
    }, null, 8, ["text"]))
  ], 2)) : A("", !0);
}
const Rf = /* @__PURE__ */ x(Uf, [["render", $f]]), Vf = T({
  name: "NotificationTitleAuthor",
  props: {
    authorId: {
      type: String,
      required: !1
    },
    isMine: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    usernameDisplay() {
      return this.isMine ? this.$t("notifications.you") : this.username;
    },
    username() {
      return this.author.isDeleted && this.author.username ? `${this.author.username} ${this.$t("notifications.info.deleted-user")}` : this.author.username;
    },
    author() {
      return this.getUser(this.authorId);
    },
    ...ue(ve, ["getUser"])
  }
}), Bf = { class: "font-bold" };
function Yf(e, t, n, o, i, r) {
  return c(), p("span", Bf, N(e.usernameDisplay || e.$t("notifications.info.author-error")), 1);
}
const Qf = /* @__PURE__ */ x(Vf, [["render", Yf]]), Pf = {}, Gf = { class: "relative" }, Zf = { class: "absolute z-20 shadow px-2 py-1 text-2xs bg-gray-9 text-white top-[calc(100%+4px)] -right-8 rounded whitespace-nowrap pointer-events-none opacity-0 peer-hover:opacity-100 transition-opacity" };
function Wf(e, t) {
  const n = P;
  return c(), p("span", Gf, [
    M(n, {
      icon: ["fas", "exclamation-circle"],
      class: "text-red cursor-pointer ml-1 peer"
    }),
    m("span", Zf, N(e.$t("notifications.urgent")), 1)
  ]);
}
const Hf = /* @__PURE__ */ x(Pf, [["render", Wf]]), Jf = T({
  name: "NotificationTitle",
  components: {
    NotificationTitleText: _f,
    NotificationTitleContent: Rf,
    NotificationTitleAuthor: Qf,
    NotificationTitleUrgentTag: Hf
  },
  emits: ["go-to-content", "loading"],
  props: {
    components: {
      type: Array,
      required: !0
    },
    loading: {
      type: Boolean,
      required: !0
    }
  }
}), Kf = { class: "text-sm inline-block break-words text-black tracking-wide space-x-0.5" };
function qf(e, t, n, o, i, r) {
  return c(), p("div", null, [
    m("p", Kf, [
      (c(!0), p(X, null, te(e.components, (s, l) => (c(), C(xt(s.name), Tt({ key: l }, s.props, {
        onGoToContent: t[0] || (t[0] = (a) => e.$emit("go-to-content")),
        onLoading: t[1] || (t[1] = (a) => e.$emit("loading"))
      }), null, 16))), 128))
    ])
  ]);
}
const Xf = /* @__PURE__ */ x(Jf, [["render", qf]]), ey = (e, t = 70, n = 50) => {
  let o = 0;
  for (let r = 0; r < e.length; r += 1)
    o = e.charCodeAt(r) + ((o << 5) - o);
  return `hsl(${o % 360},${t}%,${n}%)`;
}, ty = (e) => {
  if (!e)
    return "?";
  const n = e.split(" ").map((o) => o.charAt(0).toUpperCase());
  return [n.shift(), n.pop()].join("");
}, ny = {
  small: "w-5 h-5 text-2xs",
  medium: "w-6 h-6 text-sm"
}, oy = T({
  name: "BaseAvatar",
  props: {
    username: {
      type: String,
      default: null
    },
    isDeleted: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "small"
    }
  },
  computed: {
    colorStyle() {
      return this.isDeleted ? { backgroundColor: $e.gray[5], color: "white" } : {
        backgroundColor: this.username === null ? $e.gray[5] : ey(this.username),
        color: "white"
      };
    },
    getInitials() {
      return this.username ? ty(this.username) : "?";
    },
    sizeClass() {
      return ny[this.size];
    }
  }
});
function iy(e, t, n, o, i, r) {
  return c(), p("div", {
    class: D(["flex justify-center items-center leading-none rounded-sm flex-non", e.sizeClass]),
    style: Ce(e.colorStyle)
  }, N(e.getInitials), 7);
}
const Eo = /* @__PURE__ */ x(oy, [["render", iy]]), sy = T({
  name: "NotificationAvatar",
  props: {
    authorId: {
      type: String,
      default: ""
    },
    isDeleted: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    author() {
      return this.getUser(this.authorId);
    },
    ...ue(ve, ["getUser"])
  }
});
function ry(e, t, n, o, i, r) {
  const s = Eo;
  return c(), C(s, Tt(e.author, { size: "medium" }), null, 16);
}
const ay = /* @__PURE__ */ x(sy, [["render", ry]]), ly = [
  { label: "h", seconds: 3600 },
  { label: "min", seconds: 60 },
  { label: "s", seconds: 1 }
], cy = T({
  name: "NotificationDate",
  props: {
    date: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      displayDate: ""
    };
  },
  mounted() {
    this.displayDate = this.timeSince(this.date);
  },
  computed: {
    ...ue(ve, ["notifications"])
  },
  methods: {
    dateParser(e) {
      return new Date(Date.parse(e)).toLocaleString().slice(0, 10);
    },
    timeSince(e) {
      this.isIsoDate(e) || (e = new Date(parseInt(e, 10)).toISOString());
      const t = Math.floor((Date.now() - Date.parse(e)) / 1e3);
      if (t < 2)
        return this.$t("notifications.now");
      if (t < 86400) {
        const n = ly.find((r) => r.seconds < t);
        if (!n)
          return "";
        const i = `${Math.floor(t / n.seconds)}${n.label}`;
        return this.$t("notifications.time-ago", { time: i });
      }
      return t < 86400 * 2 ? this.$t("notifications.yesterday") : this.dateParser(e);
    },
    isIsoDate(e) {
      return /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(e) ? new Date(e).toISOString() === e : !1;
    }
  },
  watch: {
    notifications() {
      this.displayDate = this.timeSince(this.date);
    }
  }
}), uy = { class: "text-2xs font-bold text-gray-6 tracking-wide" };
function dy(e, t, n, o, i, r) {
  return c(), p("span", uy, N(e.displayDate), 1);
}
const Vr = /* @__PURE__ */ x(cy, [["render", dy]]), gy = T({
  name: "NotificationHeader",
  components: { NotificationDate: Vr },
  emits: [],
  props: {
    date: { type: String, required: !0 }
  }
});
const py = { class: "notification__item-header" };
function my(e, t, n, o, i, r) {
  const s = R("NotificationDate");
  return c(), p("div", py, [
    M(s, { date: e.date }, null, 8, ["date"])
  ]);
}
const hy = /* @__PURE__ */ x(gy, [["render", my], ["__scopeId", "data-v-187cc344"]]), fy = { class: "base-message-editor p-0 text-gray-9 text-sm text-left" }, yy = /* @__PURE__ */ T({
  __name: "BaseMessageEditor",
  props: {
    message: {},
    editable: { type: Boolean },
    messageOptions: { type: Boolean },
    handleFetchInlineMention: { type: Function },
    handleFetchInlineContent: { type: Function }
  },
  emits: ["go-to-content", "focus", "blur", "input"],
  setup(e, { emit: t }) {
    const n = e, o = Y(rn()), i = Y(null), r = Y(n.message), s = Y({
      fontOptions: !0,
      structurationOptions: !0,
      tableOptions: !1,
      richOptions: !1,
      messageOptions: n.messageOptions,
      extraStructurationOptions: !1,
      extraFontOptions: !0,
      tocClickOptions: !1,
      allowToc: !1,
      colorOptions: !0,
      hideDragHandle: !0
    });
    _t(() => {
      n.editable && u();
    });
    const l = (g) => {
      t("input", g === "<p></p>" ? "" : g);
    }, a = ({ href: g }) => {
      window.open(g, "_blank");
    }, u = () => {
      var g;
      (g = i.value) == null || g.editor.commands.focus();
    };
    return _e(
      () => n.message,
      () => {
        n.editable ? n.message || (r.value = "", o.value = rn()) : r.value = n.message;
      }
    ), (g, d) => {
      const f = R("mayday-editor"), I = It("stop-propagation");
      return c(), p("div", fy, [
        Ze((c(), C(f, {
          key: h(o),
          ref: "notification-editor",
          content: h(r),
          editable: g.editable,
          options: h(s),
          placeholder: g.$t("notifications.feedback.response.placeholder"),
          "fetch-inline-content": n.handleFetchInlineContent,
          "fetch-inline-mention": n.handleFetchInlineMention,
          onUpdate: l,
          "onClick:openLink": a,
          "onClick:inlineContent": d[0] || (d[0] = (z) => t("go-to-content", z)),
          "onClick:inlineContentModal": d[1] || (d[1] = (z) => t("go-to-content", z)),
          "onClick:inlineContentTab": d[2] || (d[2] = (z) => g.$emit("go-to-content", { ...z, newTab: !0 })),
          onFocus: d[3] || (d[3] = (z) => t("focus")),
          onBlur: d[4] || (d[4] = (z) => t("blur"))
        }, null, 8, ["content", "editable", "options", "placeholder", "fetch-inline-content", "fetch-inline-mention"])), [
          [I]
        ])
      ]);
    };
  }
});
const Br = /* @__PURE__ */ x(yy, [["__scopeId", "data-v-40ad4dad"]]), _i = /* @__PURE__ */ T({
  __name: "NotificationEditor",
  props: {
    message: {},
    editable: { type: Boolean, default: !1 },
    messageOptions: { type: Boolean, default: !1 }
  },
  emits: ["go-to-content", "focus", "blur", "input"],
  setup(e, { emit: t }) {
    const n = e, o = ve(), { users: i } = De(o), r = ({
      entityId: l,
      entityType: a
    }) => {
      const u = i.value[l];
      if (!u)
        return null;
      const { username: g, isDeleted: d } = u;
      return {
        entityId: l,
        entityType: a,
        label: g,
        isDeleted: d
      };
    }, s = (l) => {
      t("input", l === "<p></p>" ? "" : l);
    };
    return (l, a) => {
      const u = Br;
      return c(), C(u, {
        message: n.message,
        editable: l.editable,
        messageOptions: l.messageOptions,
        handleFetchInlineContent: h(o).getContent,
        handleFetchInlineMention: r,
        onGoToContent: a[0] || (a[0] = (g) => t("go-to-content", g)),
        onFocus: a[1] || (a[1] = (g) => t("focus")),
        onBlur: a[2] || (a[2] = (g) => t("blur")),
        onInput: s
      }, null, 8, ["message", "editable", "messageOptions", "handleFetchInlineContent"]);
    };
  }
}), Iy = T({
  name: "AttachmentItem",
  emits: ["disable-click", "delete-attachment"],
  props: {
    name: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    isInput: {
      type: Boolean,
      default: !1
    },
    attachmentWidth: {
      type: String,
      default: "39%"
    }
  },
  data() {
    return { hover: !1 };
  },
  computed: {
    extension() {
      var t;
      return (t = /(?:\.([^.]+))?$/.exec(this.name)) == null ? void 0 : t[1];
    },
    showLoading() {
      return !this.hover && this.loading;
    },
    dynamicStyle() {
      return {
        "--attachment-width": this.attachmentWidth
      };
    },
    icon() {
      switch (this.extension) {
        case "png":
        case "jpeg":
        case "jpg":
          return "file-image";
        case "pdf":
          return "file-pdf";
        case "doc":
        case "docx":
          return "file-alt";
        default:
          return "file-alt";
      }
    }
  },
  methods: {
    triggerDownload() {
      this.isInput || window.open(this.url, "_blank"), this.error && this.$emit("disable-click", "attachments.disable-file-upload");
    },
    deleteAttachment() {
      this.$emit("delete-attachment", this.id);
    }
  }
}), My = { class: "flex items-center gap-1 w-[calc(100%-16px)] h-full" }, Ay = { class: "w-3 h-3 flex items-center justify-center flex-none" }, Ny = {
  key: 0,
  class: "whitespace-nowrap text-2xs"
}, by = {
  key: 1,
  class: "text-secondary w-3 h-full flex-none hidden group-hover:flex items-center justify-center"
};
function Cy(e, t, n, o, i, r) {
  const s = P, l = Le;
  return c(), C(xt(e.isInput ? "div" : "button"), {
    class: D(["text-xs flex items-center justify-between gap-1 p-1 w-[var(--attachment-width)] h-5.5 bg-gray-2 rounded group", [{ "hover:text-secondary": !e.isInput }]]),
    style: Ce(e.dynamicStyle),
    onClick: e.triggerDownload,
    onMouseenter: t[1] || (t[1] = (a) => e.hover = !0),
    onMouseleave: t[2] || (t[2] = (a) => e.hover = !1)
  }, {
    default: _(() => [
      m("div", My, [
        m("div", Ay, [
          e.error ? e.isInput ? (c(), C(s, {
            key: 1,
            class: "text-red",
            icon: ["fal", "exclamation-triangle"]
          })) : A("", !0) : (c(), C(s, {
            key: 0,
            icon: ["fal", e.icon]
          }, null, 8, ["icon"]))
        ]),
        M(l, { text: e.name }, null, 8, ["text"]),
        e.size && e.isInput ? (c(), p("div", Ny, "(" + N(e.size) + ")", 1)) : A("", !0)
      ]),
      e.isInput ? (c(), p("button", {
        key: 0,
        class: "flex items-center justify-center flex-none h-full w-3 hover:text-red",
        onClick: t[0] || (t[0] = (...a) => e.deleteAttachment && e.deleteAttachment(...a))
      }, [
        e.showLoading ? (c(), C(s, {
          key: 1,
          icon: ["fas", "spinner-third"],
          class: "text-secondary",
          spin: ""
        })) : (c(), C(s, {
          key: 0,
          icon: ["fal", "times"]
        }))
      ])) : (c(), p("div", by, [
        M(s, { icon: ["fal", "external-link"] })
      ]))
    ]),
    _: 1
  }, 40, ["class", "style", "onClick"]);
}
const Yr = /* @__PURE__ */ x(Iy, [["render", Cy]]), wy = (e) => e.map((t, n) => {
  let o = t.split("/").slice(-1)[0];
  return o = o.replace(/___[^.]+/, ""), { name: o, url: t, id: String(n) };
}), Dy = T({
  name: "AttachmentList",
  emits: ["disable-click", "delete-attachment"],
  components: {
    AttachmentItem: Yr
  },
  props: {
    attachments: {
      type: Array,
      default: () => []
    },
    isInput: {
      type: Boolean,
      default: !1
    },
    displayDisableFileUpload: {
      type: Boolean,
      default: !1
    },
    errorText: {
      type: String,
      default: ""
    },
    displayHeader: {
      type: Boolean,
      default: !0
    },
    attachmentWidth: {
      type: String,
      default: "39%"
    }
  },
  computed: {
    enrichedAttachments() {
      return wy(this.attachments);
    },
    attachmentsToDisplay() {
      return this.isInput ? this.attachments : this.enrichedAttachments;
    }
  }
});
const zy = {
  key: 0,
  class: "title"
}, vy = {
  key: 1,
  class: "disable-file-upload-message"
};
function Ty(e, t, n, o, i, r) {
  const s = Yr;
  return c(), p(X, null, [
    e.attachments.length ? (c(), p("div", {
      key: 0,
      class: D(["attachments", { "custom-border-red mb-1 pb-1": e.displayDisableFileUpload }])
    }, [
      e.displayHeader ? (c(), p("div", zy, N(e.$t("attachments.title", e.attachments.length)), 1)) : A("", !0),
      (c(!0), p(X, null, te(e.attachmentsToDisplay, (l) => (c(), C(s, {
        key: l.id,
        name: l.name,
        id: l.id,
        url: l.url,
        size: l.size,
        loading: l.loading,
        error: l.error,
        isInput: e.isInput,
        "attachment-width": e.attachmentWidth,
        onDisableClick: t[0] || (t[0] = (a) => e.$emit("disable-click", a)),
        onDeleteAttachment: t[1] || (t[1] = (a) => e.$emit("delete-attachment", a))
      }, null, 8, ["name", "id", "url", "size", "loading", "error", "isInput", "attachment-width"]))), 128))
    ], 2)) : A("", !0),
    e.displayDisableFileUpload ? (c(), p("div", vy, N(e.$t(e.errorText)), 1)) : A("", !0)
  ], 64);
}
const ct = /* @__PURE__ */ x(Dy, [["render", Ty], ["__scopeId", "data-v-191ad7cc"]]), ky = T({
  name: "NotificationAttachments",
  emits: [],
  components: {
    AttachmentList: ct
  },
  props: {
    attachments: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasAttachments() {
      return !!this.attachments && !!this.attachments.length;
    }
  }
});
function jy(e, t, n, o, i, r) {
  const s = ct;
  return e.hasAttachments ? (c(), C(s, {
    key: 0,
    attachments: e.attachments,
    isInput: !1,
    displayHeader: !0
  }, null, 8, ["attachments"])) : A("", !0);
}
const Qr = /* @__PURE__ */ x(ky, [["render", jy]]), Sy = T({
  name: "NotificationMessage",
  components: { NotificationDate: Vr, NotificationEditor: _i, NotificationAttachments: Qr },
  emits: ["go-to-content"],
  props: {
    authorId: {
      type: String,
      required: !1
    },
    message: {
      type: String,
      required: !1
    },
    date: {
      type: String,
      required: !1
    },
    isHighlight: {
      type: Boolean,
      default: !1
    },
    taskId: {
      type: String,
      required: !1
    },
    edited: {
      type: Boolean,
      default: !1
    },
    attachments: {
      type: Array,
      default: () => []
    },
    messageOptions: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    displayMessage() {
      return this.taskId && !this.message ? this.getTaskBody(this.taskId) : this.message;
    },
    displayUsername() {
      return this.isMine ? this.$t("notifications.you") : this.username;
    },
    username() {
      return this.author.isDeleted && this.author.username ? `${this.author.username} ${this.$t("notifications.info.deleted-user")}` : this.author.username;
    },
    author() {
      return this.getUser(this.authorId);
    },
    isMine() {
      return this.authorId === this.userId;
    },
    hasAttachments() {
      return this.attachments && this.attachments.length;
    },
    ...ue(ve, ["userId", "getUser", "getTaskBody"])
  }
});
const Ly = { class: "thread text-xs" }, Ey = { class: "space-x-1" }, Oy = {
  key: 0,
  class: "font-bold text-gray-7 tracking-wide"
}, xy = {
  key: 2,
  class: "text-gray-6 font-bold"
}, _y = { class: "mt-1" };
function Uy(e, t, n, o, i, r) {
  const s = R("NotificationDate"), l = R("NotificationEditor"), a = R("NotificationAttachments");
  return c(), p("div", Ly, [
    m("div", Ey, [
      e.authorId ? (c(), p("span", Oy, N(e.displayUsername || e.$t("notifications.info.author-error")), 1)) : A("", !0),
      e.date ? (c(), C(s, {
        key: 1,
        date: e.date
      }, null, 8, ["date"])) : A("", !0),
      e.edited ? (c(), p("span", xy, N(e.$t("notifications.info.edited")), 1)) : A("", !0)
    ]),
    e.displayMessage ? (c(), C(l, {
      key: 0,
      message: e.displayMessage,
      class: D({ highlight: e.isHighlight }),
      "message-options": e.messageOptions,
      onGoToContent: t[0] || (t[0] = (u) => e.$emit("go-to-content", u))
    }, null, 8, ["message", "class", "message-options"])) : A("", !0),
    m("div", _y, [
      M(a, { attachments: e.attachments }, null, 8, ["attachments"])
    ])
  ]);
}
const Pr = /* @__PURE__ */ x(Sy, [["render", Uy], ["__scopeId", "data-v-2f8271ab"]]), Fy = T({
  name: "NotificationThread",
  components: {
    NotificationMessage: Pr
  },
  emits: ["go-to-content"],
  props: {
    thread: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      showAll: !1,
      maxLength: 3
    };
  },
  computed: {
    displayThread() {
      return this.showAll ? this.thread.slice(1) : this.hasMore ? this.thread.slice(-this.maxLength) : this.thread.slice(1);
    },
    hasMore() {
      return this.thread.length > this.maxLength + 1;
    },
    displayAnimation() {
      return this.showAll ? "blink-animation" : "";
    },
    hiddenMessage() {
      return this.thread.length - (this.maxLength + 1);
    }
  }
});
const $y = { class: "notification__item-thread" }, Ry = { class: "notification__item-cta" };
function Vy(e, t, n, o, i, r) {
  const s = R("NotificationMessage"), l = P;
  return c(), p("div", $y, [
    (c(), C(s, {
      isHighlight: !0,
      key: e.thread[0].taskCommentId,
      authorId: e.thread[0].authorId,
      message: e.thread[0].body,
      date: e.thread[0].createdAt,
      attachments: e.thread[0].attachments,
      class: "notification__item-message",
      onGoToContent: t[0] || (t[0] = (a) => e.$emit("go-to-content", a))
    }, null, 8, ["authorId", "message", "date", "attachments"])),
    e.hasMore ? (c(), p("button", {
      key: 0,
      class: "notification__item-more",
      onClick: t[1] || (t[1] = (a) => e.showAll = !e.showAll)
    }, [
      M(l, {
        icon: ["fas", e.showAll ? "compress-alt" : "expand-alt"]
      }, null, 8, ["icon"]),
      m("div", Ry, N(e.showAll ? e.$t("notifications.show-less") : e.$t("notifications.show-more", e.hiddenMessage)), 1)
    ])) : A("", !0),
    m("div", {
      class: D(e.displayAnimation)
    }, [
      (c(!0), p(X, null, te(e.displayThread, (a) => (c(), C(s, {
        key: a.taskCommentId,
        authorId: a.authorId,
        message: a.body,
        date: a.createdAt,
        attachments: a.attachments,
        messageOptions: !0,
        class: "notification__item-message",
        onGoToContent: t[2] || (t[2] = (u) => e.$emit("go-to-content", u))
      }, null, 8, ["authorId", "message", "date", "attachments"]))), 128))
    ], 2)
  ]);
}
const By = /* @__PURE__ */ x(Fy, [["render", Vy], ["__scopeId", "data-v-c4e76f06"]]), Yy = T({
  name: "AddAttachment",
  emits: ["disable-click", "new-attachment"],
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    attachmentLoading: {
      type: Boolean,
      default: !1
    },
    showLoader: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    handleClick() {
      this.disabled && this.$emit("disable-click"), this.$refs.fileInput.click();
    },
    handleClickOnInput() {
      const e = this.$refs.fileInput;
      e.value = "";
    }
  }
});
const Qy = ["disabled"];
function Py(e, t, n, o, i, r) {
  const s = P;
  return c(), p("button", {
    onClick: t[2] || (t[2] = (...l) => e.handleClick && e.handleClick(...l))
  }, [
    !e.attachmentLoading || !e.showLoader ? Te(e.$slots, "button", { key: 0 }, void 0, !0) : e.showLoader ? (c(), C(s, {
      key: 1,
      icon: ["fas", "spinner-third"],
      class: "loading-icon",
      spin: ""
    })) : A("", !0),
    m("input", {
      ref: "fileInput",
      type: "file",
      onChange: t[0] || (t[0] = (l) => e.$emit("new-attachment", l)),
      onClick: t[1] || (t[1] = (l) => e.handleClickOnInput()),
      id: "file-upload",
      accept: "image/png, image/jpeg, .doc, .docx, application/pdf",
      disabled: e.disabled || e.attachmentLoading,
      multiple: ""
    }, null, 40, Qy)
  ]);
}
const Fn = /* @__PURE__ */ x(Yy, [["render", Py], ["__scopeId", "data-v-7068c767"]]), Ui = (e) => {
  const t = fi({ items: [] }), n = Y(!1), o = Y(""), i = Y(!1), r = k(() => t.items.length >= 3);
  function s(g) {
    const d = Math.trunc(g / 1e3);
    return d < 1e3 ? `${d} Ko` : `${Math.trunc(d / 1e3)} Mo`;
  }
  function l(g) {
    t.items = t.items.filter((d) => d.id !== g), t.items.length || (n.value = !1);
  }
  function a(g) {
    i.value = !0, g && (o.value = g), setTimeout(() => {
      i.value = !1;
    }, 5e3);
  }
  async function u(g) {
    const d = t.items.length;
    if (!g.target.files || !g.target.files.length)
      return;
    if (g.target.files.length + d > 3) {
      a("attachments.too-many-files");
      return;
    }
    n.value = !0;
    const f = Array.from(g.target.files).reduce((z, v) => (v.name, t.items.findIndex((Q) => Q.name === v.name) > -1 ? a("attachments.existing-file") : z.push(v), z), []), I = f.map((z, v) => ({
      name: z.name,
      size: s(z.size),
      id: String(d + v),
      loading: !0,
      error: !1
    }));
    t.items.push(...I), await Promise.all(
      f.map(async (z, v) => {
        const Q = d + v;
        try {
          const H = await e([z]);
          H[0] ? (t.items[Q].loading = !1, t.items[Q].id = H[0]._id, t.items[Q].url = H[0].url) : (t.items[Q].loading = !1, t.items[Q].error = !0, a("attachments.upload-problem"));
        } catch (H) {
          H.response && H.response.status === 413 ? (a("attachments.file-too-big"), t.items.pop()) : (a("attachments.upload-problem"), t.items[Q].error = !0, t.items[Q].loading = !1, n.value = !1);
        }
      })
    ), n.value = !1;
  }
  return {
    fileInputDisable: r,
    attachments: t,
    attachmentLoading: n,
    displayDisableFileUpload: i,
    errorText: o,
    handleDeleteAttachment: l,
    handleFileChange: u,
    showDisableFileUpload: a
  };
}, Gy = T({
  name: "NotificationResponse",
  setup() {
    const e = ve(), {
      fileInputDisable: t,
      attachments: n,
      displayDisableFileUpload: o,
      errorText: i,
      attachmentLoading: r,
      handleDeleteAttachment: s,
      handleFileChange: l,
      showDisableFileUpload: a
    } = Ui(e.uploadFiles);
    return {
      fileInputDisable: t,
      attachments: n,
      displayDisableFileUpload: o,
      errorText: i,
      attachmentLoading: r,
      handleDeleteAttachment: s,
      handleFileChange: l,
      showDisableFileUpload: a
    };
  },
  components: {
    AttachmentList: ct,
    AddAttachment: Fn,
    NotificationEditor: _i
  },
  emits: ["response"],
  props: {
    notificationId: {
      type: String,
      required: !0
    },
    showAttachments: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      response: !1,
      message: "",
      focused: !1
    };
  },
  computed: {
    attachmentsSendable() {
      let e = !0;
      return this.attachments.items.length && (e = this.attachments.items.map((t) => !t.error || !t.loading).every((t) => t)), e && !this.attachmentLoading;
    },
    isSendable() {
      return !!(this.attachments.items.length && this.attachmentsSendable || !this.attachments.items.length && this.message !== "");
    },
    ...ue(ve, ["taskCommentIsLoading"])
  },
  methods: {
    resetResponse(e) {
      e === this.notificationId && (this.response = !1);
    },
    handleReset() {
      this.message = "", this.attachments.items = [];
    },
    handleResponse() {
      this.response = !0, this.handleReset();
    },
    sendMessage() {
      if (!this.isSendable || this.taskCommentIsLoading)
        return;
      const e = {
        comment: this.message,
        ...this.showAttachments ? { attachments: this.attachments.items.map((t) => t.url) } : {}
      };
      this.$emit("response", e), this.handleReset();
    }
  }
});
const Zy = {
  key: 1,
  class: "thread text-xs"
}, Wy = { class: "author" }, Hy = { class: "mt-1" };
function Jy(e, t, n, o, i, r) {
  const s = ye, l = R("NotificationEditor"), a = P, u = Fn, g = ct;
  return c(), p("div", null, [
    e.response ? (c(), p("div", Zy, [
      m("div", Wy, N(e.$t("notifications.you")), 1),
      m("div", {
        class: D(["response border", [e.focused ? "border-blue" : "border-gray-4"]]),
        onKeydown: t[6] || (t[6] = Co((d) => e.response = !1, ["esc"]))
      }, [
        M(l, {
          class: "editor-message",
          message: e.message,
          editable: !0,
          "message-options": !0,
          onInput: t[1] || (t[1] = (d) => e.message = d),
          onFocus: t[2] || (t[2] = (d) => e.focused = !0),
          onBlur: t[3] || (t[3] = (d) => e.focused = !1)
        }, null, 8, ["message"]),
        e.showAttachments ? (c(), C(u, {
          key: 0,
          class: "attachment-wrapper mr-1",
          disabled: e.fileInputDisable,
          "attachment-loading": e.attachmentLoading,
          onNewAttachment: e.handleFileChange,
          onDisableClick: t[4] || (t[4] = (d) => e.showDisableFileUpload("attachments.disable-file-upload"))
        }, {
          button: _(() => [
            M(s, {
              class: "bg-white",
              type: "secondary",
              icon: "",
              size: "mini",
              disabled: e.attachmentLoading
            }, {
              default: _(() => [
                M(a, { icon: ["fal", "paperclip"] })
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["disabled", "attachment-loading", "onNewAttachment"])) : A("", !0),
        M(s, {
          type: "custom-secondary",
          icon: "",
          size: "mini",
          disabled: !e.isSendable,
          onClick: t[5] || (t[5] = (d) => e.sendMessage())
        }, {
          default: _(() => [
            M(a, {
              icon: ["fal", e.taskCommentIsLoading ? "spinner-third" : "paper-plane"],
              spin: e.taskCommentIsLoading
            }, null, 8, ["icon", "spin"])
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 34),
      m("div", Hy, [
        M(g, {
          attachments: e.attachments.items,
          isInput: !0,
          displayDisableFileUpload: e.displayDisableFileUpload,
          errorText: e.errorText,
          onDeleteAttachment: e.handleDeleteAttachment
        }, null, 8, ["attachments", "displayDisableFileUpload", "errorText", "onDeleteAttachment"])
      ])
    ])) : (c(), C(s, {
      key: 0,
      onClick: t[0] || (t[0] = (d) => e.handleResponse()),
      type: "custom-secondary",
      size: "mini",
      outline: ""
    }, {
      default: _(() => [
        ne(N(e.$t("notifications.feedback.response.button")), 1)
      ]),
      _: 1
    }))
  ]);
}
const Ky = /* @__PURE__ */ x(Gy, [["render", Jy], ["__scopeId", "data-v-742a5d5b"]]), qy = T({
  name: "NotificationRedirection",
  props: {
    text: {
      type: String,
      required: !0
    },
    entityId: {
      type: String,
      required: !1
    },
    entityType: {
      type: String,
      required: !1
    },
    trad: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    buttonText() {
      return this.trad ? this.$t(this.text) : this.text;
    }
  }
}), Xy = {
  key: 0,
  class: "mt-2 mb-1"
};
function e2(e, t, n, o, i, r) {
  const s = ye;
  return e.entityId ? (c(), p("div", Xy, [
    M(s, {
      onClick: t[0] || (t[0] = be((l) => e.$emit("go-to-content"), ["stop"])),
      disabled: !e.entityType,
      type: "secondary",
      size: "mini",
      outline: ""
    }, {
      default: _(() => [
        ne(N(e.entityType ? e.buttonText : e.$t("notifications.info.content-error")), 1)
      ]),
      _: 1
    }, 8, ["disabled"])
  ])) : A("", !0);
}
const t2 = /* @__PURE__ */ x(qy, [["render", e2]]), n2 = T({
  name: "NotificationTags",
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  }
});
const o2 = { key: 0 };
function i2(e, t, n, o, i, r) {
  return e.tags.length > 0 ? (c(), p("div", o2, [
    (c(!0), p(X, null, te(e.tags, (s, l) => (c(), p("div", {
      class: "tags",
      key: l
    }, N(s), 1))), 128))
  ])) : A("", !0);
}
const s2 = /* @__PURE__ */ x(n2, [["render", i2], ["__scopeId", "data-v-abf687de"]]), r2 = T({
  name: "NotificationBody",
  components: {
    NotificationMessage: Pr,
    NotificationResponse: Ky,
    NotificationThread: By,
    NotificationEditor: _i,
    NotificationRedirection: t2,
    NotificationTags: s2,
    NotificationHeader: hy,
    NotificationAttachments: Qr
  },
  emits: ["go-to-content", "response", "loading"],
  props: {
    components: {
      type: Array,
      required: !0
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    resetResponse(e) {
      const n = this.$refs.notificationBodyComponents.find(
        (o) => o.$options.name === "NotificationResponse"
      );
      n && n.resetResponse(e);
    }
  }
});
function a2(e, t, n, o, i, r) {
  return c(), p("div", null, [
    (c(!0), p(X, null, te(e.components, (s, l) => (c(), C(xt(s.name), Tt({
      ref_for: !0,
      ref: "notificationBodyComponents",
      key: l
    }, s.props, {
      onGoToContent: t[0] || (t[0] = (a) => e.$emit("go-to-content", a)),
      onResponse: t[1] || (t[1] = (a) => e.$emit("response", a)),
      onLoading: t[2] || (t[2] = (a) => e.$emit("loading"))
    }), null, 16))), 128))
  ]);
}
const l2 = /* @__PURE__ */ x(r2, [["render", a2], ["__scopeId", "data-v-683d1601"]]), c2 = T({
  name: "NotificationItem",
  components: {
    NotificationTitle: Xf,
    NotificationAvatar: ay,
    NotificationBody: l2
  },
  emits: ["go-to-content"],
  props: {
    notification: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loadingTitle: !1,
      loadingBody: !1
    };
  },
  computed: {
    loading() {
      return this.loadingTitle || this.loadingBody;
    },
    resolvedNotification() {
      return this.resolveNotification(this.notification);
    },
    isUrgent() {
      return !!this.notification.metadata.urgent;
    },
    read() {
      return this.isUrgent ? !0 : this.notification.userReads.findIndex((e) => e.userId === this.userId) > -1;
    },
    ...ue(ve, ["userId", "resolveNotification"])
  },
  methods: {
    async goToContent(e = {}, { source: t }) {
      if (this.handleReadNotification(), e.id)
        return this.$emit("go-to-content", { ...e, source: t });
      const { entityId: n, entityType: o, lang: i, type: r, taskId: s, blockId: l, threadId: a, message: u } = this.notification.metadata, g = u ? u.messageId : null, d = r === "TaskAssigned" ? s : n, f = r === "TaskAssigned" ? "Task" : o;
      this.$emit("go-to-content", {
        id: d,
        type: f,
        lang: i,
        blockId: l,
        threadId: a,
        messageId: g,
        source: t
      });
    },
    async sendMessage(e) {
      const t = {
        taskId: this.notification.metadata.taskId,
        ...e,
        notificationId: this.notification._id
      };
      await this.commentNotification(t), this.$refs[`notificationBody-${this.notification._id}`].resetResponse(this.notification._id);
    },
    handleReadNotification() {
      this.read || this.readNotifications([this.notification._id]);
    },
    ...fe(ve, ["readNotifications", "commentNotification"])
  }
});
const u2 = { class: "notification__item-wrapper" }, d2 = { class: "w-12 h-full" }, g2 = { class: "notification__item-main" }, p2 = { class: "w-8 flex items-center" };
function m2(e, t, n, o, i, r) {
  const s = R("NotificationAvatar"), l = R("NotificationTitle"), a = R("NotificationBody");
  return c(), p("div", {
    class: D([{ "bg-gray-1": !e.read }, "notification__item-container"]),
    onClick: t[5] || (t[5] = (...u) => e.handleReadNotification && e.handleReadNotification(...u))
  }, [
    m("div", u2, [
      m("div", d2, [
        M(s, {
          class: "ml-4 mr-2",
          authorId: e.notification.authorId
        }, null, 8, ["authorId"])
      ]),
      m("div", g2, [
        M(l, {
          components: e.resolvedNotification.title,
          loading: e.loading,
          class: "notification__item-header",
          onGoToContent: t[0] || (t[0] = (u) => e.goToContent(u, { source: "feedback_notification" })),
          onLoading: t[1] || (t[1] = (u) => e.loadingTitle = u)
        }, null, 8, ["components", "loading"]),
        M(a, {
          ref: `notificationBody-${e.notification._id}`,
          components: e.resolvedNotification.body,
          loading: e.loading,
          class: "notification__item-body",
          onGoToContent: t[2] || (t[2] = (u) => e.goToContent(u, { source: "notification" })),
          onResponse: e.sendMessage,
          onLoading: t[3] || (t[3] = (u) => e.loadingBody = u)
        }, null, 8, ["components", "loading", "onResponse"])
      ]),
      m("div", p2, [
        e.read ? A("", !0) : (c(), p("button", {
          key: 0,
          class: "ml-2 mr-4 rounded-full bg-secondary w-2 h-2",
          onClick: t[4] || (t[4] = (...u) => e.handleReadNotification && e.handleReadNotification(...u))
        }))
      ])
    ])
  ], 2);
}
const h2 = /* @__PURE__ */ x(c2, [["render", m2], ["__scopeId", "data-v-740a70f7"]]), f2 = T({
  name: "NotificationList",
  props: {
    isFromNotificationCenter: {
      type: Boolean,
      default: !1
    }
  },
  components: {
    NotificationItem: h2
  },
  emits: ["go-to-content", "close", "get-more"],
  computed: {
    filtersApplied() {
      return this.filters.unreadOnly || this.filters.types.length > 0 || this.filters.dateRange[0] || this.filters.dateRange[1];
    },
    displayedNotifications() {
      return this.filters.unreadOnly ? this.notifications.filter(
        (e) => e.userReads.findIndex((t) => t.userId === this.userId) === -1
      ) : this.notifications;
    },
    ...ue(ve, [
      "notifications",
      "hasMoreNotifications",
      "isLoading",
      "filters",
      "userId"
    ])
  },
  methods: {
    ...fe(ve, ["resetFilters"])
  }
}), y2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='185'%20height='161'%20fill='none'%3e%3cpath%20fill='%23EAEEF9'%20d='M90.3%20142.621c28%200%2050.7-22.7%2050.7-50.8%200-28.1-22.8-50.8-50.7-50.8-28%200-50.7%2022.7-50.7%2050.8%200%2028.1%2022.7%2050.8%2050.7%2050.8Zm53.85-18.023a4.1%204.1%200%201%200%200-8.2%204.1%204.1%200%200%200%200%208.2Zm6-16a2.8%202.8%200%201%200-.001-5.601%202.8%202.8%200%200%200%20.001%205.601ZM42.3%2058.42a2.8%202.8%200%201%200%200-5.6%202.8%202.8%200%200%200%200%205.6Zm-17.1%2054.001a5.2%205.2%200%201%200%200-10.4%205.2%205.2%200%200%200%200%2010.4Z'/%3e%3cpath%20fill='white'%20d='M96.661%20110.239H85.394c-2.61%200-4.809%202.408-4.809%205.268v6.172c0%206.321%204.672%2011.439%2010.443%2011.439%205.77%200%2010.442-5.118%2010.442-11.439v-6.172c0-3.01-2.198-5.268-4.809-5.268Z'/%3e%3cg%20filter='url(%23a)'%3e%3cpath%20fill='url(%23b)'%20fill-rule='evenodd'%20d='M95.661%2051.105c11.025%202.55%2019.237%2012.423%2019.237%2024.222v3.16c0%2026.648%2020.061%2044.093%2020.061%2044.093h-90s20.198-17.445%2020.198-44.093v-3.16c0-11.799%208.212-21.672%2019.237-24.222v-1.052c0-3.16%202.473-5.632%205.634-5.632%203.16%200%205.633%202.472%205.633%205.632v1.052Z'%20clip-rule='evenodd'/%3e%3c/g%3e%3cpath%20fill='%23ADB6C8'%20d='M79.585%2089.338c-3.435%200-6.32-2.197-7.42-5.357-.275-.687.137-1.373.825-1.648.687-.275%201.374.137%201.648.824.687%202.06%202.748%203.572%204.947%203.572%202.198%200%204.26-1.374%204.947-3.572.274-.687.961-1.099%201.648-.824.687.275%201.1.961.825%201.648-1.1%203.297-3.985%205.357-7.42%205.357Zm20.748%200c-3.435%200-6.32-2.197-7.42-5.357-.275-.687.138-1.373.825-1.648.687-.275%201.374.137%201.648.824.687%202.06%202.749%203.572%204.947%203.572s4.259-1.374%204.947-3.572c.274-.687.961-1.099%201.648-.824.687.275%201.1.961.825%201.648-1.099%203.297-3.985%205.357-7.42%205.357Zm-10.305%2016.819a3.16%203.16%200%201%200-3.16-3.159%203.16%203.16%200%200%200%203.16%203.159Z'/%3e%3cpath%20fill='url(%23c)'%20d='M106.962%2028.65V24h17.97v4.65L112.67%2043.444h12.473v4.65h-18.815v-4.65L118.59%2028.65h-11.628Z'/%3e%3cpath%20fill='url(%23d)'%20d='M121.761%2063.522v-2.959h11.628v2.96l-7.823%209.51h8.034v2.959h-12.262v-2.96l7.822-9.51h-7.399Z'/%3e%3cdefs%3e%3clinearGradient%20id='b'%20x1='89.93'%20x2='89.93'%20y1='42.613'%20y2='123.423'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FDFEFF'/%3e%3cstop%20offset='.996'%20stop-color='%23ECF0F5'/%3e%3c/linearGradient%3e%3clinearGradient%20id='c'%20x1='115.737'%20x2='115.737'%20y1='24.837'%20y2='38.361'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23B0BACC'/%3e%3cstop%20offset='1'%20stop-color='%23969EAE'/%3e%3c/linearGradient%3e%3clinearGradient%20id='d'%20x1='127.47'%20x2='127.47'%20y1='61.099'%20y2='69.759'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23B0BACC'/%3e%3cstop%20offset='1'%20stop-color='%23969EAE'/%3e%3c/linearGradient%3e%3cfilter%20id='a'%20width='134'%20height='122.159'%20x='22.959'%20y='33.421'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='11'/%3e%3cfeGaussianBlur%20stdDeviation='11'/%3e%3cfeColorMatrix%20values='0%200%200%200%200.397708%200%200%200%200%200.47749%200%200%200%200%200.575%200%200%200%200.27%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_331_2'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_331_2'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", Gr = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='146'%20height='148'%20fill='none'%3e%3cpath%20fill='url(%23a)'%20d='M99.502%2018.565c0%209.317-7.41%2017.021-16.626%2017.558h-1.084c-3.072%200-6.144-.895-8.674-2.329-5.421-3.045-9.035-8.779-9.035-15.408%200-4.479%201.626-8.6%204.517-11.645C71.853%203.157%2076.552.828%2081.792.828c6.867%200%2012.83%203.942%2015.722%209.675%201.265%202.508%201.988%205.196%201.988%208.062Z'/%3e%3cpath%20fill='black'%20d='M99.346%2018.565c0%209.316-7.409%2017.02-16.625%2017.558-3.434-.537-6.687-1.433-9.759-2.15-5.421-3.046-9.035-8.779-9.035-15.408%200-4.48%201.626-8.6%204.518-11.646%205.963-.179%2012.83.359%2019.878%201.613%203.253.537%206.325%201.254%209.216%201.97%201.084%202.509%201.807%205.196%201.807%208.063Z'%20opacity='.1'/%3e%3cpath%20fill='url(%23b)'%20d='M120.954%2030.423c1.364-7.599-15.453-16.92-37.56-20.821-22.108-3.9-41.136-.903-42.5%206.695-1.364%207.599%2015.453%2016.92%2037.56%2020.821%2022.108%203.9%2041.136.903%2042.5-6.695Z'/%3e%3cpath%20fill='white'%20d='M77.758%2013.941c.1-1.282-1.915-2.484-4.503-2.683-2.587-.2-4.765.678-4.866%201.96-.1%201.283%201.915%202.485%204.502%202.684%202.587.2%204.766-.678%204.867-1.96ZM55.02%2017.234c2.487-.732%204.204-2.325%203.834-3.558-.369-1.233-2.685-1.64-5.172-.907-2.488.732-4.205%202.325-3.835%203.558.369%201.233%202.685%201.64%205.172.907Zm41.013%201.421c.228-1.267-1.66-2.659-4.214-3.11-2.555-.45-4.81.211-5.037%201.477-.227%201.267%201.66%202.659%204.214%203.11%202.555.45%204.81-.21%205.037-1.477Zm13.719%209.368c.595-1.143-.793-3.026-3.099-4.205-2.307-1.18-4.658-1.208-5.253-.065-.595%201.143.793%203.026%203.099%204.205%202.307%201.18%204.658%201.208%205.253.065Z'/%3e%3cpath%20fill='url(%23c)'%20d='m78.67%2024.982-16.986-.18L37.492%2069.8l67.9%207.14-7.566-45.865-19.155-6.092Z'/%3e%3cpath%20fill='url(%23d)'%20d='M97.718%2031.537c.612-3.41-7.017-7.607-17.039-9.376-10.022-1.768-18.643-.438-19.255%202.972-.612%203.41%207.017%207.607%2017.039%209.375%2010.022%201.769%2018.643.438%2019.255-2.971Z'/%3e%3cpath%20fill='%23CED7E2'%20d='M32.825%2048.048s-6.243%201.585-4.35%202.853c1.89%201.204%206.368%203.296%2010.592%201.902%204.225-1.395%200-3.36.063-3.36s-6.305-1.395-6.305-1.395Z'/%3e%3cpath%20fill='%23E9EEF8'%20d='M25.195%2047.54c2.27.698%209.27-.443%2013.746-3.36%203.531%204.375%204.855%205.516%206.116%205.643-1.955%201.965-8.449%205.135-12.106%201.014-4.288%202.726-7.756-3.296-7.756-3.296Zm74.977%205.707c2.396.127%208.891-2.79%2012.422-6.72%204.54%203.36%206.053%204.121%207.377%203.93-1.45%202.41-5.864%207.672-12.106%208.052-4.54-2.662-7.693-5.262-7.693-5.262Z'/%3e%3cpath%20fill='white'%20d='M79.407%2053.326c-.474-2.352-4.916-7.915-9.602-10.356%202.123-5.234%202.483-6.889%201.968-8.124%202.695.805%208.89%203.769%2010.814%209.72-1.448%205.06-3.18%208.76-3.18%208.76Z'/%3e%3cpath%20fill='%23EFF3FA'%20d='M37.741%20127.742c15.49%200%2028.047-12.557%2028.047-28.046%200-15.49-12.557-28.047-28.047-28.047S9.695%2084.206%209.695%2099.696c0%2015.489%2012.557%2028.046%2028.046%2028.046Z'/%3e%3cpath%20fill='%23D9E0EC'%20d='M140.239%20130.474H7.109l20.725-27.828%208.888-11.802%207.758%208.414%201.494%201.603%2016.682-23.093%207.139-9.87%205.573%208.122%2018.977%2027.646%207.648-8.742%203.898-4.48%203.314%203.97%2031.034%2036.06Z'/%3e%3cpath%20fill='%23E8EDF8'%20d='m36.722%2090.845-.364%2039.629H7.109l20.725-27.828%208.888-11.801Zm33.073-22.948-1.202%2058.424-22.62-25.46%2023.822-32.964Zm36.788%2056.858-12.239-21.09%2011.547-13.222.692%2034.312Z'/%3e%3cpath%20stroke='%23CDD6E1'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-miterlimit='10'%20stroke-width='2.721'%20d='M1.5%20130.474h143m-67.821%205.9h9.251m16.245%200h9.252m-14.897%200h1.967m-63.414%200h33.145m-47.132%200h4.189m102.278%200h11.655m-135.788%200h11.328m-2.295%204.918H49.07m21.635%200H96.53m13.294%200h25.825m-75.725%200h5.645m22.984%204.88h31.251m-63.741%200h20.616m-33.729%200h6.12m-28.957%200h13.513'/%3e%3cpath%20fill='white'%20d='M50.126%20121.04c0%202.294-1.857%203.314-4.116%203.314-2.258%200-4.116-1.02-4.116-3.314%200-2.295%204.116-16.464%204.116-16.464s4.116%2014.205%204.116%2016.464Z'/%3e%3cpath%20stroke='%23B9C0D0'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-miterlimit='10'%20stroke-width='1.814'%20d='M45.974%20117.033v13.004m0-10.746%201.493-1.348m-1.493%204.445-2.149-2.55'/%3e%3cpath%20fill='white'%20d='M87.132%20120.02c0%202.55-2.076%203.679-4.589%203.679-2.55%200-4.59-1.129-4.59-3.679%200-2.549%204.59-18.321%204.59-18.321s4.59%2015.808%204.59%2018.321Z'/%3e%3cpath%20stroke='%23B9C0D0'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-miterlimit='10'%20stroke-width='1.814'%20d='M82.543%20115.54v14.497m0-11.947%201.64-1.529m-1.64%204.989-2.404-2.877'/%3e%3cpath%20fill='white'%20d='M102.066%20123.918c0%201.566-1.275%202.258-2.804%202.258-1.567%200-2.805-.692-2.805-2.258s2.805-11.219%202.805-11.219%202.804%209.653%202.804%2011.219Z'/%3e%3cpath%20stroke='%23B9C0D0'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-miterlimit='10'%20stroke-width='1.814'%20d='M99.225%20121.186v8.851m0-7.322%201.02-.91m-1.02%203.023-1.457-1.748'/%3e%3cpath%20fill='white'%20d='M117.109%20122.169c0%202.003-1.603%202.877-3.606%202.877s-3.606-.874-3.606-2.877c0-2.003%203.606-14.424%203.606-14.424s3.606%2012.421%203.606%2014.424Z'/%3e%3cpath%20stroke='%23B9C0D0'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-miterlimit='10'%20stroke-width='1.814'%20d='M113.503%20118.636v11.4m0-9.433%201.275-1.165m-1.275%203.896-1.894-2.258'/%3e%3cpath%20fill='white'%20d='m46.301%20101.08-6.264.546-2.914%202.987-3.497-.619-5.791%203.606-1.822-2.368%2010.818-14.387%209.47%2010.235Z'%20opacity='.8'/%3e%3cpath%20fill='white'%20d='m78.209%2080.136-2.95-.656-3.024%201.42-2.44-.618-2.332%204.152-3.642-1.712-4.08%201.712-.691-1.603%2010.745-14.934%208.413%2012.239Zm32.927%2016.39-3.06%202.404-2.841-1.566-4.007%202.331-1.129-2.44%205.937-6.812%205.1%206.083Z'%20opacity='.6'/%3e%3cpath%20fill='%23989FB0'%20d='M33.954%2080.063c.583-.145%201.129-.182%201.712-.182.546%200%201.129.037%201.675.11.547.072%201.13.218%201.676.473s1.092.62%201.42%201.238l-.619-.145.656-.51c.255-.146.473-.328.692-.474a7.386%207.386%200%200%201%201.53-.728%208.957%208.957%200%200%201%201.639-.4c.582-.037%201.129-.037%201.712.108.109.037.145.146.109.219-.037.11-.11.146-.219.11h-.036c-.474-.11-1.02-.074-1.53%200-.51.072-1.02.254-1.493.473a9.708%209.708%200%200%200-1.348.765c-.219.145-.437.327-.62.473l-.582.51c-.182.146-.4.11-.546-.036l-.037.036-.036-.073c-.146-.4-.547-.728-.984-.947a6.006%206.006%200%200%200-1.493-.51c-.51-.11-1.056-.182-1.603-.218-.546-.037-1.092-.037-1.566.072h-.036c-.11.037-.183-.036-.219-.145%200-.11.036-.219.146-.219Zm-16.172%209.98c.582-.146%201.129-.182%201.712-.182.546%200%201.129.036%201.675.109a5.8%205.8%200%200%201%201.676.473c.546.255%201.092.62%201.42%201.239l-.62-.146.657-.51c.255-.145.473-.328.692-.473a7.384%207.384%200%200%201%201.53-.729%208.957%208.957%200%200%201%201.639-.4c.582-.037%201.129-.037%201.711.109.11.036.146.145.11.218-.037.11-.11.146-.219.11h-.036c-.474-.11-1.02-.073-1.53%200-.51.072-1.02.255-1.494.473-.473.219-.91.474-1.347.765-.219.146-.437.328-.62.474l-.582.51c-.182.145-.4.109-.546-.037l-.037-.036-.036-.073c-.146-.4-.547-.729-.984-.947a6.002%206.002%200%200%200-1.493-.51%2011.33%2011.33%200%200%200-1.603-.219c-.546-.036-1.093-.036-1.566.073h-.036c-.11.037-.183-.036-.219-.145%200-.037.073-.146.146-.146Zm20.105-1.42c.583-.146%201.13-.182%201.712-.182.547%200%201.13.036%201.676.109a5.798%205.798%200%200%201%201.675.474c.547.254%201.093.619%201.42%201.238l-.618-.146.655-.51c.255-.145.474-.328.692-.473a7.386%207.386%200%200%201%201.53-.729%208.966%208.966%200%200%201%201.64-.4c.582-.037%201.128-.037%201.711.109.11.036.146.146.11.218-.037.11-.11.146-.22.11h-.036c-.473-.11-1.02-.073-1.53%200s-1.02.255-1.493.473c-.473.219-.91.474-1.347.765-.219.146-.438.328-.62.474l-.582.51c-.183.145-.401.109-.547-.037l-.036-.036-.037-.073c-.145-.4-.546-.729-.983-.947a6.002%206.002%200%200%200-1.493-.51%2011.33%2011.33%200%200%200-1.603-.219c-.547-.036-1.093-.036-1.566.073h-.037c-.109.037-.182-.036-.218-.145%200-.037.036-.146.145-.146Z'/%3e%3cg%20filter='url(%23e)'%3e%3cpath%20fill='url(%23f)'%20d='M96.457%2089.121a3.792%203.792%200%200%201-3.81%203.791H79.924c-2.534.055-4.557-1.968-4.557-4.41a4.377%204.377%200%200%201%204.612-4.375c2.205-6.89%2012.303-5.924%2013.16%201.203%201.896.237%203.318%201.84%203.318%203.791Z'/%3e%3c/g%3e%3cpath%20fill='url(%23g)'%20d='M92.647%2092.913c2.096%200%203.81-1.695%203.81-3.792%200-2.096-1.714-3.79-3.81-3.79s-3.81%201.694-3.81%203.79c0%202.097%201.714%203.792%203.81%203.792Z'/%3e%3cpath%20fill='url(%23h)'%20d='M86.432%2092.949c3.736%200%206.78-3.026%206.78-6.763%200-3.736-3.044-6.762-6.78-6.762-3.737%200-6.781%203.026-6.781%206.762a6.764%206.764%200%200%200%206.78%206.763Z'/%3e%3cg%20filter='url(%23i)'%3e%3cpath%20fill='url(%23j)'%20d='M63.363%2095.79a2.859%202.859%200%200%201-2.871%202.858h-9.59c-1.91.041-3.435-1.484-3.435-3.325a3.3%203.3%200%200%201%203.476-3.297c1.662-5.194%209.274-4.466%209.92.906a2.857%202.857%200%200%201%202.5%202.858Z'/%3e%3c/g%3e%3cpath%20fill='url(%23k)'%20d='M60.492%2098.648a2.867%202.867%200%200%200%202.872-2.858%202.867%202.867%200%200%200-2.872-2.857%202.867%202.867%200%200%200-2.871%202.857%202.867%202.867%200%200%200%202.871%202.858Z'/%3e%3cpath%20fill='url(%23l)'%20d='M55.807%2098.675c2.816%200%205.111-2.28%205.111-5.097%200-2.817-2.294-5.097-5.111-5.097-2.817%200-5.111%202.28-5.111%205.097a5.099%205.099%200%200%200%205.11%205.097Z'/%3e%3cdefs%3e%3clinearGradient%20id='a'%20x1='81.795'%20x2='81.795'%20y1='2.054'%20y2='21.865'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23B0BACC'/%3e%3cstop%20offset='1'%20stop-color='%23969EAE'/%3e%3c/linearGradient%3e%3clinearGradient%20id='b'%20x1='43.676'%20x2='88.589'%20y1='16.786'%20y2='24.848'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E3E7EE'/%3e%3cstop%20offset='1'%20stop-color='%23D1D6DF'/%3e%3c/linearGradient%3e%3clinearGradient%20id='c'%20x1='71.447'%20x2='71.447'%20y1='26.614'%20y2='55.878'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23BDC4D1'%20stop-opacity='.53'/%3e%3cstop%20offset='1'%20stop-color='%235D7CB8'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='d'%20x1='79.571'%20x2='82.246'%20y1='33.099'%20y2='23.867'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23B0BACC'/%3e%3cstop%20offset='1'%20stop-color='%23969EAE'/%3e%3c/linearGradient%3e%3clinearGradient%20id='f'%20x1='85.912'%20x2='85.905'%20y1='85.008'%20y2='93.059'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'/%3e%3cstop%20offset='.996'%20stop-color='%23ECF0F5'/%3e%3c/linearGradient%3e%3clinearGradient%20id='g'%20x1='88.432'%20x2='91.809'%20y1='84.514'%20y2='88.207'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23BCCBE1'/%3e%3cstop%20offset='.994'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='h'%20x1='79.016'%20x2='84.339'%20y1='83.083'%20y2='85.166'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E2E8F0'/%3e%3cstop%20offset='.994'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='j'%20x1='55.415'%20x2='55.41'%20y1='92.69'%20y2='98.758'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'/%3e%3cstop%20offset='.996'%20stop-color='%23ECF0F5'/%3e%3c/linearGradient%3e%3clinearGradient%20id='k'%20x1='57.315'%20x2='59.861'%20y1='92.317'%20y2='95.102'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23BCCBE1'/%3e%3cstop%20offset='.994'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='l'%20x1='50.217'%20x2='54.229'%20y1='91.239'%20y2='92.809'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E2E8F0'/%3e%3cstop%20offset='.994'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3cfilter%20id='e'%20width='60.994'%20height='53.378'%20x='55.415'%20y='69.464'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='9.976'/%3e%3cfeGaussianBlur%20stdDeviation='9.976'/%3e%3cfeColorMatrix%20values='0%200%200%200%200.397708%200%200%200%200%200.47749%200%200%200%200%200.575%200%200%200%200.27%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_195_43808'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_195_43808'%20result='shape'/%3e%3c/filter%3e%3cfilter%20id='i'%20width='55.802'%20height='50.06'%20x='27.514'%20y='78.517'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='9.976'/%3e%3cfeGaussianBlur%20stdDeviation='9.976'/%3e%3cfeColorMatrix%20values='0%200%200%200%200.397708%200%200%200%200%200.47749%200%200%200%200%200.575%200%200%200%200.27%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_195_43808'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_195_43808'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";
const Zr = (e) => (Sn("data-v-aa785104"), e = e(), Ln(), e), I2 = { class: "notification__item-placeholder" }, M2 = {
  key: 0,
  class: "notification__item-empty"
}, A2 = /* @__PURE__ */ Zr(() => /* @__PURE__ */ m("img", { src: y2 }, null, -1)), N2 = { class: "empty-title" }, b2 = { class: "empty-description" }, C2 = {
  key: 1,
  class: "notification__item-empty"
}, w2 = /* @__PURE__ */ Zr(() => /* @__PURE__ */ m("img", { src: Gr }, null, -1)), D2 = { class: "empty-title" }, z2 = { class: "empty-description" }, v2 = { class: "flex justify-center" };
function T2(e, t, n, o, i, r) {
  const s = R("NotificationItem"), l = ye, a = P;
  return c(), p("div", null, [
    (c(!0), p(X, null, te(e.displayedNotifications, (u) => (c(), C(s, {
      key: u.id,
      notification: u,
      onClose: t[0] || (t[0] = (g) => e.$emit("close")),
      onGoToContent: t[1] || (t[1] = (g) => e.$emit("go-to-content", g))
    }, null, 8, ["notification"]))), 128)),
    m("div", I2, [
      !e.displayedNotifications.length && !e.filtersApplied ? (c(), p("div", M2, [
        A2,
        m("div", N2, N(e.$t("notifications.empty.title")), 1),
        m("div", b2, N(e.$t("notifications.empty.description")), 1)
      ])) : A("", !0),
      !e.displayedNotifications.length && e.filtersApplied ? (c(), p("div", C2, [
        w2,
        m("div", D2, N(e.$t("notifications.empty.filtered-title")), 1),
        m("div", z2, N(e.$t("notifications.empty.filtered-description")), 1),
        M(l, {
          class: "border notification__item-cta",
          onClick: t[2] || (t[2] = (u) => e.resetFilters(e.isFromNotificationCenter))
        }, {
          default: _(() => [
            ne(N(e.$t("notifications.empty.cta")), 1)
          ]),
          _: 1
        })
      ])) : A("", !0),
      m("div", v2, [
        e.hasMoreNotifications ? (c(), C(l, {
          key: 0,
          outline: "",
          onClick: t[3] || (t[3] = (u) => e.$emit("get-more")),
          type: "custom-secondary"
        }, {
          default: _(() => [
            e.isLoading ? (c(), C(a, {
              key: 0,
              icon: ["fas", "spinner-third"],
              spin: ""
            })) : A("", !0),
            ne(" " + N(e.$t("notifications.get-more")), 1)
          ]),
          _: 1
        })) : A("", !0)
      ])
    ])
  ]);
}
const k2 = /* @__PURE__ */ x(f2, [["render", T2], ["__scopeId", "data-v-aa785104"]]), j2 = T({
  name: "NotificationListView",
  components: {
    NotificationList: k2
  },
  props: {
    isFromNotificationCenter: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close", "go-to-content"],
  async created() {
    await this.getNotifications();
  },
  computed: {
    ...ue(ve, ["filtersOpened"])
  },
  methods: {
    getMoreNotifications() {
      return this.getNotifications(10);
    },
    ...fe(ve, ["getNotifications"])
  }
});
function S2(e, t, n, o, i, r) {
  const s = R("NotificationList");
  return c(), C(s, {
    onClose: t[0] || (t[0] = (l) => e.$emit("close")),
    class: D({ "filters-opened": e.filtersOpened }),
    "is-from-notification-center": e.isFromNotificationCenter,
    onGetMore: e.getMoreNotifications,
    onGoToContent: t[1] || (t[1] = (l) => e.$emit("go-to-content", l))
  }, null, 8, ["class", "is-from-notification-center", "onGetMore"]);
}
const L2 = /* @__PURE__ */ x(j2, [["render", S2]]), E2 = T({
  name: "NotificationMenu",
  props: {
    filtersOpened: {
      type: Boolean,
      default: !0
    },
    isFromNotificationCenter: {
      type: Boolean,
      default: !1
    },
    displayTitle: {
      type: Boolean,
      default: !1
    },
    showFiltersAndReadButtons: {
      type: Boolean,
      default: !0
    }
  },
  data: () => ({
    timeFilter: -1,
    timeOptions: [
      { scale: "day", number: 3, label: "3-last-days" },
      { scale: "week", number: 1, label: "last-week" },
      { scale: "week", number: 2, label: "2-last-weeks" },
      { scale: "month", number: 1, label: "last-month" },
      { scale: "month", number: 3, label: "3-last-months" }
    ],
    feedbackTypes: po,
    infoTypes: mo
  }),
  emits: ["toggle-filters"],
  computed: {
    unreadDisplay() {
      return this.unreadCount > 99 ? "99+" : this.unreadCount;
    },
    filtersCount() {
      let e = 0;
      return this.filters.unreadOnly && e++, this.filters.types.length > 0 && (this.filters.types.some((t) => po.includes(t)) && e++, this.filters.types.some((t) => mo.includes(t)) && e++), this.filters.dateRange[0] !== null && e++, e;
    },
    ...ue(ve, ["unreadCount", "filters"])
  },
  methods: {
    isSelected(e) {
      return e === "feedbackTypes" ? this.filters.types.some((t) => po.includes(t)) : e === "infoTypes" ? this.filters.types.some((t) => mo.includes(t)) : e === "date" ? this.timeFilter > -1 : !!this.filters[e];
    },
    updateFilter(e, t) {
      if (t === void 0)
        this.updateFilters(
          {
            field: e,
            value: !this.filters[e]
          },
          this.isFromNotificationCenter
        );
      else if (e === "dateRange" && t instanceof Event) {
        const n = t.target;
        n.value === "-1" ? this.updateFilters(
          {
            field: "dateRange",
            value: [null, null]
          },
          this.isFromNotificationCenter
        ) : this.updateFilters(
          {
            field: "dateRange",
            value: this.timeOptionToDates(this.timeOptions[parseInt(n.value)])
          },
          this.isFromNotificationCenter
        );
      } else if (e === "types" && !(t instanceof Event)) {
        const n = this.filters.types.some((o) => t.includes(o)) ? this.filters.types.filter((o) => !t.includes(o)) : [...this.filters.types, ...t];
        this.updateFilters(
          {
            field: e,
            value: n
          },
          this.isFromNotificationCenter
        );
      }
    },
    timeOptionToDates(e) {
      const t = /* @__PURE__ */ new Date();
      let n = /* @__PURE__ */ new Date(), o = /* @__PURE__ */ new Date();
      return e.scale === "day" ? n.setDate(t.getDate() - e.number) : e.scale === "week" ? n.setDate(t.getDate() - 7 * e.number) : e.scale === "month" && n.setMonth(t.getMonth() - e.number), [n, o];
    },
    ...fe(ve, [
      "readAllNotifications",
      "updateFilters",
      "getNotifications",
      "resetFilters"
    ])
  },
  watch: {
    filters: {
      handler(e) {
        e.dateRange[0] === null && (this.timeFilter = -1);
      },
      deep: !0
    }
  }
});
const O2 = { class: "notification__menu-container" }, x2 = {
  key: 0,
  class: "text-primary-contrast pb-2 text-lg"
}, _2 = { class: "notification__menu" }, U2 = { class: "notification__menu-actions" }, F2 = {
  key: 0,
  class: "notification__menu-filter__count"
}, $2 = ["disabled"], R2 = { key: 0 }, V2 = { class: "notification__menu-filters pt-3" }, B2 = ["disabled"], Y2 = ["value"];
function Q2(e, t, n, o, i, r) {
  const s = P;
  return c(), p("div", O2, [
    e.displayTitle ? (c(), p("span", x2, N(e.$t("notifications.title")), 1)) : A("", !0),
    m("div", _2, [
      m("div", U2, [
        e.showFiltersAndReadButtons && e.unreadCount > 0 ? (c(), p("button", {
          key: 0,
          class: "notification__menu-filter__hyperlink",
          onClick: t[0] || (t[0] = (...l) => e.readAllNotifications && e.readAllNotifications(...l))
        }, N(e.$t("notifications.read-all")), 1)) : A("", !0),
        e.showFiltersAndReadButtons ? (c(), p("button", {
          key: 1,
          class: D(["notification__menu-filter__button", [{ selected: e.filtersOpened || e.filtersCount > 0 }]]),
          onClick: t[1] || (t[1] = (l) => e.$emit("toggle-filters"))
        }, [
          M(s, {
            icon: ["fal", "sliders-v"],
            class: "notification__popover-icon"
          }),
          ne(" " + N(e.$t("notifications.filters.button")) + " ", 1),
          e.filtersCount > 0 ? (c(), p("span", F2, N(e.filtersCount), 1)) : A("", !0)
        ], 2)) : A("", !0),
        e.showFiltersAndReadButtons && e.filtersCount ? (c(), p("button", {
          key: 2,
          class: "notification__menu-filter__hyperlink",
          disabled: e.filtersCount <= 0,
          onClick: t[2] || (t[2] = (l) => e.resetFilters())
        }, [
          M(s, {
            icon: ["fal", "trash"],
            class: "notification__popover-icon"
          }),
          ne(" " + N(e.$t("notifications.filters.reset")), 1)
        ], 8, $2)) : A("", !0)
      ])
    ]),
    M(Xe, { name: "fade-height" }, {
      default: _(() => [
        e.filtersOpened ? (c(), p("div", R2, [
          m("div", V2, [
            m("button", {
              class: D(["notification__menu-filter__checkbox", [{ selected: e.isSelected("unreadOnly") }]]),
              onClick: t[3] || (t[3] = (l) => e.updateFilter("unreadOnly"))
            }, [
              M(s, {
                icon: ["fal", "eye-slash"],
                class: "notification__popover-icon"
              }),
              ne(" " + N(e.$t("notifications.filters.unread")), 1)
            ], 2),
            m("button", {
              class: D(["notification__menu-filter__checkbox", [{ selected: e.isSelected("feedbackTypes") }]]),
              onClick: t[4] || (t[4] = (l) => e.updateFilter("types", e.feedbackTypes))
            }, [
              M(s, {
                icon: ["fal", "megaphone"],
                class: "notification__popover-icon"
              }),
              ne(" " + N(e.$t("notifications.filters.feedback")), 1)
            ], 2),
            m("button", {
              class: D(["notification__menu-filter__checkbox", [{ selected: e.isSelected("infoTypes") }]]),
              onClick: t[5] || (t[5] = (l) => e.updateFilter("types", e.infoTypes))
            }, [
              M(s, {
                icon: ["fal", "info-circle"],
                class: "notification__popover-icon"
              }),
              ne(" " + N(e.$t("notifications.filters.infos")), 1)
            ], 2),
            m("div", {
              class: D(["notification__menu-filter__select-container", [{ selected: e.isSelected("date") }]])
            }, [
              M(s, {
                icon: ["fal", "calendar"],
                class: "notification__popover-icon notification__popover-calendar-icon"
              }),
              Ze(m("select", {
                "onUpdate:modelValue": t[6] || (t[6] = (l) => e.timeFilter = l),
                class: D(["notification__menu-filter__select", [{ selected: e.isSelected("date") }]]),
                onChange: t[7] || (t[7] = (l) => e.updateFilter("dateRange", l))
              }, [
                m("option", {
                  disabled: !e.isSelected("date"),
                  selected: "",
                  value: "-1"
                }, N(e.isSelected("date") ? e.$t("notifications.filters.reset") : e.$t("notifications.filters.date")), 9, B2),
                (c(!0), p(X, null, te(e.timeOptions, (l, a) => (c(), p("option", {
                  key: l.label,
                  value: a
                }, N(e.$t(`notifications.filters.timeframes.${l.label}`)), 9, Y2))), 128))
              ], 34), [
                [_s, e.timeFilter]
              ])
            ], 2)
          ])
        ])) : A("", !0)
      ]),
      _: 1
    })
  ]);
}
const P2 = /* @__PURE__ */ x(E2, [["render", Q2], ["__scopeId", "data-v-b567687d"]]), G2 = T({
  name: "NotificationMenuView",
  components: {
    NotificationMenu: P2
  },
  props: {
    isFromNotificationCenter: {
      type: Boolean,
      default: !1
    },
    displayTitle: {
      type: Boolean,
      default: !1
    },
    showFiltersAndReadButtons: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    ...ue(ve, ["filtersOpened"])
  },
  methods: {
    ...fe(ve, ["toggleFilters"])
  }
});
function Z2(e, t, n, o, i, r) {
  const s = R("NotificationMenu");
  return c(), C(s, {
    "filters-opened": e.filtersOpened,
    "is-from-notification-center": e.isFromNotificationCenter,
    "display-title": e.displayTitle,
    "show-filters-and-read-buttons": e.showFiltersAndReadButtons,
    onToggleFilters: e.toggleFilters
  }, null, 8, ["filters-opened", "is-from-notification-center", "display-title", "show-filters-and-read-buttons", "onToggleFilters"]);
}
const W2 = /* @__PURE__ */ x(G2, [["render", Z2]]), H2 = T({
  name: "UrgentNotificationSlide",
  props: {
    slideNbr: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    hasLinkedEntity: {
      type: Boolean,
      default: !1
    },
    notLastSlide: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      body: this.message
    };
  },
  methods: {
    handleOpenLink({ href: e }) {
      window.open(e, "_blank");
    }
  },
  watch: {
    message(e) {
      this.body = e;
    }
  }
});
const J2 = {
  key: 0,
  class: "content"
}, K2 = { class: "title-wrapper" }, q2 = { class: "title" }, X2 = {
  key: 1,
  class: "content reset-wrapper"
}, eI = { class: "label" };
function tI(e, t, n, o, i, r) {
  const s = P, l = R("mayday-editor"), a = ye;
  return c(), p("div", null, [
    e.notLastSlide ? (c(), p("div", J2, [
      m("div", K2, [
        m("div", q2, N(e.title), 1),
        e.hasLinkedEntity ? (c(), p("div", {
          key: 0,
          class: "linked-content",
          onClick: t[0] || (t[0] = (u) => e.$emit("reach-content"))
        }, [
          ne(N(e.$t("notifications.urgents.linked-content")) + " ", 1),
          M(s, {
            class: "redirect-icon",
            icon: ["fal", "external-link"]
          })
        ])) : A("", !0)
      ]),
      (c(), C(l, {
        key: e.slideNbr,
        class: "mayday-urgent-viewer text-gray-9 text-sm text-left !p-0",
        ref: "editor",
        editable: !1,
        content: e.body,
        "onClick:openLink": e.handleOpenLink
      }, null, 8, ["content", "onClick:openLink"]))
    ])) : (c(), p("div", X2, [
      M(s, {
        icon: ["fal", "check"],
        class: "check-icon"
      }),
      m("div", eI, N(e.$t("notifications.urgents.slide.all-read")), 1),
      M(a, {
        class: "reset-btn",
        type: "primary",
        size: "small",
        onClick: t[1] || (t[1] = (u) => e.$emit("reset"))
      }, {
        default: _(() => [
          M(s, { icon: ["fal", "undo"] }),
          ne(N(e.$t("notifications.urgents.slide.reread")), 1)
        ]),
        _: 1
      }),
      m("div", {
        class: "hide-action",
        onClick: t[2] || (t[2] = (u) => e.$emit("hide"))
      }, N(e.$t("notifications.urgents.slide.hide")), 1)
    ]))
  ]);
}
const nI = /* @__PURE__ */ x(H2, [["render", tI], ["__scopeId", "data-v-25dc9ccc"]]), oI = T({
  name: "UrgentNotificationsView",
  components: {
    BaseButton: ye,
    UrgentNotificationSlide: nI
  },
  props: {
    notifications: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      expand: !1,
      step: 0,
      transition: ""
    };
  },
  computed: {
    count() {
      return this.notifications.length;
    },
    isLastStep() {
      return this.step === this.count;
    },
    isFirstStep() {
      return this.step === 0;
    }
  },
  methods: {
    handleExpand() {
      this.expand = !this.expand, this.expand && (this.step = 0);
    },
    handlePrev() {
      this.transition = "slide-out", this.step -= 1;
    },
    handleNext() {
      this.transition = "slide-in", this.step += 1;
    },
    reset() {
      this.step = 0;
    }
  }
});
const iI = { class: "notifications__card" }, sI = { class: "notifications__circle" }, rI = {
  key: 0,
  class: "unread-count"
}, aI = { class: "action" }, lI = { class: "notifications__collapse" }, cI = { class: "transition-wrapper" }, uI = {
  key: 0,
  class: "notifications__collapse-footer bg-gray-3"
}, dI = { class: "steps" }, gI = { class: "nav" };
function pI(e, t, n, o, i, r) {
  const s = P, l = R("UrgentNotificationSlide"), a = ye;
  return c(), p("div", {
    class: D(["notifications rounded-lg", { expand: e.expand }])
  }, [
    m("div", iI, [
      m("div", sI, [
        M(s, { icon: ["fal", "bell-exclamation"] }),
        e.count > 0 ? (c(), p("span", rI, N(e.count), 1)) : A("", !0)
      ]),
      m("div", null, N(e.$t("notifications.urgents.label")), 1),
      m("div", {
        class: "notifications__dropdown",
        onClick: t[0] || (t[0] = (u) => e.handleExpand())
      }, [
        m("span", aI, N(e.$t(`notifications.urgents.${e.expand ? "hide" : "display"}`)), 1),
        M(s, {
          class: D(["font-semibold chevron-icon", e.expand ? "rotate-180" : ""]),
          icon: ["fal", "chevron-down"]
        }, null, 8, ["class"])
      ])
    ]),
    m("div", lI, [
      m("div", cI, [
        M(Xe, { name: e.transition }, {
          default: _(() => [
            e.notifications[e.step] ? (c(), C(l, {
              key: e.step,
              "has-linked-entity": !!e.notifications[e.step] && !!e.notifications[e.step].metadata.entityId,
              message: e.notifications[e.step].metadata.body,
              "slide-nbr": e.step,
              title: e.notifications[e.step].metadata.label,
              class: "transition-slide",
              onHide: t[1] || (t[1] = (u) => e.handleExpand()),
              onReset: t[2] || (t[2] = (u) => e.reset()),
              onReachContent: t[3] || (t[3] = (u) => e.$emit("reach-content", {
                id: e.notifications[e.step].metadata.entityId,
                type: e.notifications[e.step].metadata.entityType,
                source: "urgent_notification"
              }))
            }, null, 8, ["has-linked-entity", "message", "slide-nbr", "title"])) : (c(), C(l, {
              key: `${e.step}-last`,
              "not-last-slide": !1,
              class: "transition-slide",
              onHide: t[4] || (t[4] = (u) => e.handleExpand()),
              onReset: t[5] || (t[5] = (u) => e.reset())
            }))
          ]),
          _: 1
        }, 8, ["name"])
      ]),
      e.count > 1 && e.notifications[e.step] ? (c(), p("div", uI, [
        m("div", dI, N(e.$t("notifications.urgents.count")) + " " + N(e.step + 1) + "/" + N(e.count), 1),
        m("div", gI, [
          M(a, {
            class: "action-btn",
            size: "mini",
            type: "danger",
            onClick: t[6] || (t[6] = (u) => e.handlePrev())
          }, {
            default: _(() => [
              M(s, {
                icon: ["fal", "chevron-left"],
                class: "chevron-icon"
              })
            ]),
            _: 1
          }),
          M(a, {
            class: "action-btn",
            size: "mini",
            type: "danger",
            onClick: t[7] || (t[7] = (u) => e.handleNext())
          }, {
            default: _(() => [
              M(s, {
                icon: ["fal", "chevron-right"],
                class: "chevron-icon"
              })
            ]),
            _: 1
          })
        ])
      ])) : A("", !0)
    ])
  ], 2);
}
const mI = /* @__PURE__ */ x(oI, [["render", pI], ["__scopeId", "data-v-9c56bf07"]]), hI = { class: "flex items-center gap-4" }, fI = { class: "urgent-banner__circle flex justify-center items-center relative bg-white text-red rounded-full w-6 h-6" }, yI = { class: "unread-count bg-white border-red text-red text-3xs font-bold border rounded-full min-w-4 h-4 absolute -top-2 -right-2 flex items-center justify-center" }, II = { class: "text-white text-lg font-semibold tracking-wide" }, MI = /* @__PURE__ */ T({
  __name: "UrgentNotificationHeader",
  props: {
    title: {},
    numberOfNotifications: {}
  },
  setup(e) {
    return (t, n) => {
      const o = P;
      return c(), p("div", hI, [
        m("div", fI, [
          M(o, {
            icon: ["fal", "bell-exclamation"],
            class: "w-5 h-5"
          }),
          m("span", yI, N(t.numberOfNotifications), 1)
        ]),
        m("div", II, N(t.title), 1)
      ]);
    };
  }
}), AI = /* @__PURE__ */ T({
  __name: "InfiniteScroll",
  props: {
    pause: { type: Boolean },
    text: {},
    loading: { type: Boolean }
  },
  emits: ["update-overflow", "loading"],
  setup(e, { emit: t }) {
    const n = e;
    Us((l) => ({
      "7a2db1cc": h(r)
    }));
    const o = Y("animatedTextRef"), i = Y(!1), r = k(() => `${Math.log(n.text.length + 1) * 3.5}s`);
    _t(() => {
      t("loading", !0), at(() => {
        s(), t("loading", !1);
      });
    });
    const s = () => {
      at(() => {
        const l = o.value.clientWidth, a = o.value.scrollWidth;
        !l || !a || (a > l ? i.value = !0 : i.value = !1, t("update-overflow", { isScrolling: a > l }));
      });
    };
    return _e(
      () => n.text,
      () => {
        t("loading", !0), i.value && o.value.classList.remove("animated"), setTimeout(() => {
          s(), at(() => {
            i.value && o.value.classList.add("animated"), at(() => {
              t("loading", !1);
            });
          });
        }, 1);
      }
    ), (l, a) => (c(), p("div", {
      class: D(["relative h-6 overflow-hidden", { "w-full": h(i) }])
    }, [
      m("span", {
        ref_key: "animatedTextRef",
        ref: o,
        class: D(["whitespace-nowrap w-full block h-full text-white", [{ paused: l.pause }, { animated: h(i) }, { invisible: l.loading }]])
      }, [
        Te(l.$slots, "content", {}, void 0, !0)
      ], 2)
    ], 2));
  }
});
const Wr = /* @__PURE__ */ x(AI, [["__scopeId", "data-v-5eb28a8e"]]), Hr = /* @__PURE__ */ T({
  __name: "UrgentNotificationRedirection",
  props: {
    id: {},
    type: {},
    lang: {}
  },
  emits: ["go-to-content"],
  setup(e, { emit: t }) {
    return (n, o) => {
      const i = P;
      return c(), p("div", {
        class: "flex gap-2 flex-row font-semibold hover:cursor-pointer hover:text-white/75 w-fit",
        onClick: o[0] || (o[0] = (r) => t("go-to-content", { id: n.id, type: n.type, lang: n.lang }))
      }, [
        m("span", null, N(n.$t("notifications.urgents.link")), 1),
        M(i, { icon: ["fal", "external-link"] })
      ]);
    };
  }
}), NI = { class: "gap-3 items-center flex flex-row text-white content-center h-full" }, bI = /* @__PURE__ */ T({
  __name: "UrgentNotificationBody",
  props: {
    notifications: {},
    currentNotificationIndex: {},
    pause: { type: Boolean },
    currentBody: {},
    currentId: {},
    currentLinkedContent: {}
  },
  emits: ["update-overflow", "go-to-content"],
  setup(e, { emit: t }) {
    const n = e, o = Y({
      fontOptions: !0,
      extraFontOptions: !0,
      colorOptions: !0,
      structurationOptions: !0,
      extraStructurationOptions: !0,
      tableOptions: !0,
      richOptions: !0,
      tocClickOptions: !0,
      allowToc: !0
    }), i = Y(!0), r = Y(!0), s = k(() => n.currentLinkedContent && n.currentLinkedContent.id && n.currentLinkedContent.type && !r.value), l = ({ href: a }) => {
      window.open(a, "_blank");
    };
    return _e(
      () => n.currentBody,
      () => {
        i.value = !1, at(() => {
          i.value = !0;
        });
      },
      { immediate: !0 }
    ), (a, u) => {
      var d;
      const g = R("mayday-editor");
      return c(), p("div", NI, [
        M(Wr, {
          class: "text-white text-base font-normal",
          text: a.currentBody,
          pause: a.pause,
          loading: h(r),
          onUpdateOverflow: u[0] || (u[0] = (f) => t("update-overflow", f)),
          onLoading: u[1] || (u[1] = (f) => r.value = f)
        }, {
          content: _(() => [
            h(i) ? (c(), C(g, {
              key: a.currentId,
              class: "whitespace-nowrap w-full block h-full",
              ref: "editor",
              editable: !1,
              content: a.currentBody,
              options: h(o),
              "onClick:openLink": l
            }, null, 8, ["content", "options"])) : A("", !0)
          ]),
          _: 1
        }, 8, ["text", "pause", "loading"]),
        h(s) ? (c(), C(Hr, {
          key: 0,
          id: a.currentLinkedContent.id,
          type: a.currentLinkedContent.type,
          lang: (d = a.currentLinkedContent) == null ? void 0 : d.lang,
          onGoToContent: u[2] || (u[2] = (f) => t("go-to-content", f)),
          class: "flex h-full content-center mr-4"
        }, null, 8, ["id", "type", "lang"])) : A("", !0)
      ]);
    };
  }
});
const CI = /* @__PURE__ */ x(bI, [["__scopeId", "data-v-8121315b"]]), wI = { class: "body-detailed h-24 flex flex-row gap-4 relative mt-2" }, DI = ["onClick"], zI = { class: "flex flex-col w-[80%] text-white text-base overflow-y-auto h-full gap-2" }, vI = /* @__PURE__ */ T({
  __name: "UrgentNotificationBodyDetailed",
  props: {
    notifications: {},
    currentNotificationIndex: {},
    currentBody: {},
    currentId: {},
    currentLinkedContent: {}
  },
  emits: ["change-index", "go-to-content"],
  setup(e, { emit: t }) {
    const n = e, o = Y({
      fontOptions: !0,
      extraFontOptions: !0,
      colorOptions: !0,
      structurationOptions: !0,
      extraStructurationOptions: !0,
      tableOptions: !0,
      richOptions: !0,
      tocClickOptions: !0,
      allowToc: !0
    }), i = Y(!0), r = Y(0), s = Y(null);
    _t(() => {
      at(() => {
        const f = document.getElementById("main");
        f == null || f.addEventListener("scroll", a);
      });
    });
    const l = ({ href: f }) => {
      window.open(f, "_blank");
    }, a = () => {
      var f;
      r.value = ((f = s.value) == null ? void 0 : f.scrollTop) || 0;
    }, u = () => {
      var f;
      (f = s.value) == null || f.scrollTo({ top: 0, behavior: "smooth" });
    }, g = () => {
      var f, I;
      (I = s.value) == null || I.scrollTo({ top: (f = s.value) == null ? void 0 : f.scrollHeight, behavior: "smooth" });
    }, d = k(() => {
      var Q, H;
      const f = (Q = s.value) == null ? void 0 : Q.clientHeight, I = (H = s.value) == null ? void 0 : H.scrollHeight;
      if (!f || !I)
        return { top: !1, bottom: !1 };
      const z = I > f, v = I - r.value - f === 0;
      return { top: z && r.value !== 0, bottom: z && !v };
    });
    return _e(
      () => n.currentBody,
      () => {
        i.value = !1, at(() => {
          i.value = !0;
        });
      }
    ), (f, I) => {
      const z = P, v = R("mayday-editor");
      return c(), p("div", wI, [
        m("div", {
          class: "flex flex-col w-[20%] gap-1 overflow-y-auto",
          ref_key: "titlesListRef",
          ref: s,
          id: "main"
        }, [
          h(d).top ? (c(), p("div", {
            key: 0,
            class: "absolute -top-4 w-[20%] text-center hover:cursor-pointer",
            onClick: u
          }, [
            M(z, {
              icon: ["fas", "chevron-up"],
              class: "text-white"
            })
          ])) : A("", !0),
          (c(!0), p(X, null, te(f.notifications, (Q, H) => (c(), p("div", {
            key: Q.id,
            class: D([
              "text-base p-1 rounded hover:cursor-pointer",
              f.currentNotificationIndex === H ? " text-red bg-white font-bold" : " text-white hover:bg-white/50"
            ]),
            onClick: (ee) => t("change-index", { idx: H })
          }, N(Q.metadata.label), 11, DI))), 128)),
          h(d).bottom ? (c(), p("div", {
            key: 1,
            class: "absolute -bottom-3 w-[20%] text-center hover:cursor-pointer",
            onClick: g
          }, [
            M(z, {
              icon: ["fas", "chevron-down"],
              class: "text-white"
            })
          ])) : A("", !0)
        ], 512),
        m("div", zI, [
          h(i) ? (c(), C(v, {
            key: f.currentId,
            class: "whitespace-nowrap w-full block p-0",
            ref: "editor",
            editable: !1,
            content: f.currentBody,
            options: h(o),
            "onClick:openLink": l
          }, null, 8, ["content", "options"])) : A("", !0),
          f.currentLinkedContent ? (c(), C(Hr, {
            key: 1,
            id: f.currentLinkedContent.id,
            type: f.currentLinkedContent.type,
            onGoToContent: I[0] || (I[0] = (Q) => t("go-to-content", Q))
          }, null, 8, ["id", "type"])) : A("", !0)
        ])
      ]);
    };
  }
});
const TI = /* @__PURE__ */ x(vI, [["__scopeId", "data-v-ce046f16"]]), kI = { class: "flex flex-row align-items-center justify-center" }, jI = {
  key: 1,
  class: "flex flex-row items-center justify-center gap-1 w-24"
}, SI = { class: "text-white text-base font-semibold tracking-tight" }, LI = /* @__PURE__ */ T({
  __name: "UrgentNotificationActions",
  props: {
    currentNotificationIndex: {},
    totalNotificationNumber: {},
    isOverflow: { type: Boolean },
    isDetailedView: { type: Boolean }
  },
  emits: ["open-detail", "pause", "change-index"],
  setup(e, { emit: t }) {
    const n = e, o = Y(!1), i = k(() => !n.isDetailedView && n.isOverflow), r = () => {
      o.value = !o.value, t("pause");
    };
    return (s, l) => {
      const a = P;
      return c(), p("div", kI, [
        h(i) ? (c(), p("button", {
          key: 0,
          class: D(["icon-wrapper rounded-full w-7 h-7 items-center justify-center p-2 inline-flex mr-3 transition-colors", h(o) ? "bg-white text-blue-5" : "bg-white/20 hover:bg-white/50 text-white"]),
          onClick: r
        }, [
          M(a, { icon: ["fal", "pause"] })
        ], 2)) : A("", !0),
        m("button", {
          class: D(["icon-wrapper rounded-full w-7 h-7 items-center justify-center p-2 inline-flex mr-3 transition-colors", s.isDetailedView ? "bg-white text-blue-5" : "bg-white/20 hover:bg-white/50 text-white"]),
          onClick: l[0] || (l[0] = (u) => t("open-detail"))
        }, [
          M(a, { icon: ["fal", "eye"] })
        ], 2),
        s.totalNotificationNumber >= 2 ? (c(), p("div", jI, [
          m("button", {
            class: D(["icon-wrapper rounded-full w-7 h-7 items-center justify-center p-2 inline-flex font-bold", s.currentNotificationIndex === 0 ? "text-white/30" : "text-white"]),
            onClick: l[1] || (l[1] = (u) => t("change-index", { idx: s.currentNotificationIndex - 1 }))
          }, [
            M(a, { icon: ["fas", "chevron-left"] })
          ], 2),
          m("div", SI, N(`${s.currentNotificationIndex + 1}/${s.totalNotificationNumber}`), 1),
          m("button", {
            class: D([
              "icon-wrapper rounded-full w-7 h-7 items-center justify-center p-2 inline-flex",
              s.currentNotificationIndex + 1 === s.totalNotificationNumber ? "text-white/30" : "hover:cursor-pointer text-white"
            ]),
            onClick: l[2] || (l[2] = (u) => t("change-index", { idx: s.currentNotificationIndex + 1 }))
          }, [
            M(a, { icon: ["fas", "chevron-right"] })
          ], 2)
        ])) : A("", !0)
      ]);
    };
  }
}), EI = {
  key: 0,
  class: "urgent-banner bg-red py-2.5 px-3 gap-2 flex flex-col"
}, OI = { class: "w-full h-6 flex flex-row justify-between" }, xI = { class: "flex flex-row gap-4" }, _I = /* @__PURE__ */ T({
  __name: "WebUrgentNotification",
  emits: ["go-to-content"],
  setup(e, { emit: t }) {
    Us((j) => ({
      "7148cbc7": h(d)
    }));
    const n = ve(), { urgentNotifications: o, isDetailedView: i } = De(n), { getUrgentNotifications: r, mutateIsDetailedView: s } = n, l = Y(0), a = Y(!1), u = Y(!1);
    _t(async () => {
      await r();
    });
    const g = k(() => {
      var j;
      return (j = o == null ? void 0 : o.value[l.value]) == null ? void 0 : j.metadata.label;
    }), d = k(() => i.value ? "160px" : "65px"), f = k(() => i.value ? TI : CI), I = k(() => {
      var j;
      return (j = o == null ? void 0 : o.value[l.value]) == null ? void 0 : j.metadata.body;
    }), z = k(() => {
      var j;
      return (j = o == null ? void 0 : o.value[l.value]) == null ? void 0 : j.id;
    }), v = k(() => {
      const j = o == null ? void 0 : o.value[l.value];
      return j != null && j.metadata.entityId && (j != null && j.metadata.entityType) ? {
        id: j.metadata.entityId,
        type: j.metadata.entityType,
        lang: j.metadata.lang
      } : null;
    }), Q = ({ idx: j }) => {
      j < 0 || j > o.value.length - 1 || (l.value = j);
    }, H = ({ isScrolling: j }) => {
      u.value = j;
    }, ee = (j) => {
      t("go-to-content", j);
    };
    return (j, G) => h(o).length ? (c(), p("div", EI, [
      m("header", OI, [
        m("div", xI, [
          M(MI, {
            "number-of-notifications": h(o).length,
            title: h(g)
          }, null, 8, ["number-of-notifications", "title"])
        ]),
        M(LI, {
          "current-notification-index": h(l),
          "total-notification-number": h(o).length,
          "is-overflow": h(u),
          "is-detailed-view": h(i),
          onOpenDetail: h(s),
          onChangeIndex: Q,
          onPause: G[0] || (G[0] = (V) => a.value = !h(a))
        }, null, 8, ["current-notification-index", "total-notification-number", "is-overflow", "is-detailed-view", "onOpenDetail"])
      ]),
      (c(), C(xt(h(f)), {
        class: D({ "ml-10": !h(i) }),
        notifications: h(o),
        "current-notification-index": h(l),
        pause: h(a),
        "current-body": h(I),
        "current-id": h(z),
        "current-linked-content": h(v),
        onChangeIndex: Q,
        onUpdateOverflow: H,
        onGoToContent: ee
      }, null, 40, ["class", "notifications", "current-notification-index", "pause", "current-body", "current-id", "current-linked-content"]))
    ])) : A("", !0);
  }
});
const UI = /* @__PURE__ */ x(_I, [["__scopeId", "data-v-5bc0b388"]]), FI = {
  async install(e, t = {}) {
    const n = ze.NOTIFICATIONS;
    if (t.pinia === void 0) {
      console.error(`[${n}] 🍍 pinia store instance not provided`);
      return;
    }
    if (t.notificationClient === void 0 || t.adminClient === void 0 || t.knowledgeClient === void 0) {
      console.error(`[${n}] 🛰 axios instance not provided`);
      return;
    }
    t.i18n === void 0 && console.error(`[${n}] 🇫🇷 i18n instance not provided`);
    const { pinia: o, notificationClient: i, adminClient: r, knowledgeClient: s } = t;
    o.use(({ store: l }) => {
      if (l.$id === n)
        if (l.$notificationsService = Rr(
          i,
          r,
          s
        ), t.appFunctions !== void 0) {
          const { logs: a } = t.appFunctions;
          l.$logs = a || (() => {
            console.error(`[${n}] 🛠 log function not provided`);
          });
        } else
          console.error(`[${n}] 🛠 app functions not provided`);
    }), o.use(Sf()), Object.keys(et).forEach((l) => {
      var a;
      (a = t.i18n) == null || a.global.mergeLocaleMessage(l, et[l]);
    }), e.component("notifications-list-view", L2), e.component("notifications-menu-view", W2), e.component("urgent-notifications-view", mI), e.component("urgent-notification", UI);
  }
}, iN = {
  plugin: FI,
  useStore: ve,
  attachService: Rr
};
class $I {
  constructor(t, n) {
    xe(this, "knowledgeClient");
    xe(this, "brainClient");
    this.knowledgeClient = t, this.brainClient = n;
  }
  async search(t) {
    const n = await this.knowledgeClient.post("search", t);
    return n.data || n;
  }
  async suggestions(t) {
    const n = await this.knowledgeClient.post(
      "suggestions",
      t
    );
    return n.data || n;
  }
  async getContentParameterLabels() {
    const t = await this.knowledgeClient.get("labels");
    return Ne(t).labels;
  }
  async searchFromHighlight(t, n, o = "fr") {
    return await this.brainClient.post(
      "highlight",
      {
        queryText: t,
        preferredLanguage: o
      },
      {
        headers: {
          "x-correlation-id": n
        }
      }
    );
  }
}
const Jr = (e, t) => new $I(e, t), RI = T({
  name: "SearchTags",
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    popoverOpened: !1
  }),
  methods: {
    handleRemove(e) {
      this.$emit(
        "remove-tag",
        this.tags.filter((t) => t.id !== e)
      );
    }
  },
  emits: ["remove-tag"]
}), VI = { class: "flex items-center -space-x-2 mr-1.5 relative" }, BI = ["onClick"], YI = {
  key: 0,
  class: "w-5 h-5 flex justify-center items-center"
}, QI = {
  key: 1,
  class: "w-5 h-5 rounded-full bg-white flex items-center justify-center"
}, PI = ["src"], GI = { class: "max-w-0 group-hover:max-w-[160px] transition-all flex items-center h-5" }, ZI = { class: "text-2xs" }, WI = {
  key: 1,
  class: "absolute bg-gray-1 rounded-lg shadow flex items-center flex-wrap p-3 gap-2 z-20 top-10 min-w-60 w-full"
}, HI = ["onClick"], JI = {
  key: 0,
  class: "w-5 h-5 flex justify-center items-center"
}, KI = {
  key: 1,
  class: "w-5 h-5 rounded-full bg-white flex items-center justify-center"
}, qI = ["src"], XI = { class: "flex items-center h-5" }, eM = { class: "whitespace-nowrap" };
function tM(e, t, n, o, i, r) {
  const s = P, l = Le;
  return c(), p("div", VI, [
    (c(!0), p(X, null, te(e.tags.slice(0, 2), (a) => (c(), p("div", {
      key: a.id,
      class: "flex items-center bg-white flex-none rounded-md text-2xs group transition-all hover:z-10 cursor-pointer pr-0 hover:pr-1",
      onClick: be((u) => e.handleRemove(a.id), ["stop"]),
      style: Ce(`color: ${a.color}; border: 1px solid ${a.color}`)
    }, [
      a.icon ? (c(), p("div", YI, [
        M(s, {
          icon: ["fas", a.icon]
        }, null, 8, ["icon"])
      ])) : a.iconUrl ? (c(), p("div", QI, [
        m("img", {
          src: a.iconUrl,
          class: "h-3"
        }, null, 8, PI)
      ])) : A("", !0),
      m("div", GI, [
        M(l, {
          text: a.trad ? e.$t(a.label) : a.label
        }, null, 8, ["text"])
      ])
    ], 12, BI))), 128)),
    e.tags.length > 2 ? (c(), p("div", {
      key: 0,
      class: "flex justify-center items-center text-white h-6 w-6 flex-none rounded-md text-2xs bg-gray-6 cursor-pointer",
      onClick: t[0] || (t[0] = (a) => e.popoverOpened = !e.popoverOpened)
    }, [
      m("span", ZI, "+" + N(e.tags.length - 2), 1)
    ])) : A("", !0),
    e.popoverOpened ? (c(), p("div", WI, [
      (c(!0), p(X, null, te(e.tags, (a) => (c(), p("div", {
        key: a.id,
        class: "flex items-center bg-white flex-none rounded-md text-2xs group transition-all cursor-pointer pr-1",
        onClick: (u) => e.handleRemove(a.id),
        style: Ce(`color: ${a.color}; border: 1px solid ${a.color}`)
      }, [
        a.icon ? (c(), p("div", JI, [
          M(s, {
            icon: ["fas", a.icon]
          }, null, 8, ["icon"])
        ])) : a.iconUrl ? (c(), p("div", KI, [
          m("img", {
            src: a.iconUrl,
            class: "h-3"
          }, null, 8, qI)
        ])) : A("", !0),
        m("div", XI, [
          m("span", eM, N(a.trad ? e.$t(a.label) : a.label), 1)
        ])
      ], 12, HI))), 128))
    ])) : A("", !0)
  ]);
}
const nM = /* @__PURE__ */ x(RI, [["render", tM]]), oM = ["innerHTML"], iM = ["innerHTML"], sM = /* @__PURE__ */ T({
  __name: "SearchAutocomplete",
  props: {
    autocomplete: {},
    value: {},
    selectedTagsSize: {},
    searchType: {}
  },
  setup(e) {
    const t = e, n = k(() => !t.autocomplete || !t.autocomplete.remaining ? "" : t.autocomplete.remaining.replace(/ /g, "&nbsp;")), o = k(() => t.value ? t.value.replace(/ /g, "&nbsp;") : ""), i = k(() => t.searchType === "quick" ? "!leading-[40px]" : t.searchType === "agent" ? "!leading-[20px]" : t.searchType === "home" ? "!leading-[44px]" : "");
    return (r, s) => (c(), p("div", {
      class: D(["border-none text-gray-4 absolute flex items-center overflow-hidden truncate pointer-events-none left-0 top-0 tracking-normal text-base", [h(i)]])
    }, [
      m("div", {
        class: "invisible flex items-center max-h-full whitespace-nowrap",
        innerHTML: h(jn)(h(o))
      }, null, 8, oM),
      m("div", {
        class: "h-full flex items-center",
        innerHTML: h(jn)(h(n))
      }, null, 8, iM)
    ], 2));
  }
}), rM = T({
  name: "SearchInput",
  components: { SearchTags: nM, SearchAutocomplete: sM },
  inheritAttrs: !1,
  props: {
    value: String,
    placeholder: {
      type: String,
      default: "super-search.placeholder"
    },
    searchType: {
      type: String,
      required: !0
    },
    selectedTags: {
      type: Array,
      default: () => []
    },
    autocomplete: {
      type: Object,
      default: void 0
    }
  },
  emits: ["input", "key-down", "remove-tag"],
  computed: {
    wrapperClass() {
      return this.searchType === "home" ? "border-2 border-primary alt:border-gray-9 rounded-xl h-11 px-3.5" : this.searchType === "agent" ? "rounded-xl h-11 px-3.5" : this.searchType === "quick" ? "h-full" : "";
    },
    inputClass() {
      return this.searchType === "home" ? "!leading-[44px] placeholder:text-gray-5" : this.searchType === "agent" ? "!leading-[20px] items-center md:placeholder:text-primary-contrast" : this.searchType === "quick" ? "!leading-[40px] placeholder:text-gray-5" : "";
    }
  },
  data() {
    return {
      focused: !1,
      localValue: this.value
    };
  },
  methods: {
    updateValue(e) {
      const t = e.target.value;
      this.$emit("input", t);
    },
    blurInput() {
      this.focused = !1, this.$nextTick(() => {
        const e = this.$refs.input;
        e && e.blur();
      });
    },
    focusInput() {
      this.focused = !0, this.$nextTick(() => {
        const e = this.$refs.input;
        e && e.focus();
      });
    }
  },
  watch: {
    value(e) {
      this.localValue = e;
    }
  }
}), aM = { class: "relative flex-1 p-0 bg-transparent overflow-hidden" }, lM = ["placeholder"];
function cM(e, t, n, o, i, r) {
  const s = P, l = R("SearchTags"), a = R("SearchAutocomplete");
  return c(), p("div", {
    class: D(["flex items-center transition-colors", [
      e.wrapperClass,
      e.searchType === "agent" ? {
        "bg-white text-gray-9 border-2 md:border border-primary md:border-transparent alt:md:border-gray-3 alt:border-gray-9": e.focused,
        "bg-white text-gray-9 md:bg-primary-contrast/10 md:text-primary-contrast border-2 md:border border-primary md:border-transparent alt:md:border-transparent alt:border-gray-9 ": !e.focused
      } : "bg-white text-gray-9"
    ]])
  }, [
    e.searchType !== "quick" ? (c(), C(s, {
      key: 0,
      icon: ["fas", "search"],
      class: "h-4 w-4 mr-1.5 text-base leading-none"
    })) : A("", !0),
    e.selectedTags.length ? (c(), C(l, {
      key: 1,
      tags: e.selectedTags,
      onRemoveTag: t[0] || (t[0] = (u) => e.$emit("remove-tag", u))
    }, null, 8, ["tags"])) : A("", !0),
    m("div", aM, [
      Ze(m("input", Tt({
        ref: "input",
        type: "text",
        class: ["flex w-full text-base p-0 outline-none border-none overflow-hidden tracking-normal bg-transparent", [e.inputClass]],
        "onUpdate:modelValue": t[1] || (t[1] = (u) => e.localValue = u),
        placeholder: e.focused ? "" : e.$t(e.placeholder)
      }, e.$attrs, {
        spellcheck: "false",
        size: "1",
        onKeydown: t[2] || (t[2] = (u) => e.$emit("key-down", u)),
        onInput: t[3] || (t[3] = (...u) => e.updateValue && e.updateValue(...u)),
        onFocus: t[4] || (t[4] = (...u) => e.focusInput && e.focusInput(...u))
      }), null, 16, lM), [
        [yi, e.localValue]
      ]),
      e.autocomplete && e.autocomplete.remaining ? (c(), C(a, {
        key: 0,
        autocomplete: e.autocomplete,
        value: e.localValue || "",
        "selected-tags-size": e.selectedTags.length,
        "search-type": e.searchType
      }, null, 8, ["autocomplete", "value", "selected-tags-size", "search-type"])) : A("", !0)
    ]),
    Te(e.$slots, "default")
  ], 2);
}
const uM = /* @__PURE__ */ x(rM, [["render", cM]]), Kr = ["zendesk", "intercom", "frontapp", "app.crisp", "mail.google", "getmayday"], dM = (e) => {
  const t = fi({
    corrections: void 0,
    autocomplete: void 0,
    filter: void 0
  }), n = (s) => {
    t.corrections = s.corrections, t.autocomplete = s.autocomplete, t.filter = s.filter;
  }, o = k(() => !t.corrections || !t.corrections.text || !e.value ? { highlighted: "", text: "" } : t.corrections), i = k(() => {
    if (!t.filter || !t.filter.text || !t.filter.type || !e.value)
      return;
    const { type: s, value: l } = t.filter;
    return Ru({ type: s, value: l });
  }), r = k(() => {
    if (!(!t.autocomplete || !t.autocomplete.label || !t.autocomplete.remaining || !e.value || e.value === t.autocomplete.label))
      return t.autocomplete;
  });
  return {
    suggest: t,
    searchCorrection: o,
    searchFilterSuggestion: i,
    searchAutocompleteContent: r,
    updateSuggest: n
  };
}, gM = { key: 0 }, pM = {
  key: 0,
  class: "!mt-2 flex justify-center"
}, mM = {
  key: 1,
  class: "min-h-[180px] flex justify-center items-center"
}, hM = {
  key: 0,
  class: "p-2 space-y-1 w-full"
}, fM = {
  key: 1,
  class: "text-base font-bold flex justify-center items-center flex-col gap-4 p-4 text-center w-full h-full"
}, yM = /* @__PURE__ */ m("img", {
  alt: "empty search results",
  src: Gr
}, null, -1), IM = { class: "text-gray-8" }, qr = /* @__PURE__ */ T({
  __name: "SearchResults",
  props: {
    results: {},
    hovered: {},
    hasMore: { type: Boolean },
    loading: { type: Boolean },
    searchInProgress: { type: Boolean },
    labelSearchedIds: {},
    overviewId: {},
    config: {},
    itemIsFavorite: { type: Function },
    searchLanguage: {},
    list: { type: Boolean }
  },
  emits: ["toggle-favorite", "copy-link", "open-in-web", "hover", "go-to-document", "reset", "display-more", "overview", "handle-select"],
  setup(e, { emit: t }) {
    const n = e, o = kt(), i = k(() => n.results.length || n.searchInProgress), r = k(() => ({
      copy: !0,
      open: n.config.hostApp === "chrome-extension",
      overview: n.config.hostApp === "agent-client"
    })), { isGridSearch: s } = De(o);
    return (l, a) => {
      const u = Un, g = P, d = ye, f = cn;
      return h(i) ? (c(), p("div", gM, [
        n.results.length ? (c(), p("div", {
          key: 0,
          class: D(["p-2", [h(s) && !l.list ? "grid gap-4 lg:grid-cols-2" : "space-y-2"]])
        }, [
          (c(!0), p(X, null, te(n.results, (I, z) => (c(), C(u, {
            id: `search-${I.id}`,
            key: I.id,
            hovered: z === l.hovered,
            item: I,
            labelSearchedIds: l.labelSearchedIds,
            "is-favorite": l.itemIsFavorite(I.id, l.searchLanguage),
            "full-title-preference": l.config.displayFullTitle,
            options: h(r),
            "is-overview": l.overviewId === I.id,
            link: l.config.hostApp === "agent-client",
            source: "search",
            onMouseenter: (v) => t("hover", z),
            onMouseleave: a[0] || (a[0] = (v) => t("hover", -1)),
            onGoToDocument: (v) => t("go-to-document", I, z + 1),
            onToggleFavorite: a[1] || (a[1] = (v) => t("toggle-favorite", v)),
            onCopyLink: a[2] || (a[2] = (v) => t("copy-link", v)),
            onOpenInWeb: a[3] || (a[3] = (v) => t("open-in-web", v)),
            onOverview: a[4] || (a[4] = (v) => t("overview", v)),
            onHandleClick: (v) => t("go-to-document", I, z + 1)
          }, null, 8, ["id", "hovered", "item", "labelSearchedIds", "is-favorite", "full-title-preference", "options", "is-overview", "link", "onMouseenter", "onGoToDocument", "onHandleClick"]))), 128)),
          l.hasMore && n.results.length ? (c(), p("div", pM, [
            M(d, {
              onClick: a[5] || (a[5] = (I) => t("display-more")),
              type: "custom-secondary"
            }, {
              default: _(() => [
                l.loading ? (c(), C(g, {
                  key: 0,
                  icon: ["fas", "spinner-third"],
                  spin: ""
                })) : A("", !0),
                ne(" " + N(l.$t("notifications.get-more")), 1)
              ]),
              _: 1
            })
          ])) : A("", !0)
        ], 2)) : (c(), p("div", mM, [
          l.loading ? (c(), p("div", hM, [
            (c(), p(X, null, te(7, (I) => M(f, {
              key: I,
              index: I
            }, null, 8, ["index"])), 64))
          ])) : (c(), p("div", fM, [
            yM,
            m("span", IM, N(l.$t("super-search.empty-state")), 1),
            M(d, {
              onClick: a[6] || (a[6] = be((I) => t("reset"), ["stop"])),
              type: "custom-secondary"
            }, {
              default: _(() => [
                ne(N(l.$t("super-search.reset")), 1)
              ]),
              _: 1
            })
          ]))
        ]))
      ])) : A("", !0);
    };
  }
}), Ss = ["Case", "Article", "Diagnostic", "keyStep"], MM = 144, AM = T({
  name: "SuperSearch",
  components: {
    SearchInput: uM,
    SearchFilters: xi,
    TagFilter: kr,
    SearchResults: qr
  },
  setup(e) {
    const t = Y(""), {
      suggest: n,
      searchCorrection: o,
      searchFilterSuggestion: i,
      searchAutocompleteContent: r,
      updateSuggest: s
    } = dM(t), l = ji(e.config.hostApp);
    return {
      searchInputFilter: t,
      suggest: n,
      searchCorrection: o,
      searchFilterSuggestion: i,
      searchAutocompleteContent: r,
      updateSuggest: s,
      scriptSanitizer: jn,
      domRoot: l
    };
  },
  props: {
    placeholder: {
      type: String,
      default: "super-search.placeholder"
    },
    focusKnowledge: {
      type: Object,
      default: () => ({ id: "", value: "" })
    },
    isSearchNoSteps: {
      type: Boolean,
      default: !0
    },
    focusEntity: {
      type: Object,
      default: null
    },
    itemIsFavorite: {
      type: Function,
      default: () => !1
    },
    modalEntity: {
      type: Object,
      default: null
    },
    display: {
      type: Boolean,
      default: !1
    },
    searchType: {
      type: String,
      default: "home"
    },
    config: {
      type: Object,
      default: () => ({})
    },
    isTop: {
      type: Boolean,
      default: !0
    },
    overviewId: {
      type: String,
      default: ""
    },
    searchLanguage: {
      type: String,
      required: !0
    }
  },
  emits: [
    "select-result",
    "cancel",
    "copy-link",
    "open-in-web",
    "toggle-favorite",
    "go-to-search",
    "overview"
  ],
  data() {
    return {
      searchFocused: !1,
      showFilters: !1,
      selectedTags: [],
      loading: !1,
      results: [],
      totalHits: 0,
      correlationId: "",
      debounceSearchFilters: Li(() => {
        this.superSearch();
      }, 200),
      hovered: -1,
      sizeCursor: 7,
      maxHeight: 500,
      // arbitrary value
      maxSize: 100
    };
  },
  created() {
    this.generateCorrelationId();
  },
  mounted() {
    this.config.hostApp !== "agent-client" && setTimeout(() => {
      this.searchFocused = !0, this.focusInput();
    }, 750);
  },
  computed: {
    avoidBackroundToBeClickable() {
      return this.searchFocused && this.config.hostApp === "chrome-extension";
    },
    dropdownClass() {
      const e = this.searchType === "home", n = this.searchType === "quick" ? "w-80 -left-[42px]" : "w-full", o = this.isTop || e ? "top-[52px]" : "bottom-[66px]";
      return [n, o].join(" ");
    },
    displayDropdown() {
      return this.searchInProgress || this.showFilters;
    },
    filtersAndResultsDisplayed() {
      return this.showFilters && (!!this.results.length || this.searchInProgress);
    },
    preFilters() {
      return this.selectedTags.reduce((e, t) => (t.key !== "entity" && (e[t.key] ? e[t.key].push(t.value) : e[t.key] = [t.value]), e), {});
    },
    entityType() {
      return this.preFilters.type || null;
    },
    labels() {
      return this.preFilters.categories || [];
    },
    searchInProgress() {
      return this.selectedTags.length > 0 || this.searchInputFilter !== "";
    },
    searchFilters() {
      return {
        knowledgeId: this.focusKnowledge.value,
        entitiesType: this.entityType || [
          ...Ss,
          ...this.isSearchNoSteps ? [] : ["Step"]
        ]
      };
    },
    hasMore() {
      return this.results.length < this.totalHits;
    },
    maxTotalHits() {
      return this.totalHits > this.maxSize ? `+${this.maxSize}` : String(this.totalHits);
    },
    labelSearchedIds() {
      return this.selectedTags.reduce((e, t) => (t.key === "categories" && e.push(t.id), e), []);
    },
    heightStyle() {
      return `max-height: ${this.maxHeight}px`;
    },
    hasShadowRoot() {
      return this.config.hostApp === "chrome-extension";
    },
    query() {
      return {
        ...this.searchInputFilter ? { query: this.searchInputFilter } : {},
        ...this.entityType ? { types: this.entityType } : {},
        ...this.labels.length > 0 ? { labels: this.labels } : {},
        size: this.totalHits > this.maxSize ? this.maxSize : this.totalHits
      };
    },
    focusCaseId() {
      const e = this.selectedTags.findIndex((t) => t.id === "focusCase");
      return e === -1 ? null : this.selectedTags[e].value;
    }
  },
  methods: {
    handleInput(e) {
      this.searchInputFilter = e, this.searchFocused = !0;
    },
    focusInput() {
      const e = this.$refs.searchInput;
      e && e.focusInput();
    },
    blurInput() {
      const e = this.$refs.searchInput;
      e && e.blurInput();
    },
    handleMore() {
      if (this.totalHits < this.sizeCursor + 10) {
        this.sizeCursor = this.totalHits;
        return;
      }
      this.sizeCursor += 10;
    },
    updateTags(e) {
      this.selectedTags = e, this.focusInput();
    },
    toggleFilters() {
      this.showFilters = !this.showFilters, this.searchFocused = !0, this.focusInput();
    },
    handleKeydown(e) {
      var t;
      if (e.key === "Enter" && this.hovered >= 0 && this.hovered <= this.results.length) {
        e.preventDefault();
        const n = this.results[this.hovered];
        this.selectResult(n, this.hovered + 1);
      } else
        e.key === "ArrowUp" ? (this.hovered = this.hovered > 0 ? this.hovered - 1 : this.results.length - 1, this.results[this.hovered] && this.scrollToSelectedItem("start", this.results[this.hovered].id), e.stopPropagation()) : e.key === "ArrowDown" ? (this.hovered = this.hovered < this.results.length - 1 ? this.hovered + 1 : 0, this.results[this.hovered] && this.scrollToSelectedItem("end", this.results[this.hovered].id), e.stopPropagation()) : e.key === "Escape" ? (this.onClickOutside(), this.$emit("cancel")) : (e.key === "ArrowRight" || e.key === "Tab") && ((t = this.searchAutocompleteContent) != null && t.label) ? (e.preventDefault(), this.searchInputFilter = this.searchAutocompleteContent.label, this.focusInput()) : e.key === "Tab" && this.searchFilterSuggestion ? (e.preventDefault(), this.focusInput(), this.useSuggestFilter(this.searchFilterSuggestion)) : e.key === "Backspace" && !this.searchInputFilter ? (e.preventDefault(), this.focusInput(), this.removeFilter()) : e.stopPropagation();
    },
    scrollToSelectedItem(e, t) {
      this.$nextTick(() => {
        var o;
        const n = (o = this.domRoot) == null ? void 0 : o.getElementById(`search-${t}`);
        n && n.scrollIntoView({ block: e, inline: "nearest" });
      });
    },
    handleHover(e) {
      this.hovered = e;
    },
    async superSearch() {
      try {
        this.handleSearchSuggestions();
        const e = await this.knowledgeSearchAction({
          queryText: this.searchInputFilter,
          correlationId: this.correlationId,
          searchFilters: this.searchFilters,
          categories: this.labels,
          size: this.sizeCursor,
          lang: this.searchLanguage,
          ...this.focusCaseId ? { caseId: this.focusCaseId } : {}
        });
        if (!e)
          return;
        this.results = e.documents, this.totalHits = e.counts.totalCount, this.recordSearchInput(), this.loading = !1;
      } catch {
        this.loading = !1;
      }
    },
    handleSearch() {
      this.searchInProgress ? (this.loading = !0, this.updateSuggest({ autocomplete: void 0, filter: void 0, corrections: void 0 }), this.debounceSearchFilters()) : (this.results = [], this.totalHits = 0, this.sizeCursor = 7);
    },
    getSearchEvent() {
      const e = window.location.href, n = Kr.filter((o) => e.includes(o)).length ? e : "";
      return {
        lang: this.searchLanguage,
        filterType: ["attached-contents", "cases"],
        entityType: this.entityType,
        search: this.searchInputFilter,
        query: this.searchInputFilter,
        knowledge: this.focusKnowledge.value,
        knowledgeId: this.focusKnowledge.id,
        correlationId: this.correlationId,
        product: null,
        cases: null,
        status: [{ key: "published", value: !0 }],
        accessRestrictions: null,
        labels: this.labels,
        isContribution: null,
        searchFrom: 0,
        size: 10,
        focusEntity: this.focusEntity,
        modalEntity: this.modalEntity,
        source: n
      };
    },
    formatEvent(e) {
      return {
        search: e,
        displayedHits: this.results.length,
        totalHits: this.totalHits
      };
    },
    recordSearchInput() {
      this.logs({
        topic: "CONTENT_SEARCH",
        url: window.location.href,
        event: this.formatEvent(this.getSearchEvent())
      });
    },
    onDelete() {
      this.triggerAbortSearch(), this.showFilters = !1, this.resetSearch(), this.focusInput();
    },
    onClickOutside() {
      this.searchInProgress && this.searchFocused && this.triggerAbortSearch(), this.blurInput(), this.searchFocused = !1;
    },
    resetSearch() {
      this.searchInputFilter = "", this.selectedTags = [], this.results = [], this.hovered = -1, this.sizeCursor = 7, this.totalHits = 0;
    },
    triggerAbortSearch() {
      this.logs({
        topic: "CONTENT_SEARCH_ABORT",
        event: this.formatEvent(this.getSearchEvent()),
        url: window.location.href
      }), this.generateCorrelationId();
    },
    generateCorrelationId() {
      this.correlationId = `${this.config.hostApp}-${Math.random().toString(36).slice(2)}`;
    },
    selectResult(e, t) {
      this.config.hostApp !== "agent-client" && this.$emit("select-result", {
        ...e,
        source: "search"
      }), this.logs({
        topic: "CONTENT_SEARCH_SUCCESS",
        event: {
          ...this.formatEvent(this.getSearchEvent()),
          itemIndex: t,
          content: e
        },
        url: window.location.href
      }), this.searchFocused = !1, this.showFilters = !1, this.blurInput(), this.resetSearch(), this.generateCorrelationId();
    },
    calcMaxHeight() {
      if (this.searchType === "quick") {
        this.maxHeight = window.innerHeight - MM;
        return;
      }
      if (this.hasShadowRoot && this.domRoot) {
        const e = this.domRoot.getElementById("mount-point"), t = e == null ? void 0 : e.getElementsByTagName("main");
        if (!t)
          return;
        this.maxHeight = t[0].getBoundingClientRect().height - 34;
      } else
        this.maxHeight = window.innerHeight / 2;
    },
    async handleSearchSuggestions() {
      const e = await this.searchSuggestions({
        queryText: this.searchInputFilter,
        pre: {
          knowledge: [this.focusKnowledge.value],
          ...this.preFilters,
          ...this.entityType ? {} : {
            type: [...Ss, ...this.isSearchNoSteps ? [] : ["Step"]]
          }
        },
        lang: this.searchLanguage
      });
      e && this.updateSuggest(e);
    },
    useSuggestFilter(e) {
      this.selectedTags.push(e), this.searchInputFilter = "";
    },
    removeFilter() {
      this.selectedTags = this.selectedTags.slice(0, -1);
    },
    goToSearch() {
      this.searchFocused = !1, this.blurInput(), this.$emit("go-to-search", this.query);
    },
    ...fe(kt, [
      "knowledgeSearchAction",
      "logs",
      "searchSuggestions",
      "mutateSearchResults"
    ])
  },
  watch: {
    searchInputFilter() {
      this.handleSearch();
    },
    selectedTags() {
      this.handleSearch();
    },
    sizeCursor() {
      this.handleSearch();
    },
    displayDropdown(e) {
      e && this.calcMaxHeight();
    },
    searchLanguage() {
      this.handleSearch();
    }
  }
}), NM = {
  key: 0,
  class: "w-full h-4"
}, bM = { class: "flex flex-col cursor-auto overflow-y-auto" }, CM = {
  key: 0,
  class: "flex p-2 gap-2"
}, wM = { class: "text-sm" }, DM = ["innerHTML"], zM = {
  key: 1,
  class: "flex p-2 gap-2"
}, vM = { class: "text-sm" }, TM = {
  key: 0,
  class: "flex justify-end px-4 py-2.5"
};
function kM(e, t, n, o, i, r) {
  const s = P, l = R("SearchInput"), a = R("TagFilter"), u = R("SearchFilters"), g = R("SearchResults"), d = ye, f = It("click-outside");
  return Ze((c(), p("div", {
    class: "relative w-full",
    onClick: t[7] || (t[7] = (I) => e.searchFocused = !0)
  }, [
    M(l, {
      ref: "searchInput",
      value: e.searchInputFilter,
      "search-type": e.searchType,
      placeholder: e.placeholder,
      "selected-tags": e.selectedTags,
      autocomplete: e.searchAutocompleteContent,
      onKeyDown: e.handleKeydown,
      onInput: e.handleInput,
      onRemoveTag: e.updateTags
    }, {
      default: _(() => [
        e.searchInProgress ? (c(), p("button", {
          key: 0,
          class: "h-4 w-4 flex justify-center items-center mx-1.5 hover:opacity-80",
          onClick: t[0] || (t[0] = be((...I) => e.onDelete && e.onDelete(...I), ["stop"]))
        }, [
          M(s, {
            icon: ["fas", "xmark"],
            class: "text-sm"
          })
        ])) : A("", !0),
        m("button", {
          class: D(["h-6 w-6 rounded flex justify-center items-center hover:opacity-80 text-base", { "bg-primary/50 alt:bg-primary-contrast/10": e.showFilters }]),
          onClick: t[1] || (t[1] = be((...I) => e.toggleFilters && e.toggleFilters(...I), ["stop"]))
        }, [
          M(s, {
            icon: ["fal", "sliders-v"],
            class: "text-base leading-none"
          })
        ], 2)
      ]),
      _: 1
    }, 8, ["value", "search-type", "placeholder", "selected-tags", "autocomplete", "onKeyDown", "onInput", "onRemoveTag"]),
    e.avoidBackroundToBeClickable ? (c(), p("div", NM)) : A("", !0),
    M(Xe, { name: "fade" }, {
      default: _(() => [
        Ze(m("div", {
          ref: "searchDropdown",
          class: D(["bg-gray-1 rounded-xl absolute z-10 shadow flex flex-col cursor-auto text-gray-9", [e.dropdownClass]]),
          style: Ce(e.heightStyle)
        }, [
          m("div", bM, [
            e.searchCorrection.text ? (c(), p("div", CM, [
              m("div", wM, N(e.$t("super-search.correction")), 1),
              m("button", {
                class: "hover:underline",
                onClick: t[2] || (t[2] = be((I) => e.searchInputFilter = e.searchCorrection.text, ["stop"])),
                innerHTML: e.scriptSanitizer(e.searchCorrection.highlighted)
              }, null, 8, DM)
            ])) : A("", !0),
            e.searchFilterSuggestion && !e.selectedTags.find((I) => {
              var z;
              return I.id === ((z = e.searchFilterSuggestion) == null ? void 0 : z.id);
            }) ? (c(), p("div", zM, [
              m("div", vM, N(e.$t("super-search.suggestion-filter")), 1),
              M(a, {
                tag: e.searchFilterSuggestion,
                selectedTags: e.selectedTags,
                onSelectTag: e.useSuggestFilter
              }, null, 8, ["tag", "selectedTags", "onSelectTag"])
            ])) : A("", !0),
            e.showFilters ? (c(), C(u, {
              key: 2,
              "selected-tags": e.selectedTags,
              onUpdateSelectedTags: e.updateTags
            }, null, 8, ["selected-tags", "onUpdateSelectedTags"])) : A("", !0),
            M(g, {
              list: "",
              results: e.results,
              "has-more": e.hasMore,
              loading: e.loading,
              hovered: e.hovered,
              "label-searched-ids": e.labelSearchedIds,
              "search-in-progress": e.searchInProgress,
              config: e.config,
              "overview-id": e.overviewId,
              "item-is-favorite": e.itemIsFavorite,
              "search-language": e.searchLanguage,
              onHover: e.handleHover,
              onGoToDocument: e.selectResult,
              onDisplayMore: e.handleMore,
              onReset: e.onDelete,
              onCopyLink: t[3] || (t[3] = (I) => e.$emit("copy-link", I)),
              onOpenInWeb: t[4] || (t[4] = (I) => e.$emit("open-in-web", I)),
              onToggleFavorite: t[5] || (t[5] = (I) => e.$emit("toggle-favorite", I)),
              onOverview: t[6] || (t[6] = (I) => e.$emit("overview", I))
            }, null, 8, ["results", "has-more", "loading", "hovered", "label-searched-ids", "search-in-progress", "config", "overview-id", "item-is-favorite", "search-language", "onHover", "onGoToDocument", "onDisplayMore", "onReset"])
          ]),
          e.config.hostApp === "agent-client" && e.searchInProgress && e.results.length > 0 ? (c(), p("div", TM, [
            M(d, {
              onClick: be(e.goToSearch, ["stop"]),
              hyperlink: "",
              size: "mini",
              type: "secondary"
            }, {
              default: _(() => [
                ne(N(e.$t("super-search.show-all", { total: e.maxTotalHits })), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])) : A("", !0)
        ], 6), [
          [Ba, e.searchFocused]
        ])
      ]),
      _: 1
    })
  ])), [
    [f, e.onClickOutside]
  ]);
}
const jM = /* @__PURE__ */ x(AM, [["render", kM]]), SM = /* @__PURE__ */ T({
  __name: "SearchResultsWrapper",
  props: {
    config: {},
    overviewId: {},
    focusKnowledge: {},
    getSearchEvent: { type: Function },
    itemIsFavorite: { type: Function },
    searchLanguage: {}
  },
  emits: ["select-result", "copy-link", "open-in-web", "toggle-favorite", "display-more", "reset", "overview"],
  setup(e, { emit: t }) {
    const n = e, o = kt(), { results: i, total: r, hasMore: s, correlationId: l, filters: a, loading: u, sortedResults: g } = De(o), d = Y(-1), f = (j) => {
      if (j.key === "Enter" && d.value >= 0 && d.value <= i.value.length) {
        j.preventDefault();
        const G = i.value[d.value];
        v(G, d.value + 1);
      } else
        j.key === "ArrowUp" ? (d.value = d.value > 0 ? d.value - 1 : i.value.length - 1, i.value[d.value] && I("start", i.value[d.value].id), j.stopPropagation()) : (j.key === "ArrowDown" && (d.value = d.value < i.value.length - 1 ? d.value + 1 : 0, i.value[d.value] && I("end", i.value[d.value].id)), j.stopPropagation());
    }, I = (j, G) => {
      at(() => {
        const V = document == null ? void 0 : document.getElementById(`search-${G}`);
        V && V.scrollIntoView({ block: j, inline: "nearest" });
      });
    }, z = (j) => {
      d.value = j;
    }, v = (j, G) => {
      t("select-result", {
        ...j,
        source: "search"
      }), o.logs({
        topic: "CONTENT_SEARCH_SUCCESS",
        event: {
          ...Q(ee()),
          itemIndex: G,
          content: j
        },
        url: window.location.href
      });
    }, Q = (j) => ({
      search: j,
      displayedHits: i.value.length,
      totalHits: r.value
    }), H = k(() => a.value.labels), ee = () => {
      var K, U, he;
      const j = window.location.href, V = Kr.filter((se) => j.includes(se)).length ? j : "";
      return {
        lang: n.searchLanguage,
        filterType: ["attached-contents", "cases"],
        entityType: (K = a.value) == null ? void 0 : K.types,
        search: a.value.query || "",
        query: a.value.query || "",
        knowledge: (U = n.focusKnowledge) == null ? void 0 : U.value,
        knowledgeId: (he = n.focusKnowledge) == null ? void 0 : he.id,
        correlationId: l.value,
        product: null,
        cases: null,
        status: [{ key: "published", value: !0 }],
        accessRestrictions: null,
        labels: a.value.labels,
        isContribution: null,
        searchFrom: 0,
        size: 10,
        focusEntity: null,
        modalEntity: null,
        source: V
      };
    };
    return _t(() => {
      document.addEventListener("keydown", f);
    }), xs(() => {
      document.removeEventListener("keydown", f);
    }), _e(i, () => {
      const G = new URL(window.location.href).searchParams, V = G.get("query"), K = G.getAll("labels"), U = G.getAll("types");
      o.mutateSearchFilters({
        query: V,
        labels: K,
        types: U
      });
    }), (j, G) => (c(), C(qr, {
      results: h(g),
      "has-more": h(s),
      hovered: h(d),
      loading: h(u),
      "label-searched-ids": h(H),
      "search-in-progress": !0,
      config: j.config,
      "overview-id": j.overviewId,
      "item-is-favorite": j.itemIsFavorite,
      "search-language": j.searchLanguage,
      onHover: z,
      onGoToDocument: v,
      onDisplayMore: G[0] || (G[0] = (V) => t("display-more")),
      onReset: G[1] || (G[1] = (V) => t("reset")),
      onCopyLink: G[2] || (G[2] = (V) => t("copy-link", V)),
      onOpenInWeb: G[3] || (G[3] = (V) => t("open-in-web", V)),
      onToggleFavorite: G[4] || (G[4] = (V) => t("toggle-favorite", V)),
      onOverview: G[5] || (G[5] = (V) => t("overview", V))
    }, null, 8, ["results", "has-more", "hovered", "loading", "label-searched-ids", "config", "overview-id", "item-is-favorite", "search-language"]));
  }
}), LM = /* @__PURE__ */ T({
  __name: "SearchSortDropdown",
  setup(e) {
    const t = kt(), { sortOptionId: n, hasSearchFilters: o, sortedResults: i, results: r } = De(t), s = (l) => {
      t.updateSortOption(l);
    };
    return (l, a) => {
      const u = Tr;
      return c(), C(u, {
        filteredLength: h(i).length,
        resultsLength: h(r).length,
        hasFilters: h(o),
        onUpdate: s,
        sortOptionId: h(n)
      }, null, 8, ["filteredLength", "resultsLength", "hasFilters", "sortOptionId"]);
    };
  }
}), EM = {
  key: 0,
  class: "flex border-b border-gray-3 gap-4 pb-3 justify-between px-3"
}, OM = { class: "font-bold" }, xM = /* @__PURE__ */ T({
  __name: "SearchResultsFilters",
  emits: ["update-filters"],
  setup(e, { emit: t }) {
    const n = kt(), { results: o, resultsFilters: i, hasSearchFilters: r } = De(n), s = k(() => Di(i.value)), l = (a) => {
      const u = a.filter((d) => d.key === "categories").map((d) => d.id), g = a.filter((d) => d.key === "type").map((d) => d.value);
      t("update-filters", {
        labels: u,
        types: g,
        query: i.value.query,
        size: i.value.size
      });
    };
    return (a, u) => {
      const g = P, d = P;
      return c(), p(X, null, [
        h(o).length > 1 || h(r) ? (c(), p("div", EM, [
          m("div", null, [
            M(g, {
              icon: ["fal", "sliders-v"],
              class: "mr-3"
            }),
            m("span", OM, N(a.$t("list-item.actions.filter")), 1)
          ]),
          m("div", null, [
            h(r) ? (c(), p("button", {
              key: 0,
              onClick: u[0] || (u[0] = (f) => l([])),
              class: "text-xs text-gray-7 hover:text-black"
            }, [
              M(d, {
                icon: ["fal", "arrow-rotate-left"],
                style: { "font-size": "12px" }
              }),
              ne(" " + N(a.$t("list-item.actions.reset")), 1)
            ])) : A("", !0)
          ])
        ])) : A("", !0),
        M(xi, {
          onUpdateSelectedTags: l,
          "selected-tags": h(s),
          fullSize: ""
        }, null, 8, ["selected-tags"])
      ], 64);
    };
  }
}), _M = {
  async install(e, t = {}) {
    const n = ze.SEARCH;
    if (t.pinia === void 0) {
      console.error(`[${n}] 🍍 pinia store instance not provided`);
      return;
    }
    if (t.knowledgeClient === void 0) {
      console.error(`[${n}] 🛰 axios instance not provided`);
      return;
    }
    if (t.brainClient === void 0) {
      console.error(`[${n}] 🧠 axios instance not provided`);
      return;
    }
    t.i18n === void 0 && console.error(`[${n}] 🇫🇷 i18n instance not provided`);
    const { pinia: o, knowledgeClient: i, brainClient: r } = t;
    o.use(({ store: s }) => {
      if (s.$id === n)
        if (s.$searchService = Jr(i, r), t.appFunctions !== void 0) {
          const { logs: l } = t.appFunctions;
          s.$logs = l || (() => {
            console.error(`[${n}] 🛠 log function not provided`);
          });
        } else
          console.error(`[${n}] 🛠 app functions not provided`);
    }), Object.keys(et).forEach((s) => {
      var l;
      (l = t.i18n) == null || l.global.mergeLocaleMessage(s, et[s]);
    }), e.component("super-search-view", jM), e.component("search-results-view", SM), e.component("search-sort-dropdown", LM), e.component("search-results-filters", xM);
  }
}, sN = {
  plugin: _M,
  useStore: kt,
  attachService: Jr
}, UM = {}, FM = {
  authorId: "",
  savedFeedback: "",
  feedbacks: [],
  currentPage: 1,
  pages: 0,
  total: 0,
  loadingFeedbacks: !1,
  unreadCommentCount: 0,
  // layout
  activeTab: 0
};
function Ls() {
  return Object.assign({}, {}, FM);
}
const qe = Wt(ze.FEEDBACK, {
  state: Ls,
  getters: { ...UM },
  actions: {
    mutate(e) {
      this.$patch((t) => {
        Object.keys(e).forEach((n) => {
          t[n] = e[n];
        });
      });
    },
    // patch object will not be synced
    unsyncedMutate(e) {
      this.$patch(e);
    },
    reset() {
      this.mutate(Ls());
    },
    logs(e, t) {
      this.$logs(e, t);
    },
    logFeedbackComment(e, t) {
      const n = {
        object: "FEEDBACK",
        type: "COMMENT",
        feedbackId: e,
        hasAttachment: t
      };
      this.logs({
        topic: "FEEDBACK_COMMENT",
        event: n
      });
    },
    notify(e) {
      this.$notify(e);
    },
    async setFeedback(e) {
      this.mutate({ savedFeedback: e });
    },
    async postFeedback(e) {
      return this.$feedbackService.postFeedback(e);
    },
    async getFeedbacks(e = 1) {
      try {
        this.mutate({ loadingFeedbacks: !0 });
        const {
          feedbacks: t,
          total: n,
          pages: o
        } = await this.$feedbackService.getFeedbacks(e), i = e > 1 ? [...this.feedbacks, ...t] : t;
        this.mutate({ feedbacks: i, total: n, pages: o });
      } catch (t) {
        console.error(t);
      } finally {
        this.mutate({ loadingFeedbacks: !1 });
      }
    },
    async getFeedback(e) {
      return this.$feedbackService.getFeedback(e);
    },
    async feedbackComment(e, t, n) {
      try {
        const o = await this.$feedbackService.feedbackComment(e, t, n);
        return o && this.logFeedbackComment(e, n.length > 0), o;
      } catch {
        return null;
      }
    },
    async getUnreadCommentCount() {
      const e = await this.$feedbackService.getUnreadCommentCount();
      this.mutate({ unreadCommentCount: e });
    },
    async uploadFiles(e) {
      return this.$feedbackService.uploadFiles(e);
    },
    async readFeedbackComments(e) {
      await this.$feedbackService.readFeedbackComments(e);
      const t = [...this.feedbacks], n = t.findIndex((o) => o.id === e.toString());
      n !== void 0 && (t[n].unreadCommentsCount = 0, this.mutate({ unreadCommentCount: this.unreadCommentCount - 1, feedbacks: t }));
    },
    setActiveTab(e) {
      this.mutate({ activeTab: e });
    },
    setAuthorId(e) {
      this.mutate({ authorId: e });
    },
    // INLINE CONTENTS
    async getContent(e) {
      return (await this.$feedbackService.getContents([e]))[0];
    },
    // USERS
    async getUser(e) {
      return (await this.$feedbackService.getUsers([e]))[0];
    }
  },
  persist: {
    key: `md-${ze.FEEDBACK}`
  },
  share: {
    enable: !1
  }
});
class $M {
  constructor(t, n) {
    xe(this, "adminClient");
    xe(this, "knowledgeClient");
    this.adminClient = t, this.knowledgeClient = n;
  }
  async getFeedbacks(t) {
    const n = await this.adminClient.get(`feedbacks?page=${t}`);
    return Ne(n);
  }
  async getFeedback(t) {
    const n = await this.adminClient.get(`feedback/${t}`);
    return Ne(n);
  }
  async getUnreadCommentCount() {
    const t = await this.adminClient.get("feedback/comment/unread-count");
    return Ne(t);
  }
  async postFeedback(t) {
    const n = await this.adminClient.post("feedback", t);
    return Ne(n);
  }
  async feedbackComment(t, n, o) {
    const i = await this.adminClient.post(`feedback/${t}/comment`, {
      comment: n,
      attachments: o
    });
    return Ne(i);
  }
  async readFeedbackComments(t) {
    await this.adminClient.post(`feedback/read/${t}`);
  }
  async uploadFiles(t) {
    return Fr(this.knowledgeClient, t);
  }
  async getContents(t) {
    return $r(this.knowledgeClient, t);
  }
  async getUsers(t) {
    return Vs(this.adminClient, t);
  }
}
const Xr = (e, t) => new $M(e, t), Fi = /* @__PURE__ */ T({
  __name: "BaseBadge",
  props: {
    size: { default: "small" }
  },
  setup(e) {
    const t = e, n = {
      small: "h-3 min-w-3 px-0.5 -top-1 left-[calc(100%-6px)] text-3xs !leading-3",
      medium: "h-4 min-w-4 px-0.5 -top-1.5 left-[calc(100%-8px)] text-2xs !leading-4",
      large: "h-5 min-w-5 px-1 -top-2 left-[calc(100%-10px)] text-xs !leading-5"
    };
    return (o, i) => (c(), p("span", {
      class: D(["absolute rounded-full bg-red border-red font-bold text-white text-center z-10", n[t.size]])
    }, [
      Te(o.$slots, "default")
    ], 2));
  }
}), RM = T({
  name: "LoaderLine",
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  }
});
const VM = (e) => (Sn("data-v-0329106a"), e = e(), Ln(), e), BM = { class: "loading" }, YM = {
  key: 0,
  class: "loading_line_wrapper"
}, QM = /* @__PURE__ */ VM(() => /* @__PURE__ */ m("div", { class: "loading_line" }, [
  /* @__PURE__ */ m("div", { class: "loading_line_inner loading_line_inner--1" }),
  /* @__PURE__ */ m("div", { class: "loading_line_inner loading_line_inner--2" })
], -1)), PM = [
  QM
];
function GM(e, t, n, o, i, r) {
  return c(), p("div", BM, [
    e.loading ? (c(), p("div", YM, PM)) : A("", !0)
  ]);
}
const ea = /* @__PURE__ */ x(RM, [["render", GM], ["__scopeId", "data-v-0329106a"]]), ZM = { class: "flex items-center gap-1 font-bold text-xs" }, WM = { class: "flex-none" }, HM = /* @__PURE__ */ T({
  __name: "FeedbackContent",
  props: {
    entity: {}
  },
  emits: ["open-content"],
  setup(e, { emit: t }) {
    const n = e;
    return (o, i) => {
      var l;
      const r = P, s = ye;
      return c(), p("div", ZM, [
        m("span", WM, N(o.$t("feedback.content")), 1),
        M(s, {
          type: "secondary",
          size: "mini",
          class: "flex items-center gap-1",
          onClick: i[0] || (i[0] = (a) => t("open-content")),
          disabled: !((l = n.entity) != null && l.label)
        }, {
          default: _(() => {
            var a, u;
            return [
              M(Le, {
                text: ((a = n.entity) == null ? void 0 : a.label) || o.$t("notifications.info.content-error")
              }, null, 8, ["text"]),
              M(r, {
                icon: ["fal", (u = n.entity) != null && u.label ? "external-link-square" : "xmark"]
              }, null, 8, ["icon"])
            ];
          }),
          _: 1
        }, 8, ["disabled"])
      ]);
    };
  }
}), JM = /* @__PURE__ */ T({
  __name: "FeedbackEditor",
  props: {
    message: {},
    editable: { type: Boolean, default: !1 },
    messageOptions: { type: Boolean, default: !1 }
  },
  emits: ["go-to-content", "focus", "blur", "input"],
  setup(e, { emit: t }) {
    const n = e, o = qe(), i = async ({
      entityId: s,
      entityType: l
    }) => {
      if (l === "User") {
        const a = await o.getUser(s);
        if (!a)
          return null;
        const { username: u, isDeleted: g } = a;
        return {
          entityId: s,
          entityType: l,
          label: u,
          isDeleted: g
        };
      }
      return null;
    }, r = (s) => {
      t("input", s === "<p></p>" ? "" : s);
    };
    return (s, l) => {
      const a = Br;
      return c(), C(a, {
        message: n.message,
        editable: s.editable,
        messageOptions: s.messageOptions,
        handleFetchInlineContent: h(o).getContent,
        handleFetchInlineMention: i,
        onGoToContent: l[0] || (l[0] = (u) => t("go-to-content", u)),
        onFocus: l[1] || (l[1] = (u) => t("focus")),
        onBlur: l[2] || (l[2] = (u) => t("blur")),
        onInput: r
      }, null, 8, ["message", "editable", "messageOptions", "handleFetchInlineContent"]);
    };
  }
}), KM = T({
  name: "FeedbackComment",
  components: {
    AttachmentList: ct,
    FeedbackEditor: JM
  },
  props: {
    comment: {
      type: Object,
      required: !0
    }
  },
  computed: {
    hasAttachments() {
      return this.comment.attachments && this.comment.attachments.length;
    },
    isEdited() {
      return this.comment.updatedAt && this.comment.createdAt !== this.comment.updatedAt;
    },
    createdAt() {
      return new Date(parseInt(this.comment.createdAt)).toLocaleDateString("fr-FR", {
        day: "numeric",
        month: "numeric",
        year: "2-digit"
      });
    }
  }
}), qM = { class: "bg-white shadow text-xs rounded p-3 space-y-2" }, XM = { class: "flex justify-between items-center gap-2" }, e1 = { class: "font-bold" }, t1 = {
  key: 0,
  class: "text-gray-6 text-2xs ml-1"
}, n1 = { class: "text-gray-6 ml-auto" };
function o1(e, t, n, o, i, r) {
  const s = Eo, l = R("FeedbackEditor"), a = ct;
  return c(), p("div", qM, [
    m("div", XM, [
      M(s, {
        username: e.comment.author.username
      }, null, 8, ["username"]),
      m("div", e1, N(e.comment.author.username), 1),
      e.isEdited ? (c(), p("span", t1, N(e.$t("notifications.info.edited")), 1)) : A("", !0),
      m("div", n1, N(e.createdAt), 1)
    ]),
    e.comment.comment ? (c(), C(l, {
      key: 0,
      message: e.comment.comment,
      messageOptions: ""
    }, null, 8, ["message"])) : A("", !0),
    e.hasAttachments ? (c(), C(a, {
      key: 1,
      attachments: e.comment.attachments,
      isInput: !1,
      displayHeader: !0
    }, null, 8, ["attachments"])) : A("", !0)
  ]);
}
const i1 = /* @__PURE__ */ x(KM, [["render", o1]]), s1 = { class: "px-4 space-y-1 mt-1 relative" }, r1 = ["placeholder", "onKeyup"], a1 = { class: "flex" }, l1 = /* @__PURE__ */ T({
  __name: "FeedbackNewComment",
  props: {
    feedback: {}
  },
  emits: ["new-comment", "read-comments"],
  setup(e, { emit: t }) {
    const n = e, o = qe(), {
      fileInputDisable: i,
      attachments: r,
      attachmentLoading: s,
      displayDisableFileUpload: l,
      errorText: a,
      handleDeleteAttachment: u,
      handleFileChange: g,
      showDisableFileUpload: d
    } = Ui(o.uploadFiles), f = Y(""), I = Y(!1), z = k(() => {
      let G = !0;
      return r.items.length && (G = r.items.map((V) => !V.error || !V.loading).every((V) => V)), G && !s;
    }), v = k(() => r.items.length && z || !r.items.length && f.value.length), Q = async () => {
      if (v.value)
        try {
          I.value = !0;
          const G = await o.feedbackComment(
            n.feedback.id,
            f.value,
            r.items.map((V) => V.url)
          );
          if (!G)
            throw new Error("Comment not created");
          r.items = [], f.value = "", t("new-comment", G);
        } catch {
          ee();
        } finally {
          I.value = !1;
        }
    }, H = Y(!1), ee = () => {
      H.value = !0, setTimeout(() => {
        H.value = !1;
      }, 2e3);
    }, j = Y(null);
    return _e(f, () => {
      j.value && (j.value.scrollHeight > j.value.clientHeight ? j.value.style.height = j.value.scrollHeight + "px" : j.value.style.height = "34px");
    }), (G, V) => {
      const K = P, U = ye, he = It("stop-propagation");
      return c(), p("div", s1, [
        h(I) ? (c(), C(Lo, { key: 0 })) : A("", !0),
        m("div", {
          class: D(["flex items-center gap-2 relative border border-gray-2 rounded w-full px-2 transition-colors", { "border-red": h(H) }])
        }, [
          Ze(m("input", {
            ref_key: "responseInput",
            ref: j,
            "onUpdate:modelValue": V[0] || (V[0] = (se) => Be(f) ? f.value = se : null),
            class: "w-full text-sm h-8.5 border-none outline-none py-2 bg-transparent",
            placeholder: G.$t("feedback.answer"),
            onKeyup: Co(Q, ["enter"]),
            onFocus: V[1] || (V[1] = (se) => t("read-comments"))
          }, null, 40, r1), [
            [yi, h(f)],
            [he]
          ]),
          m("div", a1, [
            M(Fn, {
              disabled: h(i),
              "attachment-loading": h(s),
              onNewAttachment: h(g),
              onDisableClick: V[2] || (V[2] = (se) => h(d)("feedback.disable-file-upload")),
              ref: "add-attachment",
              class: "attachment-wrapper mr-1"
            }, {
              button: _(() => [
                M(U, {
                  type: "secondary",
                  size: "mini",
                  icon: "",
                  disabled: h(i) || h(s)
                }, {
                  default: _(() => [
                    M(K, { icon: ["fal", "paperclip"] })
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["disabled", "attachment-loading", "onNewAttachment"]),
            M(U, {
              onClick: Q,
              disabled: !h(v),
              size: "mini",
              icon: "",
              type: "custom-secondary"
            }, {
              default: _(() => [
                M(K, { icon: ["fal", "paper-plane"] })
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 2),
        M(ct, {
          attachments: h(r).items,
          isInput: !0,
          displayDisableFileUpload: h(l),
          errorText: h(a),
          onDeleteAttachment: h(u)
        }, null, 8, ["attachments", "displayDisableFileUpload", "errorText", "onDeleteAttachment"])
      ]);
    };
  }
}), c1 = { key: 0 }, u1 = { class: "flex items-center justify-center gap-1 px-4" }, d1 = /* @__PURE__ */ m("div", { class: "flex-grow h-px bg-gray-4" }, null, -1), g1 = /* @__PURE__ */ m("div", { class: "flex-grow h-px bg-gray-4" }, null, -1), p1 = /* @__PURE__ */ T({
  __name: "FeedbackThread",
  props: {
    feedback: {},
    hasUnreadComment: { type: Boolean }
  },
  emits: ["new-comment", "read-comments"],
  setup(e, { emit: t }) {
    const n = e, o = k(() => n.feedback.comment), i = Y(!1), r = Y(null), s = () => {
      var d, f;
      (f = r.value) == null || f.scrollTo({
        top: (d = r.value) == null ? void 0 : d.scrollHeight,
        behavior: "smooth"
      });
    }, l = () => {
      s(), i.value = !i.value, i.value && t("read-comments");
    }, a = k(() => n.hasUnreadComment ? [
      i.value ? "text-white bg-red hover:bg-red-6" : "text-red bg-red/10 hover:bg-red/20"
    ] : [
      i.value ? "text-white bg-secondary hover:bg-secondary-6" : "text-secondary bg-secondary/10 hover:bg-secondary/20"
    ]), u = k(() => n.hasUnreadComment ? [i.value ? "text-red bg-white" : "text-white bg-red"] : [i.value ? "text-secondary bg-white " : "text-white bg-secondary"]), g = (d) => {
      t("new-comment", d), setTimeout(() => {
        s();
      }, 100);
    };
    return (d, f) => {
      const I = P;
      return o.value.length ? (c(), p("div", c1, [
        m("div", u1, [
          d1,
          m("button", {
            class: D(["transition-colors text-xs flex items-center gap-2 py-1 px-2 rounded-sm", a.value]),
            onClick: l
          }, [
            m("span", null, N(d.$t("feedback.comments")), 1),
            m("span", {
              class: D(["text-3xs leading-3 text-center rounded-full min-w-3 h-3 px-0.5", u.value])
            }, N(o.value.length), 3),
            M(I, {
              class: D(["transition-transform", [{ "-rotate-180": i.value }]]),
              icon: ["fal", "chevron-down"]
            }, null, 8, ["class"])
          ], 2),
          g1
        ]),
        m("div", {
          class: D(["transition-height overflow-auto w-full space-y-2 px-4", [i.value ? "max-h-[200px] py-2" : "max-h-0"]]),
          ref_key: "commentsCollapse",
          ref: r
        }, [
          (c(!0), p(X, null, te(o.value, (z, v) => (c(), C(i1, {
            key: z.id,
            comment: z,
            unread: v === o.value.length - 1 && d.hasUnreadComment
          }, null, 8, ["comment", "unread"]))), 128))
        ], 2),
        i.value ? (c(), C(l1, {
          key: 0,
          feedback: n.feedback,
          onNewComment: g
        }, null, 8, ["feedback"])) : A("", !0)
      ])) : A("", !0);
    };
  }
}), m1 = T({
  name: "FeedbackCollapse",
  props: {
    feedback: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      focusedFeedback: null,
      thread: [],
      body: "",
      cardOpened: !1,
      response: "",
      entity: void 0,
      loading: !1,
      scriptSanitizer: jn
    };
  },
  components: {
    LoaderLine: ea,
    AttachmentList: ct,
    // FeedbackRating,
    FeedbackContent: HM,
    FeedbackThread: p1
  },
  computed: {
    createdAt() {
      return new Date(parseInt(this.feedback.createdAt)).toLocaleDateString("fr-FR", {
        day: "numeric",
        month: "numeric",
        year: "2-digit"
      });
    },
    hasUnreadComment() {
      return this.feedback.unreadCommentsCount > 0;
    },
    hasAttachments() {
      return this.feedback.attachments && this.feedback.attachments.length;
    },
    assigneeLabel() {
      return this.feedback.assignee ? "username" in this.feedback.assignee ? this.feedback.assignee.username : "name" in this.feedback.assignee ? this.feedback.assignee.name : null : null;
    },
    ...ue(qe, ["authorId"])
  },
  methods: {
    async focusFeedback() {
      this.loading || (!this.cardOpened && this.body === "" && (this.loading = !0, this.focusedFeedback = await this.getFeedback(this.feedback.id), this.body = this.focusedFeedback.body, this.entity = {
        id: this.focusedFeedback.entityId,
        label: this.focusedFeedback.entityLabel,
        type: this.focusedFeedback.entityType
      }, this.logs({
        topic: "HUB_CARD_VIEW",
        event: {
          cardType: "FEEDBACK",
          cardCreatedAt: this.focusedFeedback.createdAt,
          feedbackId: this.feedback.id,
          feedbackType: this.focusedFeedback.entityType ? "CONTENT" : "GENERAL",
          feedbackEntityType: this.focusedFeedback.entityType,
          isReceiver: this.focusedFeedback.assignee.id === this.authorId,
          isAuthor: !0,
          source: "FEEDBACK_HISTORY"
        }
      })), this.cardOpened = !this.cardOpened, this.loading = !1);
    },
    openEntity() {
      var e;
      this.$emit("select-item", {
        ...this.entity,
        lang: (e = this.focusedFeedback) == null ? void 0 : e.lang,
        source: "feedback_history"
      });
    },
    readComments() {
      this.hasUnreadComment && this.$emit("read-comments", this.feedback.id);
    },
    ...fe(qe, ["getFeedback", "logs"])
  }
});
const h1 = {
  key: 0,
  class: "bg-white/80 absolute inset-0 z-10 py-4 px-3"
}, f1 = { class: "flex items-center gap-2 min-w-0" }, y1 = { class: "relative" }, I1 = { class: "text-xs min-w-0" }, M1 = { class: "space-x-1" }, A1 = { class: "font-bold" }, N1 = { class: "flex items-center gap-1 min-w-0" }, b1 = { class: "flex items-center gap-2 flex-none" }, C1 = {
  key: 0,
  class: "text-black bg-white pb-4 pt-2 relative space-y-4 w-full"
}, w1 = { class: "w-full space-y-1 px-4" }, D1 = ["innerHTML"];
function z1(e, t, n, o, i, r) {
  const s = ea, l = P, a = Fi, u = Le, g = ye, d = ct, f = R("FeedbackContent"), I = R("FeedbackThread");
  return c(), p("div", {
    class: D(["shadow transition-height h-fit relative overflow-hidden rounded w-full", [e.cardOpened ? "max-h-none" : "max-h-[68px]"]])
  }, [
    m("button", {
      class: D(["w-full h-14 border-l-4 px-2 border-transparent transition-colors hover:border-secondary relative flex items-center justify-between gap-2 text-left", [e.cardOpened ? "bg-secondary border-secondary text-secondary-contrast" : "bg-white"]]),
      onClick: t[0] || (t[0] = (z) => e.focusFeedback())
    }, [
      e.loading ? (c(), p("div", h1, [
        M(s, { loading: e.loading }, null, 8, ["loading"])
      ])) : A("", !0),
      m("div", f1, [
        m("div", y1, [
          M(l, {
            class: D(["text-white flex items-center justify-center rounded h-6 w-6 transition-colors text-sm", [e.cardOpened ? "bg-white/10" : "bg-secondary"]]),
            icon: ["fal", "megaphone"]
          }, null, 8, ["class"]),
          e.hasUnreadComment ? (c(), C(a, { key: 0 }, {
            default: _(() => [
              ne(N(e.feedback.unreadCommentsCount), 1)
            ]),
            _: 1
          })) : A("", !0)
        ]),
        m("div", I1, [
          m("div", M1, [
            ne(N(e.$t("feedback.sent-at")) + " ", 1),
            m("span", A1, N(e.createdAt), 1),
            e.feedback.entityId ? (c(), C(l, {
              key: 0,
              icon: ["fal", "link"]
            })) : A("", !0)
          ]),
          m("div", N1, [
            m("span", null, N(e.$t("feedback.sent-to")), 1),
            M(u, {
              class: "font-bold",
              text: e.assigneeLabel || e.$t("feedback.deleted-user")
            }, null, 8, ["text"])
          ])
        ])
      ]),
      m("div", b1, [
        m("div", {
          class: D(["text-2xs py-1.5 px-2 rounded-sm transition-colors font-bold whitespace-nowrap", [e.feedback.status.value, { "!bg-white/10 !text-white": e.cardOpened }]])
        }, N(e.$t(`feedback.status.${e.feedback.status.value}`)), 3),
        M(g, {
          type: "secondary",
          size: "mini",
          icon: "",
          class: D([{ "!bg-transparent": e.cardOpened }])
        }, {
          default: _(() => [
            M(l, {
              class: D(["transition-all", [e.cardOpened ? "text-white -rotate-180" : "text-gray-8"]]),
              icon: ["fal", "chevron-down"]
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ], 2),
    e.cardOpened ? (c(), p("div", C1, [
      m("div", w1, [
        m("span", {
          class: "text-xs",
          innerHTML: e.scriptSanitizer(e.body)
        }, null, 8, D1),
        e.hasAttachments ? (c(), C(d, {
          key: 0,
          attachments: e.feedback.attachments,
          isInput: !1,
          displayHeader: !0
        }, null, 8, ["attachments"])) : A("", !0)
      ]),
      e.feedback.entityId ? (c(), C(f, {
        key: 0,
        class: "px-4",
        entity: e.entity,
        onOpenContent: e.openEntity
      }, null, 8, ["entity", "onOpenContent"])) : A("", !0),
      e.focusedFeedback ? (c(), C(I, {
        key: 1,
        feedback: e.focusedFeedback,
        hasUnreadComment: e.hasUnreadComment,
        onReadComments: e.readComments,
        onNewComment: t[1] || (t[1] = (z) => e.focusedFeedback.comment.push(z))
      }, null, 8, ["feedback", "hasUnreadComment", "onReadComments"])) : A("", !0)
    ])) : A("", !0)
  ], 2);
}
const v1 = /* @__PURE__ */ x(m1, [["render", z1], ["__scopeId", "data-v-10aa7056"]]), T1 = T({
  name: "FeedbackHistory",
  components: {
    LoaderSpinner: Lo,
    FeedbackCollapse: v1
  },
  emits: ["select-item", "new-feedback"],
  data() {
    return {
      page: 1,
      loading: !1
    };
  },
  computed: {
    ...ue(qe, ["feedbacks", "pages", "unreadCommentCount", "loadingFeedbacks"])
  },
  async created() {
    this.loading = !0, await this.getFeedbacks(), await this.getUnreadCommentCount(), this.loading = !1;
  },
  methods: {
    handleReadComments(e) {
      this.readFeedbackComments(e);
    },
    async showMore() {
      this.page += 1, await this.getFeedbacks(this.page);
    },
    ...fe(qe, [
      "getFeedbacks",
      "readFeedbackComments",
      "getUnreadCommentCount"
    ])
  },
  watch: {
    unreadCommentCount: {
      async handler(e, t) {
        e > t && (this.loading = !0, await this.getFeedbacks(), this.loading = !1);
      }
    }
  }
}), k1 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='230'%20height='191'%20fill='none'%3e%3cpath%20fill='%23EAEEF9'%20d='M111.418%20170.5c44.928%200%2081.351-36.416%2081.351-81.494S156.185%207.512%20111.418%207.512c-44.928%200-81.351%2036.416-81.351%2081.494S66.49%20170.5%20111.418%20170.5Z'/%3e%3cg%20filter='url(%23a)'%3e%3cpath%20fill='url(%23b)'%20d='m166.775%2048.26%201.284%20103.311c0%203.529-2.888%206.256-6.418%206.256H60.874c-3.53%200-6.418-2.887-6.418-6.256V18.742c0-3.529%202.888-6.256%206.418-6.256h73.008l32.893%2035.774Z'/%3e%3c/g%3e%3cg%20clip-path='url(%23c)'%3e%3cpath%20fill='%23D5DDEA'%20d='m130.328%2065.215%209.761%2037.02a1.477%201.477%200%200%201-1.049%201.799%201.478%201.478%200%200%201-1.8-1.048l-.269-1.024-18.436.157c.22%204.158-2.442%207.962-6.554%209.046-4.797%201.264-9.554-1.575-10.797-6.291a8.987%208.987%200%200%201-.295-2.454l-12.494.162.27%201.023a1.474%201.474%200%200%201-1.05%201.799%201.475%201.475%200%200%201-1.799-1.048l-3.754-14.239a1.475%201.475%200%200%201%201.049-1.799%201.475%201.475%200%200%201%201.8%201.049l.27%201.023%2042.569-23.4-.27-1.024a1.474%201.474%200%200%201%201.049-1.8%201.474%201.474%200%200%201%201.799%201.05Zm5.868%2033.81-7.672-29.1-42.57%2023.402%201.666%206.318%2048.576-.62Zm-24.966%209.292a5.886%205.886%200%200%200%204.375-6.082l-11.765.15c-.102.588.04%201.16.192%201.738a5.896%205.896%200%200%200%207.198%204.194Z'/%3e%3c/g%3e%3cpath%20fill='%23D5DDEA'%20d='M103.556%20137.132H83.82c-.803%200-1.444-.802-1.444-1.764%200-.963.641-1.765%201.444-1.765h19.736c.802%200%201.444.802%201.444%201.765%200%201.123-.642%201.764-1.444%201.764Z'/%3e%3cpath%20fill='%23D5DDEA'%20d='M92.324%20137.132H70.823c-.802%200-1.444-.802-1.444-1.764%200-.963.642-1.765%201.444-1.765h21.501c.802%200%201.444.802%201.444%201.765%200%201.123-.642%201.764-1.444%201.764Zm27.438-102.99H71.465c-1.123%200-2.086-.962-2.086-2.085s.963-2.086%202.086-2.086h48.297c1.123%200%202.086.963%202.086%202.086%200%201.123-.963%202.085-2.086%202.085Zm-29.684%2011.55H71.465c-1.123%200-2.086-.962-2.086-2.085s.963-2.085%202.086-2.085h18.452c1.123%200%202.086.962%202.086%202.085s-.963%202.085-1.925%202.085Zm43.804-33.206V41.04c0%204.01%203.53%207.219%207.541%207.219h25.352'/%3e%3cellipse%20cx='39.546'%20cy='31.584'%20fill='%23EAEEF9'%20rx='4.909'%20ry='4.908'/%3e%3cellipse%20cx='188.455'%20cy='165.737'%20fill='%23EAEEF9'%20rx='4.909'%20ry='4.908'/%3e%3cellipse%20cx='224.455'%20cy='5.408'%20fill='%23EAEEF9'%20rx='4.909'%20ry='4.908'/%3e%3cellipse%20cx='214.637'%20cy='28.312'%20fill='%23EAEEF9'%20rx='6.545'%20ry='6.544'/%3e%3cellipse%20cx='8.455'%20cy='115.02'%20fill='%23EAEEF9'%20rx='8.182'%20ry='8.18'/%3e%3cdefs%3e%3clinearGradient%20id='b'%20x1='111.22'%20x2='111.22'%20y1='9.124'%20y2='159.394'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FDFEFF'/%3e%3cstop%20offset='.996'%20stop-color='%23ECF0F5'/%3e%3c/linearGradient%3e%3cclipPath%20id='c'%3e%3cpath%20fill='white'%20d='m77.182%2071.607%2051.27-13.511%2013.514%2051.258-51.27%2013.512z'/%3e%3c/clipPath%3e%3cfilter%20id='a'%20width='157.603'%20height='189.341'%20x='32.456'%20y='1.486'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='11'/%3e%3cfeGaussianBlur%20stdDeviation='11'/%3e%3cfeColorMatrix%20values='0%200%200%200%200.397708%200%200%200%200%200.47749%200%200%200%200%200.575%200%200%200%200.27%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_159_116263'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_159_116263'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", j1 = { class: "bg-gray-1 w-full overflow-y-auto relative" }, S1 = { class: "p-4 space-y-1.5 w-full" }, L1 = {
  key: 2,
  class: "text-base font-bold flex justify-center items-center flex-col gap-4 p-4 text-center w-full h-full"
}, E1 = /* @__PURE__ */ m("img", {
  alt: "empty-feedbacks",
  src: k1
}, null, -1);
function O1(e, t, n, o, i, r) {
  const s = Lo, l = R("FeedbackCollapse"), a = ye, u = P;
  return c(), p("div", j1, [
    m("div", S1, [
      e.loading ? (c(), C(s, { key: 0 })) : A("", !0),
      (c(!0), p(X, null, te(e.feedbacks, (g) => (c(), C(l, {
        key: g.id,
        feedback: g,
        onSelectItem: t[0] || (t[0] = (d) => e.$emit("select-item", d)),
        onReadComments: e.handleReadComments
      }, null, 8, ["feedback", "onReadComments"]))), 128)),
      e.page < e.pages && e.feedbacks.length ? (c(), C(a, {
        key: 1,
        class: "mx-auto",
        outline: "",
        size: "small",
        onClick: e.showMore,
        type: "custom-secondary"
      }, {
        default: _(() => [
          ne(N(e.$t("feedback.show-more")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])) : A("", !0),
      e.feedbacks.length ? A("", !0) : (c(), p("div", L1, [
        E1,
        m("span", null, N(e.$t("feedback.empty")), 1),
        M(a, {
          size: "small",
          onClick: t[1] || (t[1] = (g) => e.$emit("new-feedback")),
          type: "custom-secondary"
        }, {
          default: _(() => [
            e.loadingFeedbacks ? (c(), C(u, {
              key: 0,
              icon: ["fas", "spinner-third"],
              spin: ""
            })) : A("", !0),
            ne(" " + N(e.$t("feedback.new-feedback")), 1)
          ]),
          _: 1
        })
      ]))
    ])
  ]);
}
const x1 = /* @__PURE__ */ x(T1, [["render", O1]]), _1 = T({
  name: "NewFeedback",
  components: {
    AttachmentList: ct,
    AddAttachment: Fn
  },
  emits: ["refresh-roles", "edit-feedback", "cancel"],
  setup() {
    const e = qe();
    return Ui(e.uploadFiles);
  },
  data() {
    return {
      collaborator: null,
      hasNodeLinked: !0,
      assignableEntities: { group: [], collaborator: [] }
    };
  },
  props: {
    source: {
      type: String,
      default: "feedback_section"
    },
    config: {
      type: Object,
      default: () => ({})
    },
    reportRecipients: {
      type: Array,
      default: () => []
    },
    collectionPath: {
      type: Array,
      default: () => []
    },
    contentParents: {
      type: Array,
      default: () => []
    },
    mainContent: {
      type: Object,
      default: () => null
    },
    lang: {
      type: String,
      required: !0
    }
  },
  created() {
    this.$emit("refresh-roles");
  },
  computed: {
    feedbackContext() {
      let e = [...this.collectionPath, ...this.contentParents];
      return {
        path: e.map((t) => String(t.id)),
        tags: e.map((t) => t.label)
      };
    },
    path() {
      return this.feedbackContext.path;
    },
    pathTags() {
      return this.feedbackContext.tags || [];
    },
    attachmentsSendable() {
      let e = !0;
      return this.attachments.items.forEach((t) => {
        (t.error || t.loading) && (e = !1);
      }), e;
    },
    formValidated() {
      var e;
      return this.savedFeedback.length > 0 && ((e = this.collaborator) == null ? void 0 : e.id) && !this.attachmentLoading && this.attachmentsSendable;
    },
    focusedContent() {
      return this.mainContent;
    },
    mainContentUrl() {
      if (!this.focusedContent)
        return null;
      const { type: e, id: t } = this.focusedContent;
      if (!e || !t)
        return null;
      if (e === "Case")
        return `knowledge/case/${t}`;
      if (["Article", "Diagnostic"].includes(e))
        return `knowledge/content/${t}`;
      if (["Step", "keyStep"].includes(e)) {
        const n = this.contentParents[0];
        return n ? `knowledge/content/${n.id}/step/${t}` : null;
      }
      return null;
    },
    focusContentLabel() {
      var e;
      return (e = this.focusedContent) == null ? void 0 : e.label;
    },
    ...ue(qe, ["savedFeedback"])
  },
  methods: {
    handleKeydown(e) {
      e.stopPropagation();
    },
    handleEditFeedback(e) {
      const { value: t } = e.target;
      this.setFeedback(t), this.$emit("edit-feedback"), e.stopPropagation();
    },
    async sendFeedback() {
      var o, i, r, s, l, a;
      if (!this.collaborator)
        return;
      const { id: e, type: t } = this.collaborator, n = {
        event: {
          lang: this.lang,
          feedback: {
            recipientId: t === "collaborator" ? e : null,
            groupId: t === "group" ? e : null,
            path: this.mainContentUrl ? [this.mainContentUrl] : [],
            tags: this.pathTags,
            feedback: this.savedFeedback,
            hasNodeLinked: (o = this.focusedContent) != null && o.id ? this.hasNodeLinked : !1,
            entityType: (i = this.focusedContent) == null ? void 0 : i.type,
            entityId: (r = this.focusedContent) == null ? void 0 : r.id,
            attachments: this.attachments.items.map((u) => u.url)
          },
          ...this.hasNodeLinked && ((s = this.focusedContent) != null && s.id) ? { content: this.focusedContent } : {},
          location: this.source.toUpperCase()
        },
        knowledge: {
          recipientId: t === "collaborator" ? e : void 0,
          groupId: t === "group" ? e : void 0,
          path: this.mainContentUrl ? [this.mainContentUrl] : [],
          tags: this.pathTags,
          feedback: this.savedFeedback,
          hasNodeLinked: this.hasNodeLinked,
          ...this.hasNodeLinked && ((l = this.focusedContent) != null && l.id) ? {
            entityId: this.focusedContent.id,
            entityType: this.focusedContent.type,
            lang: this.lang
          } : {},
          attachments: this.attachments.items.map((u) => u.url)
        }
      };
      try {
        (await this.postFeedback(n.knowledge)).message && (this.logs(
          {
            topic: this.hasNodeLinked && ((a = this.focusedContent) != null && a.id) ? "CONTENT_FEEDBACK" : "GENERAL_FEEDBACK",
            event: n.event
          },
          !0
        ), this.resetFeedback(), this.notify("knowledge.notification.feedback"));
      } catch (u) {
        console.error(u);
      }
    },
    resetFeedback() {
      (this.collaborator || this.savedFeedback || !this.hasNodeLinked || this.attachments.items.length) && (this.collaborator = null, this.hasNodeLinked = !0, this.attachments.items = [], this.setFeedback("")), this.$emit("cancel");
    },
    ...fe(qe, ["setFeedback", "postFeedback", "logs", "notify"])
  },
  watch: {
    reportRecipients: {
      handler: function() {
        this.assignableEntities = { group: [], collaborator: [] }, this.reportRecipients.forEach((e) => {
          this.assignableEntities[e.value.type].push(e);
        });
      },
      immediate: !0
    }
  }
}), U1 = { class: "bg-white flex flex-col gap-3 justify-between p-4" }, F1 = { class: "space-y-3" }, $1 = { class: "text-base font-bold text-black" }, R1 = ["placeholder", "value"], V1 = { class: "space-y-1" }, B1 = { class: "flex items-center justify-between" }, Y1 = { class: "text-base font-bold text-black" }, Q1 = { key: 0 }, P1 = { class: "text-base font-bold text-black" }, G1 = {
  disabled: "",
  hidden: "",
  selected: "",
  value: null
}, Z1 = {
  key: 0,
  disabled: ""
}, W1 = ["value"], H1 = {
  key: 1,
  disabled: ""
}, J1 = ["value"], K1 = { class: "flex flex-col space-y-2" }, q1 = { class: "font-bold text-base" }, X1 = {
  key: 0,
  class: "text-sm whitespace-pre-wrap [word-break:break-word]"
}, eA = { class: "flex flex-row-reverse w-full gap-2" };
function tA(e, t, n, o, i, r) {
  const s = P, l = ye, a = Fn, u = ct, g = Le, d = kn;
  return c(), p("div", U1, [
    m("div", F1, [
      m("div", null, [
        m("label", $1, N(e.$t("feedback.label-text")), 1),
        m("textarea", {
          placeholder: e.$t("feedback.placeholder"),
          value: e.savedFeedback,
          class: "mt-1 border border-gray-4 outline-none w-full rounded p-2 text-black placeholder:text-gray-5 text-sm resize-none",
          rows: "7",
          onInput: t[0] || (t[0] = (...f) => e.handleEditFeedback && e.handleEditFeedback(...f)),
          onKeydown: t[1] || (t[1] = (...f) => e.handleKeydown && e.handleKeydown(...f))
        }, `
        `, 40, R1)
      ]),
      m("div", V1, [
        m("div", B1, [
          m("label", Y1, N(e.$t("feedback.attachments", e.attachments.items.length)), 1),
          M(a, {
            disabled: e.fileInputDisable,
            "attachment-loading": e.attachmentLoading,
            "show-loader": !1,
            onNewAttachment: e.handleFileChange,
            onDisableClick: t[2] || (t[2] = (f) => e.showDisableFileUpload("attachments.disable-file-upload")),
            class: "attachment-wrapper mr-1"
          }, {
            button: _(() => [
              M(l, {
                size: "mini",
                class: "min-w-14 h-6.5",
                type: "custom-secondary"
              }, {
                default: _(() => [
                  e.attachmentLoading ? (c(), C(s, {
                    key: 1,
                    icon: ["fas", "spinner-third"],
                    spin: ""
                  })) : (c(), p("div", Q1, N(e.$t("feedback.add-attachment")), 1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled", "attachment-loading", "onNewAttachment"])
        ]),
        M(u, {
          attachments: e.attachments.items,
          isInput: !0,
          displayDisableFileUpload: e.displayDisableFileUpload,
          errorText: e.errorText,
          displayHeader: !1,
          "attachment-width": "49%",
          onDeleteAttachment: e.handleDeleteAttachment,
          onDisableClick: t[3] || (t[3] = (f) => e.showDisableFileUpload(""))
        }, null, 8, ["attachments", "displayDisableFileUpload", "errorText", "onDeleteAttachment"])
      ]),
      m("div", null, [
        m("label", P1, N(e.$t("feedback.label-target")), 1),
        Ze(m("select", {
          "onUpdate:modelValue": t[4] || (t[4] = (f) => e.collaborator = f),
          class: D(["mt-1 border border-gray-4 rounded w-full p-2 cursor-pointer outline-none text-sm", [e.collaborator ? "text-black" : "text-gray-5"]]),
          required: ""
        }, [
          m("option", G1, N(e.$t("feedback.target-placeholder")), 1),
          e.assignableEntities.collaborator.length ? (c(), p("option", Z1, N(e.$t("feedback.collaborators")), 1)) : A("", !0),
          (c(!0), p(X, null, te(e.assignableEntities.collaborator, (f) => (c(), p("option", {
            key: f.value.id,
            value: f.value
          }, N(f.username), 9, W1))), 128)),
          e.assignableEntities.group.length ? (c(), p("option", H1, N(e.$t("feedback.groups")), 1)) : A("", !0),
          (c(!0), p(X, null, te(e.assignableEntities.group, (f) => (c(), p("option", {
            key: f.value.id,
            value: f.value
          }, N(f.username), 9, J1))), 128))
        ], 2), [
          [_s, e.collaborator]
        ])
      ]),
      e.focusContentLabel ? (c(), C(d, {
        key: 0,
        checked: e.hasNodeLinked,
        "onUpdate:checked": t[5] || (t[5] = (f) => e.hasNodeLinked = f)
      }, {
        default: _(() => [
          m("div", K1, [
            m("span", q1, N(e.$t("feedback.link")), 1),
            e.config.displayFullTitle ? (c(), p("span", X1, N(e.focusContentLabel), 1)) : (c(), C(g, {
              key: 1,
              text: e.focusContentLabel,
              width: "275px"
            }, null, 8, ["text"]))
          ])
        ]),
        _: 1
      }, 8, ["checked"])) : A("", !0)
    ]),
    m("div", eA, [
      M(l, {
        type: "custom-secondary",
        disabled: !e.formValidated,
        size: "small",
        onClick: e.sendFeedback
      }, {
        default: _(() => [
          ne(N(e.$t("feedback.cta")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      M(l, {
        type: "secondary",
        size: "small",
        onClick: e.resetFeedback
      }, {
        default: _(() => [
          ne(N(e.$t("feedback.cancel")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]);
}
const ta = /* @__PURE__ */ x(_1, [["render", tA]]), nA = T({
  name: "FeedbackView",
  components: { NewFeedback: ta, FeedbackHistory: x1 },
  props: {
    source: {
      type: String,
      default: "feedback_section"
    },
    reportRecipients: {
      type: Array,
      default: () => []
    },
    collectionPath: {
      type: Array,
      default: () => []
    },
    contentParents: {
      type: Array,
      default: () => []
    },
    mainContent: {
      type: Object,
      default: () => null
    },
    lang: {
      type: String,
      required: !0
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["select-item", "refresh-roles", "cancel"],
  computed: {
    feedbackContext() {
      let e = [...this.collectionPath, ...this.contentParents];
      return {
        path: e.map((t) => String(t.id)),
        tags: e.map((t) => t.label)
      };
    },
    path() {
      return this.feedbackContext.path;
    },
    pathTags() {
      return this.feedbackContext.tags;
    },
    ...ue(qe, ["savedFeedback", "unreadCommentCount", "activeTab"])
  },
  methods: {
    ...fe(qe, ["setActiveTab"])
  }
});
function oA(e, t, n, o, i, r) {
  const s = R("NewFeedback"), l = R("FeedbackHistory");
  return e.activeTab === 0 ? (c(), C(s, Tt({ key: 0 }, e.$props, {
    source: e.source,
    config: e.config,
    onCancel: t[0] || (t[0] = (a) => e.$emit("cancel")),
    onRefreshRoles: t[1] || (t[1] = (a) => e.$emit("refresh-roles"))
  }), null, 16, ["source", "config"])) : (c(), C(l, {
    key: 1,
    onSelectItem: t[2] || (t[2] = (a) => e.$emit("select-item", a)),
    onNewFeedback: t[3] || (t[3] = (a) => e.setActiveTab(0))
  }));
}
const iA = /* @__PURE__ */ x(nA, [["render", oA]]), sA = { class: "flex justify-evenly items-center gap-8" }, rA = ["onClick"], $i = /* @__PURE__ */ T({
  __name: "BaseTabs",
  props: {
    tabs: {},
    activeTab: {},
    altStyle: { type: Boolean }
  },
  emits: ["update-tab"],
  setup(e, { emit: t }) {
    const n = e, o = (i) => t("update-tab", i);
    return (i, r) => {
      const s = P, l = Fi;
      return c(), p("nav", sA, [
        (c(!0), p(X, null, te(n.tabs, (a, u) => (c(), p("button", {
          key: u,
          class: D(["flex items-center gap-2 rounded-lg px-4 h-9 text-base font-bold transition-colors relative", [
            i.altStyle ? "text-primary hover:bg-primary/10 alt:text-gray-9.5" : "text-primary-contrast bg-transparent hover:bg-primary-contrast/10",
            {
              "!bg-primary-contrast !text-primary hover:!bg-primary-contrast": u === i.activeTab && !i.altStyle,
              "!bg-primary !text-primary-contrast hover:!bg-primary alt:!bg-gray-9.5 alt:!text-white": u === i.activeTab && i.altStyle
            }
          ]]),
          onClick: (g) => o(u)
        }, [
          M(s, {
            icon: a.icon
          }, null, 8, ["icon"]),
          m("span", null, [
            ne(N(i.$t(a.label)) + " ", 1),
            a.badge ? (c(), C(l, {
              key: 0,
              class: "!-top-1 !right-1"
            }, {
              default: _(() => [
                ne(N(a.badge), 1)
              ]),
              _: 2
            }, 1024)) : A("", !0)
          ])
        ], 10, rA))), 128))
      ]);
    };
  }
}), aA = T({
  name: "FeedbackView",
  components: { BaseTabs: $i },
  emits: ["update"],
  props: {
    focusNewTab: {
      type: Boolean,
      default: !1
    },
    altStyle: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    getTabs() {
      return [
        { icon: ["fal", "pen"], label: "feedback.tab-new", name: "new" },
        {
          icon: ["fal", "paper-plane"],
          label: "feedback.tab-history",
          name: "history",
          badge: this.unreadCommentCount > 0 ? String(this.unreadCommentCount) : void 0
        }
      ];
    },
    ...ue(qe, ["activeTab", "unreadCommentCount"])
  },
  mounted() {
    this.focusNewTab && this.setActiveTab(0);
  },
  methods: {
    handleSetActiveTab(e) {
      this.setActiveTab(e), this.$emit("update", e ? "list" : "new");
    },
    ...fe(qe, ["setActiveTab"])
  },
  watch: {
    focusNewTab(e) {
      e && this.setActiveTab(0);
    }
  }
});
function lA(e, t, n, o, i, r) {
  const s = $i;
  return c(), C(s, {
    "active-tab": e.activeTab,
    tabs: e.getTabs,
    altStyle: e.altStyle,
    onUpdateTab: e.handleSetActiveTab
  }, null, 8, ["active-tab", "tabs", "altStyle", "onUpdateTab"]);
}
const cA = /* @__PURE__ */ x(aA, [["render", lA]]), uA = {
  async install(e, t = {}) {
    const n = ze.FEEDBACK;
    if (t.pinia === void 0) {
      console.error(`[${n}] 🍍 pinia store instance not provided`);
      return;
    }
    if (t.adminClient === void 0 || t.knowledgeClient === void 0) {
      console.error(`[${n}] 🛰 axios instance not provided`);
      return;
    }
    t.i18n === void 0 && console.error(`[${n}] 🇫🇷 i18n instance not provided`);
    const { pinia: o, adminClient: i, knowledgeClient: r } = t;
    o.use(({ store: s }) => {
      if (s.$id === n)
        if (s.$feedbackService = Xr(i, r), t.appFunctions !== void 0) {
          const { logs: l, notify: a } = t.appFunctions;
          s.$logs = l || (() => {
            console.error(`[${n}] 🛠 log function not provided`);
          }), s.$notify = a || (() => {
            console.error(`[${n}] 🛠 notify function not provided`);
          });
        } else
          console.error(`[${n}] 🛠 app functions not provided`);
    }), Object.keys(et).forEach((s) => {
      var l;
      (l = t.i18n) == null || l.global.mergeLocaleMessage(s, et[s]);
    }), e.component("feedback-view", iA), e.component("feedback-menu-view", cA), e.component("new-feedback", ta);
  }
}, rN = {
  plugin: uA,
  useStore: qe,
  attachService: Xr
}, dA = "data:audio/mpeg;base64,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", gA = { class: "flex items-center gap-2" }, pA = { class: "bg-white/20 rounded-2xl px-2 py-1" }, mA = { class: "font-bold" }, hA = /* @__PURE__ */ T({
  __name: "ToastGroupHeader",
  props: {
    icon: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    isShowingMore: {
      type: Boolean,
      default: !1
    },
    isDisplayingMultiples: {
      type: Boolean,
      default: !1
    },
    hasMultiples: {
      type: Boolean,
      default: !1
    },
    totalItems: {
      type: Number,
      default: 0
    },
    parentWrapper: {
      type: String,
      required: !1
    }
  },
  emits: ["close-toast-group", "update-is-showing-more"],
  setup(e, { emit: t }) {
    const n = e, o = k(
      () => n.isDisplayingMultiples || n.parentWrapper === "header" ? { containerCorners: "rounded-lg" } : { containerCorners: "rounded-t-lg" }
    ), i = k(
      () => n.isShowingMore ? {
        chevronRotate: "rotate-90",
        buttonLabel: "less"
      } : {
        chevronRotate: "-rotate-90",
        buttonLabel: "more"
      }
    );
    return (r, s) => {
      const l = P;
      return c(), p("div", {
        class: D(["flex items-center justify-between p-2 text-white text-1.5xs", `bg-${e.color} ${h(o).containerCorners}`])
      }, [
        m("div", gA, [
          M(l, {
            class: D(["bg-white rounded h-5 w-5 py-[3.5px] px-[5px] text-xs", `text-${e.color}`]),
            icon: ["fas", e.icon]
          }, null, 8, ["class", "icon"]),
          m("div", pA, N(e.totalItems), 1),
          m("div", mA, N(e.title), 1),
          e.hasMultiples ? (c(), p("div", {
            key: 0,
            class: "bg-white/20 flex items-center rounded-xl px-2 py-1 gap-1.5 cursor-pointer hover:bg-white hover:text-gray-7 transition-colors",
            onClick: s[0] || (s[0] = (a) => t("update-is-showing-more", !e.isShowingMore))
          }, [
            m("div", null, N(r.$t(`toasts.cta.show-${h(i).buttonLabel}`)), 1),
            M(l, {
              class: D(["text-3xs", h(i).chevronRotate]),
              icon: ["fas", "chevron-right"]
            }, null, 8, ["class"])
          ])) : A("", !0)
        ]),
        M(l, {
          class: D(["bg-white rounded-full text-2xs w-4 h-4 !flex items-center justify-center cursor-pointer hover:bg-gray-3 transition-colors", `text-${e.color}`]),
          icon: ["fas", "xmark"],
          onClick: s[1] || (s[1] = (a) => t("close-toast-group"))
        }, null, 8, ["class"])
      ], 2);
    };
  }
}), fA = /* @__PURE__ */ T({
  __name: "ToastViewer",
  props: {
    id: {
      type: String,
      required: !0
    },
    body: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = {
      fontOptions: !0,
      extraFontOptions: !0,
      colorOptions: !0,
      structurationOptions: !0,
      extraStructurationOptions: !0,
      tableOptions: !0,
      richOptions: !0,
      tocClickOptions: !0,
      allowToc: !0
    }, n = ai("editorCtx"), o = ai("toast-event-emitter");
    return (i, r) => {
      var l, a;
      const s = R("mayday-editor");
      return c(), C(s, {
        class: "mayday-toast-viewer text-gray-9 text-sm text-left !p-0",
        key: e.id,
        content: e.body,
        editable: !1,
        options: t,
        "fetch-inline-content": (l = h(n)) == null ? void 0 : l.handleFetchInlineContent,
        "fetch-inline-mention": (a = h(n)) == null ? void 0 : a.handleFetchInlineMention,
        "onClick:inlineContent": r[0] || (r[0] = (u) => h(o)("click:inline-content", u)),
        "onClick:inlineContentModal": r[1] || (r[1] = (u) => h(o)("click:inline-content-modal", u))
      }, null, 8, ["content", "fetch-inline-content", "fetch-inline-mention"]);
    };
  }
});
const yA = /* @__PURE__ */ x(fA, [["__scopeId", "data-v-eec097d7"]]), IA = { class: "flex items-center" }, MA = { class: "pl-2 font-bold" }, AA = { class: "flex justify-center items-center" }, NA = {
  key: 2,
  class: "text-xl"
}, bA = { class: "font-bold w-full line-clamp-2" }, CA = { class: "w-full justify-end flex gap-2" }, wA = /* @__PURE__ */ T({
  __name: "ToastItem",
  props: {
    item: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      required: !1
    },
    emoji: {
      type: String,
      required: !1
    },
    displayHeader: {
      type: Boolean,
      required: !0
    },
    totalItems: {
      type: Number,
      default: 1
    },
    headerTitle: {
      type: String,
      required: !0
    },
    headerIcon: {
      type: String,
      required: !0
    },
    footer: {
      type: String,
      required: !0
    },
    isFirst: {
      type: Boolean,
      default: !1
    },
    isLabelClickable: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update-is-showing-more", "go-to-entity", "close-toast-item"],
  setup(e, { emit: t }) {
    const n = e, o = ve(), i = Y(!1), r = k(
      () => n.displayHeader ? { containerCorners: "rounded-lg" } : { containerCorners: "rounded-b-lg" }
    ), s = k(() => n.item), l = k(() => s.value.author || {}), a = k(() => n.item), u = () => {
      if (n.isLabelClickable)
        return g();
      i.value = !i.value, i.value && o.logNotificationsRead([s.value.id]);
    }, g = () => {
      const f = a.value.entity;
      if (f)
        return t("go-to-entity", {
          id: f.id,
          type: f.type,
          notificationId: s.value.id,
          toastType: n.type,
          recommendation: a.value.recommendation
        });
    }, d = k(() => n.type !== "URGENT_NOTIFICATION");
    return _e(
      () => n.isFirst,
      () => {
        !n.isFirst && !n.displayHeader && (i.value = !1);
      }
    ), _e(
      () => n.displayHeader,
      () => {
        !n.isFirst && !n.displayHeader && (i.value = !1);
      }
    ), (f, I) => {
      var H, ee;
      const z = P, v = Eo, Q = ye;
      return c(), p("div", {
        class: D([h(r).containerCorners, "bg-white shadow-sm relative transition-none w-full"])
      }, [
        m("div", {
          class: D([[`${e.displayHeader ? "max-h-10 p-2 opacity-1" : "max-h-0 p-0 opacity-0"}`], "bg-gray-2 flex items-center justify-between rounded-t-lg duration-300 overflow-hidden group/header"])
        }, [
          m("div", IA, [
            M(z, {
              icon: ["fas", e.headerIcon],
              class: "text-white bg-gray-5 rounded h-5 w-5 py-[3.5px] px-[5px] text-xs"
            }, null, 8, ["icon"]),
            m("div", MA, N(e.headerTitle), 1)
          ]),
          h(d) ? (c(), p("div", {
            key: 0,
            class: "hidden group-hover/header:flex justify-center items-center bg-gray-8 text-white rounded-full text-2xs w-4 h-4 cursor-pointer hover:bg-blue transition-colors",
            onClick: I[0] || (I[0] = (j) => t("close-toast-item"))
          }, [
            M(z, { icon: ["fas", "xmark"] })
          ])) : A("", !0)
        ], 2),
        m("div", {
          class: "flex w-full justify-between items-center p-2 gap-2 cursor-pointer h-12",
          onClick: u
        }, [
          m("div", AA, [
            e.type === "NOTIFICATION" || e.type === "URGENT_NOTIFICATION" ? (c(), C(v, {
              key: 0,
              "is-deleted": h(l).isDeleted,
              username: h(l).username,
              size: "small"
            }, null, 8, ["is-deleted", "username"])) : e.type === "AUTOMATION" ? (c(), C(ln, {
              key: 1,
              type: ((H = h(a).entity) == null ? void 0 : H.type) || "Article",
              typename: "Content"
            }, null, 8, ["type"])) : e.emoji ? (c(), p("span", NA, N(e.emoji), 1)) : A("", !0)
          ]),
          m("p", bA, N(e.item.title), 1),
          M(z, {
            class: D([["transform", h(i) ? "rotate-90" : "rotate-0"], "h-3 w-3 text-xs hover:text-blue-5 transition-transform"]),
            icon: ["fas", "chevron-right"]
          }, null, 8, ["class"])
        ]),
        m("div", {
          class: D(["transition-all overflow-auto duration-300 pr-2 pl-4", h(i) ? "max-h-40 space-y-2 pb-2" : "max-h-0 space-y-0 pb-0"])
        }, [
          M(yA, {
            id: e.item.id,
            body: e.item.body
          }, null, 8, ["id", "body"]),
          M(ct, {
            attachments: h(s).attachments
          }, null, 8, ["attachments"]),
          m("div", CA, [
            (ee = h(a).entity) != null && ee.id ? (c(), C(Q, {
              key: 0,
              size: "mini",
              onClick: g
            }, {
              default: _(() => [
                ne(N(f.$t("toasts.cta.open-content")), 1)
              ]),
              _: 1
            })) : A("", !0),
            e.type === "NOTIFICATION" ? (c(), C(Q, {
              key: 1,
              size: "mini",
              onClick: I[1] || (I[1] = (j) => t("close-toast-item"))
            }, {
              default: _(() => [
                ne(N(f.$t("toasts.cta.close")), 1)
              ]),
              _: 1
            })) : A("", !0)
          ])
        ], 2),
        m("div", {
          class: D([[`${!e.displayHeader && e.totalItems > 1 ? "max-h-5 pb-2 pl-2.5 " : "max-h-0 p-0"}`], "font-bold text-gray-7 text-2xs cursor-pointer transition-all duration-300 overflow-hidden flex items-center space-y-1 hover:space-y-2"]),
          onClick: I[2] || (I[2] = (j) => t("update-is-showing-more", !0))
        }, [
          ne(N(e.footer) + " ", 1),
          M(z, {
            icon: ["fal", "long-arrow-right"],
            class: "ml-1"
          })
        ], 2)
      ], 2);
    };
  }
}), DA = /* @__PURE__ */ T({
  __name: "ToastGroup",
  props: {
    type: {
      type: String,
      required: !0
    },
    items: {
      type: Array,
      required: !0
    },
    config: {
      type: Object,
      required: !0
    },
    isShowingMore: {
      type: Boolean,
      default: !1
    },
    parentWrapper: {
      type: String,
      required: !1
    }
  },
  emits: ["close-toast-group", "go-to-entity", "close-toast-item", "update-is-showing-more"],
  setup(e, { emit: t }) {
    const n = e, o = {
      AUTOMATION: {
        icon: "bolt",
        color: "purple-5",
        title: "toasts.group-titles.automation",
        footer: "toasts.footer.other-contents"
      },
      NOTIFICATION: {
        icon: "bell",
        color: "blue-5",
        title: "toasts.group-titles.notification",
        footer: "toasts.footer.other-notifications"
      },
      URGENT_NOTIFICATION: {
        icon: "bell",
        color: "red-5",
        title: "toasts.group-titles.urgent-notification",
        footer: "toasts.footer.other-notifications"
      },
      TICKET_CONTEXT: {
        icon: "info-circle",
        color: "teal-5",
        title: "toasts.group-titles.context",
        footer: "toasts.footer.other-contents"
      }
    }, i = (g) => {
      t("update-is-showing-more", g);
    }, r = k(() => n.isShowingMore && n.items.length > 1), s = k(
      () => r.value ? {
        headerSpacing: "space-y-2"
      } : {
        headerSpacing: ""
      }
    ), l = (g) => {
      if (r.value || n.items.length === 1)
        return "";
      if (!n.isShowingMore && n.parentWrapper === "header")
        return "max-height: 0px; overflow: hidden";
      let d = `scale: ${100 - g * 4}% 100%; z-index: ${40 - g};`;
      return g >= 1 && g <= 3 && (d = d.concat("margin-top: -44px;")), g > 3 && (d = d.concat("max-height: 0px; overflow: hidden")), d;
    }, a = k(() => o[n.type]), u = k(() => ({
      "--translate-x": n.config.positionIsLeft.value ? "-320px" : "320px"
    }));
    return (g, d) => (c(), p("div", {
      class: D([h(s).headerSpacing, "h-fit text-xs w-full"]),
      style: Ce(h(u))
    }, [
      M(Fs, Tt({
        name: "toast-group",
        tag: "div"
      }, { class: h(s).headerSpacing }), {
        default: _(() => [
          M(hA, {
            key: "header",
            title: g.$t(h(a).title, { count: e.items.length }),
            icon: h(a).icon,
            color: h(a).color,
            "has-multiples": e.items.length > 1,
            "is-displaying-multiples": h(r),
            "is-showing-more": e.isShowingMore,
            "total-items": e.items.length,
            "parent-wrapper": e.parentWrapper,
            onUpdateIsShowingMore: i,
            onCloseToastGroup: d[0] || (d[0] = (f) => t("close-toast-group"))
          }, null, 8, ["title", "icon", "color", "has-multiples", "is-displaying-multiples", "is-showing-more", "total-items", "parent-wrapper"]),
          (c(!0), p(X, null, te(e.items, (f, I) => (c(), C(wA, {
            key: f.id,
            color: h(a).color,
            "display-header": !!h(r),
            footer: g.$t(h(a).footer, { count: e.items.length - 1 }),
            "header-icon": h(a).icon,
            "header-title": g.$t(h(a).title),
            item: f,
            style: Ce(l(I)),
            "total-items": I ? 1 : e.items.length,
            type: e.type,
            "is-first": I === 0,
            emoji: f.emoji,
            "is-label-clickable": n.type === "AUTOMATION",
            onUpdateIsShowingMore: i,
            onGoToEntity: d[1] || (d[1] = (z) => t("go-to-entity", z)),
            onCloseToastItem: (z) => t("close-toast-item", {
              id: f.id,
              type: e.type
            })
          }, null, 8, ["color", "display-header", "footer", "header-icon", "header-title", "item", "style", "total-items", "type", "is-first", "emoji", "is-label-clickable", "onCloseToastItem"]))), 128))
        ]),
        _: 1
      }, 16)
    ], 6));
  }
});
const ii = /* @__PURE__ */ x(DA, [["__scopeId", "data-v-ee9a981d"]]), zA = { class: "notifications__card rounded-lg w-full" }, vA = { class: "notifications__circle" }, TA = {
  key: 0,
  class: "unread-count"
}, kA = { class: "notifications__dropdown" }, jA = /* @__PURE__ */ T({
  __name: "ToastNotificationGroupHeader",
  props: {
    items: {
      type: Array,
      required: !0
    }
  },
  emits: ["close-toast-group", "update-is-showing-more"],
  setup(e, { emit: t }) {
    return (n, o) => {
      const i = P;
      return c(), p("div", zA, [
        m("div", vA, [
          M(i, { icon: ["fal", "bell"] }),
          e.items.length > 0 ? (c(), p("span", TA, N(e.items.length), 1)) : A("", !0)
        ]),
        m("div", null, N(n.$t("toasts.group-titles.notification", { count: e.items.length })), 1),
        m("div", kA, [
          m("span", {
            class: "hover:text-white/60 active:text-white/20",
            onClick: o[0] || (o[0] = (r) => t("update-is-showing-more"))
          }, N(n.$t("toasts.cta.show")), 1),
          M(i, {
            class: "hover:text-white/60 active:text-white/20 font-semibold",
            icon: ["fal", "xmark"],
            onClick: o[1] || (o[1] = (r) => t("close-toast-group"))
          })
        ])
      ]);
    };
  }
});
const SA = /* @__PURE__ */ x(jA, [["__scopeId", "data-v-72fcd752"]]), LA = {
  key: 1,
  class: "text-sm"
}, EA = /* @__PURE__ */ T({
  __name: "ContextToast",
  props: {
    context: {
      type: String,
      default: null
    },
    sentiment: {
      type: Number,
      default: null
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["close-context"],
  setup(e, { emit: t }) {
    const n = e, o = [
      { emoji: "😡", color: "bg-red/40" },
      { emoji: "😞", color: "bg-orange/40" },
      { emoji: "🤔", color: "bg-yellow/40" },
      { emoji: "☺️", color: "bg-green/40" },
      { emoji: "😁", color: "bg-blue/40" }
    ], i = k(() => {
      var s;
      if (n.config)
        return n.config.positionIsLeft.value || (s = n == null ? void 0 : n.context) != null && s.length ? "left-10 " : "right-10 ";
    }), r = k(() => {
      if (!n.config)
        return;
      let s = "";
      return s += n.config.positionIsTop.value ? "-top-2 border-b-[10px] border-b-white " : "-bottom-2 border-t-[10px] border-t-white ", s += n.config.positionIsLeft.value ? "left-4 border-r-[26px] border-r-transparent " : "right-4 border-l-[26px] border-l-transparent ", s;
    });
    return (s, l) => {
      var u, g;
      const a = P;
      return c(), p("div", {
        class: D(["p-2 flex items-center gap-2 bg-white shadow-sm rounded-lg relative group/toast pointer-events-auto", [(u = n.context) != null && u.length ? "w-full" : "w-12"]])
      }, [
        n.sentiment ? (c(), p("div", {
          key: 0,
          class: D(["text-xl flex items-center justify-center h-8 w-8 rounded-lg flex-none relative group/sentiment cursor-pointer", o[n.sentiment - 1].color])
        }, [
          ne(N(o[n.sentiment - 1].emoji) + " ", 1),
          m("div", {
            class: D(["absolute hidden group-hover/sentiment:block p-1 bg-gray-9 text-white text-xs rounded whitespace-nowrap", h(i)])
          }, N(s.$t(`toasts.context.${n.sentiment}`)), 3)
        ], 2)) : A("", !0),
        (g = n.context) != null && g.length ? (c(), p("div", LA, N(n.context), 1)) : A("", !0),
        m("div", {
          class: "hidden group-hover/toast:flex items-center justify-center text-xs text-white bg-primary rounded-full cursor-pointer w-4 h-4 absolute -top-2 -right-2",
          onClick: l[0] || (l[0] = (d) => t("close-context"))
        }, [
          M(a, { icon: ["fal", "times"] })
        ]),
        m("div", {
          class: D(["absolute w-0 h-0", h(r)])
        }, null, 2)
      ], 2);
    };
  }
}), OA = {}, xA = {
  isOpen: !1,
  isNotificationGroupOpen: !1,
  notificationGroupLastClosed: null,
  notificationGroupLength: -1,
  isUrgentNotificationGroupOpen: !1,
  urgentNotificationGroupLastClosed: null,
  urgentNotificationGroupLength: -1,
  isAutomationGroupOpen: !1,
  automationGroupLastClosed: null,
  isTicketContextGroupOpen: !1,
  ticketContextGroupLastClosed: null
};
function Es() {
  return Object.assign({}, {}, xA);
}
const _A = (e) => e.toLowerCase().split("_").reduce(
  (t, n) => t + n.charAt(0).toUpperCase() + n.slice(1),
  ""
), si = (e) => e.toLowerCase().replace(/([-_][a-z])/g, (t) => t.toUpperCase().replace("-", "").replace("_", "")), ri = ["AUTOMATION", "TICKET_CONTEXT"], UA = 3600 * 24 * 1e3, na = Wt(ze.TOASTS, {
  state: Es,
  getters: { ...OA },
  actions: {
    mutate(e) {
      this.$patch((t) => {
        Object.keys(e).forEach((n) => {
          t[n] = e[n];
        });
      });
    },
    // patch object will not be synced
    unsyncedMutate(e) {
      this.$patch(e);
    },
    reset() {
      this.mutate(Es());
    },
    toggleIsOpen(e) {
      this.unsyncedMutate({ isOpen: e });
    },
    toggleIsGroupOpen(e, t, n, o) {
      const i = this[`${si(t)}GroupLastClosed`], r = !i || new Date(i).getTime() + UA < (/* @__PURE__ */ new Date()).getTime();
      if (!n && !r && e)
        return;
      const s = {
        [`is${_A(t)}GroupOpen`]: e
      };
      ri.includes(t) ? this.unsyncedMutate(s) : this.mutate(s), e || this.updateGroupLastClosed(t, o);
    },
    updateGroupLastClosed(e, t) {
      const n = {
        [`${si(e)}GroupLastClosed`]: (/* @__PURE__ */ new Date()).getTime()
      };
      ri.includes(e) ? this.unsyncedMutate(n) : this.mutate(n), this.logAppToastCloseAll(e, t);
    },
    updateGroupLength(e, t) {
      const n = {
        [`${si(e)}GroupLength`]: t
      };
      ri.includes(e) ? this.unsyncedMutate(n) : this.mutate(n);
    },
    logAppToastClose(e) {
      const t = {
        toast: {
          type: e
        }
      };
      this.$logs({
        topic: "APP_TOAST_CLOSE",
        event: t
      });
    },
    logAppToastCloseAll(e, t) {
      const n = {
        toast: {
          type: e,
          count: t
        }
      };
      this.$logs({
        topic: "APP_TOAST_CLOSE_ALL",
        event: n
      });
    },
    applyAutomation(e, t) {
      const n = {
        recommendation: t,
        content: {
          id: e
        }
      };
      this.$logs(
        {
          topic: "CONTENT_RECOMMENDATION_SUCCESS",
          event: n
        },
        !0
      );
    },
    denyAutomations(e) {
      const t = {
        recommendations: e
      };
      this.$logs({
        topic: "CONTENT_RECOMMENDATION_ABORT",
        event: t
      });
    }
  },
  blacklist: ["isAutomationGroupOpen", "isTicketContextGroupOpen", "isOpen"],
  persist: {
    key: `md-${ze.TOASTS}`
  },
  share: {
    enable: !1
  }
}), FA = (e) => (Sn("data-v-6d43e996"), e = e(), Ln(), e), $A = {
  key: 0,
  id: "toast-sound",
  ref: "toastSound",
  preload: "auto",
  autoplay: ""
}, RA = /* @__PURE__ */ FA(() => /* @__PURE__ */ m("source", {
  src: dA,
  type: "audio/mpeg"
}, null, -1)), VA = [
  RA
], BA = /* @__PURE__ */ T({
  __name: "ToastView",
  props: {
    urgentNotifications: {
      type: Array,
      default: () => []
    },
    automations: {
      type: Array,
      default: () => []
    },
    notifications: {
      type: Array,
      default: () => []
    },
    ticketContext: {
      type: Object,
      default: void 0
    },
    config: {
      type: Object,
      required: !0
    },
    context: {
      type: Object,
      required: !0
    },
    parentWrapper: {
      type: String,
      required: !1
    }
  },
  emits: ["close-toast-group", "go-to-entity", "close-toast-item", "go-to-notifications", "close-context"],
  setup(e, { emit: t }) {
    const n = e, o = na(), { toggleIsGroupOpen: i, updateGroupLength: r } = o, {
      isAutomationGroupOpen: s,
      isNotificationGroupOpen: l,
      isUrgentNotificationGroupOpen: a,
      isTicketContextGroupOpen: u,
      notificationGroupLength: g,
      urgentNotificationGroupLength: d
    } = De(o), f = ft(), { hasToastSound: I } = De(f), z = ve(), { soundPlayable: v } = De(z);
    qi("editorCtx", n.context.editor), qi("toast-event-emitter", t);
    const Q = Y(!1), H = Y(!1), ee = Y(!1), j = Y(!1), G = {
      NOTIFICATION: {
        update: Q,
        others: [H, ee]
      },
      AUTOMATION: {
        update: H,
        others: [Q, ee]
      },
      URGENT_NOTIFICATION: {
        update: ee,
        others: [Q, H]
      }
    }, V = (q, B) => {
      const { update: ae, others: re } = G[B];
      ae.value = q, q && re.forEach((de) => de.value = !1);
    }, K = (q) => {
      t("go-to-entity", { ...q, source: "automation" }), q.recommendation && o.applyAutomation(q.id, q.recommendation);
    }, U = (q) => {
      t("close-toast-item", q), q.type === "AUTOMATION" && q.recommendation && o.denyAutomations([q.recommendation]), o.logAppToastClose(q.type);
    };
    function he(q) {
      return q != null;
    }
    const se = k(() => oe.value.map((q) => q.recommendation).filter(he)), F = () => {
      i(!1, "AUTOMATION", !1, oe.value.length), se.value.length && o.denyAutomations(se.value);
    }, $ = k(() => {
      var q;
      return (q = n.urgentNotifications) == null ? void 0 : q.filter((B) => B).sort((B, ae) => new Date(ae.updatedAt).getTime() - new Date(B.updatedAt).getTime()).map((B) => ({
        title: B.metadata.label,
        body: B.metadata.body,
        id: B.id,
        author: { ...n.context.users[B.authorId] },
        entity: {
          id: B.metadata.entityId || "",
          type: B.metadata.entityType || "",
          label: ""
        }
      }));
    });
    _e($, (q, B) => {
      setTimeout(() => {
        d.value !== -1 && d.value !== B.length || (r("URGENT_NOTIFICATION", q.length), (q == null ? void 0 : q.length) > (B == null ? void 0 : B.length) && (i(!0, "URGENT_NOTIFICATION", !0), j.value = !0, setTimeout(() => {
          j.value = !1, v.value = !1;
        }, 700)));
      }, 100);
    });
    const oe = k(() => n.automations);
    _e(oe, () => {
      i(!0, "AUTOMATION", !0);
    }), _e(
      () => n.ticketContext,
      (q) => {
        i(!!q, "TICKET_CONTEXT", !0);
      }
    );
    const pe = k(() => {
      var q;
      return (q = n.notifications) == null ? void 0 : q.filter((B) => B).sort((B, ae) => new Date(ae.updatedAt).getTime() - new Date(B.updatedAt).getTime()).map((B) => ({
        title: B.metadata.label,
        body: B.metadata.body,
        id: B.id,
        author: { ...n.context.users[B.authorId] },
        entity: {
          id: B.metadata.entityId,
          type: B.metadata.entityType,
          label: ""
        },
        attachments: B.metadata.attachments
      }));
    });
    _e(pe, (q, B) => {
      setTimeout(() => {
        g.value !== -1 && g.value !== B.length || (r("NOTIFICATION", q.length), (q == null ? void 0 : q.length) > (B == null ? void 0 : B.length) && (i(!0, "NOTIFICATION", !0), j.value = !0, setTimeout(() => {
          j.value = !1, v.value = !1;
        }, 700)));
      }, 100);
    });
    const Qe = k(() => {
      if (n.parentWrapper === "header")
        return {
          mainWrapperItem: "items-start",
          transitionWrapperFlexDir: "flex-col"
        };
      const q = n.config.positionIsTop.value ? { mainWrapperItem: "items-start", transitionWrapperFlexDir: "flex-col" } : { mainWrapperItem: "items-end", transitionWrapperFlexDir: "flex-col-reverse" };
      return q.transitionWrapperFlexDir += n.config.positionIsLeft.value ? " items-start" : " items-end", q;
    }), ot = k(() => n.parentWrapper === "header" ? { "--translate-x": "0" } : { "--translate-x": n.config.positionIsLeft.value ? "-320px" : "320px" }), Mt = k(() => n.parentWrapper === "app" ? "p-2" : "");
    return (q, B) => h(s) && h(oe).length || h(l) && h(pe).length || h(a) && h($).length || h(u) && n.ticketContext ? (c(), p("div", {
      key: 0,
      class: D([[h(Qe).mainWrapperItem], "flex"]),
      style: Ce(h(ot))
    }, [
      h(v) && h(I) && h(j) ? (c(), p("audio", $A, VA, 512)) : A("", !0),
      M(Fs, Tt({
        class: "text-sm flex gap-3 max-h-full w-full toast-group__transition-group pointer-events-auto overflow-auto",
        name: "toast-group",
        tag: "div"
      }, { class: `${h(Qe).transitionWrapperFlexDir} ${h(Mt)}` }), {
        default: _(() => {
          var ae, re, de;
          return [
            n.ticketContext && n.parentWrapper === "app" ? (c(), C(EA, {
              key: 0,
              context: n.ticketContext.context,
              sentiment: n.ticketContext.sentiment,
              config: n.config,
              onCloseContext: B[0] || (B[0] = (ke) => t("close-toast-item", { id: "", type: "TICKET_CONTEXT" }))
            }, null, 8, ["context", "sentiment", "config"])) : A("", !0),
            (ae = h(pe)) != null && ae.length && h(l) ? (c(), C(xt(e.parentWrapper === "app" ? ii : SA), {
              config: e.config,
              items: h(pe),
              class: "pointer-events-auto",
              key: "NOTIFICATION",
              type: "NOTIFICATION",
              "is-showing-more": h(Q),
              "parent-wrapper": e.parentWrapper,
              onCloseToastGroup: B[1] || (B[1] = (ke) => h(i)(!1, "NOTIFICATION", !1, h(pe).length)),
              onCloseToastItem: U,
              onGoToEntity: B[2] || (B[2] = (ke) => t("go-to-entity", { ...ke, source: "toast_notification" })),
              onUpdateIsShowingMore: B[3] || (B[3] = (ke) => e.parentWrapper === "app" ? V(ke, "NOTIFICATION") : t("go-to-notifications"))
            }, null, 40, ["config", "items", "is-showing-more", "parent-wrapper"])) : A("", !0),
            (re = h(oe)) != null && re.length && h(s) ? (c(), C(ii, {
              config: e.config,
              items: h(oe),
              class: "pointer-events-auto",
              key: "AUTOMATION",
              type: "AUTOMATION",
              "is-showing-more": h(H),
              "parent-wrapper": e.parentWrapper,
              onCloseToastGroup: F,
              onCloseToastItem: U,
              onGoToEntity: K,
              onUpdateIsShowingMore: B[4] || (B[4] = (ke) => V(ke, "AUTOMATION"))
            }, null, 8, ["config", "items", "is-showing-more", "parent-wrapper"])) : A("", !0),
            (de = h($)) != null && de.length && h(a) ? (c(), C(ii, {
              config: e.config,
              items: h($),
              class: "pointer-events-auto",
              key: "URGENT_NOTIFICATION",
              type: "URGENT_NOTIFICATION",
              "is-showing-more": h(ee),
              "parent-wrapper": e.parentWrapper,
              onCloseToastGroup: B[5] || (B[5] = (ke) => h(i)(
                !1,
                "URGENT_NOTIFICATION",
                !1,
                h($).length
              )),
              onCloseToastItem: U,
              onGoToEntity: B[6] || (B[6] = (ke) => t("go-to-entity", { ...ke, source: "toast_urgent_notification" })),
              onUpdateIsShowingMore: B[7] || (B[7] = (ke) => V(ke, "URGENT_NOTIFICATION"))
            }, null, 8, ["config", "items", "is-showing-more", "parent-wrapper"])) : A("", !0)
          ];
        }),
        _: 1
      }, 16)
    ], 6)) : A("", !0);
  }
});
const YA = /* @__PURE__ */ x(BA, [["__scopeId", "data-v-6d43e996"]]), QA = {
  async install(e, t = {}) {
    const n = ze.TOASTS;
    if (t.pinia === void 0) {
      console.error(`[${n}] 🍍 pinia store instance not provided`);
      return;
    }
    t.i18n === void 0 && console.error(`[${n}] 🇫🇷 i18n instance not provided`), Object.keys(et).forEach((i) => {
      var r;
      (r = t.i18n) == null || r.global.mergeLocaleMessage(i, et[i]);
    });
    const { pinia: o } = t;
    o.use(({ store: i }) => {
      if (i.$id === n)
        if (t.appFunctions !== void 0) {
          const { logs: r } = t.appFunctions;
          i.$logs = r || (() => {
            console.error(`[${n}] 🛠 log function not provided`);
          });
        } else
          console.error(`[${n}] 🛠 app functions not provided`);
    }), e.component("toast-view", YA);
  }
}, aN = {
  plugin: QA,
  useStore: na
}, PA = ["disabled"], GA = { class: "w-4 h-4 flex justify-center items-center text-xs" }, ZA = {
  key: 0,
  class: "mx-1"
}, WA = /* @__PURE__ */ T({
  __name: "BaseAction",
  props: {
    icon: {},
    type: { default: "regular" },
    label: {},
    active: { type: Boolean },
    disabled: { type: Boolean },
    altStyle: { type: Boolean }
  },
  setup(e) {
    const t = e, n = {
      regular: "active:!bg-primary-contrast active:text-primary-complement",
      ai: "active:!bg-purple-5 active:text-white"
    }, o = {
      regular: "!bg-primary-contrast !text-primary-complement",
      ai: "!bg-purple-5 !text-white"
    };
    return (i, r) => {
      const s = P;
      return c(), p("button", {
        class: D(["rounded-full p-1 text-sm flex items-center justify-center transition-colors disabled:cursor-not-allowed", [
          t.active ? o[t.type] : n[t.type],
          t.altStyle ? "text-gray-9 bg-gray-3 hover:bg-gray-4 disabled:!bg-gray-5" : "text-primary-contrast bg-primary-contrast/10 hover:bg-primary-contrast/20 disabled:!bg-gray-2"
        ]]),
        disabled: t.disabled
      }, [
        m("span", GA, [
          M(s, {
            icon: ["fas", t.icon]
          }, null, 8, ["icon"])
        ]),
        t.label ? (c(), p("span", ZA, N(t.label), 1)) : A("", !0)
      ], 10, PA);
    };
  }
}), HA = {
  key: 0,
  class: "absolute z-20 shadow-sm px-2 py-1 text-2xs bg-gray-9 text-white top-0.5 right-[calc(100%+4px)] rounded whitespace-nowrap"
}, JA = /* @__PURE__ */ T({
  __name: "BaseTooltip",
  props: {
    text: {}
  },
  setup(e) {
    const t = e;
    return (n, o) => (c(), C(Xe, { name: "fade" }, {
      default: _(() => [
        Te(n.$slots, "default", {}, () => [
          t.text ? (c(), p("div", HA, N(n.$t(t.text)), 1)) : A("", !0)
        ])
      ]),
      _: 3
    }));
  }
}), KA = {
  BaseButton: ye,
  BaseSwitcher: zi,
  BaseAction: WA,
  BaseSwitch: kn,
  BaseDropdown: lr,
  BaseSelect: wi,
  BaseBadge: Fi,
  BaseAvatar: Eo,
  BaseDivider: or,
  BaseTabs: $i,
  BaseMenu: zr,
  BaseTooltip: JA,
  FontAwesomeIcon: P,
  TextEllipsis: Le,
  EmptyState: _n,
  InfiniteScroll: Wr
}, lN = (e) => {
  for (const [t, n] of Object.entries(KA))
    e.component(t, n);
};
window.global || (window.global = window);
export {
  tN as AdminModule,
  oN as FavoritesModule,
  rN as FeedbackModule,
  nN as KnowledgeModule,
  iN as NotificationsModule,
  sN as SearchModule,
  aN as ToastsModule,
  ls as generateConfig,
  eN as generateVariables,
  ft as useAdminStore,
  Ot as useFavoritesStore,
  qe as useFeedbackStore,
  le as useKnowledgeStore,
  lN as useModuleLibrary,
  ve as useNotificationStore,
  kt as useSearchStore,
  na as useToastStore
};
